var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/components/accordion/accordion.tsx
import React179 from "react";
import { css as css2 } from "@betterment/samba-styled-system/css";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

// src/components/icon/icon.tsx
import React178 from "react";
import { css, cva } from "@betterment/samba-styled-system/css";
import { styled } from "@betterment/samba-styled-system/jsx";
import { token } from "@betterment/samba-styled-system/tokens";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

// src/icons/components/index.ts
var components_exports = {};
__export(components_exports, {
  ArrowCircle: () => ArrowCircle_default,
  ArrowCircleCheckmark: () => ArrowCircleCheckmark_default,
  ArrowCircleMinus: () => ArrowCircleMinus_default,
  ArrowCirclePlus: () => ArrowCirclePlus_default,
  AtmCard: () => AtmCard_default,
  AtmCash: () => AtmCash_default,
  Balance: () => Balance_default,
  Bank: () => Bank_default,
  Bar: () => Bar_default,
  BeachUmbrella: () => BeachUmbrella_default,
  Bills: () => Bills_default,
  Boat: () => Boat_default,
  Briefcase: () => Briefcase_default,
  Browser: () => Browser_default,
  Building: () => Building_default,
  Buildings: () => Buildings_default,
  Bullet: () => Bullet_default,
  BulletOutline: () => BulletOutline_default,
  Calculator: () => Calculator_default,
  Calendar: () => Calendar_default,
  Camera: () => Camera_default,
  Cancel: () => Cancel_default,
  CancelFilled: () => CancelFilled_default,
  Car: () => Car_default,
  Card: () => Card_default,
  CaretDown: () => CaretDown_default,
  CaretLeft: () => CaretLeft_default,
  CaretRight: () => CaretRight_default,
  CaretUp: () => CaretUp_default,
  Cash: () => Cash_default,
  Charity: () => Charity_default,
  CharityHand: () => CharityHand_default,
  Chat: () => Chat_default,
  CheckBack: () => CheckBack_default,
  CheckFront: () => CheckFront_default,
  CheckFrontSignature: () => CheckFrontSignature_default,
  Checkmark: () => Checkmark_default,
  CheckmarkCircle: () => CheckmarkCircle_default,
  CheckmarkCircleFilled: () => CheckmarkCircleFilled_default,
  Children: () => Children_default,
  Circle: () => Circle_default,
  Clock: () => Clock_default,
  Compass: () => Compass_default,
  Copy: () => Copy_default,
  Deposit: () => Deposit_default,
  DepositCheck: () => DepositCheck_default,
  Dining: () => Dining_default,
  DirectDeposit: () => DirectDeposit_default,
  Document: () => Document_default,
  DocumentComplete: () => DocumentComplete_default,
  DocumentPlus: () => DocumentPlus_default,
  DocumentPopulated: () => DocumentPopulated_default,
  DocumentReview: () => DocumentReview_default,
  Documents: () => Documents_default,
  Dollar: () => Dollar_default,
  DollarCircle: () => DollarCircle_default,
  Donut: () => Donut_default,
  DownArrow: () => DownArrow_default,
  DownArrowSmall: () => DownArrowSmall_default,
  Download: () => Download_default,
  DragIndicator: () => DragIndicator_default,
  Edit: () => Edit_default,
  Education: () => Education_default,
  Ellipses: () => Ellipses_default,
  Exclamation: () => Exclamation_default,
  ExclamationCircle: () => ExclamationCircle_default,
  Exit: () => Exit_default,
  Eye: () => Eye_default,
  EyeCrossout: () => EyeCrossout_default,
  Filter: () => Filter_default,
  Fitness: () => Fitness_default,
  Folder: () => Folder_default,
  FolderComplete: () => FolderComplete_default,
  Fpo: () => Fpo_default,
  Fullscreen: () => Fullscreen_default,
  Gear: () => Gear_default,
  GearCircle: () => GearCircle_default,
  Gears: () => Gears_default,
  Glitter: () => Glitter_default,
  Globe: () => Globe_default,
  Guidance: () => Guidance_default,
  Hamburger: () => Hamburger_default,
  Home: () => Home_default,
  Hsa: () => Hsa_default,
  Image: () => Image_default,
  InfoBox: () => InfoBox_default,
  InfoCircle: () => InfoCircle_default,
  InfoFilled: () => InfoFilled_default,
  Inheritance: () => Inheritance_default,
  Investing: () => Investing_default,
  JointCash: () => JointCash_default,
  JointChecking: () => JointChecking_default,
  Laptop: () => Laptop_default,
  LeftArrow: () => LeftArrow_default,
  LeftArrowSmall: () => LeftArrowSmall_default,
  Lightbulb: () => Lightbulb_default,
  LightbulbCircle: () => LightbulbCircle_default,
  Lightning: () => Lightning_default,
  LightningCircle: () => LightningCircle_default,
  LightningCrossout: () => LightningCrossout_default,
  LightningCrossoutCircle: () => LightningCrossoutCircle_default,
  Link: () => Link_default,
  LinkAlt: () => LinkAlt_default,
  List: () => List_default,
  Lock: () => Lock_default,
  Mail: () => Mail_default,
  MailOpen: () => MailOpen_default,
  MajorPurchase: () => MajorPurchase_default,
  Map: () => Map_default,
  Medical: () => Medical_default,
  Message: () => Message_default,
  Minus: () => Minus_default,
  MinusCircle: () => MinusCircle_default,
  NestEgg: () => NestEgg_default,
  Open: () => Open_default,
  People: () => People_default,
  Person: () => Person_default,
  Pets: () => Pets_default,
  Phone: () => Phone_default,
  Pie: () => Pie_default,
  PieAlt: () => PieAlt_default,
  Pin: () => Pin_default,
  Plus: () => Plus_default,
  PlusCircle: () => PlusCircle_default,
  Power: () => Power_default,
  Preferences: () => Preferences_default,
  Present: () => Present_default,
  Presentation: () => Presentation_default,
  QuestionMark: () => QuestionMark_default,
  QuestionMarkCircle: () => QuestionMarkCircle_default,
  Quote: () => Quote_default,
  Rebalancing: () => Rebalancing_default,
  Redo: () => Redo_default,
  Response: () => Response_default,
  Ribbon: () => Ribbon_default,
  RightArrow: () => RightArrow_default,
  RightArrowSmall: () => RightArrowSmall_default,
  Safe: () => Safe_default,
  SafetyNet: () => SafetyNet_default,
  Search: () => Search_default,
  Security: () => Security_default,
  SecurityCheck: () => SecurityCheck_default,
  SecurityReview: () => SecurityReview_default,
  SecurityX: () => SecurityX_default,
  Shapes: () => Shapes_default,
  Share: () => Share_default,
  Shopping: () => Shopping_default,
  Signpost: () => Signpost_default,
  Sound: () => Sound_default,
  Spending: () => Spending_default,
  Stacks: () => Stacks_default,
  Stroller: () => Stroller_default,
  Sun: () => Sun_default,
  Swipe: () => Swipe_default,
  Ticket: () => Ticket_default,
  Transfer: () => Transfer_default,
  TransferCircle: () => TransferCircle_default,
  Trend: () => Trend_default,
  Trophy: () => Trophy_default,
  Umbrella: () => Umbrella_default,
  Undo: () => Undo_default,
  Unlink: () => Unlink_default,
  UnlinkAlt: () => UnlinkAlt_default,
  Unlock: () => Unlock_default,
  UpArrow: () => UpArrow_default,
  UpArrowSmall: () => UpArrowSmall_default,
  Upload: () => Upload_default,
  VennDiagram: () => VennDiagram_default,
  VerticalBar: () => VerticalBar_default,
  Warning: () => Warning_default,
  WarningFilled: () => WarningFilled_default,
  Webinar: () => Webinar_default,
  WeddingBands: () => WeddingBands_default,
  WeddingCake: () => WeddingCake_default,
  Withdraw: () => Withdraw_default,
  X: () => X_default,
  XCircle: () => XCircle_default
});

// src/icons/components/ArrowCircleCheckmark.tsx
import * as React from "react";
var SvgArrowCircleCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.75 21.412a9.6 9.6 0 0 1-3.273-1.067 9.5 9.5 0 0 1-2.615-2.074 9.6 9.6 0 0 1-1.734-2.86A9.3 9.3 0 0 1 2.5 12q0-2.217.922-4.109.922-1.89 2.641-3.276H3.375v-1.5H8.75V8.49h-1.5V5.592a7.9 7.9 0 0 0-2.409 2.823A7.84 7.84 0 0 0 4 12q0 2.97 1.902 5.188t4.848 2.699zm-.175-5.158L6.696 12.36l1.054-1.054 2.825 2.825 5.675-5.675 1.054 1.069zm4.675 4.64V15.52h1.5v2.898q1.558-1.182 2.404-2.84A7.76 7.76 0 0 0 20 12q0-2.97-1.902-5.188T13.25 4.113V2.588q3.54.482 5.895 3.128Q21.5 8.364 21.5 12q0 2.218-.922 4.113-.922 1.897-2.642 3.281h2.689v1.5z"
  }
));
var ArrowCircleCheckmark_default = SvgArrowCircleCheckmark;

// src/icons/components/ArrowCircleMinus.tsx
import * as React2 from "react";
var SvgArrowCircleMinus = (props) => /* @__PURE__ */ React2.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React2.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.75 21.412a9.6 9.6 0 0 1-3.273-1.066 9.5 9.5 0 0 1-2.615-2.075 9.6 9.6 0 0 1-1.734-2.86A9.3 9.3 0 0 1 2.5 12q0-2.218.922-4.11Q4.344 6 6.063 4.615H3.375v-1.5H8.75V8.49h-1.5V5.593a7.9 7.9 0 0 0-2.409 2.823A7.84 7.84 0 0 0 4 12q0 2.97 1.902 5.188t4.848 2.699zm4.5-.517V15.52h1.5v2.898q1.558-1.184 2.404-2.84A7.76 7.76 0 0 0 20 12q0-2.97-1.902-5.187t-4.848-2.7V2.59q3.54.48 5.895 3.128Q21.5 8.363 21.5 12q0 2.218-.922 4.114t-2.642 3.28h2.689v1.5z"
  }
), /* @__PURE__ */ React2.createElement("path", { fill: "currentColor", d: "M16 11.25v1.5H8v-1.5z" }));
var ArrowCircleMinus_default = SvgArrowCircleMinus;

// src/icons/components/ArrowCirclePlus.tsx
import * as React3 from "react";
var SvgArrowCirclePlus = (props) => /* @__PURE__ */ React3.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React3.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.75 21.412a9.6 9.6 0 0 1-3.273-1.066 9.5 9.5 0 0 1-2.615-2.075 9.6 9.6 0 0 1-1.734-2.86A9.3 9.3 0 0 1 2.5 12q0-2.218.922-4.11Q4.344 6 6.063 4.615H3.375v-1.5H8.75V8.49h-1.5V5.593a7.9 7.9 0 0 0-2.409 2.823A7.84 7.84 0 0 0 4 12q0 2.97 1.902 5.188t4.848 2.699zm4.5-.517V15.52h1.5v2.898q1.558-1.184 2.404-2.84A7.76 7.76 0 0 0 20 12q0-2.97-1.902-5.187t-4.848-2.7V2.59q3.54.48 5.895 3.128Q21.5 8.363 21.5 12q0 2.218-.922 4.114t-2.642 3.28h2.689v1.5z"
  }
), /* @__PURE__ */ React3.createElement("path", { fill: "currentColor", d: "M11.25 11.25V8h1.5v3.25H16v1.5h-3.25V16h-1.5v-3.25H8v-1.5z" }));
var ArrowCirclePlus_default = SvgArrowCirclePlus;

// src/icons/components/ArrowCircle.tsx
import * as React4 from "react";
var SvgArrowCircle = (props) => /* @__PURE__ */ React4.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React4.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.05 19.75q-3.245 0-5.522-2.258T4.25 12v-.78L2.4 13.07l-1.054-1.055L5 8.362l3.654 3.653L7.6 13.07l-1.85-1.85V12q0 2.605 1.835 4.428t4.465 1.822a5.9 5.9 0 0 0 2.452-.542l1.125 1.125a7.8 7.8 0 0 1-1.743.685q-.899.232-1.834.232M19 15.638l-3.654-3.653L16.4 10.93l1.85 1.85V12q0-2.605-1.835-4.428T11.95 5.75a5.9 5.9 0 0 0-2.452.542L8.373 5.167a7.8 7.8 0 0 1 1.743-.685 7.3 7.3 0 0 1 1.834-.232q3.245 0 5.522 2.258T19.75 12v.78l1.85-1.85 1.054 1.055z"
  }
));
var ArrowCircle_default = SvgArrowCircle;

// src/icons/components/AtmCard.tsx
import * as React5 from "react";
var SvgAtmCard = (props) => /* @__PURE__ */ React5.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React5.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.75 2.5H2.25V10H5V8.5H3.75V4h16.5v4.5H19V10h2.75zM5 5.5h14V7h-1.25v11.25A2.75 2.75 0 0 1 15 21H9a2.75 2.75 0 0 1-2.75-2.75V7H5zM15 7h1.25v11.25c0 .69-.56 1.25-1.25 1.25zm-2 0H7.75v11.25c0 .69.56 1.25 1.25 1.25h4z",
    clipRule: "evenodd"
  }
));
var AtmCard_default = SvgAtmCard;

// src/icons/components/AtmCash.tsx
import * as React6 from "react";
var SvgAtmCash = (props) => /* @__PURE__ */ React6.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React6.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 2.5h19.5V10H19V8.5h1.25V4H3.75v4.5H5V10H2.25zm14.5 3H19V7h-2.25v14h-9.5V7H5V5.5zm-8 1.5v11.25c.69 0 1.25.56 1.25 1.25h4c0-.69.56-1.25 1.25-1.25V7zM10 13.25a2 2 0 1 0 4 0 2 2 0 0 0-4 0",
    clipRule: "evenodd"
  }
));
var AtmCash_default = SvgAtmCash;

// src/icons/components/Balance.tsx
import * as React7 from "react";
var SvgBalance = (props) => /* @__PURE__ */ React7.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React7.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.5 20.5V19h8.75V7.883a2.63 2.63 0 0 1-1.188-.671A2.56 2.56 0 0 1 9.367 6h-3.31L9 13.106q-.03 1.125-.977 1.913-.948.789-2.273.789t-2.273-.789-.977-1.913L5.442 6H3.5V4.5h5.867a2.7 2.7 0 0 1 .955-1.428A2.62 2.62 0 0 1 12 2.5q.956 0 1.678.572t.955 1.428H20.5V6h-1.942l2.942 7.106q-.03 1.125-.977 1.913-.948.789-2.273.789t-2.273-.789T15 13.106L17.942 6h-3.31a2.55 2.55 0 0 1-.694 1.212 2.63 2.63 0 0 1-1.188.67V19h8.75v1.5zm13.808-7.442h3.884L18.25 8.37l-1.942 4.687Zm-12.5 0h3.884L5.75 8.37l-1.942 4.687ZM12 6.5q.521 0 .886-.364c.365-.364.364-.539.364-.886s-.121-.643-.364-.886A1.2 1.2 0 0 0 12 4q-.522 0-.886.364a1.2 1.2 0 0 0-.364.886q0 .521.364.886c.364.365.538.364.886.364"
  }
));
var Balance_default = SvgBalance;

// src/icons/components/Bank.tsx
import * as React8 from "react";
var SvgBank = (props) => /* @__PURE__ */ React8.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React8.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.75 17V9.5h1.5V17zm5.5 0V9.5h1.5V17zm-8.481 3.5V19h18.462v1.5zm13.98-3.5V9.5h1.5V17zM2.77 7.5V6.077L12 1.557l9.231 4.52V7.5zM6.315 6h11.37L12 3.25z"
  }
));
var Bank_default = SvgBank;

// src/icons/components/Bar.tsx
import * as React9 from "react";
var SvgBar = (props) => /* @__PURE__ */ React9.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React9.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.5 20.5V19h19v1.5zm1-2.885V11.5H6v6.115zm4.827 0V6.5h2.5v11.115zm4.837 0V9.5h2.5v8.115zm4.836 0V3.5h2.5v14.115z"
  }
));
var Bar_default = SvgBar;

// src/icons/components/BeachUmbrella.tsx
import * as React10 from "react";
var SvgBeachUmbrella = (props) => /* @__PURE__ */ React10.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React10.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m19.475 20.538-6.196-6.177 1.054-1.053 6.196 6.196zM5.96 19.57a9.1 9.1 0 0 1-1.87-3.048 9.9 9.9 0 0 1-.609-3.411q0-1.864.691-3.622.692-1.759 2.115-3.173 1.423-1.423 3.19-2.122a9.7 9.7 0 0 1 3.61-.699q1.748 0 3.408.618a9.3 9.3 0 0 1 3.046 1.876zm.161-2.3 1.581-1.58q-.4-.544-.777-1.133a11 11 0 0 1-.677-1.216 9.3 9.3 0 0 1-.8-2.656 7.4 7.4 0 0 0-.403 3.369 7.95 7.95 0 0 0 1.076 3.216m2.685-2.634 5.8-5.85q-1.075-.825-2.177-1.319a9 9 0 0 0-2.076-.666q-.975-.173-1.76-.029-.787.145-1.222.579-.434.45-.579 1.237-.144.786.025 1.768t.661 2.08a11.4 11.4 0 0 0 1.328 2.2m6.873-6.904 1.612-1.581a7.94 7.94 0 0 0-3.262-1.098 7.55 7.55 0 0 0-3.373.406q.714.088 1.383.299a10.2 10.2 0 0 1 2.51 1.172q.585.376 1.13.802"
  }
));
var BeachUmbrella_default = SvgBeachUmbrella;

// src/icons/components/Bills.tsx
import * as React11 from "react";
var SvgBills = (props) => /* @__PURE__ */ React11.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React11.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.5 21.385V2.615l1.385 1.231 1.423-1.23 1.423 1.23 1.423-1.23 1.423 1.23L12 2.616l1.423 1.23 1.423-1.23 1.423 1.23 1.423-1.23 1.423 1.23 1.385-1.23v18.769l-1.385-1.231-1.423 1.23-1.423-1.23-1.423 1.23-1.423-1.23L12 21.384l-1.423-1.23-1.423 1.23-1.423-1.23-1.423 1.23-1.423-1.23-1.385 1.23Zm2.75-4.943h11.5v-1.5H6.25zm0-3.692h11.5v-1.5H6.25zm0-3.692h11.5v-1.5H6.25zM5 19.1h14V4.9H5z"
  }
));
var Bills_default = SvgBills;

// src/icons/components/Boat.tsx
import * as React12 from "react";
var SvgBoat = (props) => /* @__PURE__ */ React12.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React12.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m3.48 13.25 7.27-10.452V13.25zm2.864-1.5H9.25V7.577zm6.502 1.5q.281-.72.592-2.387A18.3 18.3 0 0 0 13.75 7.5a20 20 0 0 0-.304-3.503q-.304-1.731-.59-2.641 1.476.565 2.869 1.752a14.2 14.2 0 0 1 2.485 2.776 15.5 15.5 0 0 1 1.782 3.478q.69 1.888.748 3.888zm1.956-1.5h4.277a12.1 12.1 0 0 0-1.503-4.059q-1.107-1.864-2.547-3.153.097.708.16 1.468a19 19 0 0 1-.066 3.727q-.127 1.077-.321 2.017M9 19.058q-.842 0-1.617-.358A4.4 4.4 0 0 1 6 17.692a7 7 0 0 1-.642.59 3 3 0 0 1-.745.443 6.1 6.1 0 0 1-1.425-1.526 6.5 6.5 0 0 1-.861-1.949h19.346a6.5 6.5 0 0 1-.861 1.95 6.1 6.1 0 0 1-1.425 1.525 3 3 0 0 1-.745-.443 7 7 0 0 1-.642-.59 4.6 4.6 0 0 1-1.39 1.008 3.8 3.8 0 0 1-1.61.358q-.842 0-1.622-.358A4.2 4.2 0 0 1 12 17.683q-.598.66-1.378 1.017-.78.358-1.622.358M2.25 22.75v-1.5H3q.8 0 1.558-.25A5.7 5.7 0 0 0 6 20.28a5.7 5.7 0 0 0 1.447.713q.753.243 1.553.243t1.545-.243A6 6 0 0 0 12 20.28a5.7 5.7 0 0 0 1.447.713q.753.243 1.553.243t1.55-.243T18 20.28q.71.47 1.455.721.745.25 1.545.25h.75v1.5H21q-.746 0-1.496-.192A7 7 0 0 1 18 21.97a7 7 0 0 1-1.504.587q-.75.192-1.496.192c-.746 0-.996-.064-1.496-.192A7 7 0 0 1 12 21.97a7 7 0 0 1-1.504.587q-.75.192-1.496.192c-.746 0-.996-.064-1.496-.192A7 7 0 0 1 6 21.97a7 7 0 0 1-1.504.587q-.75.192-1.496.192h-.75Z"
  }
));
var Boat_default = SvgBoat;

// src/icons/components/Briefcase.tsx
import * as React13 from "react";
var SvgBriefcase = (props) => /* @__PURE__ */ React13.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React13.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V8.308q0-.758.525-1.283T4.308 6.5H8.5V4.808q0-.758.525-1.283T10.308 3h3.384q.758 0 1.283.525t.525 1.283V6.5h4.192q.758 0 1.283.525t.525 1.283v10.384q0 .758-.525 1.283t-1.283.525zM10 6.5h4V4.808a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096h-3.384a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212zm10 8.25h-5.5v1.75h-5v-1.75H4v3.942q0 .116.096.212a.3.3 0 0 0 .212.096h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212zM11 15h2v-2h-2zm-7-1.75h5.5V11.5h5v1.75H20V8.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212z"
  }
));
var Briefcase_default = SvgBriefcase;

// src/icons/components/Browser.tsx
import * as React14 from "react";
var SvgBrowser = (props) => /* @__PURE__ */ React14.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React14.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8H4v9.692q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Browser_default = SvgBrowser;

// src/icons/components/Building.tsx
import * as React15 from "react";
var SvgBuilding = (props) => /* @__PURE__ */ React15.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React15.createElement("path", { fill: "currentColor", d: "M9 6H7v2h2zm4 0h-2v2h2zm2 0h2v2h-2zm-2 4h-2v2h2zm-6 0h2v2H7zm10 0h-2v2h2z" }), /* @__PURE__ */ React15.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 21.5h7v-19h-17v19h7v-6h3zM9 14v6H5V4h14v16h-4v-6z",
    clipRule: "evenodd"
  }
));
var Building_default = SvgBuilding;

// src/icons/components/Buildings.tsx
import * as React16 from "react";
var SvgBuildings = (props) => /* @__PURE__ */ React16.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React16.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.365 20.577v-17.5h9.5v4h9.77v13.5zm1.5-1.5h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm4 12h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm4 12h8.27v-10.5h-8.27v2.5h2.192v1.5h-2.192v2.5h2.192v1.5h-2.192zm4.385-6.5v-1.5h1.5v1.5zm0 4v-1.5h1.5v1.5z"
  }
));
var Buildings_default = SvgBuildings;

// src/icons/components/BulletOutline.tsx
import * as React17 from "react";
var SvgBulletOutline = (props) => /* @__PURE__ */ React17.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React17.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.517 14.484C10.202 15.168 11 15.5 12 15.5s1.799-.332 2.483-1.017S15.5 13 15.5 12s-.332-1.799-1.017-2.483S13 8.5 12 8.5s-1.799.332-2.483 1.017S8.5 11 8.5 12s.332 1.799 1.017 2.483Zm6.027-6.029Q14.087 7 11.999 7q-2.09 0-3.544 1.456Q7 9.913 7 12.001q0 2.09 1.456 3.544Q9.913 17 12.001 17q2.09 0 3.544-1.456Q17 14.087 17 11.999q0-2.09-1.456-3.544",
    clipRule: "evenodd"
  }
));
var BulletOutline_default = SvgBulletOutline;

// src/icons/components/Bullet.tsx
import * as React18 from "react";
var SvgBullet = (props) => /* @__PURE__ */ React18.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React18.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 18.5q-2.716 0-4.609-1.892Q5.5 14.718 5.5 12.002c0-2.716.63-3.347 1.891-4.609Q9.283 5.5 11.998 5.5c2.715 0 3.347.63 4.609 1.891Q18.5 9.283 18.5 11.998c0 2.715-.63 3.347-1.892 4.609q-1.89 1.893-4.606 1.893"
  }
));
var Bullet_default = SvgBullet;

// src/icons/components/Calculator.tsx
import * as React19 from "react";
var SvgCalculator = (props) => /* @__PURE__ */ React19.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React19.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.154 17.846h1.192v-2h2v-1.192h-2v-2H8.154v2h-2v1.192h2zm5-.75h4.692v-1.192h-4.692zm0-2.5h4.692v-1.192h-4.692zm.946-3.877 1.4-1.4 1.4 1.4.838-.838-1.4-1.431 1.4-1.4-.838-.838-1.4 1.4-1.4-1.4-.838.838 1.4 1.4-1.4 1.43.838.84ZM6.404 9.046h4.692V7.854H6.404zM5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h13.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Calculator_default = SvgCalculator;

// src/icons/components/Calendar.tsx
import * as React20 from "react";
var SvgCalendar = (props) => /* @__PURE__ */ React20.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React20.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T5.308 4.5h1.384V2.385h1.539V4.5h7.577V2.385h1.5V4.5h1.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-9.384H5v9.384q0 .116.096.212a.3.3 0 0 0 .212.096M5 8.808h14v-2.5a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212zm7 5.269a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.367.259-.626a.85.85 0 0 1 .626-.258q.368 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626.85.85 0 0 1-.625.259m-4 0a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.367.259-.626A.85.85 0 0 1 8 12.308q.367 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626.85.85 0 0 1-.625.259m8 0a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.367.259-.626a.85.85 0 0 1 .626-.258q.367 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626.85.85 0 0 1-.625.259M12 18a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.366.259-.626a.85.85 0 0 1 .626-.258q.368 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626A.85.85 0 0 1 12 18m-4 0a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.366.259-.626A.85.85 0 0 1 8 16.231q.367 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626A.85.85 0 0 1 8 18m8 0a.85.85 0 0 1-.626-.259.85.85 0 0 1-.259-.626q0-.366.259-.626a.85.85 0 0 1 .626-.258q.367 0 .626.258a.85.85 0 0 1 .259.626.85.85 0 0 1-.26.626A.85.85 0 0 1 16 18"
  }
));
var Calendar_default = SvgCalendar;

// src/icons/components/Camera.tsx
import * as React21 from "react";
var SvgCamera = (props) => /* @__PURE__ */ React21.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React21.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 17.115q1.72 0 2.918-1.197c1.198-1.197 1.197-1.77 1.197-2.918q0-1.722-1.197-2.918C13.721 8.886 13.148 8.885 12 8.885q-1.722 0-2.918 1.197C7.886 11.279 7.885 11.852 7.885 13q0 1.72 1.197 2.918c1.197 1.198 1.77 1.197 2.918 1.197m0-1.5q-1.108.001-1.862-.754-.753-.753-.753-1.861t.753-1.862T12 10.385q1.107 0 1.861.753.754.754.754 1.862.001 1.108-.754 1.861-.753.754-1.861.754M4.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V7.308q0-.758.525-1.283T4.308 5.5h3.054l1.85-2h5.576l1.85 2h3.054q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V7.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-3.724l-1.834-2h-4.27L8.031 7H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087Z"
  }
));
var Camera_default = SvgCamera;

// src/icons/components/CancelFilled.tsx
import * as React22 from "react";
var SvgCancelFilled = (props) => /* @__PURE__ */ React22.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React22.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m7.815 9.092 6.717 6.717 1.06-1.06L8.876 8.03l-1.06 1.06Zm-2.828 9.547a9.3 9.3 0 0 1-2.09-3.149 9.6 9.6 0 0 1-.698-3.569q0-1.814.696-3.568a9.2 9.2 0 0 1 2.09-3.149 9.3 9.3 0 0 1 3.149-2.09 9.6 9.6 0 0 1 3.569-.699q1.815 0 3.569.696a9.25 9.25 0 0 1 3.148 2.09 9.3 9.3 0 0 1 2.091 3.15q.698 1.756.698 3.568 0 1.815-.696 3.57a9.25 9.25 0 0 1-2.09 3.148 9.3 9.3 0 0 1-3.15 2.09 9.6 9.6 0 0 1-3.568.698 9.6 9.6 0 0 1-3.569-.696 9.2 9.2 0 0 1-3.149-2.09"
  }
));
var CancelFilled_default = SvgCancelFilled;

// src/icons/components/Cancel.tsx
import * as React23 from "react";
var SvgCancel = (props) => /* @__PURE__ */ React23.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React23.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q1.408 0 2.71-.476a7.9 7.9 0 0 0 2.382-1.378L5.854 6.908A8.1 8.1 0 0 0 4.48 9.29 7.8 7.8 0 0 0 4 12q0 3.35 2.325 5.675T12 20m6.146-2.908a7.9 7.9 0 0 0 1.378-2.382A7.8 7.8 0 0 0 20 12q0-3.35-2.325-5.675T12 4q-1.41 0-2.717.471a7.6 7.6 0 0 0-2.375 1.383z"
  }
));
var Cancel_default = SvgCancel;

// src/icons/components/Car.tsx
import * as React24 from "react";
var SvgCar = (props) => /* @__PURE__ */ React24.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React24.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.615 18.5v1.25q0 .318-.215.534a.73.73 0 0 1-.535.216H4.25a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534v-7.673L5.542 6.25q.112-.345.41-.547t.663-.203h10.808q.352 0 .637.206.287.207.398.544l2.042 5.827v7.673q0 .318-.216.534a.73.73 0 0 1-.534.216h-.615a.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534V18.5zm-.007-7.923h12.784L17.131 7H6.869zm1.856 5.27q.546 0 .925-.383.38-.382.38-.928t-.382-.925a1.27 1.27 0 0 0-.928-.38q-.546 0-.925.382-.38.382-.38.928t.382.925q.382.38.928.38Zm9.077 0q.546 0 .925-.383c.379-.383.38-.564.38-.928q0-.546-.382-.925a1.27 1.27 0 0 0-.928-.38q-.546 0-.925.382-.38.382-.38.928t.382.925q.382.38.928.38ZM5 17h14v-4.923H5z"
  }
));
var Car_default = SvgCar;

// src/icons/components/Card.tsx
import * as React25 from "react";
var SvgCard = (props) => /* @__PURE__ */ React25.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React25.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M21.5 6.308v11.384q0 .758-.525 1.283t-1.283.525H4.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283M4 8.404h16V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212zm0 3.192v6.096q0 .116.096.212a.3.3 0 0 0 .212.096h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-6.096z"
  }
));
var Card_default = SvgCard;

// src/icons/components/CaretDown.tsx
import * as React26 from "react";
var SvgCaretDown = (props) => /* @__PURE__ */ React26.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React26.createElement("path", { fill: "currentColor", d: "M12 15.054 6.346 9.4 7.4 8.346l4.6 4.6 4.6-4.6L17.654 9.4z" }));
var CaretDown_default = SvgCaretDown;

// src/icons/components/CaretLeft.tsx
import * as React27 from "react";
var SvgCaretLeft = (props) => /* @__PURE__ */ React27.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React27.createElement("path", { fill: "currentColor", d: "M14 17.654 8.346 12 14 6.346 15.054 7.4l-4.6 4.6 4.6 4.6z" }));
var CaretLeft_default = SvgCaretLeft;

// src/icons/components/CaretRight.tsx
import * as React28 from "react";
var SvgCaretRight = (props) => /* @__PURE__ */ React28.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React28.createElement("path", { fill: "currentColor", d: "m12.946 12-4.6-4.6L9.4 6.346 15.054 12 9.4 17.654 8.346 16.6z" }));
var CaretRight_default = SvgCaretRight;

// src/icons/components/CaretUp.tsx
import * as React29 from "react";
var SvgCaretUp = (props) => /* @__PURE__ */ React29.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React29.createElement("path", { fill: "currentColor", d: "m12 10.454-4.6 4.6L6.346 14 12 8.346 17.654 14 16.6 15.054z" }));
var CaretUp_default = SvgCaretUp;

// src/icons/components/Cash.tsx
import * as React30 from "react";
var SvgCash = (props) => /* @__PURE__ */ React30.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React30.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.75 12.712q-1.048 0-1.774-.726a2.41 2.41 0 0 1-.726-1.774q0-1.049.726-1.774a2.41 2.41 0 0 1 1.774-.726q1.048 0 1.774.726c.726.726.726 1.075.726 1.774q0 1.048-.726 1.774a2.41 2.41 0 0 1-1.774.726m-6.596 3.096a1.74 1.74 0 0 1-1.277-.531A1.74 1.74 0 0 1 5.347 14V6.423q0-.746.53-1.277a1.74 1.74 0 0 1 1.277-.53h13.192q.746 0 1.277.53.53.531.53 1.277V14q0 .746-.53 1.277a1.74 1.74 0 0 1-1.277.53H7.154Zm1.5-1.5h10.192q0-.748.531-1.278t1.277-.53V7.923a1.74 1.74 0 0 1-1.278-.53 1.74 1.74 0 0 1-.53-1.278H8.654q0 .75-.531 1.278a1.74 1.74 0 0 1-1.277.53V12.5q.748 0 1.278.531t.53 1.277m10.519 5H3.653a1.74 1.74 0 0 1-1.276-.531 1.74 1.74 0 0 1-.53-1.277V7.596h1.5V17.5q0 .116.095.212a.3.3 0 0 0 .212.096h15.519zm-12.02-5h-.307V6.115h.308a.3.3 0 0 0-.217.092.3.3 0 0 0-.09.216V14q0 .124.09.216a.3.3 0 0 0 .217.092Z"
  }
));
var Cash_default = SvgCash;

// src/icons/components/CharityHand.tsx
import * as React31 from "react";
var SvgCharityHand = (props) => /* @__PURE__ */ React31.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React31.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.846 12.692 11.89 8.863a7 7 0 0 1-1.207-1.54 3.64 3.64 0 0 1-.49-1.85q0-1.239.868-2.106a2.87 2.87 0 0 1 2.105-.867q.81 0 1.496.39t1.185.995a4.3 4.3 0 0 1 1.186-.995 2.97 2.97 0 0 1 1.495-.39q1.239 0 2.106.867t.867 2.106a3.7 3.7 0 0 1-.482 1.85 6.8 6.8 0 0 1-1.199 1.54l-3.973 3.83Zm0-2.088 2.86-2.771q.504-.495.899-1.075C20 6.178 20 5.942 20 5.473q0-.617-.428-1.045A1.42 1.42 0 0 0 18.527 4a1.6 1.6 0 0 0-.87.248 2.8 2.8 0 0 0-.695.629l-1.116 1.358-1.115-1.358a2.8 2.8 0 0 0-.696-.629 1.6 1.6 0 0 0-.87-.248q-.617 0-1.045.428a1.42 1.42 0 0 0-.428 1.045q0 .705.396 1.285.395.58.899 1.075l2.86 2.77Zm-9.144 7.973 7.258 2.054 5.969-1.85a.87.87 0 0 0-.317-.522.88.88 0 0 0-.544-.182H14.17q-.654 0-1.112-.05a4.2 4.2 0 0 1-.94-.22l-2.258-.745.444-1.47 2.025.704a4.6 4.6 0 0 0 1.048.21q.594.055 1.69.071a1.2 1.2 0 0 0-.167-.64.83.83 0 0 0-.44-.364l-5.802-2.13a.3.3 0 0 0-.106-.02h-1.85zm-5 2.923v-9.577h6.839q.157 0 .319.035.16.035.3.08l5.827 2.147q.68.252 1.13.891.45.64.45 1.501h2.5q1.077 0 1.755.695t.678 1.805v.808l-7.49 2.326-7.308-2.084V21.5zm1.5-1.5h2v-6.577h-2z"
  }
));
var CharityHand_default = SvgCharityHand;

// src/icons/components/Charity.tsx
import * as React32 from "react";
var SvgCharity = (props) => /* @__PURE__ */ React32.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React32.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.846 12.692 11.89 8.863a7 7 0 0 1-1.207-1.54 3.64 3.64 0 0 1-.49-1.85q0-1.239.868-2.106a2.87 2.87 0 0 1 2.105-.867q.81 0 1.496.39t1.185.995a4.3 4.3 0 0 1 1.186-.995 2.97 2.97 0 0 1 1.495-.39q1.239 0 2.106.867t.867 2.106a3.7 3.7 0 0 1-.482 1.85 6.8 6.8 0 0 1-1.199 1.54l-3.973 3.83Zm0-2.088 2.86-2.771q.504-.495.899-1.075C20 6.178 20 5.942 20 5.473q0-.617-.428-1.045A1.42 1.42 0 0 0 18.527 4a1.6 1.6 0 0 0-.87.248 2.8 2.8 0 0 0-.695.629l-1.116 1.358-1.115-1.358a2.8 2.8 0 0 0-.696-.629 1.6 1.6 0 0 0-.87-.248q-.617 0-1.045.428a1.42 1.42 0 0 0-.428 1.045q0 .705.396 1.285.395.58.899 1.075l2.86 2.77Zm-9.144 7.973 7.258 2.054 5.969-1.85a.87.87 0 0 0-.317-.522.88.88 0 0 0-.544-.182H14.17q-.654 0-1.112-.05a4.2 4.2 0 0 1-.94-.22l-2.258-.745.444-1.47 2.025.704a4.6 4.6 0 0 0 1.048.21q.594.055 1.69.071a1.2 1.2 0 0 0-.167-.64.83.83 0 0 0-.44-.364l-5.802-2.13a.3.3 0 0 0-.106-.02h-1.85zm-5 2.923v-9.577h6.839q.157 0 .319.035.16.035.3.08l5.827 2.147q.68.252 1.13.891.45.64.45 1.501h2.5q1.077 0 1.755.695t.678 1.805v.808l-7.49 2.326-7.308-2.084V21.5zm1.5-1.5h2v-6.577h-2z"
  }
));
var Charity_default = SvgCharity;

// src/icons/components/Chat.tsx
import * as React33 from "react";
var SvgChat = (props) => /* @__PURE__ */ React33.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React33.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 10.885a.85.85 0 0 0 .626-.26.85.85 0 0 0 .259-.625.85.85 0 0 0-.26-.626A.85.85 0 0 0 8 9.115a.85.85 0 0 0-.626.259.85.85 0 0 0-.259.626q0 .368.259.626a.85.85 0 0 0 .626.259m4 0a.85.85 0 0 0 .626-.26.85.85 0 0 0 .259-.625.85.85 0 0 0-.26-.626.85.85 0 0 0-.625-.259.85.85 0 0 0-.626.259.85.85 0 0 0-.259.626q0 .368.259.626a.85.85 0 0 0 .626.259m4 0a.85.85 0 0 0 .626-.26.85.85 0 0 0 .259-.625.85.85 0 0 0-.26-.626.85.85 0 0 0-.625-.259.85.85 0 0 0-.626.259.85.85 0 0 0-.259.626q0 .368.259.626a.85.85 0 0 0 .626.259M2.5 21.038V4.308q0-.758.525-1.283T4.308 2.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525H6.038zM5.4 16h14.292a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.077z"
  }
));
var Chat_default = SvgChat;

// src/icons/components/CheckBack.tsx
import * as React34 from "react";
var SvgCheckBack = (props) => /* @__PURE__ */ React34.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React34.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.5 5.5h19v13h-19zM20 17V7H4v10z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fill: "currentColor", d: "M17.75 14.75v-5.5H16v5.5z" }));
var CheckBack_default = SvgCheckBack;

// src/icons/components/CheckFrontSignature.tsx
import * as React35 from "react";
var SvgCheckFrontSignature = (props) => /* @__PURE__ */ React35.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React35.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.25 14.75h7.644l1.5-1.5H6.25zm0-4h5.5v-1.5h-5.5zM4 7v10h7.644l-1.5 1.5H2.5v-13h19v3.144H20V7zm18.227 5.127a.36.36 0 0 1 .115.256.36.36 0 0 1-.115.255l-.842.843-1.27-1.27.843-.842a.36.36 0 0 1 .255-.115q.142 0 .256.115zm-9.073 8.335v-1.27l6.38-6.38 1.27 1.269-6.381 6.38h-1.27Z"
  }
));
var CheckFrontSignature_default = SvgCheckFrontSignature;

// src/icons/components/CheckFront.tsx
import * as React36 from "react";
var SvgCheckFront = (props) => /* @__PURE__ */ React36.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React36.createElement("path", { fill: "currentColor", d: "M11.75 10.75h-5.5v-1.5h5.5zm-5.5 4v-1.5h11.5v1.5z" }), /* @__PURE__ */ React36.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.5 5.5h-19v13h19zM4 17V7h16v10z", clipRule: "evenodd" }));
var CheckFront_default = SvgCheckFront;

// src/icons/components/CheckmarkCircleFilled.tsx
import * as React37 from "react";
var SvgCheckmarkCircleFilled = (props) => /* @__PURE__ */ React37.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React37.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m10.58 16.254 6.724-6.723-1.054-1.054-5.67 5.67-2.85-2.85-1.053 1.053 3.904 3.904Zm1.422 5.246a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749"
  }
));
var CheckmarkCircleFilled_default = SvgCheckmarkCircleFilled;

// src/icons/components/CheckmarkCircle.tsx
import * as React38 from "react";
var SvgCheckmarkCircle = (props) => /* @__PURE__ */ React38.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React38.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m10.58 16.254 6.724-6.723-1.054-1.054-5.67 5.67-2.85-2.85-1.053 1.053 3.904 3.904Zm1.422 5.246a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var CheckmarkCircle_default = SvgCheckmarkCircle;

// src/icons/components/Checkmark.tsx
import * as React39 from "react";
var SvgCheckmark = (props) => /* @__PURE__ */ React39.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React39.createElement("path", { fill: "currentColor", d: "m9.55 17.654-5.335-5.335 1.07-1.069 4.265 4.265 9.165-9.165 1.07 1.07L9.55 17.653Z" }));
var Checkmark_default = SvgCheckmark;

// src/icons/components/Children.tsx
import * as React40 from "react";
var SvgChildren = (props) => /* @__PURE__ */ React40.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React40.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.365 21.173q-.705 0-1.209-.503a1.65 1.65 0 0 1-.502-1.209q0-.705.502-1.208a1.65 1.65 0 0 1 1.21-.503q.705 0 1.208.503.503.502.503 1.209 0 .705-.503 1.208a1.65 1.65 0 0 1-1.209.503m-8.884 0q-.7 0-1.206-.503a1.64 1.64 0 0 1-.506-1.209q0-.705.506-1.208a1.65 1.65 0 0 1 1.206-.503q.718 0 1.215.503.495.502.496 1.209 0 .705-.496 1.208t-1.215.503m2.59-5.923h5.198a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V8.8zm-1.646 1.5q-.485 0-.681-.43-.196-.432.123-.807L15.97 4.838a3.25 3.25 0 0 1 1.026-.817q.555-.27 1.222-.271 1.14 0 1.928.787.787.788.787 1.932v.53h-1.5v-.534q0-.518-.348-.866a1.18 1.18 0 0 0-.867-.349q-.327 0-.581.124a1.5 1.5 0 0 0-.467.363l-1.092 1.26v7.942q0 .752-.531 1.281-.531.53-1.277.53zm2.492-7.121L5.533 5.244a8.4 8.4 0 0 1 2.255-1.119 8.1 8.1 0 0 1 2.471-.375q1.01 0 1.977.227a9.2 9.2 0 0 1 1.92.69L9.916 9.63Zm-.096-2.21 1.73-2.023a6 6 0 0 0-1.292-.146q-.576 0-1.12.099a7 7 0 0 0-1.087.291L9.82 7.42Z"
  }
));
var Children_default = SvgChildren;

// src/icons/components/Circle.tsx
import * as React41 from "react";
var SvgCircle = (props) => /* @__PURE__ */ React41.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React41.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var Circle_default = SvgCircle;

// src/icons/components/Clock.tsx
import * as React42 from "react";
var SvgClock = (props) => /* @__PURE__ */ React42.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React42.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m15.473 16.527 1.054-1.054-3.777-3.777V7h-1.5v5.304zM12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.325 0 5.663-2.337Q19.999 15.325 20 12c.001-3.325-.78-4.104-2.337-5.663Q15.325 4.001 12 4c-3.325-.001-4.104.78-5.663 2.337Q4.001 8.675 4 12c-.001 3.325.78 4.104 2.337 5.663Q8.675 19.999 12 20"
  }
));
var Clock_default = SvgClock;

// src/icons/components/Compass.tsx
import * as React43 from "react";
var SvgCompass = (props) => /* @__PURE__ */ React43.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React43.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m6.827 17.173 6.904-3.442 3.442-6.904-6.904 3.442zM12 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12q0-.424.287-.713A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.713A.97.97 0 0 1 12 13m.002 8.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var Compass_default = SvgCompass;

// src/icons/components/Copy.tsx
import * as React44 from "react";
var SvgCopy = (props) => /* @__PURE__ */ React44.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React44.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.058 17.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T9.058 2.5h8.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h8.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H9.058a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096m-3.5 5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308h1.5v12.884q0 .116.096.212a.3.3 0 0 0 .212.096h9.884V21z"
  }
));
var Copy_default = SvgCopy;

// src/icons/components/DepositCheck.tsx
import * as React45 from "react";
var SvgDepositCheck = (props) => /* @__PURE__ */ React45.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React45.createElement("path", { fill: "currentColor", d: "M21.5 1.5h-19v13H9V13H4V3h16v10h-5v1.5h6.5z" }), /* @__PURE__ */ React45.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.75 6.75h-5.5v-1.5h5.5zm-5.5 4h11.5v-1.5H6.25zm2.535 7.185L7.73 19.019 12 23.29l4.27-4.27-1.055-1.084L12.75 20.4V13h-1.5v7.4z"
  }
));
var DepositCheck_default = SvgDepositCheck;

// src/icons/components/Deposit.tsx
import * as React46 from "react";
var SvgDeposit = (props) => /* @__PURE__ */ React46.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React46.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.99 20.5V19h6.702a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H11.99V3.5h6.702q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm-1.355-4.23-1.039-1.085 2.435-2.435H3.5v-1.5h8.53L9.597 8.815l1.039-1.084L14.904 12z"
  }
));
var Deposit_default = SvgDeposit;

// src/icons/components/Dining.tsx
import * as React47 from "react";
var SvgDining = (props) => /* @__PURE__ */ React47.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React47.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.25 21.75v-9.092a3.67 3.67 0 0 1-2.051-1.232q-.834-.969-.834-2.31V2.25h1.5v6.865H7.25V2.25h1.5v6.865h1.384V2.25h1.5v6.865q0 1.342-.833 2.31a3.67 3.67 0 0 1-2.051 1.233v9.092zm9.615 0v-8h-2.73V7q0-1.873 1.202-3.249 1.203-1.376 3.028-1.482V21.75z"
  }
));
var Dining_default = SvgDining;

// src/icons/components/DirectDeposit.tsx
import * as React48 from "react";
var SvgDirectDeposit = (props) => /* @__PURE__ */ React48.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React48.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.99 20.5V19h6.702a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H11.99V3.5h6.702q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm-1.355-4.23-1.039-1.085 2.435-2.435H3.5v-1.5h8.53L9.597 8.815l1.039-1.084L14.904 12z"
  }
));
var DirectDeposit_default = SvgDirectDeposit;

// src/icons/components/DocumentComplete.tsx
import * as React49 from "react";
var SvgDocumentComplete = (props) => /* @__PURE__ */ React49.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React49.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m10.95 17.433 5.304-5.304-1.085-1.085-4.234 4.235-2.12-2.12-1.069 1.07zM6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.942l5.25 5.25v11.942q0 .758-.525 1.283t-1.283.525zm7.192-13V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5z"
  }
));
var DocumentComplete_default = SvgDocumentComplete;

// src/icons/components/DocumentPlus.tsx
import * as React50 from "react";
var SvgDocumentPlus = (props) => /* @__PURE__ */ React50.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React50.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 17.75h1.5v-3h3v-1.5h-3v-3h-1.5v3h-3v1.5h3zM6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.942l5.25 5.25v11.942q0 .758-.525 1.283t-1.283.525zm7.192-13V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5z"
  }
));
var DocumentPlus_default = SvgDocumentPlus;

// src/icons/components/DocumentPopulated.tsx
import * as React51 from "react";
var SvgDocumentPopulated = (props) => /* @__PURE__ */ React51.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React51.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.25 17.75h7.5v-1.5h-7.5zm0-4h7.5v-1.5h-7.5zM6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.942l5.25 5.25v11.942q0 .758-.525 1.283t-1.283.525zm7.192-13V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5z"
  }
));
var DocumentPopulated_default = SvgDocumentPopulated;

// src/icons/components/DocumentReview.tsx
import * as React52 from "react";
var SvgDocumentReview = (props) => /* @__PURE__ */ React52.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React52.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5 4v6.179-.025V20zm2.25 9.75h3.548q.187-.43.435-.801.248-.37.557-.699H7.25zm0 4h3.03a4.8 4.8 0 0 1-.111-1.5H7.25zM5.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T5.308 2.5h7.942l5.25 5.25v2.76a4 4 0 0 0-.735-.217A8 8 0 0 0 17 10.18V8.5h-4.5V4.001H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h5.9q.294.446.66.824.364.378.792.676H5.308ZM16.5 19.154q1.117 0 1.886-.768.768-.769.768-1.886t-.768-1.886-1.886-.768-1.886.768q-.768.769-.768 1.886t.768 1.886q.769.768 1.886.768m5.1 3.49-2.739-2.738a3.8 3.8 0 0 1-1.108.558q-.603.19-1.253.19-1.731 0-2.942-1.212-1.212-1.21-1.212-2.942 0-1.731 1.212-2.942 1.21-1.212 2.942-1.212 1.731 0 2.942 1.212 1.212 1.21 1.212 2.942 0 .649-.19 1.253a3.8 3.8 0 0 1-.558 1.108l2.738 2.739z"
  }
));
var DocumentReview_default = SvgDocumentReview;

// src/icons/components/Document.tsx
import * as React53 from "react";
var SvgDocument = (props) => /* @__PURE__ */ React53.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React53.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.942l5.25 5.25v11.942q0 .758-.525 1.283t-1.283.525zm7.192-13V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5z"
  }
));
var Document_default = SvgDocument;

// src/icons/components/Documents.tsx
import * as React54 from "react";
var SvgDocuments = (props) => /* @__PURE__ */ React54.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React54.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M18.692 18.5H8.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V3.308q0-.758.525-1.283T8.308 1.5h6.942l5.25 5.25v9.942q0 .758-.525 1.283t-1.283.525M14.5 7.5V3H8.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h10.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V7.5zm-10.192 15q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V7.5H4v13.192q0 .116.096.212a.3.3 0 0 0 .212.096H14.5v1.5z"
  }
));
var Documents_default = SvgDocuments;

// src/icons/components/DollarCircle.tsx
import * as React55 from "react";
var SvgDollarCircle = (props) => /* @__PURE__ */ React55.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React55.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.292 18.808h1.366v-1.212a4.4 4.4 0 0 0 2.106-.874q.945-.717.944-2.172 0-1.05-.62-1.858-.619-.807-2.419-1.457-1.577-.54-2.094-.933-.517-.394-.517-1.102t.53-1.15 1.462-.442q.78 0 1.26.368.478.367.736.924l1.235-.496a3.26 3.26 0 0 0-1.022-1.367 2.8 2.8 0 0 0-1.551-.633V5.192h-1.366v1.212q-1.278.246-1.964 1.037-.686.792-.686 1.759 0 1.127.683 1.813.683.688 2.225 1.24 1.595.585 2.178 1.05t.583 1.247q0 .94-.678 1.366a2.8 2.8 0 0 1-1.533.426 2.43 2.43 0 0 1-1.51-.507q-.667-.508-1.025-1.485l-1.265.515q.389 1.114 1.116 1.77.729.655 1.826.911zM12 21.5a9.2 9.2 0 0 1-3.703-.75 9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.017A9.2 9.2 0 0 1 2.5 12q0-1.97.749-3.703a9.6 9.6 0 0 1 2.032-3.016 9.6 9.6 0 0 1 3.016-2.032A9.2 9.2 0 0 1 12 2.5q1.97 0 3.703.749a9.6 9.6 0 0 1 3.016 2.032 9.6 9.6 0 0 1 2.032 3.016q.75 1.734.749 3.703 0 1.97-.75 3.703a9.6 9.6 0 0 1-2.03 3.016 9.6 9.6 0 0 1-3.017 2.032q-1.734.75-3.703.749m0-1.5q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var DollarCircle_default = SvgDollarCircle;

// src/icons/components/Dollar.tsx
import * as React56 from "react";
var SvgDollar = (props) => /* @__PURE__ */ React56.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React56.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.256 20.75v-2.092q-1.305-.233-2.25-1.02-.942-.789-1.393-2.203l1.389-.577q.404 1.16 1.15 1.777.748.615 1.996.615 1.083 0 1.91-.515.828-.516.828-1.635 0-.97-.622-1.551-.621-.58-2.574-1.21-2.045-.646-2.84-1.512T8.056 8.65q0-1.509 1.06-2.376 1.06-.866 2.14-.962V3.25h1.5v2.062q1.143.15 1.923.744a3.96 3.96 0 0 1 1.211 1.54l-1.369.627q-.33-.723-.917-1.123-.59-.4-1.548-.4-1.13 0-1.815.55t-.685 1.4q0 .873.702 1.396.7.523 2.61 1.096 1.772.539 2.645 1.535t.873 2.392q0 1.641-1.054 2.546-1.055.906-2.576 1.073v2.062z"
  }
));
var Dollar_default = SvgDollar;

// src/icons/components/Donut.tsx
import * as React57 from "react";
var SvgDonut = (props) => /* @__PURE__ */ React57.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React57.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2.55a9.1 9.1 0 0 0-2.706.698A9.6 9.6 0 0 0 5.278 5.28a9.6 9.6 0 0 0-2.03 3.017 9.3 9.3 0 0 0-.748 3.705q0 1.97.748 3.704a9.6 9.6 0 0 0 2.031 3.016 9.6 9.6 0 0 0 3.018 2.03q1.285.555 2.703.698v-1.504q-2.706-.301-4.675-2.271Q4 15.35 4 12t2.325-5.675q1.97-1.97 4.675-2.27zm2 1.504V2.55a9.1 9.1 0 0 1 2.703.698 9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016q.556 1.287.7 2.706h-1.505q-.301-2.706-2.271-4.675-1.97-1.97-4.675-2.27Zm0 15.892q2.705-.301 4.675-2.271T19.945 13h1.505a9.1 9.1 0 0 1-.698 2.703 9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.1 9.1 0 0 1-2.706.7z",
    clipRule: "evenodd"
  }
));
var Donut_default = SvgDonut;

// src/icons/components/DownArrowSmall.tsx
import * as React58 from "react";
var SvgDownArrowSmall = (props) => /* @__PURE__ */ React58.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React58.createElement("path", { fill: "currentColor", d: "M12 17.654 6.346 12 7.4 10.946l3.85 3.85V5.25h1.5v9.546l3.85-3.85L17.654 12z" }));
var DownArrowSmall_default = SvgDownArrowSmall;

// src/icons/components/DownArrow.tsx
import * as React59 from "react";
var SvgDownArrow = (props) => /* @__PURE__ */ React59.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React59.createElement("path", { fill: "currentColor", d: "M11.25 4.5v12.127L5.554 10.93 4.5 12l7.5 7.5 7.5-7.5-1.054-1.07-5.696 5.697V4.5z" }));
var DownArrow_default = SvgDownArrow;

// src/icons/components/Download.tsx
import * as React60 from "react";
var SvgDownload = (props) => /* @__PURE__ */ React60.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React60.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 15.788 7.73 11.52l1.055-1.084L11.25 12.9V4.5h1.5v8.4l2.465-2.465 1.054 1.084L12 15.79ZM6.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283v-2.711H6v2.711q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-2.711h1.5v2.711q0 .758-.525 1.283t-1.283.525z"
  }
));
var Download_default = SvgDownload;

// src/icons/components/DragIndicator.tsx
import * as React61 from "react";
var SvgDragIndicator = (props) => /* @__PURE__ */ React61.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React61.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9 19.615q-.666 0-1.14-.474A1.56 1.56 0 0 1 7.384 18q0-.666.474-1.14A1.56 1.56 0 0 1 9 16.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14A1.56 1.56 0 0 1 9 19.616Zm6 0q-.666 0-1.14-.474A1.56 1.56 0 0 1 13.384 18q0-.666.474-1.14A1.56 1.56 0 0 1 15 16.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14a1.56 1.56 0 0 1-1.141.475Zm-6-6q-.666 0-1.14-.474A1.56 1.56 0 0 1 7.384 12q0-.666.474-1.14A1.56 1.56 0 0 1 9 10.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14A1.56 1.56 0 0 1 9 13.616Zm6 0q-.666 0-1.14-.474A1.56 1.56 0 0 1 13.384 12q0-.666.474-1.14A1.56 1.56 0 0 1 15 10.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14a1.56 1.56 0 0 1-1.141.475Zm-6-6q-.666 0-1.14-.474A1.56 1.56 0 0 1 7.384 6q0-.666.474-1.14A1.56 1.56 0 0 1 9 4.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14A1.56 1.56 0 0 1 9 7.616Zm6 0q-.666 0-1.14-.474A1.56 1.56 0 0 1 13.384 6q0-.666.474-1.14A1.56 1.56 0 0 1 15 4.384q.666 0 1.14.474.475.475.475 1.141t-.474 1.14A1.56 1.56 0 0 1 15 7.616Z"
  }
));
var DragIndicator_default = SvgDragIndicator;

// src/icons/components/Edit.tsx
import * as React62 from "react";
var SvgEdit = (props) => /* @__PURE__ */ React62.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React62.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5 19h1.261L16.498 8.763l-1.261-1.261L5 17.738zm-1.5 1.5v-3.385L16.69 3.931a1.7 1.7 0 0 1 .501-.319 1.5 1.5 0 0 1 .575-.112q.3 0 .583.107.282.106.499.34l1.221 1.236q.233.217.332.5.099.282.099.565 0 .301-.103.576t-.328.501L6.885 20.5zM15.856 8.144l-.62-.642 1.262 1.261z"
  }
));
var Edit_default = SvgEdit;

// src/icons/components/Education.tsx
import * as React63 from "react";
var SvgEducation = (props) => /* @__PURE__ */ React63.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React63.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h11.384q.758 0 1.283.525t.525 1.283v15.384q0 .758-.525 1.283t-1.283.525zm0-1.5h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H16v6.558L13.75 9.21l-2.25 1.347V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Education_default = SvgEducation;

// src/icons/components/Ellipses.tsx
import * as React64 from "react";
var SvgEllipses = (props) => /* @__PURE__ */ React64.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React64.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.23 13.5q-.618 0-1.058-.44A1.44 1.44 0 0 1 4.73 12q0-.619.44-1.06.44-.44 1.06-.44.618 0 1.06.44.44.441.44 1.06t-.44 1.06a1.45 1.45 0 0 1-1.06.44m5.77 0a1.45 1.45 0 0 1-1.06-.44A1.44 1.44 0 0 1 10.5 12q0-.619.44-1.06A1.45 1.45 0 0 1 12 10.5q.62 0 1.06.44.44.441.44 1.06t-.44 1.06q-.44.44-1.06.44m5.77 0q-.62 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.619.44-1.06.44-.44 1.06-.44.618 0 1.059.44.44.441.44 1.06t-.44 1.06q-.44.44-1.06.44Z"
  }
));
var Ellipses_default = SvgEllipses;

// src/icons/components/ExclamationCircle.tsx
import * as React65 from "react";
var SvgExclamationCircle = (props) => /* @__PURE__ */ React65.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React65.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 16.73a.78.78 0 0 0 .575-.232.78.78 0 0 0 .233-.575.78.78 0 0 0-.232-.575.78.78 0 0 0-.576-.233.78.78 0 0 0-.575.233.78.78 0 0 0-.233.575q0 .343.232.575a.78.78 0 0 0 .576.233Zm-.75-3.653h1.5v-6h-1.5zm.752 8.423a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var ExclamationCircle_default = SvgExclamationCircle;

// src/icons/components/Exclamation.tsx
import * as React66 from "react";
var SvgExclamation = (props) => /* @__PURE__ */ React66.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React66.createElement("path", { fill: "currentColor", d: "M11.25 14.039v-8.5h1.5v8.5zm0 4.423v-1.5h1.5v1.5z" }));
var Exclamation_default = SvgExclamation;

// src/icons/components/Exit.tsx
import * as React67 from "react";
var SvgExit = (props) => /* @__PURE__ */ React67.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React67.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h6.702V5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h6.702v1.5zm10.923-4.23-1.039-1.085 2.435-2.435h-8.53v-1.5h8.53l-2.435-2.435 1.039-1.084L20.5 12l-4.27 4.27Z"
  }
));
var Exit_default = SvgExit;

// src/icons/components/EyeCrossout.tsx
import * as React68 from "react";
var SvgEyeCrossout = (props) => /* @__PURE__ */ React68.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React68.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.773 12.973 14.65 11.85q.225-1.242-.709-2.234-.934-.99-2.29-.766l-1.124-1.123A3.45 3.45 0 0 1 12 7.423q1.702 0 2.89 1.188 1.187 1.186 1.187 2.889 0 .423-.076.788t-.228.685m3.18 3.111L17.85 15.05a11 11 0 0 0 1.688-1.588A9 9 0 0 0 20.8 11.5a9.85 9.85 0 0 0-3.587-4.013Q14.875 6 12 6q-.724 0-1.425.1a10 10 0 0 0-1.375.3L8.035 5.235a10 10 0 0 1 1.936-.556q.989-.18 2.03-.18 3.514.001 6.34 1.94 2.824 1.938 4.12 5.06a11.3 11.3 0 0 1-1.435 2.503 11 11 0 0 1-2.072 2.082Zm.809 5.785-4.046-4.015a11 11 0 0 1-1.705.465 10.6 10.6 0 0 1-2.01.18q-3.525 0-6.341-1.938-2.815-1.938-4.121-5.061a11 11 0 0 1 1.43-2.472A11.4 11.4 0 0 1 4.9 7.038l-2.77-2.8 1.055-1.053 17.63 17.63zM5.954 8.092A11 11 0 0 0 4.413 9.61 8.3 8.3 0 0 0 3.2 11.5q1.25 2.526 3.588 4.013T12 17a8 8 0 0 0 1.36-.116 14 14 0 0 0 1.148-.238l-1.266-1.296a3.6 3.6 0 0 1-1.242.227q-1.701 0-2.89-1.188-1.187-1.187-1.187-2.89 0-.303.062-.635.06-.33.165-.606z"
  }
));
var EyeCrossout_default = SvgEyeCrossout;

// src/icons/components/Eye.tsx
import * as React69 from "react";
var SvgEye = (props) => /* @__PURE__ */ React69.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React69.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 15.577q1.7 0 2.887-1.19t1.188-2.89q0-1.699-1.19-2.886t-2.89-1.188q-1.699 0-2.886 1.19t-1.188 2.89q0 1.699 1.19 2.886t2.89 1.188ZM12 14.2q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.788-1.913A2.6 2.6 0 0 1 12 8.8q1.125 0 1.913.787.787.789.787 1.913c0 1.124-.262 1.387-.787 1.912A2.6 2.6 0 0 1 12 14.2m.001 4.3q-3.449 0-6.286-1.903T1.539 11.5q1.34-3.195 4.175-5.097T12 4.5q3.45 0 6.286 1.903 2.836 1.902 4.177 5.097-1.341 3.195-4.176 5.097T12.002 18.5Zm0-1.5a9.55 9.55 0 0 0 5.187-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.612-4.013A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.187 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.613 4.012A9.55 9.55 0 0 0 12 17Z"
  }
));
var Eye_default = SvgEye;

// src/icons/components/Filter.tsx
import * as React70 from "react";
var SvgFilter = (props) => /* @__PURE__ */ React70.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React70.createElement("path", { fill: "currentColor", d: "M10.279 17.5V16h3.432v1.5zm-3.875-4.75v-1.5h11.183v1.5zM3.5 8V6.5h17V8z" }));
var Filter_default = SvgFilter;

// src/icons/components/Fitness.tsx
import * as React71 from "react";
var SvgFitness = (props) => /* @__PURE__ */ React71.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React71.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m20.025 9.375-1.044-1.044.615-.64a.3.3 0 0 0 .096-.217.3.3 0 0 0-.096-.216l-2.854-2.854a.3.3 0 0 0-.216-.096.3.3 0 0 0-.216.096l-.64.615L14.6 3.95l.654-.679a1.66 1.66 0 0 1 1.252-.495q.744.013 1.252.52l2.946 2.946q.508.508.508 1.24c0 .732-.17.9-.508 1.24zM8.746 20.679a1.69 1.69 0 0 1-1.24.507q-.73 0-1.239-.507L3.36 17.77a1.74 1.74 0 0 1-.518-1.278q0-.76.518-1.278l.615-.615 1.07 1.07-.631.615a.3.3 0 0 0-.097.216q0 .12.097.216l2.869 2.87a.3.3 0 0 0 .216.096q.12 0 .217-.096l.615-.631 1.07 1.069zm9.83-7.602 1.28-1.28a.304.304 0 0 0 0-.443l-7.21-7.21a.304.304 0 0 0-.442 0l-1.28 1.281a.3.3 0 0 0-.097.216.3.3 0 0 0 .096.217l7.22 7.219a.3.3 0 0 0 .216.096q.12 0 .216-.096Zm-6.78 6.779 1.281-1.296a.3.3 0 0 0 .096-.217.3.3 0 0 0-.096-.216l-7.204-7.204a.3.3 0 0 0-.216-.096.3.3 0 0 0-.217.096l-1.296 1.28a.304.304 0 0 0 0 .443l7.21 7.21a.304.304 0 0 0 .442 0m-.429-5.562 2.943-2.927-1.677-1.677-2.927 2.943zm1.489 6.616a1.74 1.74 0 0 1-1.28.517 1.74 1.74 0 0 1-1.282-.517l-7.203-7.204a1.74 1.74 0 0 1-.518-1.281q0-.764.518-1.28l1.28-1.291q.518-.517 1.278-.517c.76 0 .933.172 1.278.517l1.71 1.71 2.942-2.943-1.71-1.694q-.517-.517-.517-1.286 0-.768.517-1.285l1.29-1.29a1.74 1.74 0 0 1 1.279-.518q.76 0 1.277.517l7.22 7.22q.517.517.517 1.277 0 .762-.517 1.278l-1.29 1.29q-.518.518-1.286.518c-.768 0-.94-.172-1.286-.517l-1.694-1.71-2.942 2.942 1.71 1.71q.516.517.517 1.278 0 .76-.518 1.278l-1.29 1.28Z"
  }
));
var Fitness_default = SvgFitness;

// src/icons/components/FolderComplete.tsx
import * as React72 from "react";
var SvgFolderComplete = (props) => /* @__PURE__ */ React72.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React72.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h5.49l2 2h7.894q.758 0 1.283.525t.525 1.283v9.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V8.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-8.508l-2-2H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087Z"
  }
), /* @__PURE__ */ React72.createElement("path", { fill: "currentColor", d: "m16.254 10.9-5.304 5.303-3.188-3.188 1.069-1.07 2.119 2.12 4.235-4.235z" }));
var FolderComplete_default = SvgFolderComplete;

// src/icons/components/Folder.tsx
import * as React73 from "react";
var SvgFolder = (props) => /* @__PURE__ */ React73.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React73.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h5.49l2 2h7.894q.758 0 1.283.525t.525 1.283v9.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V8.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-8.508l-2-2H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087Z"
  }
));
var Folder_default = SvgFolder;

// src/icons/components/Fpo.tsx
import * as React74 from "react";
var SvgFpo = (props) => /* @__PURE__ */ React74.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React74.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.859 12c0 1.202.519 1.935 1.39 1.935.873 0 1.384-.725 1.384-1.935s-.511-1.935-1.383-1.935-1.391.725-1.391 1.935m-4.094-.17h-.825v-1.709h.825c.597 0 .935.314.935.855s-.346.855-.935.855Z"
  }
), /* @__PURE__ */ React74.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m8-10c0 1.847-1.076 3-2.75 3s-2.75-1.161-2.75-3c0-1.847 1.076-3 2.75-3S20 10.153 20 12M8.819 10.17V9.136H5v5.726h1.328v-2.355h2.35v-1.016h-2.35v-1.323h2.49Zm3.268-1.033H9.612v5.726h1.328v-2.08h1.116c1.257 0 2.035-.71 2.035-1.848 0-1.088-.794-1.798-2.004-1.798",
    clipRule: "evenodd"
  }
));
var Fpo_default = SvgFpo;

// src/icons/components/Fullscreen.tsx
import * as React75 from "react";
var SvgFullscreen = (props) => /* @__PURE__ */ React75.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React75.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.5 20.5V15H5v2.946l3.35-3.35 1.054 1.054L6.054 19H9v1.5zm11.5 0V19h2.946l-3.35-3.35 1.054-1.054 3.35 3.35V15h1.5v5.5zM8.35 9.404 5 6.054V9H3.5V3.5H9V5H6.054l3.35 3.35zm7.3 0L14.596 8.35 17.946 5H15V3.5h5.5V9H19V6.054z"
  }
));
var Fullscreen_default = SvgFullscreen;

// src/icons/components/GearCircle.tsx
import * as React76 from "react";
var SvgGearCircle = (props) => /* @__PURE__ */ React76.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React76.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
), /* @__PURE__ */ React76.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 12q-.002-.533-.14-1.021l1.095-.83-.75-1.299-1.267.535a3.75 3.75 0 0 0-1.768-1.021L12.75 7h-1.5l-.17 1.364a3.75 3.75 0 0 0-1.768 1.021l-1.267-.534-.75 1.299 1.096.83a3.75 3.75 0 0 0 0 2.04l-1.096.83.75 1.3 1.267-.535c.476.49 1.085.849 1.768 1.021L11.25 17h1.5l.17-1.364a3.75 3.75 0 0 0 1.768-1.021l1.267.535.75-1.3-1.096-.829A3.7 3.7 0 0 0 15.75 12M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
    clipRule: "evenodd"
  }
));
var GearCircle_default = SvgGearCircle;

// src/icons/components/Gear.tsx
import * as React77 from "react";
var SvgGear = (props) => /* @__PURE__ */ React77.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React77.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m9.692 21.5-.38-3.046a5.3 5.3 0 0 1-1.579-.896L4.912 18.75l-2.308-4 2.44-1.844a5 5 0 0 1-.049-.448 7 7 0 0 1 0-.882 7 7 0 0 1 .05-.482L2.603 9.25l2.308-3.98 2.811 1.182a6.4 6.4 0 0 1 .772-.524q.411-.237.807-.382l.39-3.046h4.616l.38 3.056q.45.163.815.381t.736.515l2.85-1.183 2.307 3.981-2.479 1.873q.054.243.059.453t.005.424a9 9 0 0 1-.01.414q-.01.21-.069.482l2.46 1.854-2.308 4-2.815-1.202a6.5 6.5 0 0 1-.758.524 4.6 4.6 0 0 1-.793.372l-.38 3.056zM11 20h1.966l.36-2.679a5.6 5.6 0 0 0 1.398-.568q.634-.369 1.222-.947l2.485 1.044.985-1.7-2.17-1.635q.125-.389.17-.761a6.3 6.3 0 0 0 0-1.508 4 4 0 0 0-.17-.742l2.189-1.654-.985-1.7-2.513 1.06a5.3 5.3 0 0 0-1.203-.948 5.2 5.2 0 0 0-1.418-.583L13 4h-1.985l-.33 2.67a5.2 5.2 0 0 0-1.414.553q-.648.374-1.236.962L5.55 7.15l-.985 1.7 2.16 1.61a3.7 3.7 0 0 0-.175.74 6.3 6.3 0 0 0 0 1.575q.05.375.165.74l-2.15 1.635.985 1.7 2.475-1.05q.57.585 1.217.958t1.433.573zm1.012-5q1.248 0 2.124-.876A2.9 2.9 0 0 0 15.012 12q0-1.248-.876-2.124A2.9 2.9 0 0 0 12.012 9q-1.264 0-2.132.876A2.9 2.9 0 0 0 9.012 12q0 1.248.868 2.124.869.876 2.132.876"
  }
));
var Gear_default = SvgGear;

// src/icons/components/Gears.tsx
import * as React78 from "react";
var SvgGears = (props) => /* @__PURE__ */ React78.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React78.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m6.1 11.442-.204-1.192a4 4 0 0 1-.726-.296 3.2 3.2 0 0 1-.643-.458l-1.152.412-.769-1.277.948-.808a3.17 3.17 0 0 1 0-1.646l-.948-.808.77-1.277 1.151.412a3.2 3.2 0 0 1 .643-.458q.34-.181.726-.296L6.1 2.558h1.5l.204 1.192q.387.116.726.296t.643.458l1.152-.412.77 1.277-.949.808a3.17 3.17 0 0 1 0 1.646l.948.808-.769 1.277-1.152-.412a3.2 3.2 0 0 1-.643.458q-.339.18-.726.296L7.6 11.442zm.75-2.365q.864 0 1.47-.607.607-.606.607-1.47c0-.864-.202-1.066-.607-1.47a2 2 0 0 0-1.47-.607q-.864 0-1.47.607A2 2 0 0 0 4.773 7q0 .864.607 1.47.606.607 1.47.607m8.354 12.932-.315-1.58a3.4 3.4 0 0 1-1.023-.387 3.7 3.7 0 0 1-.852-.684l-1.49.515-1.006-1.708 1.215-1.034a3.94 3.94 0 0 1 0-2.262l-1.216-1.034 1.006-1.708 1.49.515q.38-.41.853-.684a3.3 3.3 0 0 1 1.023-.387l.315-1.58h1.992l.316 1.58a3.3 3.3 0 0 1 1.023.387q.473.274.852.684l1.49-.515 1.006 1.707-1.216 1.035a3.95 3.95 0 0 1 0 2.262l1.216 1.034-1.006 1.708-1.49-.515a3.7 3.7 0 0 1-.852.684 3.4 3.4 0 0 1-1.023.387l-.316 1.58zM16.2 19q1.25.001 2.125-.874A2.9 2.9 0 0 0 19.2 16a2.9 2.9 0 0 0-.875-2.125A2.9 2.9 0 0 0 16.2 13q-1.25 0-2.125.875A2.9 2.9 0 0 0 13.2 16q0 1.25.875 2.125A2.9 2.9 0 0 0 16.2 19"
  }
));
var Gears_default = SvgGears;

// src/icons/components/Glitter.tsx
import * as React79 from "react";
var SvgGlitter = (props) => /* @__PURE__ */ React79.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React79.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.555 5.555 17.5 3l.945 2.555L21 6.5l-2.555.945L17.5 10l-.945-2.555L14 6.5zM17.5 14l-.945 2.555L14 17.5l2.555.945L17.5 21l.945-2.555L21 17.5l-2.555-.945zm-6.7-7.839 1.36 3.678 3.68 1.361L18 12l-2.161.8-3.678 1.36-1.361 3.68L10 20l-.8-2.161-1.36-3.678L4.16 12.8 2 12l2.161-.8L7.84 9.84 9.2 6.16 10 4zm.84 5.085 2.038.754-2.038.754-.647.24-.24.646L10 15.678l-.754-2.038-.24-.647-.646-.24L6.322 12l2.038-.754.647-.24.24-.646L10 8.322l.754 2.038.24.647z",
    clipRule: "evenodd"
  }
));
var Glitter_default = SvgGlitter;

// src/icons/components/Globe.tsx
import * as React80 from "react";
var SvgGlobe = (props) => /* @__PURE__ */ React80.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React80.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12a13 13 0 0 0-.025-.685 1.84 1.84 0 0 1-.603 1.152 1.76 1.76 0 0 1-1.218.456h-2.27q-.761 0-1.303-.542a1.78 1.78 0 0 1-.542-1.303v-.922h-3.693V8.31q0-.76.543-1.305a1.77 1.77 0 0 1 1.303-.544h.923v-.385q0-.652.395-1.08.394-.428.95-.597a8 8 0 0 0-1.196-.296A7.5 7.5 0 0 0 12 4Q8.65 4 6.325 6.325T4 12v.144q0 .067.01.145h4.74q1.535 0 2.613 1.078a3.55 3.55 0 0 1 1.08 2.61v.927h-2.77v2.74A7.7 7.7 0 0 0 12 20"
  }
));
var Globe_default = SvgGlobe;

// src/icons/components/Guidance.tsx
import * as React81 from "react";
var SvgGuidance = (props) => /* @__PURE__ */ React81.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React81.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9 20 3 3 3-3h4q.824 0 1.413-.587A1.93 1.93 0 0 0 21 18V4q0-.824-.587-1.413A1.93 1.93 0 0 0 19 2H5q-.824 0-1.413.587A1.93 1.93 0 0 0 3 4v14q0 .824.587 1.413.589.586 1.413.587zm8.029-9-3.45 1.55-1.55 3.45-1.55-3.45L7.029 11l3.45-1.55L12.029 6l1.55 3.45z",
    clipRule: "evenodd"
  }
));
var Guidance_default = SvgGuidance;

// src/icons/components/Hamburger.tsx
import * as React82 from "react";
var SvgHamburger = (props) => /* @__PURE__ */ React82.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React82.createElement("path", { fill: "currentColor", d: "M3.5 17.635v-1.5h17v1.5zm0-4.885v-1.5h17v1.5zm0-4.885v-1.5h17v1.5z" }));
var Hamburger_default = SvgHamburger;

// src/icons/components/Home.tsx
import * as React83 from "react";
var SvgHome = (props) => /* @__PURE__ */ React83.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React83.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6 19h3.346v-5.942h5.308V19H18v-9l-6-4.52L6 10zm-1.5 1.5V9.25L12 3.606l7.5 5.644V20.5h-6.346v-5.943h-2.308V20.5z"
  }
));
var Home_default = SvgHome;

// src/icons/components/Hsa.tsx
import * as React84 from "react";
var SvgHsa = (props) => /* @__PURE__ */ React84.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React84.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.482 21.5q-2.496 0-4.254-1.751t-1.757-4.25v-.545q-2.025-.264-3.387-1.806Q2.72 11.606 2.72 9.5V3.75h3v-1h1.5v3.5h-1.5v-1h-1.5V9.5q0 1.65 1.175 2.825T8.22 13.5c1.649 0 2.042-.392 2.825-1.175Q12.221 11.15 12.22 9.5V5.25h-1.5v1h-1.5v-3.5h1.5v1h3V9.5q0 2.106-1.362 3.648T8.97 14.954v.546q0 1.875 1.315 3.187Q11.6 20 13.48 20q1.875 0 3.187-1.313c1.312-1.313 1.313-1.937 1.313-3.187v-1.617a2.47 2.47 0 0 1-1.298-.907q-.51-.674-.51-1.534 0-1.065.746-1.811a2.47 2.47 0 0 1 1.813-.746q1.065 0 1.811.746.745.745.745 1.811 0 .86-.51 1.534a2.47 2.47 0 0 1-1.297.907V15.5q0 2.498-1.751 4.249t-4.248 1.75Zm5.249-9q.444 0 .75-.307.307-.307.307-.75 0-.445-.306-.752a1.02 1.02 0 0 0-.751-.306q-.444 0-.751.306a1.02 1.02 0 0 0-.307.751q0 .444.307.751t.75.307Z"
  }
));
var Hsa_default = SvgHsa;

// src/icons/components/Image.tsx
import * as React85 from "react";
var SvgImage = (props) => /* @__PURE__ */ React85.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React85.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h13.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096m1.442-2.25h10.577l-3.289-4.385-2.807 3.654-2-2.557zm1.75-7q.519 0 .885-.365.365-.366.365-.885c0-.519-.122-.641-.365-.885A1.2 1.2 0 0 0 8.5 7.25q-.519 0-.885.365a1.2 1.2 0 0 0-.365.885q0 .519.365.885.366.365.885.365"
  }
));
var Image_default = SvgImage;

// src/icons/components/InfoBox.tsx
import * as React86 from "react";
var SvgInfoBox = (props) => /* @__PURE__ */ React86.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React86.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.058 16.77a.86.86 0 0 0 .63-.255q.255-.255.254-.631a.86.86 0 0 0-.254-.63.86.86 0 0 0-.631-.254q-.375 0-.63.255a.86.86 0 0 0-.254.63q0 .377.255.63.255.255.63.254Zm0-3.885a.85.85 0 0 0 .63-.255q.255-.255.254-.63a.85.85 0 0 0-.254-.63.86.86 0 0 0-.631-.255q-.375 0-.63.255a.86.86 0 0 0-.254.63q0 .377.255.63.255.255.63.255m0-3.885a.85.85 0 0 0 .63-.255q.255-.255.254-.63a.86.86 0 0 0-.254-.63.86.86 0 0 0-.631-.254q-.375 0-.63.254a.86.86 0 0 0-.254.631q0 .375.255.63t.63.254m3.038 7.635h5.692v-1.5h-5.692zm0-3.885h5.692v-1.5h-5.692zm0-3.885h5.692v-1.5h-5.692zM5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h13.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var InfoBox_default = SvgInfoBox;

// src/icons/components/InfoCircle.tsx
import * as React87 from "react";
var SvgInfoCircle = (props) => /* @__PURE__ */ React87.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React87.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 16.75h1.5V11h-1.5zM12 9.288a.78.78 0 0 0 .575-.232.78.78 0 0 0 .233-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.576q0 .343.232.575a.78.78 0 0 0 .576.232m.002 12.212a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var InfoCircle_default = SvgInfoCircle;

// src/icons/components/InfoFilled.tsx
import * as React88 from "react";
var SvgInfoFilled = (props) => /* @__PURE__ */ React88.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React88.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 16.75h1.5V11h-1.5zM12 9.288a.78.78 0 0 0 .575-.232.78.78 0 0 0 .233-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.576q0 .343.232.575a.78.78 0 0 0 .576.232m.002 12.212a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749"
  }
));
var InfoFilled_default = SvgInfoFilled;

// src/icons/components/Inheritance.tsx
import * as React89 from "react";
var SvgInheritance = (props) => /* @__PURE__ */ React89.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React89.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.5 21.558v-1.5h5.75v-4.366H9q-1.873 0-3.187-1.313Q4.5 13.065 4.5 11.192q0-1.413.844-2.555a5.1 5.1 0 0 1 2.168-1.698q.215-1.923 1.469-3.085T12 2.692c1.765 0 2.183.388 3.02 1.162q1.253 1.16 1.468 3.085 1.334.536 2.172 1.688.84 1.152.84 2.565 0 1.874-1.314 3.187-1.312 1.314-3.186 1.313h-2.25v4.366h5.75v1.5zM9 14.192h6a2.9 2.9 0 0 0 2.125-.875A2.9 2.9 0 0 0 18 11.192q0-.967-.594-1.731A3.57 3.57 0 0 0 15.9 8.327l-.8-.335-.111-.9q-.16-1.346-.983-2.123-.824-.777-2.006-.777-1.183 0-2.006.777t-.982 2.123l-.112.9-.877.373A3.5 3.5 0 0 0 6.575 9.49 2.74 2.74 0 0 0 6 11.192q0 1.25.875 2.125A2.9 2.9 0 0 0 9 14.192"
  }
));
var Inheritance_default = SvgInheritance;

// src/icons/components/Investing.tsx
import * as React90 from "react";
var SvgInvesting = (props) => /* @__PURE__ */ React90.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React90.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 9.106q.463 0 .784-.321A1.07 1.07 0 0 0 13.105 8q0-.464-.32-.785a1.07 1.07 0 0 0-.785-.32q-.464 0-.785.32a1.07 1.07 0 0 0-.321.785q0 .463.321.785.321.32.785.32Zm.002 5.192a2.7 2.7 0 0 1-1.585-.5 2.67 2.67 0 0 1-1-1.335q-.125.03-.249.042a3 3 0 0 1-.259.012 2.66 2.66 0 0 1-1.94-.8 2.63 2.63 0 0 1-.806-1.936q0-.485.18-.935T6.844 8a3.4 3.4 0 0 1-.48-.846 2.6 2.6 0 0 1-.176-.935q0-1.137.795-1.936.795-.8 1.926-.8.135 0 .26.012.123.013.258.032.293-.826.993-1.326A2.66 2.66 0 0 1 12 1.7q.879 0 1.58.5.7.5.993 1.326.135-.02.258-.032.125-.012.26-.012 1.131 0 1.926.8t.794 1.936q0 .489-.167.941a2.9 2.9 0 0 1-.488.84q.305.396.48.846t.175.935q0 1.136-.794 1.936-.795.8-1.927.8a2.6 2.6 0 0 1-.527-.054 2.63 2.63 0 0 1-.983 1.336 2.66 2.66 0 0 1-1.578.499ZM12 21.423a7.5 7.5 0 0 1 .674-3.117 8.84 8.84 0 0 1 4.44-4.44 7.5 7.5 0 0 1 3.116-.674 7.5 7.5 0 0 1-.674 3.117 8.84 8.84 0 0 1-4.439 4.44 7.5 7.5 0 0 1-3.117.674m1.796-1.796a6.95 6.95 0 0 0 2.904-1.735 6.94 6.94 0 0 0 1.734-2.904 6.95 6.95 0 0 0-2.904 1.735 6.95 6.95 0 0 0-1.734 2.904M12 21.423a7.5 7.5 0 0 0-.674-3.117 8.84 8.84 0 0 0-4.44-4.44 7.5 7.5 0 0 0-3.117-.674q0 1.629.674 3.117a8.84 8.84 0 0 0 4.44 4.44q1.487.674 3.117.674m-1.796-1.796A6.95 6.95 0 0 1 7.3 17.892a6.94 6.94 0 0 1-1.735-2.904q1.695.525 2.904 1.735a6.95 6.95 0 0 1 1.735 2.904m4.886-8.61q.51 0 .874-.363.363-.363.363-.875 0-.377-.212-.678a1.06 1.06 0 0 0-.56-.413l-.98-.328a3 3 0 0 1-.127.492 2.7 2.7 0 0 1-.49.852q-.156.18-.356.336l.752.681a1.03 1.03 0 0 0 .736.296m-.515-3.377.98-.329q.35-.111.552-.42.204-.308.204-.672 0-.51-.352-.873a1.16 1.16 0 0 0-.869-.363 1 1 0 0 0-.404.078 1.4 1.4 0 0 0-.332.218l-.768.68q.2.156.364.337.163.18.288.396t.21.456q.084.24.127.492m-3.533-2.055a3 3 0 0 1 .468-.14q.234-.05.491-.05.258 0 .492.05t.464.14l.27-1.175q.108-.481-.284-.845A1.34 1.34 0 0 0 12 3.202a1.34 1.34 0 0 0-.944.363q-.39.364-.283.845l.27 1.175ZM12 12.798q.552 0 .943-.364.391-.363.284-.844l-.27-1.175a2.2 2.2 0 0 1-.464.146q-.234.045-.492.045-.256 0-.493-.046a2.2 2.2 0 0 1-.466-.145l-.27 1.175q-.106.48.284.845.392.363.944.363M9.425 7.64q.042-.252.127-.492a2.7 2.7 0 0 1 .49-.852 2.5 2.5 0 0 1 .356-.336l-.752-.681a1.02 1.02 0 0 0-.737-.296q-.51 0-.873.363a1.2 1.2 0 0 0-.363.873q0 .364.211.673.212.308.56.42zm-.516 3.362q.23 0 .408-.071a.95.95 0 0 0 .329-.225l.767-.666a3 3 0 0 1-.363-.336 2.3 2.3 0 0 1-.289-.396 2.7 2.7 0 0 1-.21-.456 3 3 0 0 1-.126-.492l-.981.328a1.04 1.04 0 0 0-.557.42q-.208.309-.208.673.015.513.366.867t.864.354"
  }
));
var Investing_default = SvgInvesting;

// src/icons/components/JointCash.tsx
import * as React91 from "react";
var SvgJointCash = (props) => /* @__PURE__ */ React91.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React91.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.75 12.712q-1.048 0-1.774-.726a2.41 2.41 0 0 1-.726-1.774q0-1.049.726-1.774a2.41 2.41 0 0 1 1.774-.726q1.048 0 1.774.726c.726.726.726 1.075.726 1.774q0 1.048-.726 1.774a2.41 2.41 0 0 1-1.774.726m-6.596 3.096a1.74 1.74 0 0 1-1.277-.531A1.74 1.74 0 0 1 5.347 14V6.423q0-.746.53-1.277a1.74 1.74 0 0 1 1.277-.53h13.192q.746 0 1.277.53.53.531.53 1.277V14q0 .746-.53 1.277a1.74 1.74 0 0 1-1.277.53H7.154Zm1.5-1.5h10.192q0-.748.531-1.278t1.277-.53V7.923a1.74 1.74 0 0 1-1.278-.53 1.74 1.74 0 0 1-.53-1.278H8.654q0 .75-.531 1.278a1.74 1.74 0 0 1-1.277.53V12.5q.748 0 1.278.531t.53 1.277m10.519 5H3.653a1.74 1.74 0 0 1-1.276-.531 1.74 1.74 0 0 1-.53-1.277V7.596h1.5V17.5q0 .116.095.212a.3.3 0 0 0 .212.096h15.519zm-12.02-5h-.307V6.115h.308a.3.3 0 0 0-.217.092.3.3 0 0 0-.09.216V14q0 .124.09.216a.3.3 0 0 0 .217.092Z"
  }
));
var JointCash_default = SvgJointCash;

// src/icons/components/JointChecking.tsx
import * as React92 from "react";
var SvgJointChecking = (props) => /* @__PURE__ */ React92.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React92.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.154 15.807a1.74 1.74 0 0 1-1.277-.53A1.74 1.74 0 0 1 5.347 14V6.423q0-.746.53-1.277a1.74 1.74 0 0 1 1.277-.53h13.192q.746 0 1.277.53.53.531.53 1.277V14q0 .745-.53 1.277a1.74 1.74 0 0 1-1.277.53zM6.846 9.75v4.558h13.808V9.75zm0-1.5h13.808V6.115H6.846z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React92.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M19.173 19.308H3.653a1.74 1.74 0 0 1-1.276-.532 1.74 1.74 0 0 1-.53-1.276V7.596h1.5V17.5q0 .115.095.211a.3.3 0 0 0 .212.097h15.519z"
  }
));
var JointChecking_default = SvgJointChecking;

// src/icons/components/Laptop.tsx
import * as React93 from "react";
var SvgLaptop = (props) => /* @__PURE__ */ React93.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React93.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.135 19.635q-.672 0-1.153-.482A1.57 1.57 0 0 1 .5 18h3.808q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T4.308 3.5h15.384q.758 0 1.283.525t.525 1.283v10.884q0 .758-.525 1.283T19.692 18H23.5q0 .671-.482 1.153a1.57 1.57 0 0 1-1.153.482zm9.865-.75a.78.78 0 0 0 .573-.235.78.78 0 0 0 .235-.573.78.78 0 0 0-.235-.573.78.78 0 0 0-.573-.235.78.78 0 0 0-.573.235.78.78 0 0 0-.235.573.78.78 0 0 0 .235.573.78.78 0 0 0 .573.235M4.308 16.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v10.884q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Laptop_default = SvgLaptop;

// src/icons/components/LeftArrowSmall.tsx
import * as React94 from "react";
var SvgLeftArrowSmall = (props) => /* @__PURE__ */ React94.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React94.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.952 17.654 4.298 12l5.654-5.654 1.054 1.085-3.82 3.819h12.516v1.5H7.187l3.819 3.82z"
  }
));
var LeftArrowSmall_default = SvgLeftArrowSmall;

// src/icons/components/LeftArrow.tsx
import * as React95 from "react";
var SvgLeftArrow = (props) => /* @__PURE__ */ React95.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React95.createElement("path", { fill: "currentColor", d: "m7.373 12.75 5.696 5.696L12 19.5 4.5 12 12 4.5l1.07 1.054-5.697 5.696H19.5v1.5z" }));
var LeftArrow_default = SvgLeftArrow;

// src/icons/components/LightbulbCircle.tsx
import * as React96 from "react";
var SvgLightbulbCircle = (props) => /* @__PURE__ */ React96.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React96.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20m0-1.27q.519 0 .894-.34.375-.342.423-.852h-2.634q.048.51.423.851.375.342.894.342Zm-2.846-2.384h5.692v-1.192H9.154zm-.08-2.385h5.853a4.8 4.8 0 0 0 1.398-1.652 4.7 4.7 0 0 0 .521-2.194q0-2.01-1.417-3.428T12 5.269q-2.01 0-3.429 1.418-1.417 1.418-1.417 3.428 0 1.192.521 2.194a4.8 4.8 0 0 0 1.398 1.652Zm.443-1.192a4.1 4.1 0 0 1-.858-1.217 3.4 3.4 0 0 1-.313-1.44q0-1.512 1.07-2.581A3.52 3.52 0 0 1 12 6.46q1.514 0 2.584 1.07a3.52 3.52 0 0 1 1.07 2.582q0 .756-.313 1.439-.314.682-.858 1.217z"
  }
));
var LightbulbCircle_default = SvgLightbulbCircle;

// src/icons/components/Lightbulb.tsx
import * as React97 from "react";
var SvgLightbulb = (props) => /* @__PURE__ */ React97.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React97.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.577q-.757 0-1.307-.525a1.88 1.88 0 0 1-.597-1.283h3.808a1.88 1.88 0 0 1-.597 1.283q-.55.525-1.307.525m-3.75-3.192v-1.5h7.5v1.5zm.154-2.885a7.3 7.3 0 0 1-2.488-2.553A6.74 6.74 0 0 1 5 9.5q0-2.923 2.038-4.962Q9.078 2.501 12 2.5q2.923 0 4.962 2.038Q19 6.578 19 9.5a6.74 6.74 0 0 1-.916 3.447 7.3 7.3 0 0 1-2.488 2.553zM8.85 14h6.3a5.55 5.55 0 0 0 1.737-1.975A5.4 5.4 0 0 0 17.5 9.5q0-2.3-1.6-3.9T12 4c-2.3 0-2.833.533-3.9 1.6Q6.5 7.2 6.5 9.5q0 1.35.612 2.525A5.55 5.55 0 0 0 8.85 14"
  }
));
var Lightbulb_default = SvgLightbulb;

// src/icons/components/LightningCircle.tsx
import * as React98 from "react";
var SvgLightningCircle = (props) => /* @__PURE__ */ React98.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React98.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m11.65 17.961 3.696-7.211H12.5V6l-3.827 7.25h2.977zm.352 3.539a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var LightningCircle_default = SvgLightningCircle;

// src/icons/components/LightningCrossoutCircle.tsx
import * as React99 from "react";
var SvgLightningCrossoutCircle = (props) => /* @__PURE__ */ React99.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React99.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.297 20.752a9.3 9.3 0 0 0 3.705.748 9.3 9.3 0 0 0 3.704-.748 9.6 9.6 0 0 0 3.016-2.031 9.6 9.6 0 0 0 2.03-3.018 9.3 9.3 0 0 0 .748-3.705 9.3 9.3 0 0 0-.748-3.704 9.6 9.6 0 0 0-2.031-3.016 9.6 9.6 0 0 0-3.018-2.03 9.3 9.3 0 0 0-3.705-.748 9.3 9.3 0 0 0-3.704.748A9.6 9.6 0 0 0 5.278 5.28a9.6 9.6 0 0 0-2.03 3.018 9.3 9.3 0 0 0-.748 3.705q0 1.97.748 3.704a9.6 9.6 0 0 0 2.031 3.016 9.6 9.6 0 0 0 3.018 2.03Zm6.413-1.228A7.8 7.8 0 0 1 12 20q-3.35 0-5.675-2.325T4 12q0-1.408.48-2.71a8.1 8.1 0 0 1 1.374-2.382l4.036 4.036-1.217 2.306h2.977v4.711l1.782-3.476 3.66 3.661a7.9 7.9 0 0 1-2.382 1.378m-.564-6.432 4 4a7.9 7.9 0 0 0 1.378-2.382A7.8 7.8 0 0 0 20 12q0-3.35-2.325-5.675T12 4q-1.41 0-2.717.471a7.6 7.6 0 0 0-2.375 1.383l3.71 3.71L12.5 6v4.75h2.846z",
    clipRule: "evenodd"
  }
));
var LightningCrossoutCircle_default = SvgLightningCrossoutCircle;

// src/icons/components/LightningCrossout.tsx
import * as React100 from "react";
var SvgLightningCrossout = (props) => /* @__PURE__ */ React100.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React100.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20.873 20.873-1.07 1.07-5.678-5.679-4.317 5.178H8.577l1-6.942H4.952l3.032-4.377-5.926-5.927 1.069-1.069zM9.068 11.206 7.825 13h3.036zm2.177 2.177 1.812 1.813L10.55 18.2z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React100.createElement("path", { fill: "currentColor", d: "m16.462 13.462 2.47-2.962H13.5zM14.423 2.605l-.983 7.835-3.353-3.353 3.105-4.482z" }));
var LightningCrossout_default = SvgLightningCrossout;

// src/icons/components/Lightning.tsx
import * as React101 from "react";
var SvgLightning = (props) => /* @__PURE__ */ React101.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React101.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m10.55 18.2 5.175-6.2h-4l.725-5.675L7.825 13H11.3zm-1.973 3.242 1-6.942H4.952l8.24-11.894h1.231l-.99 7.894h5.5L9.808 21.442z"
  }
));
var Lightning_default = SvgLightning;

// src/icons/components/LinkAlt.tsx
import * as React102 from "react";
var SvgLinkAlt = (props) => /* @__PURE__ */ React102.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React102.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m7.948 14.366-2.665-2.665q-1.332-1.332-1.332-3.209t1.331-3.209q1.332-1.33 3.21-1.332 1.877 0 3.209 1.332l2.665 2.665-1.06 1.06-2.666-2.664a2.93 2.93 0 0 0-2.148-.891q-1.258 0-2.149.89a2.93 2.93 0 0 0-.89 2.15q0 1.257.89 2.148l2.665 2.665zm.87-4.487 1.06-1.06 5.304 5.303-1.06 1.06L8.817 9.88Zm.816 6.174 1.06-1.061 2.666 2.665q.891.89 2.148.89t2.149-.89q.89-.891.89-2.148t-.89-2.149l-2.665-2.665 1.06-1.06 2.666 2.665q1.33 1.33 1.331 3.209 0 1.876-1.331 3.209-1.332 1.33-3.21 1.331-1.876 0-3.209-1.331z"
  }
));
var LinkAlt_default = SvgLinkAlt;

// src/icons/components/Link.tsx
import * as React103 from "react";
var SvgLink = (props) => /* @__PURE__ */ React103.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React103.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.808 16.538h-3.77q-1.883 0-3.21-1.327Q2.5 13.884 2.5 12.001T3.828 8.79q1.327-1.328 3.21-1.328h3.77v1.5h-3.77q-1.26 0-2.149.89A2.93 2.93 0 0 0 4 12q0 1.26.89 2.15a2.93 2.93 0 0 0 2.148.889h3.77v1.5ZM8.25 12.75v-1.5h7.5v1.5zm4.942 3.788v-1.5h3.77q1.26 0 2.149-.889.888-.89.889-2.149 0-1.26-.89-2.149a2.93 2.93 0 0 0-2.148-.89h-3.77v-1.5h3.77q1.883 0 3.21 1.328 1.328 1.327 1.328 3.21t-1.328 3.212q-1.327 1.327-3.21 1.327z"
  }
));
var Link_default = SvgLink;

// src/icons/components/List.tsx
import * as React104 from "react";
var SvgList = (props) => /* @__PURE__ */ React104.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React104.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.327 9.058v-1.5H20.5v1.5zm0 3.692v-1.5H20.5v1.5zm0 3.692v-1.5H20.5v1.5zm-3.02-7.327a.796.796 0 0 1-.808-.817.786.786 0 0 1 .808-.798.786.786 0 0 1 .808.798.796.796 0 0 1-.807.817Zm0 3.683A.786.786 0 0 1 3.5 12a.79.79 0 0 1 .808-.817.79.79 0 0 1 .808.817.786.786 0 0 1-.808.798Zm0 3.702a.796.796 0 0 1-.808-.817.787.787 0 0 1 .808-.798.787.787 0 0 1 .808.798.796.796 0 0 1-.807.817Z"
  }
));
var List_default = SvgList;

// src/icons/components/Lock.tsx
import * as React105 from "react";
var SvgLock = (props) => /* @__PURE__ */ React105.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React105.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-9.384q0-.75.53-1.278.53-.53 1.278-.53H7.5v-2q0-1.873 1.313-3.187Q10.128 2 12 2q1.873 0 3.187 1.313Q16.5 4.627 16.5 6.5v2h1.192q.749 0 1.278.53.53.53.53 1.278v9.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h11.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-9.385a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086H6.307a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v9.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087ZM12 16.75q.729 0 1.24-.51.51-.511.51-1.24c0-.729-.17-.9-.51-1.24q-.511-.51-1.24-.51c-.729 0-.9.17-1.24.51q-.51.51-.51 1.24c0 .73.17.899.51 1.24q.51.51 1.24.51M9 8.5h6v-2q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3.5q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6.5z"
  }
));
var Lock_default = SvgLock;

// src/icons/components/MailOpen.tsx
import * as React106 from "react";
var SvgMailOpen = (props) => /* @__PURE__ */ React106.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React106.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m12 1.596 8.78 5.227q.336.218.528.572.192.355.192.755v10.542q0 .758-.525 1.283t-1.283.525H4.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V8.15q0-.4.192-.755.193-.354.527-.572zm0 11.054L19.8 8 12 3.35 4.2 8zm0 1.754L4 9.623v9.07a.3.3 0 0 0 .087.22.3.3 0 0 0 .22.087h15.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-9.07l-8 4.78Z"
  }
));
var MailOpen_default = SvgMailOpen;

// src/icons/components/Mail.tsx
import * as React107 from "react";
var SvgMail = (props) => /* @__PURE__ */ React107.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React107.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zM12 12.558 4 7.442v10.25a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h15.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V7.442zM12 11l7.846-5H4.154zM4 7.442V6v11.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087H4z"
  }
));
var Mail_default = SvgMail;

// src/icons/components/MajorPurchase.tsx
import * as React108 from "react";
var SvgMajorPurchase = (props) => /* @__PURE__ */ React108.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React108.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.904 21.054q-.432.43-1.07.43-.637 0-1.069-.43l-8.8-8.8a1.6 1.6 0 0 1-.34-.5 1.5 1.5 0 0 1-.125-.604V4q0-.613.443-1.057A1.44 1.44 0 0 1 4 2.5h7.15a1.57 1.57 0 0 1 1.085.446l8.8 8.816q.44.44.445 1.075.004.636-.426 1.067zM12.83 20l7.155-7.15L11.155 4H4v7.15zM6.5 7.75q.52 0 .886-.364.365-.365.365-.885c0-.52-.121-.642-.364-.886A1.2 1.2 0 0 0 6.5 5.25q-.52 0-.886.364a1.2 1.2 0 0 0-.365.885q0 .52.364.886.364.365.885.365Z"
  }
));
var MajorPurchase_default = SvgMajorPurchase;

// src/icons/components/Map.tsx
import * as React109 from "react";
var SvgMap = (props) => /* @__PURE__ */ React109.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React109.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m15 20.462-6-2.1-4.304 1.665a.82.82 0 0 1-.82-.098.86.86 0 0 1-.376-.737V6.077a.93.93 0 0 1 .159-.532.9.9 0 0 1 .445-.341L9 3.539l6 2.1 4.304-1.666a.84.84 0 0 1 .819.084q.377.255.377.712v13.193a.87.87 0 0 1-.173.536 1 1 0 0 1-.47.337zm-.75-1.835v-11.7l-4.5-1.573v11.7zm1.5 0L19 17.55V5.7l-3.25 1.227zM5 18.3l3.25-1.246v-11.7L5 6.45z"
  }
));
var Map_default = SvgMap;

// src/icons/components/Medical.tsx
import * as React110 from "react";
var SvgMedical = (props) => /* @__PURE__ */ React110.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React110.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.482 21.5q-2.496 0-4.254-1.751t-1.757-4.25v-.545q-2.025-.264-3.387-1.806Q2.72 11.606 2.72 9.5V3.75h3v-1h1.5v3.5h-1.5v-1h-1.5V9.5q0 1.65 1.175 2.825T8.22 13.5c1.649 0 2.042-.392 2.825-1.175Q12.221 11.15 12.22 9.5V5.25h-1.5v1h-1.5v-3.5h1.5v1h3V9.5q0 2.106-1.362 3.648T8.97 14.954v.546q0 1.875 1.315 3.187Q11.6 20 13.48 20q1.875 0 3.187-1.313c1.312-1.313 1.313-1.937 1.313-3.187v-1.617a2.47 2.47 0 0 1-1.298-.907q-.51-.674-.51-1.534 0-1.065.746-1.811a2.47 2.47 0 0 1 1.813-.746q1.065 0 1.811.746.745.745.745 1.811 0 .86-.51 1.534a2.47 2.47 0 0 1-1.297.907V15.5q0 2.498-1.751 4.249t-4.248 1.75Zm5.249-9q.444 0 .75-.307a1.02 1.02 0 0 0 .307-.75q0-.445-.306-.752a1.02 1.02 0 0 0-.751-.306q-.444 0-.751.306a1.02 1.02 0 0 0-.307.751q0 .444.307.751t.75.307Z"
  }
));
var Medical_default = SvgMedical;

// src/icons/components/Message.tsx
import * as React111 from "react";
var SvgMessage = (props) => /* @__PURE__ */ React111.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React111.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.25 13.75h7.5v-1.5h-7.5zm0-3h11.5v-1.5H6.25zm0-3h11.5v-1.5H6.25zM2.5 21.038V4.308q0-.758.525-1.283T4.308 2.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525H6.038zM5.4 16h14.292a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.077z"
  }
));
var Message_default = SvgMessage;

// src/icons/components/MinusCircle.tsx
import * as React112 from "react";
var SvgMinusCircle = (props) => /* @__PURE__ */ React112.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React112.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.75 12.75v-1.5h-9.5v1.5zm-4.748 8.75a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var MinusCircle_default = SvgMinusCircle;

// src/icons/components/Minus.tsx
import * as React113 from "react";
var SvgMinus = (props) => /* @__PURE__ */ React113.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React113.createElement("path", { fill: "currentColor", d: "M5.5 12.75v-1.5h13v1.5z" }));
var Minus_default = SvgMinus;

// src/icons/components/NestEgg.tsx
import * as React114 from "react";
var SvgNestEgg = (props) => /* @__PURE__ */ React114.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React114.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.988 20.51q-2.72 0-4.614-1.918C5.48 16.674 5.481 15.76 5.481 13.93a11.9 11.9 0 0 1 .594-3.656 15 15 0 0 1 1.54-3.36q.945-1.51 2.104-2.467t2.272-.957q1.129 0 2.281.952 1.154.95 2.097 2.461a15 15 0 0 1 1.537 3.365 12 12 0 0 1 .594 3.662q0 2.745-1.895 4.662-1.896 1.918-4.617 1.918m.003-1.5q2.085 0 3.547-1.482T17 13.937q0-1.449-.483-3.019a14.8 14.8 0 0 0-1.22-2.888q-.737-1.318-1.619-2.179t-1.688-.86q-.794 0-1.681.86-.888.861-1.625 2.184a15 15 0 0 0-1.22 2.893q-.483 1.57-.483 3.005 0 2.113 1.462 3.595c1.462 1.482 2.158 1.482 3.548 1.482m1.01-1.5q.318 0 .534-.216a.73.73 0 0 0 .215-.535.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.215q-1.354 0-2.302-.948T9.75 12.76a.73.73 0 0 0-.216-.535A.73.73 0 0 0 9 12.01a.73.73 0 0 0-.534.215.73.73 0 0 0-.216.535q0 1.971 1.39 3.36 1.389 1.39 3.36 1.39Z"
  }
));
var NestEgg_default = SvgNestEgg;

// src/icons/components/Open.tsx
import * as React115 from "react";
var SvgOpen = (props) => /* @__PURE__ */ React115.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React115.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h6.307V5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-6.307h1.5v6.307q0 .758-.525 1.283t-1.283.525zm4.411-5.165L8.665 14.28 17.946 5H14V3.5h6.5V10H19V6.054l-9.28 9.28Z"
  }
));
var Open_default = SvgOpen;

// src/icons/components/People.tsx
import * as React116 from "react";
var SvgPeople = (props) => /* @__PURE__ */ React116.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React116.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.798 19.308v-2.223q0-.774.4-1.38a2.7 2.7 0 0 1 1.065-.944q1.425-.697 2.867-1.075 1.44-.378 3.168-.378t3.169.378q1.44.378 2.866 1.075.667.338 1.066.944.4.606.4 1.38v2.223zm17 0v-2.346q0-.985-.482-1.877a4.54 4.54 0 0 0-1.368-1.531q1.005.15 1.91.464.903.315 1.725.744.776.413 1.197.974c.421.561.422.783.422 1.226v2.346zm-9.5-7.616q-1.443 0-2.472-1.028T5.798 8.192c0-1.444.343-1.786 1.028-2.471q1.029-1.029 2.472-1.029t2.472 1.029a3.37 3.37 0 0 1 1.028 2.471q0 1.444-1.028 2.472a3.37 3.37 0 0 1-2.472 1.028m8.635-3.5q0 1.444-1.028 2.472t-2.472 1.028q-.17 0-.43-.038a4 4 0 0 1-.432-.085q.592-.711.91-1.578a5.2 5.2 0 0 0-.007-3.593 5.8 5.8 0 0 0-.903-1.583q.215-.075.431-.1.216-.023.43-.023 1.444 0 2.473 1.029t1.028 2.471M3.298 17.808h12v-.723a1 1 0 0 0-.156-.558 1.3 1.3 0 0 0-.497-.427 11.8 11.8 0 0 0-2.543-.964 11.5 11.5 0 0 0-2.804-.328 11.5 11.5 0 0 0-2.804.328 11.8 11.8 0 0 0-2.542.964 1.3 1.3 0 0 0-.497.427 1 1 0 0 0-.157.558zm6-7.616q.825 0 1.413-.587.587-.588.587-1.413c0-.825-.196-1.02-.587-1.412a1.93 1.93 0 0 0-1.413-.588q-.824 0-1.412.588a1.93 1.93 0 0 0-.588 1.412q0 .825.588 1.413.587.587 1.412.587"
  }
));
var People_default = SvgPeople;

// src/icons/components/Person.tsx
import * as React117 from "react";
var SvgPerson = (props) => /* @__PURE__ */ React117.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React117.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 11.692a3.37 3.37 0 0 1-2.472-1.028Q8.5 9.637 8.5 8.192c0-1.445.343-1.786 1.028-2.471Q10.556 4.692 12 4.692t2.472 1.029T15.5 8.192q0 1.444-1.028 2.472T12 11.692m-7.5 7.616v-2.223q0-.735.399-1.36a2.66 2.66 0 0 1 1.066-.963 14.5 14.5 0 0 1 2.992-1.09 12.95 12.95 0 0 1 6.086 0q1.509.363 2.992 1.09.667.336 1.066.962t.399 1.36v2.224zm1.5-1.5h12v-.723a1 1 0 0 0-.176-.563 1.33 1.33 0 0 0-.478-.422 13 13 0 0 0-2.635-.964 11.4 11.4 0 0 0-5.422 0 12.8 12.8 0 0 0-2.635.964q-.301.164-.478.422a1 1 0 0 0-.176.563zm6-7.616q.825 0 1.412-.587Q14 9.017 14 8.192c0-.825-.196-1.02-.588-1.412A1.93 1.93 0 0 0 12 6.192q-.825 0-1.412.588A1.93 1.93 0 0 0 10 8.192q0 .825.588 1.413.587.587 1.412.587"
  }
));
var Person_default = SvgPerson;

// src/icons/components/Pets.tsx
import * as React118 from "react";
var SvgPets = (props) => /* @__PURE__ */ React118.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React118.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.5 11.875q-.945 0-1.597-.652a2.17 2.17 0 0 1-.653-1.597q0-.945.652-1.598A2.17 2.17 0 0 1 4.5 7.375q.945 0 1.598.652.653.653.653 1.597 0 .945-.652 1.598a2.17 2.17 0 0 1-1.597.653Zm4.5-4q-.945 0-1.597-.652a2.17 2.17 0 0 1-.653-1.597q0-.945.652-1.598A2.17 2.17 0 0 1 9 3.375q.945 0 1.598.652.653.653.653 1.597 0 .945-.652 1.598A2.17 2.17 0 0 1 9 7.875m6 0q-.945 0-1.597-.652a2.17 2.17 0 0 1-.653-1.597q0-.945.652-1.598A2.17 2.17 0 0 1 15 3.375q.945 0 1.598.652.653.653.653 1.597 0 .945-.652 1.598A2.17 2.17 0 0 1 15 7.875m4.5 4q-.945 0-1.597-.652a2.17 2.17 0 0 1-.653-1.597q0-.945.652-1.598a2.17 2.17 0 0 1 1.597-.653q.945 0 1.598.652.653.653.653 1.597 0 .945-.652 1.598a2.17 2.17 0 0 1-1.598.653m-12.85 10q-1.029 0-1.714-.788a2.75 2.75 0 0 1-.686-1.862q0-1.261.873-2.184.873-.921 1.72-1.843a9.7 9.7 0 0 0 1.254-1.692q.53-.908 1.245-1.708a5 5 0 0 1 1.195-1.012A2.76 2.76 0 0 1 12 10.375q.8 0 1.483.39t1.194 1.002a11 11 0 0 1 1.233 1.716q.532.915 1.248 1.715.846.922 1.719 1.843a3.07 3.07 0 0 1 .873 2.184q0 1.073-.686 1.862-.685.788-1.714.788-1.35 0-2.675-.225a16 16 0 0 0-5.35 0 16 16 0 0 1-2.675.225"
  }
));
var Pets_default = SvgPets;

// src/icons/components/Phone.tsx
import * as React119 from "react";
var SvgPhone = (props) => /* @__PURE__ */ React119.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React119.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.308 22.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V3.308q0-.758.525-1.283T7.308 1.5h9.384q.758 0 1.283.525t.525 1.283v17.384q0 .758-.525 1.283t-1.283.525zM7 19.75v.942q0 .116.096.212a.3.3 0 0 0 .212.096h9.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-.942zm0-1.5h10V5.75H7zm0-14h10v-.942a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H7.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212z"
  }
));
var Phone_default = SvgPhone;

// src/icons/components/PieAlt.tsx
import * as React120 from "react";
var SvgPieAlt = (props) => /* @__PURE__ */ React120.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React120.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11 2.552c-4.777.5-8.5 4.539-8.5 9.448a9.5 9.5 0 0 0 9.5 9.5c4.909 0 8.948-3.723 9.448-8.5h-1.51A8.001 8.001 0 0 1 4 12a8 8 0 0 1 7-7.938z"
  }
), /* @__PURE__ */ React120.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.5 11.5h-11V.5H14a9.5 9.5 0 0 1 9.5 9.5zM14 10V2h.001q.77.001 1.499.14A8.01 8.01 0 0 1 22 10z",
    clipRule: "evenodd"
  }
));
var PieAlt_default = SvgPieAlt;

// src/icons/components/Pie.tsx
import * as React121 from "react";
var SvgPie = (props) => /* @__PURE__ */ React121.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React121.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.75 11.25h7.22q-.29-2.895-2.307-4.917-2.018-2.024-4.913-2.302zm-1.5 8.72V4.03q-3.093.28-5.171 2.561Q4 8.873 4 12c0 3.127.693 3.887 2.079 5.409q2.08 2.28 5.171 2.56Zm1.5 0q2.895-.264 4.92-2.295c2.025-2.031 2.117-2.995 2.3-4.925h-7.22zm-.748 1.53a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.97 0 3.697.749a9.7 9.7 0 0 1 3.017 2.04q1.29 1.29 2.039 3.015t.749 3.699q0 1.95-.748 3.683a9.7 9.7 0 0 1-2.03 3.026 9.5 9.5 0 0 1-3.016 2.04 9.3 9.3 0 0 1-3.704.748"
  }
));
var Pie_default = SvgPie;

// src/icons/components/Pin.tsx
import * as React122 from "react";
var SvgPin = (props) => /* @__PURE__ */ React122.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React122.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6 19.616q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 6 16.385q.667 0 1.141.474.474.475.474 1.141t-.474 1.141a1.56 1.56 0 0 1-1.14.475Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 12 16.385q.666 0 1.141.474.475.475.475 1.141t-.475 1.141a1.56 1.56 0 0 1-1.14.475Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 18 16.385q.666 0 1.141.474.474.475.475 1.141 0 .666-.475 1.141a1.56 1.56 0 0 1-1.14.475Zm-12-6q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 6 10.385q.667 0 1.141.474.474.475.474 1.141t-.474 1.141a1.56 1.56 0 0 1-1.14.475Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 12 10.385q.666 0 1.141.474.475.475.475 1.141t-.475 1.141a1.56 1.56 0 0 1-1.14.475Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 18 10.385q.666 0 1.141.474.474.475.475 1.141 0 .666-.475 1.141a1.56 1.56 0 0 1-1.14.475Zm-12-6q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 6 4.385q.667 0 1.141.474.474.475.474 1.141 0 .667-.474 1.141a1.56 1.56 0 0 1-1.14.474Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 12 4.385q.666 0 1.141.474.475.475.475 1.141 0 .667-.475 1.141a1.56 1.56 0 0 1-1.14.474Zm6 0q-.666 0-1.14-.475a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 18 4.385q.666 0 1.141.474.474.475.475 1.141 0 .667-.475 1.141a1.56 1.56 0 0 1-1.14.474Z"
  }
));
var Pin_default = SvgPin;

// src/icons/components/PlusCircle.tsx
import * as React123 from "react";
var SvgPlusCircle = (props) => /* @__PURE__ */ React123.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React123.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 16.75h1.5v-4h4v-1.5h-4v-4h-1.5v4h-4v1.5h4zm.752 4.75a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var PlusCircle_default = SvgPlusCircle;

// src/icons/components/Plus.tsx
import * as React124 from "react";
var SvgPlus = (props) => /* @__PURE__ */ React124.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React124.createElement("path", { fill: "currentColor", d: "M11.25 12.75H5.5v-1.5h5.75V5.5h1.5v5.75h5.75v1.5h-5.75v5.75h-1.5z" }));
var Plus_default = SvgPlus;

// src/icons/components/Power.tsx
import * as React125 from "react";
var SvgPower = (props) => /* @__PURE__ */ React125.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React125.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 13V3.423h1.5V13zm.75 7.5q-1.755 0-3.3-.67a8.6 8.6 0 0 1-2.704-1.826A8.6 8.6 0 0 1 4.17 15.3 8.2 8.2 0 0 1 3.5 12q0-1.894.796-3.578a8.7 8.7 0 0 1 2.22-2.907L7.56 6.56a6.9 6.9 0 0 0-1.885 2.415A7 7 0 0 0 5 12q0 2.9 2.05 4.95T12 19q2.925 0 4.962-2.05Q19.001 14.9 19 12a7.1 7.1 0 0 0-.663-3.025A6.66 6.66 0 0 0 16.44 6.56l1.045-1.045a8.6 8.6 0 0 1 2.224 2.907A8.3 8.3 0 0 1 20.5 12q0 1.755-.67 3.3a8.54 8.54 0 0 1-4.515 4.53A8.3 8.3 0 0 1 12 20.5"
  }
));
var Power_default = SvgPower;

// src/icons/components/Preferences.tsx
import * as React126 from "react";
var SvgPreferences = (props) => /* @__PURE__ */ React126.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React126.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 20.75v-5.5h1.5v2h8v1.5h-8v2zm-8-2v-1.5h5.5v1.5zm4-4v-2h-4v-1.5h4v-2h1.5v5.5zm4-2v-1.5h9.5v1.5zm4-4v-5.5h1.5v2h4v1.5h-4v2zm-12-2v-1.5h9.5v1.5z"
  }
));
var Preferences_default = SvgPreferences;

// src/icons/components/Present.tsx
import * as React127 from "react";
var SvgPresent = (props) => /* @__PURE__ */ React127.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React127.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.115 21.5V10.615H2.5V5.404h5.171a1.3 1.3 0 0 1-.287-.55 2.7 2.7 0 0 1-.076-.642q0-1.122.785-1.907A2.6 2.6 0 0 1 10 1.519q.575 0 1.065.242.491.24.877.645.387-.42.877-.653a2.44 2.44 0 0 1 1.066-.234q1.12 0 1.907.786.785.785.785 1.907 0 .332-.084.632t-.28.56H21.5v5.211h-1.615V21.5zm9.77-18.48q-.507 0-.85.342a1.15 1.15 0 0 0-.343.85q0 .505.343.85.343.342.85.342.505 0 .85-.343.342-.342.342-.85 0-.506-.343-.849a1.15 1.15 0 0 0-.85-.343ZM8.808 4.211q0 .505.342.85.343.342.85.342t.85-.343q.342-.342.342-.85 0-.506-.342-.849a1.15 1.15 0 0 0-.85-.343q-.507 0-.85.343a1.15 1.15 0 0 0-.342.85M4 6.904v2.211h7.25V6.904zM11.25 20v-9.385H5.615V20zm1.5 0h5.635v-9.385H12.75zM20 9.115V6.904h-7.25v2.211z"
  }
));
var Present_default = SvgPresent;

// src/icons/components/Presentation.tsx
import * as React128 from "react";
var SvgPresentation = (props) => /* @__PURE__ */ React128.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React128.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.365 16.75h1.5v-6.5h-1.5zm3.885 0h1.5v-9.5h-1.5zm3.885 0h1.5v-3.5h-1.5zM5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h13.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Presentation_default = SvgPresentation;

// src/icons/components/QuestionMarkCircle.tsx
import * as React129 from "react";
var SvgQuestionMarkCircle = (props) => /* @__PURE__ */ React129.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React129.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.989 17.615a.98.98 0 0 0 .723-.295.99.99 0 0 0 .296-.724.98.98 0 0 0-.296-.724.99.99 0 0 0-.724-.295.98.98 0 0 0-.724.296.99.99 0 0 0-.295.724q0 .428.296.723a.99.99 0 0 0 .724.295m-.708-3.58h1.407q.02-.74.217-1.18.196-.441.957-1.17.66-.66 1.01-1.219.351-.558.351-1.32 0-1.29-.928-2.016-.927-.726-2.195-.726-1.252 0-2.072.668t-1.17 1.574l1.284.515q.183-.498.625-.97.443-.472 1.314-.472.886 0 1.31.486t.424 1.068q0 .51-.29.933t-.74.817q-.985.889-1.245 1.417-.26.529-.26 1.595ZM12 21.5a9.3 9.3 0 0 1-3.704-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749Zm0-1.5q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var QuestionMarkCircle_default = SvgQuestionMarkCircle;

// src/icons/components/QuestionMark.tsx
import * as React130 from "react";
var SvgQuestionMark = (props) => /* @__PURE__ */ React130.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React130.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.965 15.77q0-1.7.392-2.6.39-.903 1.633-2 .968-.862 1.467-1.563a2.68 2.68 0 0 0 .499-1.59q0-1.179-.803-1.96t-2.21-.78q-1.286 0-2 .688a4.8 4.8 0 0 0-1.087 1.537L7.03 6.7a5.7 5.7 0 0 1 1.82-2.395q1.236-.96 3.092-.959 2.424 0 3.73 1.367t1.307 3.243q0 1.173-.509 2.07-.508.896-1.543 1.868-1.302 1.194-1.613 1.884t-.31 1.991zm.977 5.73q-.613 0-1.056-.443A1.44 1.44 0 0 1 10.442 20q0-.613.444-1.057a1.44 1.44 0 0 1 1.056-.443q.614 0 1.057.443.443.444.443 1.057t-.443 1.057a1.44 1.44 0 0 1-1.057.443"
  }
));
var QuestionMark_default = SvgQuestionMark;

// src/icons/components/Quote.tsx
import * as React131 from "react";
var SvgQuote = (props) => /* @__PURE__ */ React131.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React131.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m6.142 17.654 2.348-4.087a.6.6 0 0 1-.202.068 1.5 1.5 0 0 1-.23.019q-1.525 0-2.59-1.073A3.53 3.53 0 0 1 4.404 10q0-1.525 1.064-2.59t2.59-1.064q1.507 0 2.58 1.065t1.073 2.586q0 .53-.127.984-.128.453-.374.865l-3.345 5.808zm8.885 0 2.348-4.087a.6.6 0 0 1-.202.068 1.5 1.5 0 0 1-.23.019q-1.525 0-2.59-1.073A3.53 3.53 0 0 1 13.288 10q0-1.535 1.065-2.594 1.065-1.06 2.59-1.06 1.506 0 2.58 1.065 1.073 1.064 1.073 2.586 0 .53-.128.984t-.374.865l-3.344 5.808zm-6.97-5.808q.77 0 1.308-.538A1.78 1.78 0 0 0 9.904 10q0-.77-.539-1.308a1.78 1.78 0 0 0-1.307-.538q-.77 0-1.308.538A1.78 1.78 0 0 0 6.21 10q0 .77.539 1.308a1.78 1.78 0 0 0 1.308.538m8.885 0q.77 0 1.308-.538A1.78 1.78 0 0 0 18.788 10q0-.77-.538-1.308a1.78 1.78 0 0 0-1.308-.538q-.77 0-1.308.538A1.78 1.78 0 0 0 15.096 10q0 .77.538 1.308a1.78 1.78 0 0 0 1.308.538"
  }
));
var Quote_default = SvgQuote;

// src/icons/components/Rebalancing.tsx
import * as React132 from "react";
var SvgRebalancing = (props) => /* @__PURE__ */ React132.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React132.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.173 19.75v-7.058h-2v-1.5h5.5v1.5h-2v7.058zm0-10.942V4.25h1.5v4.558zm4.077 0v-1.5h2V4.25h1.5v3.058h2v1.5zm2 10.942v-8.558h1.5v8.558zm6.077 0v-3.058h-2v-1.5h5.5v1.5h-2v3.058zm0-6.942V4.25h1.5v8.558z"
  }
));
var Rebalancing_default = SvgRebalancing;

// src/icons/components/Redo.tsx
import * as React133 from "react";
var SvgRedo = (props) => /* @__PURE__ */ React133.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React133.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.621 18.5q-2.193 0-3.758-1.47t-1.565-3.617c0-2.148.522-2.636 1.565-3.612S8.159 8.337 9.62 8.337h7.022L13.86 5.554 14.914 4.5 19.5 9.087l-4.586 4.586-1.054-1.054 2.783-2.783H9.62q-1.564 0-2.694 1.03-1.128 1.028-1.129 2.547 0 1.52 1.13 2.553Q8.056 17.001 9.62 17h7.177v1.5z"
  }
));
var Redo_default = SvgRedo;

// src/icons/components/Response.tsx
import * as React134 from "react";
var SvgResponse = (props) => /* @__PURE__ */ React134.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React134.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.115 17.115a.86.86 0 0 1-.63-.254.86.86 0 0 1-.254-.63v-1.5h12.375l.317.317V6h1.5q.375 0 .63.254.255.255.255.63v13.77l-3.539-3.539zm-4.423-.846V3.385q0-.377.255-.63.255-.255.63-.255h12.461q.377 0 .63.254.255.255.255.63v8.462q0 .375-.254.63a.86.86 0 0 1-.63.255H6.23zm12.731-5.038V4H4.193v7.923l.692-.692z"
  }
));
var Response_default = SvgResponse;

// src/icons/components/Ribbon.tsx
import * as React135 from "react";
var SvgRibbon = (props) => /* @__PURE__ */ React135.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React135.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.692 22.5v-7.59L3.356 9.5l4.317-7h8.654l4.317 7-3.336 5.41v7.59L12 20.702zm1.5-2.121L12 19.11l3.808 1.268V16.5H8.192zM8.51 4l-3.4 5.5 3.4 5.5h6.98l3.4-5.5-3.4-5.5zm2.44 9.22-3.194-3.17 1.07-1.07 2.124 2.126 4.225-4.25 1.07 1.044z"
  }
));
var Ribbon_default = SvgRibbon;

// src/icons/components/RightArrowSmall.tsx
import * as React136 from "react";
var SvgRightArrowSmall = (props) => /* @__PURE__ */ React136.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React136.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m13.846 17.654-1.054-1.085 3.82-3.819H4.5v-1.5h12.112l-3.82-3.82 1.054-1.084L19.5 12z"
  }
));
var RightArrowSmall_default = SvgRightArrowSmall;

// src/icons/components/RightArrow.tsx
import * as React137 from "react";
var SvgRightArrow = (props) => /* @__PURE__ */ React137.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React137.createElement("path", { fill: "currentColor", d: "M16.627 12.75H4.5v-1.5h12.127L10.93 5.554 12 4.5l7.5 7.5-7.5 7.5-1.07-1.054z" }));
var RightArrow_default = SvgRightArrow;

// src/icons/components/Safe.tsx
import * as React138 from "react";
var SvgSafe = (props) => /* @__PURE__ */ React138.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React138.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m12 16.866-3.09 1.783-.75-1.299 3.09-1.783V12h1.5v3.567l3.09 1.783-.75 1.3L12 16.865ZM12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  }
), /* @__PURE__ */ React138.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V4.308q0-.748.53-1.278t1.278-.53h13.384q.749 0 1.278.53.53.53.53 1.278v15.384q0 .749-.53 1.278-.53.53-1.278.53zM19 4.308a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H5.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v15.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V16.75h-2v-1.5h2v-6.5h-2v-1.5h2V4.308Z",
    clipRule: "evenodd"
  }
));
var Safe_default = SvgSafe;

// src/icons/components/SafetyNet.tsx
import * as React139 from "react";
var SvgSafetyNet = (props) => /* @__PURE__ */ React139.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React139.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M9.1 19.45l1.47-3.346a4.2 4.2 0 0 1-1.617-1.025 4.7 4.7 0 0 1-1.038-1.629l-3.384 1.4q.584 1.6 1.784 2.8t2.785 1.8m-1.185-8.9A4.3 4.3 0 0 1 8.94 8.934a4.4 4.4 0 0 1 1.611-1.019l-1.4-3.384a7.9 7.9 0 0 0-2.81 1.81q-1.2 1.2-1.81 2.809zm4.083 4.296a2.75 2.75 0 0 0 2.016-.83 2.74 2.74 0 0 0 .832-2.014 2.75 2.75 0 0 0-.83-2.016 2.74 2.74 0 0 0-2.014-.832 2.75 2.75 0 0 0-2.016.83 2.74 2.74 0 0 0-.832 2.014q0 1.185.83 2.016a2.74 2.74 0 0 0 2.014.832M14.9 19.45q1.574-.6 2.763-1.787A7.8 7.8 0 0 0 19.45 14.9l-3.346-1.47a4.1 4.1 0 0 1-1.006 1.607 4.8 4.8 0 0 1-1.598 1.048zm1.185-8.95 3.365-1.4a7.8 7.8 0 0 0-1.787-2.763A7.8 7.8 0 0 0 14.9 4.55l-1.4 3.396a4.5 4.5 0 0 1 1.554 1.008q.663.66 1.03 1.546Z"
  }
));
var SafetyNet_default = SvgSafetyNet;

// src/icons/components/Search.tsx
import * as React140 from "react";
var SvgSearch = (props) => /* @__PURE__ */ React140.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React140.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m19.542 20.577-6.28-6.28q-.75.618-1.726.968-.975.35-2.017.35-2.564 0-4.34-1.775T3.404 9.502t1.775-4.34q1.776-1.777 4.339-1.777 2.562 0 4.34 1.776 1.776 1.775 1.776 4.34 0 1.07-.36 2.045a5.7 5.7 0 0 1-.959 1.696l6.281 6.281zM9.52 14.115q1.933 0 3.274-1.34 1.342-1.342 1.342-3.275t-1.342-3.274q-1.34-1.341-3.274-1.341-1.932 0-3.274 1.341Q4.905 7.568 4.905 9.5q0 1.933 1.341 3.274 1.342 1.342 3.274 1.342Z"
  }
));
var Search_default = SvgSearch;

// src/icons/components/SecurityCheck.tsx
import * as React141 from "react";
var SvgSecurityCheck = (props) => /* @__PURE__ */ React141.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React141.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.95 15.204 16.254 9.9l-1.07-1.07-4.234 4.236-2.12-2.12-1.068 1.07zM12 21.48q-3.245-.885-5.372-3.82Q4.5 14.726 4.5 11.1V5.345L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562T12 21.481Zm0-1.58q2.6-.825 4.3-3.3c1.7-2.475 1.7-3.484 1.7-5.5V6.374l-6-2.24-6 2.24V11.1q0 3.025 1.7 5.5c1.7 2.475 2.567 2.75 4.3 3.3"
  }
));
var SecurityCheck_default = SvgSecurityCheck;

// src/icons/components/SecurityReview.tsx
import * as React142 from "react";
var SvgSecurityReview = (props) => /* @__PURE__ */ React142.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React142.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.48q-3.245-.884-5.372-3.818Q4.5 14.727 4.5 11.1V5.346L12 2.54l7.5 2.807V11.1q0 1.904-.624 3.693a10.7 10.7 0 0 1-1.85 3.28l-3.141-3.142q-.412.285-.896.427A3.5 3.5 0 0 1 12 15.5q-1.444 0-2.472-1.028C8.5 13.444 8.5 12.962 8.5 12s.343-1.786 1.028-2.472Q10.556 8.5 12 8.5t2.472 1.028T15.5 12q0 .507-.137.978a3.8 3.8 0 0 1-.394.899l1.866 1.865q.538-1.053.851-2.212A9.3 9.3 0 0 0 18 11.1V6.375l-6-2.24-6 2.24V11.1q0 3.025 1.7 5.5c1.7 2.475 2.567 2.75 4.3 3.3a7 7 0 0 0 1.238-.512 9 9 0 0 0 1.162-.738l1.015 1.073q-.786.608-1.619 1.045a9.4 9.4 0 0 1-1.796.713ZM12 14q.825 0 1.412-.587Q14 12.825 14 12c0-.825-.196-1.02-.588-1.412A1.93 1.93 0 0 0 12 10q-.825 0-1.412.588A1.93 1.93 0 0 0 10 12q0 .824.588 1.413Q11.175 14 12 14"
  }
));
var SecurityReview_default = SvgSecurityReview;

// src/icons/components/SecurityX.tsx
import * as React143 from "react";
var SvgSecurityX = (props) => /* @__PURE__ */ React143.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React143.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m9.9 15.115 2.1-2.1 2.1 2.1 1.054-1.053-2.1-2.1 2.1-2.1L14.1 8.808l-2.1 2.1-2.1-2.1-1.054 1.054 2.1 2.1-2.1 2.1zm2.1 6.366q-3.245-.885-5.372-3.82Q4.5 14.727 4.5 11.101V5.345L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562T12 21.481m0-1.58q2.6-.825 4.3-3.3c1.7-2.475 1.7-3.484 1.7-5.5V6.374l-6-2.24-6 2.24V11.1q0 3.025 1.7 5.5c1.7 2.475 2.567 2.75 4.3 3.3Z"
  }
));
var SecurityX_default = SvgSecurityX;

// src/icons/components/Security.tsx
import * as React144 from "react";
var SvgSecurity = (props) => /* @__PURE__ */ React144.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React144.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.48q-3.245-.884-5.372-3.818Q4.5 14.727 4.5 11.1V5.346L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562T12 21.481Zm0-1.58q2.425-.75 4.05-2.962A9.87 9.87 0 0 0 17.95 12H12V4.135l-6 2.24v5.165q0 .186.05.46H12z"
  }
));
var Security_default = SvgSecurity;

// src/icons/components/Shapes.tsx
import * as React145 from "react";
var SvgShapes = (props) => /* @__PURE__ */ React145.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React145.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.304 10.365 13.26 9.321l2.715-2.715L13.26 3.89l1.044-1.054 2.715 2.716 2.716-2.716 1.044 1.054-2.715 2.716 2.715 2.715-1.044 1.044-2.716-2.715zm-11.92.346 4.635-8.22 4.635 8.22zM7.03 20.76q-1.564 0-2.662-1.098T3.27 17.005q0-1.583 1.098-2.673t2.662-1.09 2.661 1.097q1.098 1.099 1.099 2.662 0 1.564-1.099 2.661Q8.593 20.76 7.03 20.76m0-1.5q.94 0 1.6-.66.66-.658.66-1.6 0-.94-.66-1.6a2.18 2.18 0 0 0-1.6-.659q-.94 0-1.6.66t-.66 1.6.66 1.6 1.6.66ZM4.949 9.211H9.1L7.02 5.567 4.947 9.211Zm8.31 11.548V13.24h7.52v7.52zm1.5-1.5h4.52V14.74h-4.52z"
  }
));
var Shapes_default = SvgShapes;

// src/icons/components/Share.tsx
import * as React146 from "react";
var SvgShare = (props) => /* @__PURE__ */ React146.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React146.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 22.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V10.308q0-.758.525-1.283T6.308 8.5h2.557V10H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v10.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V10.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096h-2.557V8.5h2.557q.758 0 1.283.525t.525 1.283v10.384q0 .758-.525 1.283t-1.283.525zm4.942-6.75V4.72L9.4 6.57 8.346 5.5 12 1.846 15.654 5.5 14.6 6.57l-1.85-1.85v11.03z"
  }
));
var Share_default = SvgShare;

// src/icons/components/Shopping.tsx
import * as React147 from "react";
var SvgShopping = (props) => /* @__PURE__ */ React147.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React147.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V8.308q0-.758.525-1.283T6.308 6.5H8.25v-.25q0-1.554 1.098-2.652A3.61 3.61 0 0 1 12 2.5q1.554 0 2.652 1.098A3.61 3.61 0 0 1 15.75 6.25v.25h1.942q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H15.75v2.25a.73.73 0 0 1-.215.535A.73.73 0 0 1 15 11a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535V8h-4.5v2.25a.73.73 0 0 1-.215.535A.73.73 0 0 1 9 11a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535V8H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096M9.75 6.5h4.5v-.25q0-.94-.655-1.595A2.17 2.17 0 0 0 12 4a2.17 2.17 0 0 0-1.595.655A2.17 2.17 0 0 0 9.75 6.25z"
  }
));
var Shopping_default = SvgShopping;

// src/icons/components/Signpost.tsx
import * as React148 from "react";
var SvgSignpost = (props) => /* @__PURE__ */ React148.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React148.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 21.5v-4h-5L3.5 14.75 6.25 12h5v-2H4.5V4.5h6.75v-2h1.5v2h5l2.75 2.75L17.75 10h-5v2h6.75v5.5h-6.75v4zM6 8.5h11.137l1.25-1.25L17.137 6H6zm.863 7.5H18v-2.5H6.863l-1.25 1.25z"
  }
));
var Signpost_default = SvgSignpost;

// src/icons/components/Sound.tsx
import * as React149 from "react";
var SvgSound = (props) => /* @__PURE__ */ React149.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React149.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.038 20.11v-1.55q2.164-.69 3.486-2.5 1.322-1.812 1.322-4.085T17.524 7.89q-1.322-1.81-3.486-2.5V3.84q2.793.749 4.55 2.998 1.758 2.25 1.758 5.137t-1.758 5.136-4.55 2.998ZM3.654 14.5v-5h3.711l4.289-4.288v13.576L7.365 14.5zm10.384 1.154V8.296a3.85 3.85 0 0 1 1.564 1.55q.552.997.552 2.154a4.23 4.23 0 0 1-.557 2.122 3.93 3.93 0 0 1-1.559 1.532M10.154 8.85 8.004 11h-2.85v2h2.85l2.15 2.15z"
  }
));
var Sound_default = SvgSound;

// src/icons/components/Spending.tsx
import * as React150 from "react";
var SvgSpending = (props) => /* @__PURE__ */ React150.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React150.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.308q0-.748.53-1.278t1.278-.53h13.384q.749 0 1.278.53.53.53.53 1.278v2.72H19v-2.72a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H5.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v13.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V15.97h1.5v2.721q0 .749-.53 1.278-.53.53-1.278.53zm8-4q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V9.308q0-.748.53-1.278t1.278-.53h6.384q.749 0 1.278.53.53.53.53 1.278v5.384q0 .749-.53 1.278-.53.53-1.278.53zm6.384-1.5a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V9.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-6.385a.3.3 0 0 0-.222.087.3.3 0 0 0-.086.22v5.385a.3.3 0 0 0 .086.221.3.3 0 0 0 .222.087zM16 13.5q.625 0 1.063-.438.437-.437.437-1.062 0-.624-.438-1.063A1.45 1.45 0 0 0 16 10.5q-.624 0-1.063.438A1.45 1.45 0 0 0 14.5 12q0 .624.438 1.063.437.437 1.062.437"
  }
));
var Spending_default = SvgSpending;

// src/icons/components/Stacks.tsx
import * as React151 from "react";
var SvgStacks = (props) => /* @__PURE__ */ React151.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React151.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 4.75H3v-1.5h8zm-8 4h8v-1.5H3zm8 4H3v-1.5h8zm-8 4h8v-1.5H3zm0 4h8v-1.5H3zm10 0h8v-1.5h-8zm8-4h-8v-1.5h8zm-8-4h8v-1.5h-8z",
    clipRule: "evenodd"
  }
));
var Stacks_default = SvgStacks;

// src/icons/components/Stroller.tsx
import * as React152 from "react";
var SvgStroller = (props) => /* @__PURE__ */ React152.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React152.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.365 21.173q-.705 0-1.209-.503a1.65 1.65 0 0 1-.502-1.209q0-.705.502-1.208a1.65 1.65 0 0 1 1.21-.503q.705 0 1.208.503.503.502.503 1.209 0 .705-.503 1.208a1.65 1.65 0 0 1-1.209.503m-8.884 0q-.7 0-1.206-.503a1.64 1.64 0 0 1-.506-1.209q0-.705.506-1.208a1.65 1.65 0 0 1 1.206-.503q.718 0 1.215.503.495.502.496 1.209 0 .705-.496 1.208t-1.215.503m2.59-5.923h5.198a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V8.8zm-1.646 1.5q-.485 0-.681-.43-.196-.432.123-.807L15.97 4.838a3.25 3.25 0 0 1 1.026-.817q.555-.27 1.222-.271 1.14 0 1.928.787.787.788.787 1.932v.53h-1.5v-.534q0-.518-.348-.866a1.18 1.18 0 0 0-.867-.349q-.327 0-.581.124a1.5 1.5 0 0 0-.467.363l-1.092 1.26v7.942q0 .752-.531 1.281-.531.53-1.277.53zm2.492-7.121L5.533 5.244a8.4 8.4 0 0 1 2.255-1.119 8.1 8.1 0 0 1 2.471-.375q1.01 0 1.977.227a9.2 9.2 0 0 1 1.92.69L9.916 9.63Zm-.096-2.21 1.73-2.023a6 6 0 0 0-1.292-.146q-.576 0-1.12.099a7 7 0 0 0-1.087.291L9.82 7.42Z"
  }
));
var Stroller_default = SvgStroller;

// src/icons/components/Sun.tsx
import * as React153 from "react";
var SvgSun = (props) => /* @__PURE__ */ React153.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React153.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 5.212V1.52h1.5v3.692zm6.073 2.519-1.029-1.029 2.58-2.663 1.063 1.079zm1.466 5.02v-1.5h3.692v1.5zm-7.539 9.73v-3.683h1.5v3.683zM6.696 7.691 4.04 5.127l1.088-1.054 2.614 2.604-1.045 1.014Zm12.162 12.27-2.564-2.663 1.014-1.003 2.62 2.548zM1.52 12.752v-1.5h3.692v1.5zm3.598 7.21-1.045-1.088 2.58-2.579.542.512.551.527-2.628 2.629Zm6.884-2.46q-2.29 0-3.896-1.604T6.5 12.003q0-2.29 1.604-3.896Q9.707 6.5 11.998 6.5q2.29 0 3.897 1.604Q17.5 9.708 17.5 11.998t-1.603 3.897Q14.293 17.5 12.002 17.5ZM12 16q1.65 0 2.825-1.176Q16.001 13.65 16 12c-.001-1.65-.391-2.041-1.175-2.825Q13.65 8 12 8c-1.65 0-2.041.392-2.825 1.175Q8 10.351 8 12c0 1.649.392 2.042 1.175 2.825Q10.351 16.001 12 16"
  }
));
var Sun_default = SvgSun;

// src/icons/components/Swipe.tsx
import * as React154 from "react";
var SvgSwipe = (props) => /* @__PURE__ */ React154.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React154.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.825 21.5a2.72 2.72 0 0 1-1.942-.808l-5.014-5.02.616-.62q.313-.304.726-.403t.822.012l2.217.581V7q0-.318.216-.535A.73.73 0 0 1 10 6.25a.73.73 0 0 1 .535.215.73.73 0 0 1 .215.535v10.238l-3.03-.829 3.232 3.224a1.29 1.29 0 0 0 .873.367h3.925q.94 0 1.595-.655A2.17 2.17 0 0 0 18 17.75v-4q0-.319.216-.535A.73.73 0 0 1 18.75 13a.73.73 0 0 1 .535.215.73.73 0 0 1 .215.535v4q0 1.554-1.098 2.652a3.6 3.6 0 0 1-2.65 1.098zm.339-6.75v-4q0-.32.215-.535a.73.73 0 0 1 .535-.215q.318 0 .534.215a.73.73 0 0 1 .215.535v4zm2.922 0v-3q0-.32.216-.535a.73.73 0 0 1 .535-.215q.318 0 .534.215a.73.73 0 0 1 .216.535v3zM21.5 7.192h-4.692V6H19.9a13.7 13.7 0 0 0-3.69-2.244A11 11 0 0 0 12 2.933q-2.2 0-4.21.823A13.7 13.7 0 0 0 4.1 6h3.092v1.192H2.5V2.5h1.192v2.265a14.7 14.7 0 0 1 3.903-2.22A12.3 12.3 0 0 1 12 1.74q2.292 0 4.405.804a14.7 14.7 0 0 1 3.903 2.221V2.5H21.5z"
  }
));
var Swipe_default = SvgSwipe;

// src/icons/components/Ticket.tsx
import * as React155 from "react";
var SvgTicket = (props) => /* @__PURE__ */ React155.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React155.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 16.654a.73.73 0 0 0 .535-.216.73.73 0 0 0 .215-.534.73.73 0 0 0-.216-.535.73.73 0 0 0-.534-.215.73.73 0 0 0-.535.216.73.73 0 0 0-.215.534q0 .319.216.534a.73.73 0 0 0 .534.216m0-3.904a.73.73 0 0 0 .535-.216.73.73 0 0 0 .215-.534.73.73 0 0 0-.216-.535.73.73 0 0 0-.534-.215.73.73 0 0 0-.535.216.73.73 0 0 0-.215.534q0 .32.216.535a.73.73 0 0 0 .534.215m0-3.904a.73.73 0 0 0 .535-.216.73.73 0 0 0 .215-.534.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.216.73.73 0 0 0-.535.216.73.73 0 0 0-.215.534q0 .32.216.535a.73.73 0 0 0 .534.215M19.692 19.5H4.308a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277v-3.288a2.42 2.42 0 0 0 1.427-.838Q4.5 12.892 4.5 12q0-.893-.573-1.566A2.42 2.42 0 0 0 2.5 9.596V6.308q0-.746.531-1.277A1.74 1.74 0 0 1 4.308 4.5h15.384q.746 0 1.277.531t.531 1.277v3.288a2.42 2.42 0 0 0-1.427.838A2.34 2.34 0 0 0 19.5 12q0 .893.573 1.566.573.675 1.427.838v3.288q0 .746-.531 1.277a1.74 1.74 0 0 1-1.277.531m0-1.5a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V15.45a4.1 4.1 0 0 1-1.462-1.462A3.85 3.85 0 0 1 18 12q0-1.076.538-1.988A4.1 4.1 0 0 1 20 8.55V6.308a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H4.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22V8.55a4.1 4.1 0 0 1 1.462 1.462q.54.914.539 1.988 0 1.076-.538 1.988A4.1 4.1 0 0 1 4 15.45v2.242a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087z"
  }
));
var Ticket_default = SvgTicket;

// src/icons/components/TransferCircle.tsx
import * as React156 from "react";
var SvgTransferCircle = (props) => /* @__PURE__ */ React156.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React156.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.346 17.654 10.4 16.6l-1.82-1.85H13v-1.5H8.58l1.82-1.85-1.054-1.054L5.692 14zm5.308-4L18.308 10l-3.654-3.654L13.6 7.4l1.82 1.85H11v1.5h4.42L13.6 12.6zM12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var TransferCircle_default = SvgTransferCircle;

// src/icons/components/Transfer.tsx
import * as React157 from "react";
var SvgTransfer = (props) => /* @__PURE__ */ React157.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React157.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.154 19.49 2.5 14.837l4.654-4.654 1.054 1.069-2.835 2.834h7.28v1.5h-7.28l2.835 2.835-1.054 1.07Zm9.692-5.682-1.054-1.07 2.835-2.834h-7.28v-1.5h7.28l-2.835-2.835L16.846 4.5 21.5 9.154z"
  }
));
var Transfer_default = SvgTransfer;

// src/icons/components/Trend.tsx
import * as React158 from "react";
var SvgTrend = (props) => /* @__PURE__ */ React158.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React158.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.554 17.548 2.5 16.494l6.852-6.901 4 4 5.613-5.545H16v-1.5h5.5v5.5H20V9.102l-6.648 6.648-4-4z"
  }
));
var Trend_default = SvgTrend;

// src/icons/components/Trophy.tsx
import * as React159 from "react";
var SvgTrophy = (props) => /* @__PURE__ */ React159.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React159.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.692 20.5V19h3.558v-3.427A5 5 0 0 1 9 14.502a4.46 4.46 0 0 1-1.388-2.033A4.65 4.65 0 0 1 4.69 11 4.23 4.23 0 0 1 3.5 8V7q0-.613.443-1.057A1.44 1.44 0 0 1 5 5.5h2.327v-2h9.346v2H19q.613 0 1.057.443.443.444.443 1.057v1a4.23 4.23 0 0 1-1.19 3 4.65 4.65 0 0 1-2.922 1.47A4.46 4.46 0 0 1 15 14.501q-.977.815-2.25 1.071V19h3.558v1.5zm-.365-9.642V7H5v1q0 1.046.656 1.837.656.792 1.67 1.02ZM12 14.135q1.317 0 2.236-.919.918-.918.918-2.235V5H8.846v5.98q0 1.318.918 2.236.92.92 2.236.919m4.673-3.277a2.96 2.96 0 0 0 1.671-1.02A2.8 2.8 0 0 0 19 8V7h-2.327z"
  }
));
var Trophy_default = SvgTrophy;

// src/icons/components/Umbrella.tsx
import * as React160 from "react";
var SvgUmbrella = (props) => /* @__PURE__ */ React160.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React160.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.75a.8.8 0 0 1-.423-.12.72.72 0 0 1-.287-.382L6.375 6.421l3.183.773L11.25 5.9V3.4q0-.895.653-1.522.652-.628 1.597-.628c.945 0 1.162.21 1.597.628q.653.628.653 1.522V4h-1.5v-.6a.68.68 0 0 0-.222-.52.75.75 0 0 0-.528-.205.73.73 0 0 0-.528.214.69.69 0 0 0-.222.511v2.5l1.692 1.294 3.183-.773-4.915 14.802a.8.8 0 0 1-.287.395.73.73 0 0 1-.423.132m.75-5.383 2.575-7.873-1.217.312L12.75 7.8zm-1.5 0V7.8L9.892 8.83 8.64 8.486l2.61 7.882Z"
  }
));
var Umbrella_default = SvgUmbrella;

// src/icons/components/Undo.tsx
import * as React161 from "react";
var SvgUndo = (props) => /* @__PURE__ */ React161.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React161.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.202 18.5V17h7.177q1.565 0 2.694-1.034t1.129-2.553-1.129-2.548q-1.129-1.028-2.694-1.029H7.358l2.782 2.783-1.053 1.054L4.5 9.087 9.087 4.5l1.053 1.054-2.782 2.783h7.02q2.195 0 3.76 1.464t1.564 3.612c0 2.148-.522 2.638-1.565 3.618S15.842 18.5 14.38 18.5z"
  }
));
var Undo_default = SvgUndo;

// src/icons/components/UnlinkAlt.tsx
import * as React162 from "react";
var SvgUnlinkAlt = (props) => /* @__PURE__ */ React162.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React162.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m7.948 14.366-2.665-2.665q-1.332-1.332-1.332-3.209t1.331-3.209q1.332-1.33 3.21-1.332 1.877 0 3.209 1.332l2.665 2.665-1.06 1.06-2.666-2.664a2.93 2.93 0 0 0-2.148-.891q-1.258 0-2.149.89a2.93 2.93 0 0 0-.89 2.15q0 1.257.89 2.148l2.665 2.665zm1.686 1.687 1.06-1.061 2.666 2.665q.891.89 2.148.89t2.149-.89q.89-.891.89-2.148t-.89-2.149l-2.665-2.665 1.06-1.06 2.666 2.665q1.33 1.33 1.331 3.209 0 1.876-1.331 3.209-1.332 1.33-3.21 1.331-1.876 0-3.209-1.331z"
  }
));
var UnlinkAlt_default = SvgUnlinkAlt;

// src/icons/components/Unlink.tsx
import * as React163 from "react";
var SvgUnlink = (props) => /* @__PURE__ */ React163.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React163.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m18.884 16.104-1.134-1.166a3 3 0 0 0 1.63-1.082A2.96 2.96 0 0 0 20 12q0-1.26-.885-2.15a2.9 2.9 0 0 0-2.134-.889h-3.808v-1.5h3.808q1.872 0 3.196 1.328 1.323 1.329 1.323 3.21 0 1.33-.714 2.429a4.64 4.64 0 0 1-1.902 1.676m-3.303-3.354-1.5-1.5h1.65v1.5zm4.565 9.504-18.4-18.4L2.8 2.8l18.4 18.4zm-9.32-5.716H7.039q-1.883 0-3.21-1.328Q2.5 13.883 2.5 12a4.37 4.37 0 0 1 1.074-2.926 4.35 4.35 0 0 1 2.695-1.52H6.5L7.908 8.96h-.87q-1.26 0-2.149.89A2.93 2.93 0 0 0 4 12q0 1.26.89 2.149c.89.889 1.31.89 2.15.89h3.788v1.5ZM8.27 12.75v-1.5h1.942l1.476 1.5h-3.42Z"
  }
));
var Unlink_default = SvgUnlink;

// src/icons/components/Unlock.tsx
import * as React164 from "react";
var SvgUnlock = (props) => /* @__PURE__ */ React164.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React164.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.308 20h11.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-9.385a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086H6.307a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v9.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087ZM12 16.75q.729 0 1.24-.51.51-.511.51-1.24c0-.729-.17-.9-.51-1.24q-.511-.51-1.24-.51c-.729 0-.9.17-1.24.51q-.51.51-.51 1.24c0 .73.17.899.51 1.24q.51.51 1.24.51M6.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-9.384q0-.75.53-1.278.53-.53 1.278-.53H13.5v-2q0-1.873 1.313-3.187Q16.128 2 18 2q1.873 0 3.186 1.313Q22.5 4.627 22.5 6.5H21q0-1.25-.875-2.125A2.9 2.9 0 0 0 18 3.5q-1.25 0-2.125.875A2.9 2.9 0 0 0 15 6.5v2h2.692q.749 0 1.278.53.53.53.53 1.278v9.384q0 .749-.53 1.278-.53.53-1.278.53z"
  }
));
var Unlock_default = SvgUnlock;

// src/icons/components/UpArrowSmall.tsx
import * as React165 from "react";
var SvgUpArrowSmall = (props) => /* @__PURE__ */ React165.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React165.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 17.654V8.108l-3.85 3.85-1.054-1.054L12 5.25l5.654 5.654-1.054 1.054-3.85-3.85v9.546z"
  }
));
var UpArrowSmall_default = SvgUpArrowSmall;

// src/icons/components/UpArrow.tsx
import * as React166 from "react";
var SvgUpArrow = (props) => /* @__PURE__ */ React166.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React166.createElement("path", { fill: "currentColor", d: "M11.25 19.5V7.373l-5.696 5.696L4.5 12 12 4.5l7.5 7.5-1.054 1.07-5.696-5.697V19.5z" }));
var UpArrow_default = SvgUpArrow;

// src/icons/components/Upload.tsx
import * as React167 from "react";
var SvgUpload = (props) => /* @__PURE__ */ React167.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React167.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 15.788v-8.4L8.785 9.854 7.73 8.769 12 4.5l4.27 4.27-1.055 1.084-2.465-2.466v8.4zM6.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283v-2.711H6v2.711q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-2.711h1.5v2.711q0 .758-.525 1.283t-1.283.525z"
  }
));
var Upload_default = SvgUpload;

// src/icons/components/VennDiagram.tsx
import * as React168 from "react";
var SvgVennDiagram = (props) => /* @__PURE__ */ React168.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React168.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 18.5q-2.714 0-4.607-1.893C1.5 14.714 1.5 13.809 1.5 12q0-2.714 1.893-4.607C5.286 5.5 6.191 5.5 8 5.5a6 6 0 0 1 2.906.744 6 6 0 0 0-.584.57q-.275.307-.522.632a3.7 3.7 0 0 0-.85-.33A3.8 3.8 0 0 0 8.001 7Q5.926 7 4.463 8.462 3 9.925 3 12c0 2.075.487 2.563 1.462 3.537Q5.925 17 8 17q.496 0 .951-.116a3.7 3.7 0 0 0 .849-.33q.248.324.522.632.274.306.584.57A5.94 5.94 0 0 1 8 18.5m8 0a6 6 0 0 1-2.906-.744q.31-.264.584-.57.273-.308.522-.632.41.213.857.33.447.116.943.116 2.075 0 3.538-1.463Q20.999 14.075 21 12c.001-2.075-.488-2.563-1.462-3.538Q18.074 7 16 7q-.496 0-.943.116a4 4 0 0 0-.857.33 11 11 0 0 0-.522-.632 6 6 0 0 0-.584-.57A5.94 5.94 0 0 1 16 5.5q2.714 0 4.607 1.893C22.5 9.286 22.5 10.191 22.5 12q0 2.714-1.893 4.607C18.714 18.5 17.809 18.5 16 18.5m-4-1.404a6.3 6.3 0 0 1-1.842-2.25A6.4 6.4 0 0 1 9.5 12q0-1.504.658-2.846A6.3 6.3 0 0 1 12 6.904a6.3 6.3 0 0 1 1.842 2.25Q14.5 10.496 14.5 12q0 1.503-.658 2.846A6.3 6.3 0 0 1 12 17.096"
  }
));
var VennDiagram_default = SvgVennDiagram;

// src/icons/components/VerticalBar.tsx
import * as React169 from "react";
var SvgVerticalBar = (props) => /* @__PURE__ */ React169.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React169.createElement("path", { fill: "currentColor", d: "M10.5 4h3v16h-3z" }));
var VerticalBar_default = SvgVerticalBar;

// src/icons/components/WarningFilled.tsx
import * as React170 from "react";
var SvgWarningFilled = (props) => /* @__PURE__ */ React170.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React170.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.865 20.5 12 3l10.134 17.5zM12 17.808a.78.78 0 0 0 .575-.233.78.78 0 0 0 .232-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.575-.232.78.78 0 0 0-.576.232.78.78 0 0 0-.232.576q0 .343.232.575a.78.78 0 0 0 .576.233m-.75-2.616h1.5v-5h-1.5z"
  }
));
var WarningFilled_default = SvgWarningFilled;

// src/icons/components/Warning.tsx
import * as React171 from "react";
var SvgWarning = (props) => /* @__PURE__ */ React171.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React171.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.865 20.5 12 3l10.134 17.5zM4.45 19h15.1L12 6zM12 17.808a.78.78 0 0 0 .575-.233.78.78 0 0 0 .232-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.575-.232.78.78 0 0 0-.576.232.78.78 0 0 0-.232.576q0 .343.232.575a.78.78 0 0 0 .576.233m-.75-2.616h1.5v-5h-1.5z"
  }
));
var Warning_default = SvgWarning;

// src/icons/components/Webinar.tsx
import * as React172 from "react";
var SvgWebinar = (props) => /* @__PURE__ */ React172.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React172.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.346 14.654h7.308v-.358q0-1-.99-1.571-.99-.57-2.664-.571-1.675 0-2.664.571t-.99 1.571zM12 10.846q.729 0 1.24-.51.51-.51.51-1.24c0-.73-.17-.899-.51-1.24q-.511-.51-1.24-.51c-.729 0-.9.17-1.24.51q-.51.511-.51 1.24c0 .729.17.9.51 1.24q.51.51 1.24.51M8.5 20.5v-2H4.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T4.308 3.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525H15.5v2zM4.308 17h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  }
));
var Webinar_default = SvgWebinar;

// src/icons/components/WeddingBands.tsx
import * as React173 from "react";
var SvgWeddingBands = (props) => /* @__PURE__ */ React173.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React173.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 17q2.075 0 3.538-1.463Q21 14.075 21 12c0-2.075-.488-2.563-1.462-3.538Q18.074 7 16 7a4.7 4.7 0 0 0-2.894.973 6.3 6.3 0 0 1 1.03 1.86A6.5 6.5 0 0 1 14.5 12a6.5 6.5 0 0 1-.364 2.166 6.3 6.3 0 0 1-1.03 1.86A4.72 4.72 0 0 0 16 17m-4-2a4.93 4.93 0 0 0 1-3 4.92 4.92 0 0 0-1-3 4.93 4.93 0 0 0-1 3 4.92 4.92 0 0 0 1 3m-4 2a4.7 4.7 0 0 0 2.894-.973 6.3 6.3 0 0 1-1.03-1.86A6.5 6.5 0 0 1 9.5 12q0-1.139.363-2.166a6.3 6.3 0 0 1 1.031-1.86A4.72 4.72 0 0 0 8 7Q5.925 7 4.462 8.462 3 9.925 3 12c0 2.075.487 2.563 1.462 3.537Q5.925 17 8 17m0 1.5q-2.714 0-4.607-1.893C1.5 14.714 1.5 13.809 1.5 12q0-2.714 1.893-4.607C5.286 5.5 6.191 5.5 8 5.5a6.3 6.3 0 0 1 4 1.404A6.3 6.3 0 0 1 16 5.5q2.714 0 4.607 1.893C22.5 9.286 22.5 10.191 22.5 12q0 2.714-1.893 4.607C18.714 18.5 17.809 18.5 16 18.5a6.3 6.3 0 0 1-4-1.404A6.28 6.28 0 0 1 8 18.5"
  }
));
var WeddingBands_default = SvgWeddingBands;

// src/icons/components/WeddingCake.tsx
import * as React174 from "react";
var SvgWeddingCake = (props) => /* @__PURE__ */ React174.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React174.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.997 6.5 2.614-2.669c.247-.25.387-.59.389-.946a1.36 1.36 0 0 0-.38-.95l-.041-.044a1.3 1.3 0 0 0-.93-.391c-.348 0-.682.14-.929.39l-.718.733-.717-.732a1.3 1.3 0 0 0-.93-.391c-.348 0-.682.14-.929.39l-.043.045A1.36 1.36 0 0 0 9 2.883c0 .355.138.696.383.948zM20 16.5v-4a2 2 0 0 0-2-2v-2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2a2 2 0 0 0-2 2v4H3v2h7a1 1 0 1 1 0 2H9v2h6v-2h-1a1 1 0 1 1 0-2h7v-2zm-1.5 0v-4a.5.5 0 0 0-.5-.5h-1.5V8.5A.5.5 0 0 0 16 8H8a.5.5 0 0 0-.5.5V12H6a.5.5 0 0 0-.5.5v4z",
    clipRule: "evenodd"
  }
));
var WeddingCake_default = SvgWeddingCake;

// src/icons/components/Withdraw.tsx
import * as React175 from "react";
var SvgWithdraw = (props) => /* @__PURE__ */ React175.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React175.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h6.702V5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h6.702v1.5zm10.923-4.23-1.039-1.085 2.435-2.435h-8.53v-1.5h8.53l-2.435-2.435 1.039-1.084L20.5 12l-4.27 4.27Z"
  }
));
var Withdraw_default = SvgWithdraw;

// src/icons/components/XCircle.tsx
import * as React176 from "react";
var SvgXCircle = (props) => /* @__PURE__ */ React176.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React176.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m8.4 16.654 3.6-3.6 3.6 3.6 1.054-1.054-3.6-3.6 3.6-3.6L15.6 7.346l-3.6 3.6-3.6-3.6L7.346 8.4l3.6 3.6-3.6 3.6zm3.602 4.846a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }
));
var XCircle_default = SvgXCircle;

// src/icons/components/X.tsx
import * as React177 from "react";
var SvgX = (props) => /* @__PURE__ */ React177.createElement("svg", { fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React177.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.4 18.654 5.346 17.6l5.6-5.6-5.6-5.6L6.4 5.346l5.6 5.6 5.6-5.6L18.654 6.4l-5.6 5.6 5.6 5.6-1.054 1.054-5.6-5.6z"
  }
));
var X_default = SvgX;

// src/components/icon/icon.tsx
var iconStyle = cva({
  variants: {
    size: {
      xxsmall: { width: "icon.xxsmall", height: "icon.xxsmall" },
      xsmall: { width: "icon.xsmall", height: "icon.xsmall" },
      small: { width: "icon.small", height: "icon.small" },
      medium: { width: "icon.medium", height: "icon.medium" },
      large: { width: "icon.large", height: "icon.large" },
      inline: { width: "1em", height: "1em" }
    }
  }
});
var IconWrapper = styled("span", {
  base: {
    display: "inline-block"
  },
  variants: {
    size: {
      xxsmall: { width: "icon.xxsmall", height: "icon.xxsmall" },
      xsmall: { width: "icon.xsmall", height: "icon.xsmall" },
      small: { width: "icon.small", height: "icon.small" },
      medium: { width: "icon.medium", height: "icon.medium" },
      large: { width: "icon.large", height: "icon.large" },
      inline: { width: "1em", height: "1em", lineHeight: "1" }
    }
  }
});
var Icon = (props) => {
  const {
    size,
    name,
    css: cssProp,
    color = "currentColor",
    label,
    mode = "decorative",
    "data-samba-target": dataSambaTarget,
    ...iconProps
  } = props;
  const colorValue = color === "currentColor" ? "currentColor" : token.var(`colors.${color}`);
  const wrapperStyle = { color: colorValue };
  const RawIcon = components_exports[name];
  const className = css(iconStyle.raw({ size }), cssProp);
  return /* @__PURE__ */ React178.createElement(
    IconWrapper,
    {
      "data-samba-component": true,
      "data-samba-target": dataSambaTarget,
      style: wrapperStyle,
      size,
      className
    },
    /* @__PURE__ */ React178.createElement(RawIcon, { "aria-hidden": true, focusable: false, ...iconProps }),
    mode === "functional" && /* @__PURE__ */ React178.createElement(VisuallyHidden, null, label)
  );
};
Icon.displayName = "Icon";

// src/components/accordion/accordion.tsx
var rootStyles = css2.raw({
  bg: "background.surface"
});
var Root2 = ({ css: cssProp, children, ...props }) => {
  const className = css2(rootStyles, cssProp);
  return /* @__PURE__ */ React179.createElement(AccordionPrimitive.Root, { "data-samba-component": true, className, ...props }, children);
};
var itemStyles = css2.raw({
  borderBottom: "token(borderWidths.thin) solid token(colors.border)"
});
var Item2 = React179.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css2(itemStyles, cssProp);
  return /* @__PURE__ */ React179.createElement(AccordionPrimitive.Item, { "data-samba-component": true, className, ref: forwardedRef, ...props }, children);
});
var buttonColorReset = css2.raw({
  color: "text",
  paddingInline: "space.0"
});
var triggerStyles = css2.raw({
  ...buttonColorReset,
  border: "none",
  paddingY: "space.300",
  textStyle: "title100",
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: "space.50",
  cursor: "pointer",
  bg: "background.surface",
  '&[data-state="open"] [data-samba-target="Accordion.Trigger-Icon"]': {
    transform: "rotate(90deg)"
  },
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    borderRadius: "medium",
    outlineOffset: "calc(-1 * token(borderWidths.thick))",
    outline: "token(borderWidths.thick) solid token(colors.border.focused)"
  }
});
var Trigger2 = React179.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css2(triggerStyles, cssProp);
  return /* @__PURE__ */ React179.createElement(AccordionPrimitive.Header, { "data-samba-component": true, className: css2({ display: "flex" }) }, /* @__PURE__ */ React179.createElement(AccordionPrimitive.Trigger, { "data-samba-component": true, className, ref: forwardedRef, ...props }, /* @__PURE__ */ React179.createElement(
    Icon,
    {
      name: "CaretRight",
      size: "small",
      color: "icon",
      "data-samba-target": "Accordion.Trigger-Icon",
      css: { flexShrink: 0, transition: "transform", transitionDuration: "200ms" }
    }
  ), children));
});
var contentStyles = css2.raw({
  overflow: "hidden",
  bg: "background.surface",
  transition: "all",
  '&[data-state="open"]': {
    animation: "accordionDown"
  },
  '&[data-state="closed"]': {
    animation: "accordionUp"
  }
});
var Content2 = React179.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css2(contentStyles, cssProp);
  return /* @__PURE__ */ React179.createElement(AccordionPrimitive.Content, { "data-samba-component": true, className, ref: forwardedRef, ...props }, children);
});
var CompositeComponent = Object.assign(Root2, { Item: Item2, Trigger: Trigger2, Content: Content2 });
var Accordion = CompositeComponent;
Accordion.displayName = "Accordion";
Accordion.Item.displayName = "Accordion.Item";
Accordion.Trigger.displayName = "Accordion.Trigger";
Accordion.Content.displayName = "Accordion.Content";

// src/components/banner/banner.tsx
import React182, { forwardRef as forwardRef3 } from "react";
import { css as css6, sva } from "@betterment/samba-styled-system/css";

// src/components/box/box.tsx
import React180, { forwardRef } from "react";
import { css as css3 } from "@betterment/samba-styled-system/css";
import { Slot } from "@radix-ui/react-slot";
var Box = forwardRef((props, forwardedRef) => {
  const { css: cssProp = {}, children, as: Tag2 = "div", asChild, ...boxProps } = props;
  const Component = asChild ? Slot : Tag2;
  return /* @__PURE__ */ React180.createElement(Component, { "data-samba-component": true, ref: forwardedRef, className: css3(cssProp), ...boxProps }, children);
});
Box.displayName = "Box";

// src/components/icon-button/icon-button.tsx
import React181, { forwardRef as forwardRef2 } from "react";
import { css as css5 } from "@betterment/samba-styled-system/css";

// src/components/shared/clickable-styles.tsx
import { css as css4, cva as cva2 } from "@betterment/samba-styled-system/css";
var buttonOverrideStyles = css4.raw({
  appearance: "none",
  background: "none",
  border: "none",
  padding: "0",
  margin: "0",
  color: "inherit",
  textAlign: "inherit",
  textDecoration: "none",
  lineHeight: "inherit",
  outline: "none"
});
var linkBaseStyles = css4.raw({
  ...buttonOverrideStyles,
  cursor: "pointer",
  textDecoration: "none",
  textDecorationSkipInk: "auto",
  fontFamily: "gtAmerica",
  width: "fit-content",
  height: "fit-content",
  _focusVisible: {
    outline: "token(borderWidths.thick) solid token(colors.border.focused)",
    outlineOffset: "1px"
  },
  _disabled: {
    cursor: "not-allowed",
    color: "text.disabled",
    _hover: { color: "text.disabled" }
  }
});
var linkVariantStyles = cva2({
  base: { ...linkBaseStyles },
  variants: {
    variant: {
      textPrimary: {
        color: "text.link",
        _active: { color: "text.link.active", textDecoration: "underline" },
        _hover: { color: "text.link.hover", textDecoration: "underline" },
        _disabled: {
          _hover: { textDecoration: "none" }
        }
      },
      textSecondary: {
        color: "currentcolor",
        textDecoration: "underline"
      },
      textCritical: {
        color: "text.critical",
        _active: { color: "text.critical.active", textDecoration: "underline" },
        _hover: { color: "text.critical.hover", textDecoration: "underline" },
        _disabled: {
          _hover: { textDecoration: "none" }
        }
      }
    }
  }
});
var buttonBaseStyles = css4.raw({
  textDecoration: "none",
  alignItems: "center",
  border: "none",
  borderRadius: "medium",
  cursor: "pointer",
  display: "inline-flex",
  verticalAlign: "middle",
  textAlign: "center",
  gap: "space.50",
  justifyContent: "center",
  textStyle: "title100",
  _disabled: {
    cursor: "not-allowed"
  },
  _focusVisible: {
    outline: "token(borderWidths.thick) solid token(colors.border.focused)",
    outlineOffset: "1px"
  }
});
var buttonVariantStyles = cva2({
  base: { ...buttonBaseStyles },
  variants: {
    variant: {
      solidPrimary: {
        bg: "background.primary",
        color: "text.onPrimary",
        _hover: { bg: "background.primary.hover" },
        _disabled: {
          bg: "background.primary.disabled",
          color: "text.onPrimary.disabled",
          _hover: { bg: "background.primary.disabled" }
        }
      },
      solidSecondary: {
        bg: "background.surface",
        boxShadow: "inset 0 0 0 1px token(colors.border.strong)",
        color: "text",
        _hover: { bg: "background.surface.hover" },
        _disabled: {
          bg: "background.surface.disabled",
          color: "text.disabled",
          _hover: { bg: "background.surface.disabled" }
        }
      },
      solidCritical: {
        bg: "background.critical.strong",
        color: "text.onPrimary",
        _hover: { bg: "background.critical.strong.hover" },
        _disabled: {
          bg: "background.critical.strong.disabled",
          color: "text.onPrimary.disabled",
          _hover: { bg: "background.critical.strong.disabled" }
        }
      },
      ghostPrimary: {
        bg: "background.transparent",
        color: "text.link",
        _hover: { bg: "background.transparent.hover" },
        _disabled: {
          color: "text.disabled",
          _hover: { bg: "background.transparent" }
        }
      },
      ghostSecondary: {
        bg: "background.transparent",
        color: "text",
        _hover: { bg: "background.transparent.hover" },
        _disabled: {
          color: "text.disabled",
          _hover: { bg: "background.transparent" }
        }
      },
      ghostCritical: {
        bg: "background.transparent",
        color: "text.critical",
        _hover: { bg: "background.transparent.hover" },
        _disabled: {
          color: "text.disabled",
          _hover: { bg: "background.transparent" }
        }
      }
    }
  }
});
var buttonSpacingStyles = cva2({
  variants: {
    spacing: {
      default: { py: "space.150", px: "space.300", minHeight: "48px" },
      compact: { py: "space.50", px: "space.200", minHeight: "32px", textStyle: "title50" }
    }
  }
});
var iconButtonSpacingStyles = cva2({
  variants: {
    spacing: {
      default: { py: "space.150", px: "space.150", gap: "space.100" },
      compact: { py: "space.50", px: "space.50", gap: "space.50" },
      none: { py: "space.0", px: "space.0", gap: "space.25" }
    }
  }
});
function isButtonStyle(value) {
  return buttonVariantStyles.variantMap.variant.includes(value);
}
function isLinkStyle(value) {
  return linkVariantStyles.variantMap.variant.includes(value);
}
function generateClickableStyles({ variant, spacing }) {
  if (isButtonStyle(variant)) {
    return css4.raw(buttonVariantStyles.raw({ variant }), buttonSpacingStyles.raw({ spacing }));
  }
  if (isLinkStyle(variant)) {
    return css4.raw(linkVariantStyles.raw({ variant }));
  }
  throw new Error("Unable to generate variant styles");
}

// src/components/icon-button/icon-button.tsx
var IconButton = forwardRef2((props, forwardedRef) => {
  const { label, name, variant = "ghostSecondary", spacing = "default", css: cssProp, ...buttonProps } = props;
  const className = css5(iconButtonSpacingStyles.raw({ spacing }), buttonVariantStyles.raw({ variant }), cssProp);
  return /* @__PURE__ */ React181.createElement(
    "button",
    {
      "data-samba-component": true,
      type: "button",
      ref: forwardedRef,
      className,
      "aria-label": label,
      ...buttonProps
    },
    React181.cloneElement(/* @__PURE__ */ React181.createElement(Icon, { size: "small", color: "currentColor", name }))
  );
});
IconButton.displayName = "IconButton";

// src/components/banner/banner.tsx
var ICONS = {
  info: "InfoFilled",
  success: "CheckmarkCircleFilled",
  warning: "WarningFilled",
  critical: "CancelFilled"
};
var bannerStyles = sva({
  slots: ["root", "icon"],
  base: {
    root: {
      display: "flex",
      alignItems: "flex-start",
      p: "space.200",
      gap: "space.100",
      borderRadius: "medium",
      textStyle: "text100",
      border: "token(borderWidths.thin) solid token(colors.border.weak)"
    }
  },
  variants: {
    variant: {
      info: {
        root: { bg: "background.info" },
        icon: { color: "icon.info" }
      },
      success: {
        root: { bg: "background.success" },
        icon: { color: "icon.success" }
      },
      warning: {
        root: { bg: "background.warning" },
        icon: { color: "icon.warning" }
      },
      critical: {
        root: { bg: "background.critical" },
        icon: { color: "icon.critical" }
      }
    }
  }
});
function Content3(props) {
  const { children, css: cssProp = {}, ...restProps } = props;
  const className = css6({ flexGrow: "1" }, cssProp);
  return /* @__PURE__ */ React182.createElement(Box, { ...restProps, className }, children);
}
Content3.displayName = "Banner.Content";
function Close({ label = "close", ...props }) {
  return /* @__PURE__ */ React182.createElement(IconButton, { name: "X", spacing: "none", label, ...props });
}
Close.displayName = "Banner.Close";
var BannerComponent = forwardRef3((props, forwardedRef) => {
  const { css: cssProp = {}, children, variant, ...bannerProps } = props;
  const classes = bannerStyles.raw({ variant });
  const className = css6(classes.root, cssProp);
  const iconColor = bannerStyles.raw({ variant }).icon.color;
  return /* @__PURE__ */ React182.createElement("div", { ref: forwardedRef, className, ...bannerProps }, /* @__PURE__ */ React182.createElement(Box, { css: { display: "flex" } }, /* @__PURE__ */ React182.createElement(Icon, { name: ICONS[variant], size: "small", color: iconColor })), children);
});
BannerComponent.displayName = "Banner";
var Banner = Object.assign(BannerComponent, { Close, Content: Content3 });

// src/components/button-legacy/button.tsx
import React185, { forwardRef as forwardRef4 } from "react";
import { css as css8, cva as cva4 } from "@betterment/samba-styled-system/css";
import { Slot as Slot2 } from "@radix-ui/react-slot";

// src/components/button/button-icon.tsx
import React183 from "react";
var ButtonIcon = ({ name, css: cssProp }) => React183.cloneElement(/* @__PURE__ */ React183.createElement(Icon, { size: "small", color: "currentColor", name, css: cssProp }));

// src/components/shared/button-base-variants.tsx
import { cva as cva3 } from "@betterment/samba-styled-system/css";
var buttonBaseVariants = cva3({
  base: {
    alignItems: "center",
    border: "none",
    borderRadius: "medium",
    cursor: "pointer",
    display: "flex",
    gap: "space.50",
    justifyContent: "center",
    textStyle: "title100",
    _disabled: {
      cursor: "not-allowed"
    },
    _focusVisible: {
      outline: "token(borderWidths.thick) solid token(colors.border.focused)",
      outlineOffset: "1px"
    }
  },
  variants: {
    variant: {
      primary: {
        bg: "background.primary",
        color: "text.onPrimary",
        _hover: { bg: "background.primary.hover" },
        _disabled: {
          bg: "background.primary.disabled",
          color: "text.onPrimary.disabled",
          _hover: { bg: "background.primary.disabled" }
        }
      },
      secondary: {
        bg: "background.surface",
        boxShadow: "inset 0 0 0 1px token(colors.border.strong)",
        color: "text",
        _hover: { bg: "background.surface.hover" },
        _disabled: {
          bg: "background.surface.disabled",
          color: "text.disabled",
          _hover: { bg: "background.surface.disabled" }
        }
      },
      ghost: {
        bg: "background.transparent",
        color: "text.link",
        _hover: { bg: "background.transparent.hover" },
        _disabled: {
          color: "text.disabled",
          _hover: { bg: "background.transparent" }
        }
      },
      "ghost-alt": {
        bg: "background.transparent",
        color: "text",
        _hover: { bg: "background.transparent.hover" },
        _disabled: {
          color: "text.disabled",
          _hover: { bg: "background.transparent" }
        }
      },
      linkPrimary: {
        bg: "background.transparent",
        color: "text.link",
        display: "inline-flex",
        width: "fit-content",
        height: "fit-content",
        textStyle: "text100",
        _hover: {
          bg: "background.transparent",
          textDecoration: "underline"
        },
        _disabled: {
          color: "text.disabled",
          _hover: {
            bg: "background.transparent",
            textDecoration: "none"
          }
        }
      }
    }
  }
});

// src/components/spinner/spinner.tsx
import React184 from "react";
import { css as css7, sva as sva2 } from "@betterment/samba-styled-system/css";
var arcDuration = 1333;
var cycleDuration = 4 * arcDuration;
var linearRotationDuration = arcDuration * 360 / 306;
var indeterminateEasing = "cubic-bezier(0.4, 0, 0.2, 1)";
var baseCss = css7.raw({
  position: "absolute",
  inset: 0
});
var spinnerSlotStyles = sva2({
  slots: ["root", "circle"],
  base: {
    root: {
      display: "flex",
      verticalAlign: "middle",
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
      contain: "strict",
      contentVisibility: "auto"
    },
    circle: {
      ...baseCss,
      boxSizing: "border-box",
      borderRadius: "50%",
      animation: "expandArc",
      animationIterationCount: "infinite",
      animationFillMode: "both",
      animationDuration: `${arcDuration}ms, ${cycleDuration}ms`,
      animationTimingFunction: indeterminateEasing,
      borderColor: "currentColor currentColor transparent transparent"
    }
  },
  variants: {
    size: {
      xs: {
        root: { width: "20px", height: "20px" },
        circle: { border: "solid 2px" }
      },
      sm: {
        root: { width: "24px", height: "24px" },
        circle: { border: "solid 2.5px" }
      },
      md: {
        root: { width: "32px", height: "32px" },
        circle: { border: "solid 3px" }
      },
      lg: {
        root: { width: "48px", height: "48px" },
        circle: { border: "solid 4px" }
      }
    },
    variant: {
      primary: {
        root: {
          color: "token(colors.icon.accent.blue)"
        }
      },
      secondary: {
        root: { color: "token(colors.icon)" }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "primary"
  }
});
var progressCss = css7({
  ...baseCss,
  display: "block",
  margin: "space.25",
  flex: 1,
  alignSelf: "stretch",
  animation: "linear infinite rootRotate",
  animationDuration: `${linearRotationDuration}ms`
});
var spinnerCss = css7({
  ...baseCss,
  animation: "infinite both rotateArc",
  animationDuration: `${cycleDuration}ms`,
  animationTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)"
});
var leftCss = css7({
  overflow: "hidden",
  position: "absolute",
  inset: "0 50% 0 0"
});
var rightCss = css7({
  overflow: "hidden",
  position: "absolute",
  inset: "0 0 0 50%"
});
var leftCircleCss = css7.raw({
  rotate: "135deg",
  inset: "0 -100% 0 0"
});
var rightCircleCss = css7.raw({
  rotate: "100deg",
  inset: "0 0 0 -100%",
  animationDelay: `${-0.5 * arcDuration}ms, 0ms`
});
var Spinner = ({ css: cssProp, size = "md", variant = "primary" }) => {
  const classes = spinnerSlotStyles.raw({ size, variant });
  return /* @__PURE__ */ React184.createElement("div", { className: css7(classes.root, cssProp) }, /* @__PURE__ */ React184.createElement("div", { role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 1, className: progressCss }, /* @__PURE__ */ React184.createElement("div", { className: spinnerCss }, /* @__PURE__ */ React184.createElement("div", { className: leftCss }, /* @__PURE__ */ React184.createElement("div", { className: css7(classes.circle, leftCircleCss) })), /* @__PURE__ */ React184.createElement("div", { className: rightCss }, /* @__PURE__ */ React184.createElement("div", { className: css7(classes.circle, rightCircleCss) })))));
};
Spinner.displayName = "Spinner";

// src/components/button-legacy/button.tsx
var buttonSpacingStyles2 = cva4({
  variants: {
    spacing: {
      default: { py: "space.150", px: "space.300", minHeight: "48px" },
      compact: { py: "space.50", px: "space.200", minHeight: "32px", textStyle: "title50" },
      none: { py: "space.0", px: "space.0" }
    }
  }
});
var ButtonComponent = forwardRef4((props, forwardedRef) => {
  const {
    asChild = false,
    children,
    css: cssProp,
    disabled,
    variant = "primary",
    spacing: spacingProp = "default",
    loading,
    ...buttonProps
  } = props;
  const spacing = variant === "linkPrimary" ? "none" : spacingProp;
  const className = css8(
    buttonBaseVariants.raw({ variant }),
    buttonSpacingStyles2.raw({ spacing }),
    loading && css8.raw({ _disabled: { cursor: "progress" } }),
    cssProp
  );
  const Component = asChild ? Slot2 : "button";
  return /* @__PURE__ */ React185.createElement(
    Component,
    {
      "data-samba-component": true,
      ref: forwardedRef,
      className,
      disabled: disabled || loading,
      ...buttonProps
    },
    loading ? /* @__PURE__ */ React185.createElement(Box, { css: { display: "grid", justifyItems: "center", alignItems: "center" } }, /* @__PURE__ */ React185.createElement(
      Spinner,
      {
        "aria-hidden": true,
        size: spacing === "default" ? "sm" : "xs",
        css: {
          color: "currentcolor",
          gridColumnStart: 1,
          gridRowStart: 1,
          textAlign: "center"
        }
      }
    ), /* @__PURE__ */ React185.createElement(Box, { css: { color: "transparent", gridColumnStart: 1, gridRowStart: 1 } }, children)) : children
  );
});
var Button = ButtonComponent;
Button.Icon = ButtonIcon;
Button.displayName = "Button";
Button.Icon.displayName = "Button.Icon";

// src/components/button/button.tsx
import React186, { forwardRef as forwardRef5 } from "react";
import { css as css9 } from "@betterment/samba-styled-system/css";
var ButtonSpinner = ({ children, spacing }) => {
  return /* @__PURE__ */ React186.createElement(Box, { css: { display: "grid", justifyItems: "center", alignItems: "center" } }, /* @__PURE__ */ React186.createElement(
    Spinner,
    {
      "aria-hidden": true,
      size: spacing === "default" ? "sm" : "xs",
      css: {
        color: "currentcolor",
        gridColumnStart: 1,
        gridRowStart: 1,
        textAlign: "center"
      }
    }
  ), /* @__PURE__ */ React186.createElement(Box, { css: { color: "transparent", gridColumnStart: 1, gridRowStart: 1 } }, children));
};
var ButtonComponent2 = forwardRef5((props, forwardedRef) => {
  const {
    children,
    css: cssProp,
    disabled,
    variant = "solidPrimary",
    spacing = "default",
    loading,
    ...buttonProps
  } = props;
  const className = css9(generateClickableStyles({ variant, spacing }), cssProp);
  return /* @__PURE__ */ React186.createElement(
    "button",
    {
      "data-samba-component": true,
      ref: forwardedRef,
      className,
      disabled: disabled || loading,
      type: "button",
      ...buttonProps
    },
    loading ? /* @__PURE__ */ React186.createElement(ButtonSpinner, { spacing }, children) : children
  );
});
var Button2 = ButtonComponent2;
Button2.Icon = ButtonIcon;
Button2.displayName = "Button";
Button2.Icon.displayName = "Button.Icon";

// src/components/card/card.tsx
import React187, { forwardRef as forwardRef6 } from "react";
import { css as css10 } from "@betterment/samba-styled-system/css";
import { styled as styled2 } from "@betterment/samba-styled-system/jsx";
var cardStyles = css10.raw({
  display: "flex",
  flexDirection: "column",
  bg: "background.surface",
  overflow: "hidden",
  boxShadow: "0px 1px 0px token(colors.primitives.grey.90alpha10)",
  sm: {
    borderRadius: "medium"
  }
});
var Root3 = forwardRef6(({ children, css: cssProp, ...props }, forwardedRef) => {
  const className = css10.raw(cardStyles, cssProp);
  return /* @__PURE__ */ React187.createElement(Box, { ref: forwardedRef, css: className, ...props }, children);
});
var Header2 = styled2("div");
var Content4 = styled2("div");
var Footer = styled2("div");
Header2.displayName = "Card.Header";
Content4.displayName = "Card.Content";
Footer.displayName = "Card.Footer";
var Card = Object.assign(Root3, { Header: Header2, Content: Content4, Footer });
Card.displayName = "Card";

// src/layouts/centered-layout/centered-layout.tsx
import React188 from "react";
import { css as css11, cva as cva5 } from "@betterment/samba-styled-system/css";
var centeredLayoutStyles = cva5({
  base: {
    mx: "auto",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start"
  },
  variants: {
    size: {
      small: {
        maxWidth: "container.medium"
      },
      medium: {
        maxWidth: "container.large"
      },
      large: {
        maxWidth: "container.xlarge"
      },
      full: {
        maxWidth: "container.max"
      }
    }
  }
});
var CenteredLayout = ({ css: cssProp, size, children }) => {
  const className = css11(centeredLayoutStyles.raw({ size }), cssProp);
  return /* @__PURE__ */ React188.createElement("div", { className }, children);
};

// src/components/checkbox/checkbox.tsx
import React194 from "react";
import { css as css14, cva as cva8 } from "@betterment/samba-styled-system/css";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

// src/components/form/formik-field.tsx
import React192, { useMemo as useMemo2 } from "react";
import { Slot as Slot4 } from "@radix-ui/react-slot";
import { ErrorMessage, useField } from "formik";

// src/components/form/label.tsx
import React189, { forwardRef as forwardRef7 } from "react";
import { css as css12, cva as cva6 } from "@betterment/samba-styled-system/css";
import { Root as Root4 } from "@radix-ui/react-label";
var labelStyles = cva6({
  base: {
    display: "block",
    textStyle: "text100",
    color: "text"
  }
});
var Label = forwardRef7(
  ({ css: cssProp = {}, htmlFor, children, ...rest }, forwardedRef) => {
    const className = css12(labelStyles.raw(), cssProp);
    return /* @__PURE__ */ React189.createElement(Root4, { "data-samba-component": true, ref: forwardedRef, htmlFor, className, ...rest }, children);
  }
);
Label.displayName = "Label";

// src/components/form/utilities/field-id.tsx
import React190, { useMemo } from "react";
var FieldIdContext = React190.createContext(void 0);
var FieldIdProvider = ({ id: idProp, children }) => {
  const id = idProp || React190.useId();
  const value = useMemo(() => ({ id }), [id]);
  return /* @__PURE__ */ React190.createElement(FieldIdContext.Provider, { value }, children);
};
var useFieldId = () => {
  const context = React190.useContext(FieldIdContext);
  if (!context) {
    throw new Error("useFieldId must be used within a FieldIdProvider");
  }
  return context.id;
};

// src/components/text/text.tsx
import React191, { forwardRef as forwardRef8 } from "react";
import { css as css13, cva as cva7 } from "@betterment/samba-styled-system/css";
import { token as token2 } from "@betterment/samba-styled-system/tokens";
import { Slot as Slot3 } from "@radix-ui/react-slot";
var textCss = cva7({
  variants: {
    variant: {
      text400: { textStyle: "text400" },
      text300: { textStyle: "text300" },
      text200: { textStyle: "text200" },
      text100: { textStyle: "text100" },
      text50: { textStyle: "text50" },
      text25: { textStyle: "text25" },
      caption: { textStyle: "caption" },
      smallCaps: { textStyle: "smallCaps" }
    }
  }
});
var Text = forwardRef8((props, forwardedRef) => {
  const { variant = "text100", css: cssProp = {}, color, as: Tag2 = "span", children, asChild, ...textProps } = props;
  const colorValue = color ? token2.var(`colors.${color}`) : null;
  const style = { color: colorValue };
  const className = css13(textCss.raw({ variant }), css13.raw({ color }), cssProp);
  const Component = asChild ? Slot3 : Tag2;
  return /* @__PURE__ */ React191.createElement(Component, { "data-samba-component": true, style, ref: forwardedRef, className, ...textProps }, children);
});
Text.displayName = "Text";

// src/components/form/formik-field.tsx
var FormikFieldContext = React192.createContext(void 0);
function isFormFieldName(propsOrFieldName) {
  return propsOrFieldName.name !== void 0;
}
function formikFieldName(propsOrFieldName) {
  return isFormFieldName(propsOrFieldName) ? propsOrFieldName.name : propsOrFieldName.fieldHookConfig.name;
}
var useFormikField = () => {
  const context = React192.useContext(FormikFieldContext);
  if (!context) {
    throw new Error("useFormikFieldContext must be used within a FormikFieldContext.Provider");
  }
  const { id, ...propsOrFieldName } = context;
  const fieldState = useField(
    isFormFieldName(propsOrFieldName) ? propsOrFieldName.name : propsOrFieldName.fieldHookConfig
  );
  return {
    id,
    propsOrFieldName,
    fieldState
  };
};
var FormikFieldProvider = ({
  propsOrFieldName,
  children
}) => {
  const id = useFieldId();
  const value = useMemo2(() => ({ id, ...propsOrFieldName }), []);
  return /* @__PURE__ */ React192.createElement(FormikFieldContext.Provider, { value }, /* @__PURE__ */ React192.createElement(Box, null, children));
};
var Root5 = ({ id: idProp, children, ...props }) => {
  return /* @__PURE__ */ React192.createElement(FieldIdProvider, { id: idProp }, /* @__PURE__ */ React192.createElement(FormikFieldProvider, { propsOrFieldName: props }, children));
};
var FormikControl = ({ children, css: cssProp, ...props }) => {
  const { fieldState } = useFormikField();
  const id = useFieldId();
  const [field, { error }] = fieldState;
  const appearance = error ? "critical" : "default";
  const controlProps = {
    formStrategy: "formik",
    appearance
  };
  return /* @__PURE__ */ React192.createElement(Box, { css: cssProp }, /* @__PURE__ */ React192.createElement(Slot4, { id, ...field, ...props, ...controlProps }, children));
};
var FormikLabel = ({ children }) => {
  const id = useFieldId();
  return /* @__PURE__ */ React192.createElement(Label, { htmlFor: id, css: { mb: "space.100" } }, children);
};
var FormikDescription = ({ children }) => {
  return /* @__PURE__ */ React192.createElement(Text, { css: { textStyle: "caption", display: "block" } }, children);
};
var FormikErrorMessage = () => {
  const { propsOrFieldName } = useFormikField();
  const name = formikFieldName(propsOrFieldName);
  return /* @__PURE__ */ React192.createElement(ErrorMessage, { name }, (errorMessage) => /* @__PURE__ */ React192.createElement(Text, { css: { textStyle: "text50", color: "text.critical", display: "block" } }, errorMessage));
};
var FormikField = Root5;
FormikField.Control = FormikControl;
FormikField.Label = FormikLabel;
FormikField.Description = FormikDescription;
FormikField.ErrorMessage = FormikErrorMessage;
FormikField.displayName = "FormikField";
FormikField.Control.displayName = "FormikField.Control";
FormikField.Label.displayName = "FormikField.Label";
FormikField.Description.displayName = "FormikField.Description";
FormikField.ErrorMessage.displayName = "FormikField.ErrorMessage";

// src/components/form/utilities/form-strategy.ts
import React193 from "react";
var FormStrategyContext = React193.createContext(void 0);
var FormStrategyProvider = FormStrategyContext.Provider;
var useFormStrategy = () => {
  const context = React193.useContext(FormStrategyContext);
  if (!context) {
    throw new Error("useFormStrategy must be used within a FormStrategyProvider");
  }
  return context;
};

// src/components/checkbox/checkbox.tsx
var Container = ({
  formStrategy = "vanilla",
  children,
  id: idProp,
  css: cssProp,
  appearance,
  disabled,
  ...props
}) => {
  const id = idProp || React194.useId();
  const containerCss = css14.raw(
    {
      display: "flex",
      gap: "space.100",
      alignItems: "center"
    },
    cssProp
  );
  let control = null;
  let label = null;
  React194.Children.forEach(children, (child) => {
    if (!React194.isValidElement(child)) {
      return;
    }
    if (child.type.displayName === "Checkbox.Control") {
      control = child;
    }
    if (child.type.displayName === "Checkbox.Label") {
      label = child;
    }
  });
  return /* @__PURE__ */ React194.createElement(FormStrategyProvider, { value: formStrategy }, /* @__PURE__ */ React194.createElement(FieldIdProvider, { id }, /* @__PURE__ */ React194.createElement(Box, { css: containerCss }, control && React194.cloneElement(control, props), label)));
};
var rootStyles2 = cva8({
  base: {
    backgroundColor: "background.surface",
    width: "size.250",
    height: "size.250",
    borderRadius: "medium",
    display: "flex",
    flex: "none",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: "space.25",
    transition: "background-color 0.2s ease, border 0.1s ease-in-out",
    _focus: {
      outline: "2px solid token(colors.border.focused)",
      outlineOffset: "1px"
    },
    _hover: {
      backgroundColor: "background.surface.hover",
      _disabled: {
        backgroundColor: "background.input.disabled"
      }
    },
    _disabled: {
      border: "token(borderWidths.thin) solid token(colors.border.strong)",
      backgroundColor: "background.input.disabled",
      "& + label": {
        color: "text.disabled"
      }
    },
    "&[data-state=checked]": {
      backgroundColor: "background.primary",
      border: "none",
      _disabled: {
        border: "token(borderWidths.thin) solid token(colors.border.strong)"
      },
      _hover: {
        backgroundColor: "background.primary.hover",
        _disabled: {
          background: "background.input.disabled"
        }
      }
    }
  },
  variants: {
    appearance: {
      default: {
        border: "token(borderWidths.thin) solid token(colors.border.strong)"
      },
      critical: {
        border: "token(borderWidths.thin) solid token(colors.border.critical)"
      }
    }
  },
  defaultVariants: {
    appearance: "default"
  }
});
var indicatorStyles = css14({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "icon.inverse",
  "&[data-disabled=true]": {
    color: "icon.disabled"
  }
});
var checkmarkStyles = css14({
  fill: "currentColor"
});
var CustomCheckmark = (props) => /* @__PURE__ */ React194.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20", viewBox: "0 -960 960 960", width: "20", ...props }, /* @__PURE__ */ React194.createElement("path", { d: "M395-277.348 218.348-455l57.891-57.891L395-395.131l288.761-287.76L741.652-624 395-277.348Z" }));
var VanillaControl = React194.forwardRef(
  ({ id: idProp, css: cssProp, appearance, disabled, ...props }, forwardedRef) => {
    const id = idProp || useFieldId();
    const className = css14(rootStyles2.raw({ appearance }), cssProp);
    return /* @__PURE__ */ React194.createElement(
      CheckboxPrimitive.Root,
      {
        disabled,
        id,
        "data-samba-component": true,
        className,
        ...props,
        ref: forwardedRef
      },
      /* @__PURE__ */ React194.createElement(CheckboxPrimitive.Indicator, { className: indicatorStyles, "data-disabled": disabled }, /* @__PURE__ */ React194.createElement(CustomCheckmark, { className: checkmarkStyles }))
    );
  }
);
var FormikControl2 = React194.forwardRef((props, forwardedRef) => {
  const { fieldState } = useFormikField();
  const [field, { value, error }, { setValue }] = fieldState;
  const { value: _omitValue, ...rest } = field;
  const appearance = error ? "critical" : "default";
  return React194.cloneElement(/* @__PURE__ */ React194.createElement(VanillaControl, null), {
    ...props,
    ...rest,
    appearance,
    checked: value,
    onCheckedChange: (newValue) => void setValue(newValue),
    ref: forwardedRef
  });
});
var Control = React194.forwardRef((props, forwardedRef) => {
  const formStrategy = useFormStrategy();
  const Component = formStrategy === "formik" ? FormikControl2 : VanillaControl;
  return React194.cloneElement(/* @__PURE__ */ React194.createElement(Component, null), { ...props, ref: forwardedRef });
});
var ControlLabel = ({ children, ...props }) => {
  const id = useFieldId();
  return /* @__PURE__ */ React194.createElement(Label, { htmlFor: id, ...props }, children);
};
var Checkbox = Object.assign(Container, { Control, Label: ControlLabel });
Checkbox.displayName = "Checkbox";
Checkbox.Control.displayName = "Checkbox.Control";
Checkbox.Label.displayName = "Checkbox.Label";

// src/components/combobox/combobox.tsx
import React195, { cloneElement } from "react";
import { css as css15, sva as sva3 } from "@betterment/samba-styled-system/css";
import * as ReactAriaPrimitives from "react-aria-components";
var reactAriaComboBoxTriggerWidth = "var(--trigger-width)";
var { Section } = ReactAriaPrimitives;
var VanillaRoot = ({ children, ...props }) => {
  return /* @__PURE__ */ React195.createElement(ReactAriaPrimitives.ComboBox, { menuTrigger: "focus", ...props }, children);
};
var FormikRoot = ({ children, ...props }) => {
  const { propsOrFieldName, fieldState } = useFormikField();
  const [field, , { setValue }] = fieldState;
  return /* @__PURE__ */ React195.createElement(
    VanillaRoot,
    {
      name: formikFieldName(propsOrFieldName),
      onSelectionChange: (key) => void setValue(key),
      selectedKey: field.value,
      formValue: "text",
      ...props
    },
    children
  );
};
var Root7 = ({ formStrategy = "vanilla", ...props }) => {
  const Component = formStrategy === "formik" ? FormikRoot : VanillaRoot;
  return /* @__PURE__ */ React195.createElement(FormStrategyProvider, { value: formStrategy }, /* @__PURE__ */ React195.createElement(Component, { ...props }));
};
var inputColorReset = css15.raw({
  color: "text"
});
var comboBoxStyles = sva3({
  slots: ["input", "leadingIcon", "button"],
  base: {
    input: {
      ...inputColorReset,
      borderRadius: "medium",
      border: "token(borderWidths.thin) solid token(colors.border.input)",
      width: "100%",
      textStyle: "text100",
      backgroundColor: "background.surface",
      paddingX: "space.200",
      _placeholder: { color: "text.placeholder" },
      _focus: {
        outline: "2px solid token(colors.border.focused)",
        outlineOffset: "1px"
      },
      _disabled: {
        backgroundColor: "background.input.disabled",
        color: "text.disabled",
        cursor: "default",
        _placeholder: {
          color: "text.disabled"
        }
      }
    },
    leadingIcon: {
      alignSelf: "center",
      flexShrink: 0,
      position: "absolute",
      all: "unset",
      _disabled: {
        color: "text.disabled",
        _hover: {
          cursor: "default"
        }
      },
      _hover: {
        cursor: "text"
      }
    },
    button: {
      // Unset user agent stylesheet for RAC button
      all: "unset",
      alignItems: "center",
      cursor: "pointer",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      position: "absolute",
      right: "0px",
      _disabled: {
        color: "text.disabled",
        cursor: "default"
      }
    }
  },
  variants: {
    appearance: {
      default: {
        input: {
          borderColor: "border.input",
          _focus: {
            outlineColor: "border.focused"
          }
        }
      },
      critical: {
        input: {
          borderColor: "border.critical",
          _focus: {
            outlineColor: "border.critical"
          },
          _disabled: {
            borderColor: "border.input"
          }
        }
      }
    },
    spacing: {
      default: {
        input: {
          height: "48px",
          paddingRight: "space.600",
          paddingLeft: "space.200",
          '[data-samba-component="ComboBox.LeadingIconButton"] + &': {
            paddingLeft: "calc(token(spacing.space.150) + token(sizes.icon.small) + token(spacing.space.100))"
          }
        },
        leadingIcon: {
          left: "space.150"
        },
        button: {
          paddingRight: "space.200"
        }
      },
      compact: {
        input: {
          height: "40px",
          paddingRight: "space.500",
          paddingLeft: "space.150",
          '[data-samba-component="ComboBox.LeadingIconButton"] + &': {
            paddingLeft: "calc(token(spacing.space.100) + token(sizes.icon.small) + token(spacing.space.50))"
          }
        },
        leadingIcon: {
          left: "space.100"
        },
        button: {
          paddingRight: "space.150"
        }
      }
    }
  },
  defaultVariants: {
    appearance: "default",
    spacing: "default"
  }
});
var VanillaInput = React195.forwardRef(
  // Provide default aria-label for RAC button to override built-in label provided by RAC
  ({ placeholder, "aria-label": ariaLabel = "Show options", css: cssProp, leadingIcon, appearance, spacing, ...props }, forwardedRef) => {
    const classes = comboBoxStyles.raw({ appearance, spacing });
    return /* @__PURE__ */ React195.createElement(
      Box,
      {
        css: {
          display: "flex",
          position: "relative"
        }
      },
      leadingIcon && /* @__PURE__ */ React195.createElement(
        ReactAriaPrimitives.Button,
        {
          "data-samba-component": "ComboBox.LeadingIconButton",
          className: css15(classes.leadingIcon)
        },
        /* @__PURE__ */ React195.createElement(Icon, { name: leadingIcon, size: "small" })
      ),
      /* @__PURE__ */ React195.createElement(
        ReactAriaPrimitives.Input,
        {
          "data-samba-component": "ComboBox.Input",
          className: css15(classes.input, cssProp),
          placeholder,
          ref: forwardedRef,
          ...props
        }
      ),
      /* @__PURE__ */ React195.createElement(
        ReactAriaPrimitives.Button,
        {
          "aria-label": ariaLabel,
          "data-samba-component": "ComboBox.Button",
          className: css15(classes.button)
        },
        /* @__PURE__ */ React195.createElement(Icon, { name: "CaretDown", size: "small" })
      )
    );
  }
);
var FormikInput = (props) => {
  const { fieldState } = useFormikField();
  const [, { error }] = fieldState;
  const appearance = error ? "critical" : "default";
  return /* @__PURE__ */ React195.createElement(VanillaInput, { appearance, ...props });
};
var Input2 = (props) => {
  const formStrategy = useFormStrategy();
  const Component = formStrategy === "formik" ? FormikInput : VanillaInput;
  return cloneElement(/* @__PURE__ */ React195.createElement(Component, null), props);
};
var popoverStyles = css15({
  width: reactAriaComboBoxTriggerWidth,
  borderRadius: "medium",
  border: "token(borderWidths.thin) solid token(colors.border.input)",
  overflow: "hidden",
  flexDirection: "column",
  display: "flex",
  pointerEvents: "auto"
});
var listboxStyles = css15.raw({
  backgroundColor: "background.surface",
  display: "block",
  maxHeight: "300px",
  paddingY: "space.100",
  overflow: "hidden auto"
});
var Content5 = ({
  css: cssProp,
  children,
  UNSTABLE_portalContainer: unstablePortalContainer,
  ...props
}) => {
  const className = css15(listboxStyles, cssProp);
  return /* @__PURE__ */ React195.createElement(
    ReactAriaPrimitives.Popover,
    {
      UNSTABLE_portalContainer: unstablePortalContainer,
      className: popoverStyles,
      ...props
    },
    /* @__PURE__ */ React195.createElement(ReactAriaPrimitives.ListBox, { className }, children)
  );
};
var headerStyles = css15.raw({
  textStyle: "text50",
  color: "text.weak",
  paddingY: "space.100",
  paddingX: "space.200"
});
var Header4 = React195.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css15(headerStyles, cssProp);
  return /* @__PURE__ */ React195.createElement(ReactAriaPrimitives.Header, { className, ...props, ref: forwardedRef }, children);
});
var listboxItemStyles = css15.raw({
  outline: "none",
  textStyle: "text100",
  display: "flex",
  alignItems: "center",
  paddingY: "space.100",
  paddingX: "space.200",
  position: "relative",
  userSelect: "none",
  cursor: "default",
  _hover: { bg: "background.surface.hover" },
  "&[data-focused]": { bg: "background.surface.hover" }
});
var Item3 = React195.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const className = css15(listboxItemStyles, cssProp);
  return /* @__PURE__ */ React195.createElement(ReactAriaPrimitives.ListBoxItem, { className, ref: forwardedRef, ...props });
});
var separatorStyles = css15.raw({
  height: "1px",
  bg: "border",
  marginX: "space.200",
  marginTop: "space.150",
  marginBottom: "space.100"
});
var Separator2 = React195.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const className = css15(separatorStyles, cssProp);
  return /* @__PURE__ */ React195.createElement(ReactAriaPrimitives.Separator, { className, ...props, ref: forwardedRef });
});
var ComboBox2 = Object.assign(Root7, {
  Input: Input2,
  Content: Content5,
  Separator: Separator2,
  Section,
  Header: Header4,
  Item: Item3
});
ComboBox2.displayName = "ComboBox";
ComboBox2.Input.displayName = "ComboBox.Input";
ComboBox2.Content.displayName = "ComboBox.Content";
ComboBox2.Separator.displayName = "ComboBox.Separator";
ComboBox2.Section.displayName = "ComboBox.Section";
ComboBox2.Header.displayName = "ComboBox.Header";
ComboBox2.Item.displayName = "ComboBox.Item";

// src/layouts/content-layout-f/content-layout-f.tsx
import React196 from "react";
import { styled as styled3 } from "@betterment/samba-styled-system/jsx";
var SlotContainer = styled3("div", {
  base: {
    display: "grid",
    maxWidth: "1200px",
    gridTemplateColumns: "1fr",
    gap: "space.150",
    gridTemplateAreas: `
      'slot-1'
      'slot-2'
    `,
    "@container (min-width: calc({sizes.layout.slotMinWidth} * 2 + {spacing.space.400}))": {
      gap: "space.400",
      gridTemplateColumns: "1fr minmax(token(sizes.layout.slotMinWidth), 30%)",
      gridTemplateAreas: `
        'slot-1 slot-2'
      `
    }
  }
});
var hideEmptyChildrenCss = {
  "& > *:empty": {
    display: "none"
  }
};
var Slot1 = styled3("div", { base: { gridArea: "slot-1", ...hideEmptyChildrenCss } });
var Slot22 = styled3("div", { base: { gridArea: "slot-2", ...hideEmptyChildrenCss } });
var Root8 = ({ children, css: cssProp, ...props }) => {
  return /* @__PURE__ */ React196.createElement(Box, { css: { containerType: "inline-size", ...cssProp }, ...props }, children);
};
var ContentLayoutF = Root8;
ContentLayoutF.SlotContainer = SlotContainer;
ContentLayoutF.Slot1 = Slot1;
ContentLayoutF.Slot2 = Slot22;
ContentLayoutF.displayName = "ContentLayoutF";
ContentLayoutF.SlotContainer.displayName = "ContentLayoutF.SlotContainer";
ContentLayoutF.Slot1.displayName = "ContentLayoutF.Slot1";
ContentLayoutF.Slot2.displayName = "ContentLayoutF.Slot2";

// src/components/dialog/dialog.tsx
import * as React198 from "react";
import { css as css17, cva as cva10 } from "@betterment/samba-styled-system/css";
import * as DialogPrimitive2 from "@radix-ui/react-dialog";

// src/components/overlay/overlay.tsx
import * as React197 from "react";
import { css as css16, cva as cva9 } from "@betterment/samba-styled-system/css";
import * as DialogPrimitive from "@radix-ui/react-dialog";
var overlayStyles = cva9({
  base: {
    background: "background.overlay",
    height: "100vh",
    left: "space.0",
    position: "fixed",
    top: "space.0",
    width: "100vw",
    _open: {
      animation: "fadeIn"
    },
    _closed: {
      animation: "fadeOut"
    }
  },
  variants: {
    variant: {
      default: {
        background: "background.overlay"
      },
      weak: {
        background: "background.overlay.weak"
      },
      transparent: {
        background: "background.transparent"
      }
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var Overlay2 = React197.forwardRef(({ css: cssProps, variant, ...props }, ref) => {
  return /* @__PURE__ */ React197.createElement(DialogPrimitive.Overlay, { className: css16(overlayStyles.raw({ variant }), cssProps), ref, ...props });
});
Overlay2.displayName = "Overlay";

// src/components/dialog/dialog.tsx
var DialogContext = React198.createContext({
  overlay: "default"
});
var useDialogContext = () => React198.useContext(DialogContext);
var Root10 = ({ overlay = "default", ...props }) => {
  const contextValue = React198.useMemo(() => ({ overlay }), [overlay]);
  return /* @__PURE__ */ React198.createElement(DialogContext.Provider, { value: contextValue }, /* @__PURE__ */ React198.createElement(DialogPrimitive2.Root, { ...props }));
};
var { Trigger: Trigger3, Close: Close2, Portal, Title, Description } = DialogPrimitive2;
var dialogStyles = cva10({
  base: {
    background: "background.surface",
    boxShadow: "sm",
    minWidth: "container.small",
    p: "space.0",
    position: "fixed",
    borderRadius: "medium",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minHeight: "size.800",
    maxWidth: "container.large",
    maxHeight: "85vh",
    _focus: {
      outline: "none"
    },
    _closed: {
      animation: "dialogScaleOut"
    }
  },
  variants: {
    size: {
      small: {
        width: "min(90vw, token(sizes.container.small))"
      },
      medium: {
        width: "min(90vw, token(sizes.container.medium))"
      },
      large: {
        width: "min(90vw, token(sizes.container.large))"
      }
    }
  },
  defaultVariants: {
    size: "small"
  }
});
var dialogCloseStyles = css17.raw({
  position: "absolute",
  right: "space.200",
  top: "space.200"
});
var Content7 = React198.forwardRef(({ size, css: cssProps, children, ...props }, ref) => {
  const { overlay } = useDialogContext();
  return /* @__PURE__ */ React198.createElement(Portal, null, /* @__PURE__ */ React198.createElement(Overlay2, { variant: overlay }), /* @__PURE__ */ React198.createElement(DialogPrimitive2.Content, { ref, className: css17(dialogStyles.raw({ size }), cssProps), ...props }, children, /* @__PURE__ */ React198.createElement(Close2, { asChild: true }, /* @__PURE__ */ React198.createElement(Box, { className: css17(dialogCloseStyles) }, /* @__PURE__ */ React198.createElement(IconButton, { label: "Close", name: "X", spacing: "compact" })))));
});
var CompositeComponent2 = Object.assign(Root10, {
  Trigger: Trigger3,
  Close: Close2,
  Portal,
  Content: Content7,
  Title,
  Description
});
var Dialog = CompositeComponent2;
Dialog.displayName = "Dialog";
Dialog.Trigger.displayName = "Dialog.Trigger";
Dialog.Close.displayName = "Dialog.Close";
Dialog.Portal.displayName = "Dialog.Portal";
Dialog.Content.displayName = "Dialog.Content";
Dialog.Title.displayName = "Dialog.Title";
Dialog.Description.displayName = "Dialog.Description";

// src/components/dropdown-menu/dropdown-menu.tsx
import React200 from "react";
import { css as css19 } from "@betterment/samba-styled-system/css";
import { token as token3 } from "@betterment/samba-styled-system/tokens";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

// src/components/separator/separator.tsx
import React199, { forwardRef as forwardRef11 } from "react";
import { css as css18 } from "@betterment/samba-styled-system/css";
import { Root as RootPrimitive } from "@radix-ui/react-separator";
var separatorCss = css18.raw({
  bg: "border.weak",
  height: "1px",
  fullWidthWithInset: "space.0"
});
var Separator3 = forwardRef11((props, forwardedRef) => {
  const { css: cssProp = {} } = props;
  const className = css18(separatorCss, cssProp);
  return /* @__PURE__ */ React199.createElement(RootPrimitive, { "data-samba-component": true, ref: forwardedRef, className });
});
Separator3.displayName = "Separator";

// src/components/dropdown-menu/dropdown-menu.tsx
var { Root: Root11, Trigger: Trigger4 } = DropdownMenuPrimitive;
var contentStyles2 = css19.raw({
  minWidth: "120px",
  backgroundColor: "background.surface",
  borderRadius: "medium",
  paddingY: "space.100",
  border: "token(borderWidths.thin) solid token(colors.border)",
  boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
  '&[data-state="closed"]': {
    animation: "fadeOut 0.13s ease"
  }
});
var Content9 = React200.forwardRef(
  ({ css: cssProp, children, sideOffset: sideOffsetToken = "space.100", ...props }, forwardedRef) => {
    const className = css19(contentStyles2, cssProp);
    const sideOffset = parseInt(token3(`spacing.${sideOffsetToken}`), 10);
    return /* @__PURE__ */ React200.createElement(DropdownMenuPrimitive.Portal, null, /* @__PURE__ */ React200.createElement(DropdownMenuPrimitive.Content, { className, ref: forwardedRef, sideOffset, ...props }, children));
  }
);
var itemStyles2 = css19.raw({
  color: "text",
  textDecoration: "none",
  outline: "none",
  textStyle: "text100",
  display: "flex",
  alignItems: "center",
  paddingY: "space.100",
  paddingX: "space.200",
  position: "relative",
  userSelect: "none",
  cursor: "default",
  _focus: { bg: "background.surface.hover" },
  _hover: { bg: "background.surface.hover" }
});
var Item5 = React200.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css19(itemStyles2, cssProp);
  return /* @__PURE__ */ React200.createElement(DropdownMenuPrimitive.Item, { className, ref: forwardedRef, ...props }, children);
});
var Separator5 = React200.forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ React200.createElement(DropdownMenuPrimitive.Separator, { ref: forwardedRef, asChild: true }, /* @__PURE__ */ React200.createElement(Separator3, { ...props }));
});
var CompositeComponent3 = Object.assign(Root11, { Trigger: Trigger4, Content: Content9, Item: Item5, Separator: Separator5 });
var DropdownMenu = CompositeComponent3;
DropdownMenu.displayName = "DropdownMenu";
DropdownMenu.Trigger.displayName = "DropdownMenu.Trigger";
DropdownMenu.Content.displayName = "DropdownMenu.Content";
DropdownMenu.Item.displayName = "DropdownMenu.Item";
DropdownMenu.Separator.displayName = "DropdownMenu.Separator";

// src/components/guidance-box/guidance-box.tsx
import React201, { forwardRef as forwardRef12 } from "react";
import { css as css20, cva as cva11 } from "@betterment/samba-styled-system/css";
var guidanceBoxStyles = cva11({
  base: {
    maxWidth: "358px",
    height: "fit-content",
    background: "background.neutral",
    padding: "space.200",
    display: "grid",
    gap: "space.100",
    gridTemplateColumns: "auto 1fr auto",
    borderRadius: "medium"
  },
  variants: {
    variant: {
      a: {
        gridTemplateAreas: `
        'icon header close'
        'content content content'
        `
      },
      b: {
        gridTemplateAreas: `
        'icon content close'
        '. content .'
        `
      }
    }
  }
});
var Root12 = forwardRef12((props, forwardedRef) => {
  const { css: cssProp = {}, variant = "a", children, ...boxProps } = props;
  const className = css20(guidanceBoxStyles.raw({ variant }), cssProp);
  return /* @__PURE__ */ React201.createElement(Box, { "data-samba-component": true, ref: forwardedRef, className, ...boxProps }, children);
});
var Icon2 = ({ css: cssProp, ...props }) => {
  const iconStyles = css20.raw({ gridArea: "icon" }, cssProp);
  return /* @__PURE__ */ React201.createElement(Icon, { css: iconStyles, ...props, name: "Guidance", size: "small", color: "icon.accent.gold" });
};
var Header5 = ({ children, css: cssProp, ...props }) => {
  const headerStyles3 = css20.raw({ gridArea: "header" }, cssProp);
  return /* @__PURE__ */ React201.createElement(Box, { css: headerStyles3, ...props }, children);
};
function Close3({ onClick, css: cssProp }) {
  const closeStyles = css20.raw({ gridArea: "close" }, cssProp);
  return /* @__PURE__ */ React201.createElement(IconButton, { css: closeStyles, name: "X", label: "close", onClick, spacing: "none" });
}
var Content10 = ({ children, css: cssProp, ...props }) => {
  const contentStyles6 = css20.raw({ gridArea: "content" }, cssProp);
  return /* @__PURE__ */ React201.createElement(Box, { css: contentStyles6, ...props }, children);
};
var GuidanceBox = Object.assign(Root12, {
  Header: Header5,
  Content: Content10,
  Close: Close3,
  Icon: Icon2
});
GuidanceBox.displayName = "GuidanceBox";
Icon2.displayName = "GuidanceBox.Icon";
Close3.displayName = "GuidanceBox.Close";
Header5.displayName = "GuidanceBox.Header";
Content10.displayName = "GuidanceBox.Content";

// src/components/heading/heading.tsx
import React202, { forwardRef as forwardRef13 } from "react";
import { css as css21, cva as cva12 } from "@betterment/samba-styled-system/css";
import { token as token4 } from "@betterment/samba-styled-system/tokens";
import { Slot as Slot5 } from "@radix-ui/react-slot";
var headingCss = cva12({
  variants: {
    variant: {
      brandTitle: { textStyle: "brandTitle" },
      pageTitle: { textStyle: "pageTitle" },
      title400: { textStyle: "title400" },
      title300: { textStyle: "title300" },
      title200: { textStyle: "title200" },
      title100: { textStyle: "title100" }
    }
  }
});
var Heading = forwardRef13((props, forwardedRef) => {
  const { variant = "title400", css: cssProp = {}, color, as: Tag2 = "h1", children, asChild, ...headingProps } = props;
  const colorValue = color ? token4.var(`colors.${color}`) : null;
  const style = { color: colorValue };
  const className = css21(headingCss.raw({ variant }), css21.raw({ color }), cssProp);
  const Component = asChild ? Slot5 : Tag2;
  return /* @__PURE__ */ React202.createElement(Component, { "data-samba-component": true, style, ref: forwardedRef, className, ...headingProps }, children);
});
Heading.displayName = "Heading";

// src/components/icon-link/icon-link.tsx
import React203, { forwardRef as forwardRef14 } from "react";
import { css as css22 } from "@betterment/samba-styled-system/css";
import { Slot as Slot6 } from "@radix-ui/react-slot";
var IconLink = forwardRef14((props, forwardedRef) => {
  const {
    label,
    name,
    variant = "ghostSecondary",
    spacing = "default",
    css: cssProp,
    asChild,
    children,
    ...linkProps
  } = props;
  const className = css22(iconButtonSpacingStyles.raw({ spacing }), buttonVariantStyles.raw({ variant }), cssProp);
  if (asChild && children) {
    return /* @__PURE__ */ React203.createElement(Slot6, { "data-samba-component": true, ref: forwardedRef, className, "aria-label": label, ...linkProps }, React203.cloneElement(children, {
      children: /* @__PURE__ */ React203.createElement(Icon, { size: "small", color: "currentColor", name })
    }));
  }
  return /* @__PURE__ */ React203.createElement("a", { "data-samba-component": true, ref: forwardedRef, className, "aria-label": label, ...linkProps }, /* @__PURE__ */ React203.createElement(Icon, { size: "small", color: "currentColor", name }));
});
IconLink.displayName = "IconLinkButton";

// src/components/form/input.tsx
import React206, { forwardRef as forwardRef16 } from "react";
import { css as css23, sva as sva4 } from "@betterment/samba-styled-system/css";

// src/components/form/masked-input/masked-input.tsx
import React205, { forwardRef as forwardRef15 } from "react";
import {
  createAutoCorrectedDatePipe as _createAutoCorrectedDatePipe,
  createNumberMask as _createNumberMask
} from "text-mask-addons";

// src/components/form/masked-input/masked-input-base.tsx
import React204 from "react";
import { createTextMaskInputElement } from "text-mask-core";
import { conformToMask } from "text-mask-core";
function isNil(value) {
  return typeof value === "undefined" || value === null;
}
var MaskedInput = class extends React204.PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "inputElement", null);
    __publicField(this, "textMaskInputElement", {
      update() {
      }
    });
    this.setRef = this.setRef.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  setRef(inputElement) {
    this.inputElement = inputElement;
  }
  initTextMask() {
    const {
      props,
      props: { value }
    } = this;
    this.textMaskInputElement = createTextMaskInputElement({
      inputElement: this.inputElement,
      ...props
    });
    this.textMaskInputElement.update(value);
  }
  componentDidMount() {
    this.initTextMask();
  }
  componentDidUpdate(prevProps) {
    const { value, pipe, mask, guide, placeholderChar, showMask } = this.props;
    const settings = { guide, placeholderChar, showMask };
    const isPipeChanged = typeof pipe === "function" && typeof prevProps.pipe === "function" ? pipe.toString() !== prevProps.pipe.toString() : isNil(pipe) && !isNil(prevProps.pipe) || !isNil(pipe) && isNil(prevProps.pipe);
    const isMaskChanged = mask.toString() !== prevProps.mask.toString();
    const isSettingChanged = Object.keys(settings).some((prop) => settings[prop] !== prevProps[prop]) || isMaskChanged || isPipeChanged;
    const isValueChanged = value !== this.inputElement?.value;
    if (isValueChanged || isSettingChanged) {
      this.initTextMask();
    }
  }
  render() {
    const { render, value, ...props } = this.props;
    delete props.guide;
    delete props.pipe;
    delete props.placeholderChar;
    delete props.keepCharPositions;
    delete props.onBlur;
    delete props.onChange;
    delete props.showMask;
    return render(this.setRef, {
      onBlur: this.onBlur,
      onChange: this.onChange,
      defaultValue: value?.toString(),
      ...props
    });
  }
  onChange(event) {
    this.textMaskInputElement.update();
    const { onChange } = this.props;
    if (typeof onChange === "function") {
      onChange(event);
    }
  }
  onBlur(event) {
    const { onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(event);
    }
  }
};
__publicField(MaskedInput, "defaultProps", {
  render: (ref, { mask: _omitMask, ...props }) => /* @__PURE__ */ React204.createElement("input", { ref, ...props })
});

// src/components/form/masked-input/masked-input.tsx
var createNumberMask = _createNumberMask;
var createNotatedNumberMask = _createNumberMask;
var createAutoCorrectedDatePipe = _createAutoCorrectedDatePipe;
var maskProps = (variant) => {
  switch (variant) {
    case "ssn":
      return {
        placeholderChar: "x",
        mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
      };
    case "ein":
      return {
        placeholderChar: "x",
        mask: [/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
      };
    case "phone":
      return {
        mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
      };
    case "money":
      return {
        mask: createNumberMask({
          allowDecimal: true
        })
      };
    case "number":
      return {
        mask: createNumberMask({
          allowDecimal: true,
          prefix: ""
        })
      };
    case "percent":
      return {
        mask: createNotatedNumberMask({
          prefix: "",
          suffix: "%",
          allowDecimal: true
        })
      };
    case "date-mm/dd/yyyy":
      return {
        mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
        placeholder: "MM/DD/YYYY",
        pipe: createAutoCorrectedDatePipe("mm/dd/yyyy", { minYear: 1900 }),
        keepCharPositions: true
      };
    case "date-mm/yyyy":
      return {
        mask: [/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
        placeholder: "MM/YYYY",
        pipe: createAutoCorrectedDatePipe("mm/yyyy", { minYear: 1900 }),
        keepCharPositions: true
      };
    default:
      throw new TypeError("invalid template provided");
  }
};
var MaskedInput2 = forwardRef15(({ variant, ...props }, forwardedRef) => /* @__PURE__ */ React205.createElement(MaskedInput, { ...maskProps(variant), ...props, ref: forwardedRef }));
MaskedInput2.displayName = "MaskedInput";

// src/components/form/input.tsx
var inputColorReset2 = css23.raw({
  color: "text"
});
var inputStyles = sva4({
  slots: ["wrapper", "input", "leadingIcon", "leadingSymbol", "trailingSymbol"],
  defaultVariants: {
    appearance: "default",
    spacing: "default",
    alignment: "left"
  },
  base: {
    wrapper: {
      ...inputColorReset2,
      width: "100%",
      borderRadius: "medium",
      textStyle: "text100",
      border: "token(borderWidths.thin) solid",
      backgroundColor: "background.input",
      display: "flex",
      flexDirection: "row",
      verticalAlign: "middle",
      cursor: "text",
      pointerEvents: "auto",
      overflow: "hidden",
      alignItems: "stretch",
      _focusWithin: {
        outline: "token(borderWidths.thick) solid",
        outlineOffset: "-1px"
      },
      "&[data-disabled = true]": {
        color: "text.disabled",
        bg: "background.input.disabled",
        cursor: "auto"
      },
      "&[data-readonly = true]": {
        bg: "background.input.disabled",
        cursor: "auto"
      }
    },
    input: {
      fontSize: "inherit",
      fontFamily: "inherit",
      color: "inherit",
      backgroundColor: "transparent",
      appearance: "none",
      width: "100%",
      border: "token(borderWidths.none)",
      _focus: {
        outline: "token(borderWidths.none)"
      }
    },
    leadingIcon: {
      alignSelf: "center",
      flexShrink: 0
    },
    trailingSymbol: {
      alignSelf: "center",
      flexShrink: 0
    },
    leadingSymbol: {
      alignSelf: "center",
      flexShrink: 0
    }
  },
  variants: {
    appearance: {
      default: {
        wrapper: {
          borderColor: "border.input",
          _focusWithin: {
            outlineColor: "border.focused",
            borderColor: "border.focused"
          }
        }
      },
      critical: {
        wrapper: {
          borderColor: "border.critical",
          _focusWithin: {
            outlineColor: "border.critical"
          }
        }
      }
    },
    spacing: {
      default: {
        wrapper: {
          height: "48px",
          gap: "space.100"
        },
        input: {
          _only: {
            paddingX: "space.150"
          },
          _first: {
            paddingLeft: "space.150"
          },
          _last: {
            paddingRight: "space.150"
          }
        },
        leadingIcon: {
          marginLeft: "space.150"
        },
        leadingSymbol: {
          marginLeft: "space.150"
        },
        trailingSymbol: {
          marginRight: "space.150"
        }
      },
      compact: {
        wrapper: {
          height: "40px",
          gap: "space.50"
        },
        input: {
          _only: {
            paddingX: "space.100"
          },
          _first: {
            paddingLeft: "space.100"
          },
          _last: {
            paddingRight: "space.100"
          }
        },
        leadingIcon: {
          marginLeft: "space.100"
        },
        leadingSymbol: {
          marginLeft: "space.100"
        },
        trailingSymbol: {
          marginRight: "space.100"
        }
      }
    },
    alignment: {
      left: {
        input: {
          textAlign: "left"
        }
      },
      right: {
        input: {
          textAlign: "right"
        }
      }
    }
  }
});
var passwordManagerIgnoredFieldProps = {
  "data-1p-ignore": true,
  // 1Password
  "data-bwignore": true,
  // Bitwarden
  "data-lpignore": true,
  // Lastpass
  "data-form-type": "other"
  // Dashlane
};
var Input3 = forwardRef16(
  ({
    css: cssProp,
    mask,
    leadingIcon,
    leadingSymbol,
    trailingSymbol,
    appearance,
    spacing,
    alignment,
    readOnly,
    disabled,
    onMouseDown,
    formStrategy: _unusedFormStrategy,
    ignorePasswordManagers,
    ...props
  }, forwardedRef) => {
    const classes = inputStyles.raw({ appearance, spacing, alignment });
    const inputRef = React206.useRef(null);
    const setInputRef = (inputElement) => {
      inputRef.current = inputElement;
      if (!forwardedRef) {
        return;
      }
      if (typeof forwardedRef === "object") {
        forwardedRef.current = inputElement;
      }
      if (typeof forwardedRef === "function") {
        forwardedRef(inputElement);
      }
    };
    const handleOnMouseDown = (event) => {
      const target = event.target;
      if (target.tagName !== "INPUT") {
        event.preventDefault();
      }
      if (inputRef && inputRef.current && document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
      onMouseDown?.(event);
    };
    return /* @__PURE__ */ React206.createElement(
      Box,
      {
        "data-readonly": readOnly,
        "data-disabled": disabled,
        className: css23(classes.wrapper, cssProp),
        onMouseDown: handleOnMouseDown
      },
      leadingIcon && /* @__PURE__ */ React206.createElement(Icon, { name: leadingIcon, size: "small", css: classes.leadingIcon }),
      leadingSymbol && /* @__PURE__ */ React206.createElement(Box, { css: classes.leadingSymbol }, leadingSymbol),
      mask ? /* @__PURE__ */ React206.createElement(
        MaskedInput2,
        {
          readOnly,
          disabled,
          variant: mask,
          ref: forwardedRef,
          className: css23(classes.input),
          ...props,
          ...ignorePasswordManagers && passwordManagerIgnoredFieldProps,
          "data-samba-component": true
        }
      ) : /* @__PURE__ */ React206.createElement(
        "input",
        {
          readOnly,
          disabled,
          ref: setInputRef,
          className: css23(classes.input),
          ...props,
          ...ignorePasswordManagers && passwordManagerIgnoredFieldProps,
          "data-samba-component": true
        }
      ),
      trailingSymbol && /* @__PURE__ */ React206.createElement(Box, { css: classes.trailingSymbol }, trailingSymbol)
    );
  }
);
Input3.displayName = "Input";

// src/layouts/legacy-content-layout-e/legacy-content-layout-e.tsx
import { cva as cva13 } from "@betterment/samba-styled-system/css";
import { styled as styled4 } from "@betterment/samba-styled-system/jsx";
var contentLayoutCss = cva13({
  base: {
    display: "grid",
    "--sc-legacy-gap": {
      base: "spacing.space.300",
      md: "20px",
      lg: "spacing.space.400"
    },
    gridTemplateColumns: {
      // Style Closet ContentLayout* components use a negative margin on the container and apply equal horizontal padding
      // to their child slots. This means that child slot percentage widths are not based directly on the width of the
      // parent container. Instead, they're a percentage of the sum of the parent container width and the gap width.
      //
      // In Samba's near future, we'll use simpler gridTemplateColumns rules that look something like this:
      // md: 'minmax(0, 1fr) minmax(0, 2fr)',
      // lg: 'minmax(0, 1fr) minmax(0, 3fr)'
      //
      // In the meantime, we'll match the Style Closet percentage widths in "legacy" content layout components by
      // multiplying the fractional width by the sum of the parent container width and the gap width, then subtracting
      // the gap. Which ends up looking like this:
      md: "calc(calc(100% + var(--sc-legacy-gap)) * 1/3 - var(--sc-legacy-gap)) calc(calc(100% + var(--sc-legacy-gap)) * 2/3 - var(--sc-legacy-gap))",
      lg: "calc(calc(100% + var(--sc-legacy-gap)) * 1/4 - var(--sc-legacy-gap)) calc(calc(100% + var(--sc-legacy-gap)) * 3/4 - var(--sc-legacy-gap))"
    },
    gridTemplateAreas: {
      base: `
      'Slot1'
      'Slot2'
      `,
      md: `'Slot1 Slot2'`
    },
    gap: "var(--sc-legacy-gap)"
  }
});
var ContentLayout = styled4("div", contentLayoutCss);
var Slot12 = styled4("div", { base: { gridArea: "Slot1" } });
var Slot23 = styled4("div", { base: { gridArea: "Slot2" } });
var LegacyContentLayoutE = ContentLayout;
LegacyContentLayoutE.Slot1 = Slot12;
LegacyContentLayoutE.Slot2 = Slot23;
LegacyContentLayoutE.displayName = "LegacyContentLayoutE";
LegacyContentLayoutE.Slot1.displayName = "LegacyContentLayoutE.Slot1";
LegacyContentLayoutE.Slot2.displayName = "LegacyContentLayoutE.Slot2";

// src/layouts/legacy-section-layout/legacy-section-layout.tsx
import { styled as styled5 } from "@betterment/samba-styled-system/jsx";
var CONTENT_MAX_WIDTH = "1200px";
var ContentWrapper = styled5("div", {
  base: {
    width: "100%",
    margin: "0 auto",
    maxWidth: CONTENT_MAX_WIDTH
  }
});
var SectionLayout = styled5("section", {
  base: {
    display: "flex",
    minHeight: "1px",
    position: "relative",
    justifyContent: "flex-start",
    px: {
      base: "space.300",
      md: "space.400"
    }
  }
});
var LegacySectionLayout = Object.assign(SectionLayout, { ContentWrapper });
SectionLayout.displayName = "LegacySectionLayout";
LegacySectionLayout.ContentWrapper.displayName = "LegacySectionLayout.ContentWrapper";

// src/components/link-legacy/link.tsx
import React207 from "react";
import { css as css24, cva as cva14 } from "@betterment/samba-styled-system/css";
import { Slot as Slot7 } from "@radix-ui/react-slot";
var linkButtonOverrides = css24.raw({
  display: "inline-flex",
  textDecoration: "none",
  _focus: {
    textDecoration: "none"
  },
  _active: {
    textDecoration: "none"
  },
  _hover: {
    textDecoration: "none"
  }
});
var linkCss = cva14({
  base: {
    cursor: "pointer",
    textDecoration: "none",
    fontFamily: "gtAmerica",
    textDecorationSkipInk: "auto",
    _focus: { textDecoration: "underline" },
    _active: { textDecoration: "underline" },
    _hover: { textDecoration: "underline" }
  },
  variants: {
    variant: {
      primary: {
        color: "text.link",
        _focus: { color: "text.link.active" },
        _active: { color: "text.link.active" },
        _hover: { color: "text.link.hover" }
      },
      secondary: {
        color: "currentcolor",
        textDecoration: "underline"
      },
      buttonPrimary: css24.raw(
        buttonBaseVariants.raw({ variant: "primary" }),
        buttonSpacingStyles2.raw({ spacing: "default" }),
        linkButtonOverrides
      ),
      buttonSecondary: css24.raw(
        buttonBaseVariants.raw({ variant: "secondary" }),
        buttonSpacingStyles2.raw({ spacing: "default" }),
        linkButtonOverrides
      )
    }
  }
});
var Link = React207.forwardRef((props, forwardedRef) => {
  const { variant = "primary", asChild, children, css: cssProp = {}, ...linkProps } = props;
  const Comp = asChild ? Slot7 : "a";
  return /* @__PURE__ */ React207.createElement(
    Comp,
    {
      "data-samba-component": true,
      ref: forwardedRef,
      className: css24(linkCss.raw({ variant }), cssProp),
      ...linkProps
    },
    children
  );
});
Link.displayName = "Link";

// src/components/link/link.tsx
import React208 from "react";
import { css as css25 } from "@betterment/samba-styled-system/css";
import { Slot as Slot8 } from "@radix-ui/react-slot";
var Link2 = React208.forwardRef((props, forwardedRef) => {
  const { variant = "textPrimary", spacing = "default", asChild, children, css: cssProp = {}, ...linkProps } = props;
  const Comp = asChild ? Slot8 : "a";
  const className = css25(generateClickableStyles({ variant, spacing }), cssProp);
  return /* @__PURE__ */ React208.createElement(Comp, { "data-samba-component": true, ref: forwardedRef, className, ...linkProps }, children);
});
Link2.displayName = "Link";

// src/layouts/list-row/list-row.tsx
import React209 from "react";
import { css as css26, cva as cva15 } from "@betterment/samba-styled-system/css";
import { styled as styled6 } from "@betterment/samba-styled-system/jsx";
var wrapperStyles = css26.raw({
  display: "grid",
  gridTemplateAreas: `
  'leading-asset leading-content trailing-content trailing-asset'
  'bottom-content bottom-content bottom-content bottom-content'
  `,
  gridTemplateColumns: "min-content auto auto min-content",
  padding: "space.300",
  background: "background.surface",
  alignItems: "center"
});
var Wrapper = ({ children, css: cssProp, ...props }) => {
  return /* @__PURE__ */ React209.createElement("div", { className: css26(wrapperStyles, cssProp), ...props }, children);
};
var LeadingAsset = styled6("div", {
  base: {
    gridArea: "leading-asset",
    gridRow: "1/2",
    gridColumn: "1/2",
    display: "inline-flex",
    marginRight: "space.150"
  }
});
var LeadingContent = styled6("div", {
  base: {
    gridArea: "leading-content",
    gridRow: "1/2",
    gridColumn: "2/3",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    textAlign: "start",
    justifyContent: "center"
  }
});
var TrailingContent = styled6("div", {
  base: {
    gridArea: "trailing-content",
    gridRow: "1/2",
    gridColumn: "3/4",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "end",
    textAlign: "end"
  }
});
var TrailingAsset = ({ children, css: cssProp }) => {
  const className = css26({ display: "inline-flex", gridArea: "trailing-asset", marginLeft: "space.50" }, cssProp);
  return /* @__PURE__ */ React209.createElement("div", { className }, children);
};
var bottomContentStyles = cva15({
  base: {
    marginTop: "space.200",
    gridArea: "bottom-content",
    gridRow: "2/3"
  },
  variants: {
    alignment: {
      start: {
        gridColumnStart: "1"
      },
      inset: {
        gridColumnStart: "2"
      }
    }
  }
});
var BottomContent = ({ children, css: cssProp, alignment = "start", ...props }) => {
  const className = css26(bottomContentStyles.raw({ alignment }), cssProp);
  if (!children) return null;
  return /* @__PURE__ */ React209.createElement("div", { className, ...props }, children);
};
var CompositeComponent4 = Object.assign(Wrapper, {
  LeadingAsset,
  LeadingContent,
  TrailingContent,
  TrailingAsset,
  BottomContent
});
var ListRow = CompositeComponent4;
ListRow.displayName = "ListRow";
ListRow.LeadingAsset.displayName = "ListRow.LeadingAsset";
ListRow.LeadingContent.displayName = "ListRow.LeadingContent";
ListRow.TrailingContent.displayName = "ListRow.TrailingContent";
ListRow.TrailingAsset.displayName = "ListRow.TrailingAsset";
ListRow.BottomContent.displayName = "ListRow.BottomContent";

// src/components/logo/logo.tsx
import React221 from "react";

// src/components/logo/b4a-signature.tsx
import React210 from "react";
var B4ASignature = (props) => {
  return /* @__PURE__ */ React210.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 661 40",
      "aria-label": "Betterment B4A logo",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M334.033 36.3785L330.634 26.8339H317.132L313.733 36.3785H309.17L321.694 3.32154H326.071L338.595 36.3785H334.033ZM329.33 23.1092L324.721 10.2123C324.379 9.28111 324.116 8.44304 323.929 7.69809H323.836C323.65 8.44304 323.386 9.28111 323.045 10.2123L318.435 23.1092H329.33Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M349.909 36.9372C348.047 36.9372 346.401 36.4406 344.974 35.4473C343.546 34.423 342.428 32.9952 341.621 31.1639C340.845 29.3015 340.457 27.1598 340.457 24.7387C340.457 22.3797 340.876 20.2846 341.715 18.4533C342.553 16.5909 343.717 15.1476 345.206 14.1233C346.727 13.0679 348.45 12.5402 350.375 12.5402C353.478 12.5402 355.76 13.8749 357.219 16.5443V2.62315H361.176V36.3785H357.452V32.0485C356.738 33.6315 355.744 34.8421 354.472 35.6801C353.23 36.5182 351.709 36.9372 349.909 36.9372ZM350.98 33.4453C352.904 33.4453 354.441 32.7159 355.589 31.257C356.738 29.7671 357.312 27.7806 357.312 25.2974V24.2266C357.312 21.6814 356.738 19.6793 355.589 18.2205C354.472 16.7616 352.935 16.0322 350.98 16.0322C348.993 16.0322 347.441 16.8082 346.324 18.3601C345.206 19.8811 344.648 22.0073 344.648 24.7387C344.648 27.4702 345.206 29.6119 346.324 31.1639C347.441 32.6848 348.993 33.4453 350.98 33.4453Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M365.132 13.099H369.415L374.63 28.7894C375.034 29.9999 375.359 31.1794 375.608 32.3279H375.747C375.996 31.1794 376.322 29.9999 376.725 28.7894L381.94 13.099H386.223L377.796 36.3785H373.559L365.132 13.099Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M389.932 36.3785V13.099H393.889V36.3785H389.932ZM389.653 8.76895V3.78713H394.169V8.76895H389.653Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M409.051 36.9372C406.258 36.9372 403.976 36.2699 402.207 34.9352C400.469 33.6005 399.398 31.6916 398.995 29.2084L402.999 28.51C403.309 30.2172 403.992 31.5053 405.047 32.3744C406.103 33.2435 407.499 33.6781 409.238 33.6781C410.79 33.6781 411.985 33.3677 412.823 32.7469C413.661 32.1261 414.08 31.2725 414.08 30.1862C414.08 29.0377 413.769 28.1841 413.149 27.6254C412.559 27.0667 411.628 26.7097 410.355 26.5545L406.584 26.1355C404.349 25.8872 402.657 25.1733 401.509 23.9938C400.36 22.8143 399.786 21.2934 399.786 19.431C399.786 17.3203 400.578 15.6442 402.161 14.4026C403.744 13.161 405.901 12.5402 408.632 12.5402C411.271 12.5402 413.428 13.1921 415.104 14.4957C416.811 15.7683 417.789 17.4755 418.037 19.6172L414.126 20.5019C413.847 19.043 413.226 17.8945 412.264 17.0565C411.333 16.1874 410.091 15.7528 408.539 15.7528C406.987 15.7528 405.777 16.0632 404.908 16.684C404.07 17.2738 403.651 18.1273 403.651 19.2448C403.651 21.2934 405.047 22.4729 407.841 22.7833L411.566 23.2023C415.849 23.6679 417.991 25.8717 417.991 29.8137C417.991 32.0485 417.199 33.8022 415.616 35.0749C414.064 36.3164 411.876 36.9372 409.051 36.9372Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M432.151 36.9372C429.979 36.9372 428.07 36.4561 426.424 35.4939C424.779 34.5006 423.507 33.0883 422.607 31.257C421.738 29.4257 421.303 27.2529 421.303 24.7387C421.303 22.2245 421.738 20.0518 422.607 18.2205C423.507 16.3891 424.779 14.9924 426.424 14.0301C428.07 13.0369 429.979 12.5402 432.151 12.5402C434.324 12.5402 436.233 13.0369 437.878 14.0301C439.523 14.9924 440.78 16.3891 441.649 18.2205C442.549 20.0518 443 22.2245 443 24.7387C443 27.2529 442.549 29.4257 441.649 31.257C440.78 33.0883 439.523 34.5006 437.878 35.4939C436.233 36.4561 434.324 36.9372 432.151 36.9372ZM432.151 33.4919C434.262 33.4919 435.892 32.7469 437.04 31.257C438.219 29.7671 438.809 27.5944 438.809 24.7387C438.809 21.8831 438.219 19.7104 437.04 18.2205C435.892 16.7306 434.262 15.9856 432.151 15.9856C430.041 15.9856 428.396 16.7306 427.216 18.2205C426.068 19.7104 425.493 21.8831 425.493 24.7387C425.493 27.5944 426.068 29.7671 427.216 31.257C428.396 32.7469 430.041 33.4919 432.151 33.4919Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M452.016 18.4067C452.606 16.6685 453.506 15.2562 454.717 14.1698C455.958 13.0834 457.417 12.5402 459.093 12.5402C459.466 12.5402 459.745 12.5558 459.931 12.5868V16.4512H459.745C457.541 16.4512 455.834 17.0565 454.624 18.267C453.63 19.2603 452.994 20.4087 452.715 21.7124C452.435 23.0161 452.296 24.5835 452.296 26.4149V36.3785H448.338V13.099H452.016V18.4067Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M485.778 37.17C481.743 37.17 478.593 36.2078 476.327 34.2834C474.061 32.3279 472.788 29.7516 472.509 26.5545L476.979 25.9027C477.32 28.1376 478.205 29.9689 479.632 31.3967C481.091 32.8245 483.186 33.5384 485.918 33.5384C487.967 33.5384 489.705 33.0728 491.133 32.1416C492.56 31.2105 493.274 29.7826 493.274 27.8582C493.274 26.0269 492.762 24.6922 491.738 23.8541C490.714 22.985 489.131 22.3332 486.989 21.8986L482.193 20.9209C476.668 19.7724 473.906 16.7306 473.906 11.7953C473.906 9.96397 474.371 8.34992 475.302 6.95315C476.265 5.55637 477.599 4.46999 479.307 3.69401C481.045 2.91802 483.078 2.53003 485.406 2.53003C488.851 2.53003 491.676 3.32153 493.88 4.90455C496.083 6.48756 497.34 8.83103 497.651 11.935L493.228 12.8662C492.638 8.30336 490 6.02197 485.313 6.02197C483.264 6.02197 481.603 6.50308 480.331 7.4653C479.089 8.42752 478.469 9.73118 478.469 11.3763C478.469 12.9593 478.903 14.2009 479.772 15.101C480.641 16.0011 482.007 16.653 483.869 17.0565L488.712 18.0808C491.598 18.6705 493.833 19.6793 495.416 21.1071C497.03 22.5349 497.837 24.6456 497.837 27.4392C497.837 29.2084 497.387 30.838 496.487 32.3279C495.618 33.7867 494.268 34.9662 492.436 35.8664C490.636 36.7355 488.417 37.17 485.778 37.17Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M511.724 36.9372C509.551 36.9372 507.642 36.4561 505.997 35.4939C504.352 34.5006 503.079 33.0883 502.179 31.257C501.31 29.4257 500.875 27.2529 500.875 24.7387C500.875 22.2245 501.31 20.0518 502.179 18.2205C503.079 16.3891 504.352 14.9924 505.997 14.0301C507.642 13.0369 509.551 12.5402 511.724 12.5402C513.896 12.5402 515.805 13.0369 517.451 14.0301C519.096 14.9924 520.353 16.3891 521.222 18.2205C522.122 20.0518 522.572 22.2245 522.572 24.7387C522.572 27.2529 522.122 29.4257 521.222 31.257C520.353 33.0883 519.096 34.5006 517.451 35.4939C515.805 36.4561 513.896 36.9372 511.724 36.9372ZM511.724 33.4919C513.834 33.4919 515.464 32.7469 516.612 31.257C517.792 29.7671 518.382 27.5944 518.382 24.7387C518.382 21.8831 517.792 19.7104 516.612 18.2205C515.464 16.7306 513.834 15.9856 511.724 15.9856C509.613 15.9856 507.968 16.7306 506.788 18.2205C505.64 19.7104 505.066 21.8831 505.066 24.7387C505.066 27.5944 505.64 29.7671 506.788 31.257C507.968 32.7469 509.613 33.4919 511.724 33.4919Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement("path", { d: "M532.101 2.62315V36.3785H528.143V2.62315H532.101Z", fill: "#000B50" }),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M547.065 36.9372C544.271 36.9372 542.238 36.1612 540.965 34.6093C539.724 33.0573 539.103 30.838 539.103 27.9513V13.099H543.061V27.4857C543.061 29.4412 543.464 30.9466 544.271 32.002C545.109 33.0263 546.289 33.5384 547.81 33.5384C549.672 33.5384 551.177 32.809 552.326 31.3501C553.474 29.8913 554.049 27.9824 554.049 25.6234V13.099H558.006V36.3785H554.281V32.002C553.754 33.4298 552.822 34.6093 551.488 35.5405C550.153 36.4716 548.679 36.9372 547.065 36.9372Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M561.977 13.099H566.307V6.99971L570.265 5.32358V13.099H576.084V16.3581H570.265V29.255C570.265 30.5897 570.528 31.5674 571.056 32.1882C571.615 32.778 572.484 33.0728 573.663 33.0728C574.346 33.0728 575.153 32.9642 576.084 32.7469V36.3785C575.06 36.6579 573.912 36.7976 572.639 36.7976C570.28 36.7976 568.635 36.1612 567.704 34.8886C566.773 33.616 566.307 31.7847 566.307 29.3947V16.3581H561.977V13.099Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M580.952 36.3785V13.099H584.909V36.3785H580.952ZM580.672 8.76895V3.78713H585.189V8.76895H580.672Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M601.095 36.9372C598.923 36.9372 597.014 36.4561 595.369 35.4939C593.724 34.5006 592.451 33.0883 591.551 31.257C590.682 29.4257 590.247 27.2529 590.247 24.7387C590.247 22.2245 590.682 20.0518 591.551 18.2205C592.451 16.3891 593.724 14.9924 595.369 14.0301C597.014 13.0369 598.923 12.5402 601.095 12.5402C603.268 12.5402 605.177 13.0369 606.822 14.0301C608.467 14.9924 609.724 16.3891 610.594 18.2205C611.494 20.0518 611.944 22.2245 611.944 24.7387C611.944 27.2529 611.494 29.4257 610.594 31.257C609.724 33.0883 608.467 34.5006 606.822 35.4939C605.177 36.4561 603.268 36.9372 601.095 36.9372ZM601.095 33.4919C603.206 33.4919 604.836 32.7469 605.984 31.257C607.164 29.7671 607.753 27.5944 607.753 24.7387C607.753 21.8831 607.164 19.7104 605.984 18.2205C604.836 16.7306 603.206 15.9856 601.095 15.9856C598.985 15.9856 597.34 16.7306 596.16 18.2205C595.012 19.7104 594.438 21.8831 594.438 24.7387C594.438 27.5944 595.012 29.7671 596.16 31.257C597.34 32.7469 598.985 33.4919 601.095 33.4919Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M617.282 13.099H621.007V17.7083C622.528 14.2009 625.12 12.4471 628.783 12.4471C631.359 12.4471 633.299 13.2542 634.602 14.8682C635.906 16.4512 636.558 18.7947 636.558 21.8986V36.3785H632.6V22.1314C632.6 18.0032 630.893 15.9391 627.479 15.9391C625.554 15.9391 624.033 16.684 622.916 18.1739C621.799 19.6328 621.24 21.6503 621.24 24.2266V36.3785H617.282V13.099Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M651.042 36.9372C648.249 36.9372 645.968 36.2699 644.198 34.9352C642.46 33.6005 641.389 31.6916 640.986 29.2084L644.99 28.51C645.3 30.2172 645.983 31.5053 647.038 32.3744C648.094 33.2435 649.491 33.6781 651.229 33.6781C652.781 33.6781 653.976 33.3677 654.814 32.7469C655.652 32.1261 656.071 31.2725 656.071 30.1862C656.071 29.0377 655.76 28.1841 655.14 27.6254C654.55 27.0667 653.619 26.7097 652.346 26.5545L648.575 26.1355C646.34 25.8872 644.648 25.1733 643.5 23.9938C642.351 22.8143 641.777 21.2934 641.777 19.431C641.777 17.3203 642.569 15.6442 644.152 14.4026C645.735 13.161 647.892 12.5402 650.623 12.5402C653.262 12.5402 655.419 13.1921 657.095 14.4957C658.802 15.7683 659.78 17.4755 660.028 19.6172L656.117 20.5019C655.838 19.043 655.217 17.8945 654.255 17.0565C653.324 16.1874 652.082 15.7528 650.53 15.7528C648.978 15.7528 647.768 16.0632 646.899 16.684C646.061 17.2738 645.642 18.1273 645.642 19.2448C645.642 21.2934 647.038 22.4729 649.832 22.7833L653.557 23.2023C657.84 23.6679 659.982 25.8717 659.982 29.8137C659.982 32.0485 659.19 33.8022 657.607 35.0749C656.055 36.3164 653.867 36.9372 651.042 36.9372Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M270.382 12.5499C268.845 12.5296 267.327 12.9014 265.962 13.6325C264.597 14.3636 263.426 15.4315 262.553 16.7422V13.2626H256.489V36.8628H262.553V25.3118C262.553 20.8728 264.587 18.2243 267.995 18.2243C270.999 18.2243 273.148 20.2859 273.148 23.731V36.8628H279.166V22.4117C279.169 16.2465 275.577 12.5499 270.382 12.5499Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M210.449 36.8456H204.053V23.7151C204.053 20.4725 202.03 18.2089 199.126 18.2089C195.502 18.2089 193.34 20.8572 193.34 25.2957V36.8456H186.893V13.2551H193.34V16.7418C194.267 15.4311 195.511 14.3632 196.961 13.6321C198.412 12.9011 200.025 12.5294 201.658 12.5499C205.355 12.5499 208.145 14.4042 209.513 17.5308C210.483 15.9928 211.845 14.7258 213.466 13.853C215.088 12.9801 216.913 12.5312 218.765 12.5499C224.106 12.5499 227.556 16.4187 227.556 22.4131V36.8628H221.162V23.7323C221.162 20.4898 219.139 18.2262 216.233 18.2262C212.611 18.2262 210.446 20.8745 210.446 25.3129L210.449 36.8456Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M79.0853 20.9563L77.7083 20.4027L79.0245 19.7286C79.1789 19.6498 82.7023 17.7602 82.7023 13.2134C82.7023 9.37521 79.3004 5.49023 72.7979 5.49023H57.0845V36.8628H72.8283C83.1503 36.8628 83.6717 29.7547 83.6717 28.3301C83.6743 22.868 79.1308 20.9784 79.0853 20.9563ZM63.5845 10.6521H71.3526C73.4838 10.6521 75.7796 11.8996 75.7796 14.6429C75.7796 17.3198 73.5522 18.7223 71.3526 18.7223H63.5845V10.6521ZM72.3701 31.7009H63.5845V23.6308H72.3701C75.248 23.6308 76.7516 25.6827 76.7516 27.7125C76.7516 30.0278 74.9089 31.7058 72.3701 31.7058V31.7009Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M110.259 25.1068C110.119 17.7152 105.049 12.5491 97.9242 12.5491C90.6921 12.5491 85.2367 17.9454 85.2367 25.1018C85.1938 28.3771 86.433 31.5419 88.6951 33.934C91.0074 36.3327 94.3232 37.6471 97.9292 37.6471C101.535 37.6471 104.851 36.3277 107.163 33.934C108.406 32.6337 109.346 31.0799 109.916 29.3818H104.073C102.877 31.4883 100.622 32.7656 97.9292 32.7656C94.8287 32.7656 92.3262 30.5848 91.638 27.2108L91.4703 26.394H110.259V25.1068ZM91.8132 22.0893C92.1855 20.7722 92.9856 19.613 94.09 18.7903C95.1944 17.9676 96.5417 17.5272 97.9242 17.537C100.84 17.537 103.019 19.2401 103.78 22.0893H91.8132Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M168.125 25.1068C167.99 17.7152 163.079 12.5491 156.177 12.5491C149.169 12.5491 143.885 17.9454 143.885 25.1018C143.845 28.3768 145.045 31.5412 147.235 33.934C149.475 36.3327 152.687 37.6471 156.182 37.6471C159.678 37.6471 162.887 36.3277 165.127 33.934C166.331 32.6337 167.241 31.0799 167.793 29.3818H162.126C160.967 31.4883 158.781 32.7656 156.175 32.7656C153.171 32.7656 150.747 30.5848 150.081 27.2108L149.918 26.394H168.118L168.125 25.1068ZM150.255 22.0893C150.617 20.772 151.392 19.6127 152.462 18.79C153.532 17.9674 154.838 17.5271 156.177 17.537C159.001 17.537 161.113 19.2401 161.85 22.0893H150.255Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M253.361 25.1068C253.225 17.7152 248.314 12.5491 241.412 12.5491C234.403 12.5491 229.121 17.9454 229.121 25.1018C229.079 28.3765 230.279 31.5409 232.469 33.934C234.711 36.3327 237.923 37.6471 241.417 37.6471C244.91 37.6471 248.122 36.3277 250.362 33.934C251.566 32.6337 252.476 31.0799 253.029 29.3818H247.361C246.202 31.4883 244.018 32.7656 241.409 32.7656C238.406 32.7656 235.981 30.5848 235.315 27.2108L235.152 26.394H253.361V25.1068ZM235.492 22.0893C235.852 20.772 236.627 19.6125 237.697 18.7898C238.767 17.967 240.072 17.5268 241.412 17.537C244.236 17.537 246.348 19.2401 247.085 22.0893H235.492Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M185.329 12.5723C181.351 12.3257 177.969 14.0521 176.257 17.3224V13.2604H169.689V36.8628H176.257V26.6154C176.257 20.3559 180.743 17.1621 185.329 18.9551V12.5723Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M143.14 31.7301C142.216 32.1368 141.217 32.348 140.207 32.3504C137.417 32.3504 135.879 30.6525 135.879 27.568V18.1145H143.417V13.2925H135.874V3.13956L129.582 5.43063V13.2925H118.896V3.13708L112.605 5.42819V28.4133C112.605 34.4537 115.733 37.6469 121.649 37.6469C123.958 37.6469 125.938 37.2737 127.684 36.5051L126.158 31.735C125.233 32.1417 124.235 32.3529 123.225 32.3554C120.434 32.3554 118.896 30.6574 118.896 27.573V18.1219H129.587V28.4133C129.587 34.4537 132.716 37.6469 138.634 37.6469C140.94 37.6469 142.92 37.2737 144.666 36.5051L143.14 31.7301Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M295.648 31.7276C294.738 32.1342 293.755 32.3454 292.76 32.3479C290.009 32.3479 288.496 30.65 288.496 27.5656V18.112H295.921V13.2901H288.493V3.13708L282.294 5.42816V28.4133C282.294 34.4537 285.377 37.6469 291.208 37.6469C293.483 37.6469 295.434 37.2737 297.152 36.5051L295.648 31.7276Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React210.createElement(
      "path",
      {
        d: "M24.7088 32.8718L44.3326 40C47.5464 35.8451 49.4176 30.5549 49.4176 24.6545C49.4176 10.5999 38.7968 0 24.7088 0C10.6208 0 0 10.5999 0 24.6545C0 30.5549 1.87369 35.8378 5.08747 40L24.7088 32.8718Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/b4a-signature-stacked.tsx
import React211 from "react";
var B4ASignatureStacked = (props) => {
  return /* @__PURE__ */ React211.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 386 96",
      "aria-label": "Betterment B4A logo with stacked text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M350.835 16.1762C348.845 16.1501 346.88 16.6293 345.112 17.5717C343.344 18.514 341.828 19.8905 340.697 21.5799V17.0948H332.845V47.5144H340.697V32.6257C340.697 26.9041 343.332 23.4902 347.744 23.4902C351.633 23.4902 354.416 26.1476 354.416 30.5881V47.5144H362.209V28.8876C362.212 20.941 357.562 16.1762 350.835 16.1762Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M273.231 47.4922H264.949V30.5676C264.949 26.3882 262.33 23.4704 258.57 23.4704C253.877 23.4704 251.077 26.8839 251.077 32.6049V47.4922H242.73V17.0852H251.077V21.5793C252.278 19.89 253.889 18.5135 255.767 17.5712C257.645 16.6289 259.734 16.1498 261.848 16.1762C266.636 16.1762 270.248 18.5663 272.02 22.5964C273.276 20.614 275.039 18.9809 277.138 17.8558C279.237 16.7308 281.601 16.1522 283.999 16.1762C290.915 16.1762 295.382 21.163 295.382 28.8895V47.5144H287.103V30.5899C287.103 26.4104 284.483 23.4927 280.721 23.4927C276.031 23.4927 273.228 26.9062 273.228 32.6272L273.231 47.4922Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M103.137 27.0117L101.354 26.2981L103.058 25.4292C103.258 25.3277 107.821 22.8921 107.821 17.0315C107.821 12.0842 103.416 7.07666 94.996 7.07666H74.6497V47.5144H95.0353C108.401 47.5144 109.076 38.3524 109.076 36.5162C109.079 29.4758 103.196 27.0402 103.137 27.0117ZM83.0661 13.7301H93.1246C95.8842 13.7301 98.8568 15.338 98.8568 18.874C98.8568 22.3244 95.9726 24.1321 93.1246 24.1321H83.0661V13.7301ZM94.4421 40.861H83.0661V30.4589H94.4421C98.1685 30.4589 100.115 33.1038 100.115 35.7202C100.115 38.7044 97.7294 40.8673 94.4421 40.8673V40.861Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M143.502 32.3614C143.32 22.8341 136.756 16.1752 127.531 16.1752C118.166 16.1752 111.102 23.1308 111.102 32.355C111.047 36.5767 112.651 40.656 115.58 43.7394C118.574 46.8311 122.868 48.5254 127.537 48.5254C132.206 48.5254 136.5 46.8248 139.494 43.7394C141.103 42.0633 142.319 40.0605 143.058 37.8717H135.492C133.943 40.587 131.024 42.2334 127.537 42.2334C123.522 42.2334 120.282 39.4224 119.391 35.0735L119.174 34.0206H143.502V32.3614ZM119.618 28.472C120.1 26.7744 121.136 25.2802 122.566 24.2198C123.996 23.1594 125.74 22.5918 127.531 22.6044C131.305 22.6044 134.128 24.7996 135.113 28.472H119.618Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M218.429 32.3614C218.253 22.8341 211.894 16.1752 202.959 16.1752C193.884 16.1752 187.042 23.1308 187.042 32.355C186.99 36.5764 188.544 40.6551 191.38 43.7394C194.28 46.8311 198.439 48.5254 202.965 48.5254C207.491 48.5254 211.646 46.8248 214.547 43.7394C216.105 42.0633 217.284 40.0605 217.999 37.8717H210.661C209.161 40.587 206.33 42.2334 202.955 42.2334C199.066 42.2334 195.928 39.4224 195.065 35.0735L194.854 34.0206H218.42L218.429 32.3614ZM195.291 28.472C195.758 26.7742 196.762 25.2799 198.148 24.2195C199.534 23.1591 201.224 22.5916 202.959 22.6044C206.615 22.6044 209.349 24.7996 210.303 28.472H195.291Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M328.795 32.3614C328.619 22.8341 322.26 16.1752 313.323 16.1752C304.248 16.1752 297.408 23.1308 297.408 32.355C297.355 36.576 298.908 40.6548 301.743 43.7394C304.647 46.8311 308.806 48.5254 313.329 48.5254C317.853 48.5254 322.012 46.8248 324.912 43.7394C326.471 42.0633 327.65 40.0605 328.365 37.8717H321.026C319.526 40.587 316.697 42.2334 313.32 42.2334C309.431 42.2334 306.292 39.4224 305.428 35.0735L305.218 34.0206H328.795V32.3614ZM305.657 28.472C306.124 26.7742 307.128 25.2796 308.513 24.2191C309.898 23.1587 311.589 22.5912 313.323 22.6044C316.98 22.6044 319.714 24.7996 320.668 28.472H305.657Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M240.705 16.2051C235.555 15.8872 231.175 18.1125 228.959 22.3277V17.092H220.454V47.5144H228.959V34.306C228.959 26.2378 234.767 22.1211 240.705 24.4322V16.2051Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M186.078 40.8987C184.88 41.4229 183.587 41.6952 182.279 41.6983C178.667 41.6983 176.675 39.5098 176.675 35.5341V23.3489H186.436V17.1336H176.669V4.04689L168.522 6.99997V17.1336H154.686V4.0437L146.539 6.99682V36.6236C146.539 44.4093 150.59 48.5252 158.25 48.5252C161.24 48.5252 163.804 48.0442 166.064 47.0534L164.088 40.9051C162.891 41.4293 161.598 41.7015 160.29 41.7047C156.677 41.7047 154.686 39.5161 154.686 35.5404V23.3584H168.529V36.6236C168.529 44.4093 172.58 48.5252 180.243 48.5252C183.229 48.5252 185.793 48.0442 188.053 47.0534L186.078 40.8987Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M383.55 40.8955C382.372 41.4197 381.099 41.6919 379.811 41.6951C376.248 41.6951 374.289 39.5066 374.289 35.5309V23.3457H383.903V17.1304H374.286V4.0437L366.259 6.99679V36.6235C366.259 44.4093 370.25 48.5252 377.801 48.5252C380.747 48.5252 383.273 48.0442 385.497 47.0534L383.55 40.8955Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M32.7287 42.3702L58.1382 51.5581C62.2995 46.2027 64.7225 39.3839 64.7225 31.7785C64.7225 13.6628 50.9703 0 32.7287 0C14.4871 0 0.734863 13.6628 0.734863 31.7785C0.734863 39.3839 3.16098 46.1933 7.32229 51.5581L32.7287 42.3702Z",
        fill: "#FFC729"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M96.766 93.1135L93.7759 84.7167H81.8976L78.9075 93.1135H74.8934L85.9116 64.032H89.7618L100.78 93.1135H96.766ZM92.629 81.4399L88.574 70.0941C88.2736 69.2749 88.0415 68.5376 87.8777 67.8822H87.7958C87.6319 68.5376 87.3998 69.2749 87.0994 70.0941L83.0444 81.4399H92.629Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M110.733 93.605C109.095 93.605 107.647 93.1681 106.391 92.2943C105.135 91.3931 104.152 90.137 103.442 88.526C102.759 86.8876 102.418 85.0034 102.418 82.8735C102.418 80.7982 102.787 78.955 103.524 77.3439C104.261 75.7055 105.285 74.4358 106.596 73.5347C107.934 72.6063 109.45 72.142 111.143 72.142C113.873 72.142 115.88 73.3162 117.164 75.6646V63.4176H120.645V93.1135H117.368V89.3042C116.74 90.6968 115.867 91.7618 114.747 92.4991C113.655 93.2363 112.317 93.605 110.733 93.605ZM111.675 90.533C113.368 90.533 114.72 89.8913 115.73 88.6079C116.74 87.2972 117.246 85.5496 117.246 83.365V82.423C117.246 80.1838 116.74 78.4225 115.73 77.1391C114.747 75.8557 113.395 75.214 111.675 75.214C109.927 75.214 108.562 75.8967 107.579 77.262C106.596 78.6 106.104 80.4705 106.104 82.8735C106.104 85.2765 106.596 87.1606 107.579 88.526C108.562 89.864 109.927 90.533 111.675 90.533Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M124.125 72.6336H127.893L132.481 86.437C132.836 87.502 133.123 88.5396 133.341 89.55H133.464C133.682 88.5396 133.969 87.502 134.324 86.437L138.912 72.6336H142.68L135.266 93.1135H131.539L124.125 72.6336Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M145.943 93.1135V72.6336H149.424V93.1135H145.943ZM145.697 68.8243V64.4416H149.67V68.8243H145.697Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M162.763 93.605C160.305 93.605 158.298 93.0179 156.742 91.8437C155.212 90.6695 154.27 88.9902 153.915 86.8056L157.438 86.1913C157.711 87.6931 158.312 88.8263 159.24 89.5909C160.169 90.3555 161.397 90.7378 162.927 90.7378C164.292 90.7378 165.343 90.4647 166.08 89.9186C166.818 89.3725 167.186 88.6215 167.186 87.6658C167.186 86.6555 166.913 85.9045 166.367 85.413C165.848 84.9215 165.029 84.6075 163.91 84.4709L160.592 84.1023C158.626 83.8839 157.138 83.2558 156.127 82.2182C155.117 81.1805 154.612 79.8425 154.612 78.2041C154.612 76.3473 155.308 74.8727 156.701 73.7804C158.093 72.6882 159.991 72.142 162.394 72.142C164.715 72.142 166.613 72.7155 168.087 73.8624C169.589 74.9819 170.45 76.4838 170.668 78.3679L167.227 79.1462C166.982 77.8628 166.435 76.8524 165.589 76.1151C164.77 75.3506 163.677 74.9683 162.312 74.9683C160.947 74.9683 159.882 75.2413 159.117 75.7875C158.38 76.3063 158.011 77.0572 158.011 78.0403C158.011 79.8425 159.24 80.8801 161.698 81.1532L164.975 81.5218C168.743 81.9314 170.627 83.8702 170.627 87.3381C170.627 89.3042 169.931 90.847 168.538 91.9666C167.173 93.0588 165.248 93.605 162.763 93.605Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M183.085 93.605C181.173 93.605 179.494 93.1817 178.046 92.3352C176.599 91.4614 175.48 90.219 174.688 88.6079C173.923 86.9968 173.541 85.0853 173.541 82.8735C173.541 80.6617 173.923 78.7502 174.688 77.1391C175.48 75.5281 176.599 74.2993 178.046 73.4528C179.494 72.579 181.173 72.142 183.085 72.142C184.996 72.142 186.675 72.579 188.123 73.4528C189.57 74.2993 190.676 75.5281 191.44 77.1391C192.232 78.7502 192.628 80.6617 192.628 82.8735C192.628 85.0853 192.232 86.9968 191.44 88.6079C190.676 90.219 189.57 91.4614 188.123 92.3352C186.675 93.1817 184.996 93.605 183.085 93.605ZM183.085 90.574C184.941 90.574 186.375 89.9186 187.385 88.6079C188.423 87.2972 188.942 85.3857 188.942 82.8735C188.942 80.3613 188.423 78.4499 187.385 77.1391C186.375 75.8284 184.941 75.1731 183.085 75.1731C181.228 75.1731 179.78 75.8284 178.743 77.1391C177.732 78.4499 177.227 80.3613 177.227 82.8735C177.227 85.3857 177.732 87.2972 178.743 88.6079C179.78 89.9186 181.228 90.574 183.085 90.574Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M200.561 77.303C201.079 75.7738 201.871 74.5314 202.936 73.5756C204.029 72.6199 205.312 72.142 206.786 72.142C207.114 72.142 207.36 72.1557 207.524 72.183V75.5827H207.36C205.421 75.5827 203.919 76.1151 202.854 77.1801C201.981 78.0539 201.421 79.0643 201.175 80.2111C200.929 81.358 200.806 82.737 200.806 84.3481V93.1135H197.325V72.6336H200.561V77.303Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M230.262 93.8098C226.712 93.8098 223.941 92.9633 221.947 91.2703C219.954 89.55 218.834 87.2835 218.589 84.4709L222.521 83.8975C222.821 85.8636 223.599 87.4747 224.856 88.7308C226.139 89.9869 227.982 90.6149 230.385 90.6149C232.187 90.6149 233.716 90.2053 234.973 89.3861C236.229 88.5669 236.857 87.3108 236.857 85.6178C236.857 84.0067 236.406 82.8326 235.505 82.0953C234.604 81.3307 233.211 80.7573 231.327 80.375L227.108 79.5148C222.248 78.5045 219.817 75.8284 219.817 71.4867C219.817 69.8756 220.227 68.4557 221.046 67.2269C221.893 65.9981 223.067 65.0424 224.569 64.3597C226.098 63.677 227.887 63.3357 229.935 63.3357C232.966 63.3357 235.45 64.032 237.389 65.4246C239.328 66.8173 240.434 68.8789 240.707 71.6096L236.816 72.4288C236.297 68.4147 233.976 66.4077 229.853 66.4077C228.05 66.4077 226.589 66.8309 225.47 67.6774C224.378 68.5239 223.832 69.6708 223.832 71.1181C223.832 72.5107 224.214 73.6029 224.978 74.3948C225.743 75.1867 226.944 75.7602 228.583 76.1151L232.843 77.0163C235.382 77.5351 237.348 78.4225 238.741 79.6786C240.161 80.9347 240.871 82.7916 240.871 85.2492C240.871 86.8057 240.475 88.2392 239.683 89.55C238.918 90.8334 237.731 91.871 236.119 92.6629C234.536 93.4275 232.583 93.8098 230.262 93.8098Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M253.087 93.605C251.176 93.605 249.497 93.1817 248.049 92.3352C246.602 91.4614 245.483 90.219 244.691 88.6079C243.926 86.9968 243.544 85.0853 243.544 82.8735C243.544 80.6617 243.926 78.7502 244.691 77.1391C245.483 75.5281 246.602 74.2993 248.049 73.4528C249.497 72.579 251.176 72.142 253.087 72.142C254.999 72.142 256.678 72.579 258.125 73.4528C259.573 74.2993 260.679 75.5281 261.443 77.1391C262.235 78.7502 262.631 80.6617 262.631 82.8735C262.631 85.0853 262.235 86.9968 261.443 88.6079C260.679 90.219 259.573 91.4614 258.125 92.3352C256.678 93.1817 254.999 93.605 253.087 93.605ZM253.087 90.574C254.944 90.574 256.378 89.9186 257.388 88.6079C258.426 87.2972 258.945 85.3857 258.945 82.8735C258.945 80.3613 258.426 78.4499 257.388 77.1391C256.378 75.8284 254.944 75.1731 253.087 75.1731C251.231 75.1731 249.783 75.8284 248.746 77.1391C247.735 78.4499 247.23 80.3613 247.23 82.8735C247.23 85.3857 247.735 87.2972 248.746 88.6079C249.783 89.9186 251.231 90.574 253.087 90.574Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement("path", { d: "M271.014 63.4176V93.1135H267.532V63.4176H271.014Z", fill: "#000B50" }),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M284.178 93.605C281.721 93.605 279.932 92.9223 278.812 91.557C277.72 90.1917 277.174 88.2392 277.174 85.6997V72.6336H280.656V85.2901C280.656 87.0104 281.011 88.3348 281.721 89.2632C282.458 90.1644 283.495 90.6149 284.833 90.6149C286.472 90.6149 287.796 89.9732 288.807 88.6898C289.817 87.4064 290.322 85.727 290.322 83.6517V72.6336H293.804V93.1135H290.527V89.2632C290.063 90.5193 289.243 91.557 288.069 92.3762C286.895 93.1954 285.598 93.605 284.178 93.605Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M297.297 72.6336H301.106V67.2678L304.588 65.7933V72.6336H309.708V75.5007H304.588V86.8466C304.588 88.0208 304.82 88.8809 305.284 89.4271C305.776 89.9459 306.54 90.2053 307.578 90.2053C308.179 90.2053 308.889 90.1097 309.708 89.9186V93.1135C308.807 93.3592 307.796 93.4821 306.677 93.4821C304.602 93.4821 303.154 92.9223 302.335 91.8027C301.516 90.6832 301.106 89.0721 301.106 86.9695V75.5007H297.297V72.6336Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M313.99 93.1135V72.6336H317.471V93.1135H313.99ZM313.744 68.8243V64.4416H317.717V68.8243H313.744Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M331.711 93.605C329.799 93.605 328.12 93.1817 326.673 92.3352C325.226 91.4614 324.106 90.219 323.314 88.6079C322.55 86.9968 322.167 85.0853 322.167 82.8735C322.167 80.6617 322.55 78.7502 323.314 77.1391C324.106 75.5281 325.226 74.2993 326.673 73.4528C328.12 72.579 329.799 72.142 331.711 72.142C333.622 72.142 335.302 72.579 336.749 73.4528C338.196 74.2993 339.302 75.5281 340.067 77.1391C340.859 78.7502 341.255 80.6617 341.255 82.8735C341.255 85.0853 340.859 86.9968 340.067 88.6079C339.302 90.219 338.196 91.4614 336.749 92.3352C335.302 93.1817 333.622 93.605 331.711 93.605ZM331.711 90.574C333.568 90.574 335.001 89.9186 336.012 88.6079C337.049 87.2972 337.568 85.3857 337.568 82.8735C337.568 80.3613 337.049 78.4499 336.012 77.1391C335.001 75.8284 333.568 75.1731 331.711 75.1731C329.854 75.1731 328.407 75.8284 327.369 77.1391C326.359 78.4499 325.854 80.3613 325.854 82.8735C325.854 85.3857 326.359 87.2972 327.369 88.6079C328.407 89.9186 329.854 90.574 331.711 90.574Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M345.951 72.6336H349.228V76.6886C350.566 73.6029 352.846 72.0601 356.068 72.0601C358.335 72.0601 360.041 72.7701 361.188 74.19C362.335 75.5827 362.909 77.6443 362.909 80.375V93.1135H359.427V80.5798C359.427 76.948 357.925 75.1321 354.921 75.1321C353.228 75.1321 351.89 75.7875 350.907 77.0982C349.924 78.3816 349.433 80.1565 349.433 82.423V93.1135H345.951V72.6336Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React211.createElement(
      "path",
      {
        d: "M375.651 93.605C373.194 93.605 371.187 93.0179 369.63 91.8437C368.101 90.6695 367.159 88.9902 366.804 86.8056L370.326 86.1913C370.599 87.6931 371.2 88.8263 372.129 89.5909C373.057 90.3555 374.286 90.7378 375.815 90.7378C377.18 90.7378 378.232 90.4647 378.969 89.9186C379.706 89.3725 380.075 88.6215 380.075 87.6658C380.075 86.6555 379.802 85.9045 379.256 85.413C378.737 84.9215 377.918 84.6075 376.798 84.4709L373.48 84.1023C371.514 83.8839 370.026 83.2558 369.016 82.2182C368.005 81.1805 367.5 79.8425 367.5 78.2041C367.5 76.3473 368.197 74.8727 369.589 73.7804C370.982 72.6882 372.88 72.142 375.283 72.142C377.604 72.142 379.501 72.7155 380.976 73.8624C382.478 74.9819 383.338 76.4838 383.556 78.3679L380.116 79.1462C379.87 77.8628 379.324 76.8524 378.477 76.1151C377.658 75.3506 376.566 74.9683 375.201 74.9683C373.835 74.9683 372.77 75.2413 372.006 75.7875C371.268 76.3063 370.9 77.0572 370.9 78.0403C370.9 79.8425 372.129 80.8801 374.586 81.1532L377.863 81.5218C381.631 81.9314 383.515 83.8702 383.515 87.3381C383.515 89.3042 382.819 90.847 381.427 91.9666C380.061 93.0588 378.136 93.605 375.651 93.605Z",
        fill: "#000B50"
      }
    )
  );
};

// src/components/logo/b4a-signature-white.tsx
import React212 from "react";
var B4ASignatureWhite = (props) => {
  return /* @__PURE__ */ React212.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 661 40",
      "aria-label": "Betterment B4A logo with white text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M334.033 36.3785L330.634 26.8339H317.132L313.733 36.3785H309.17L321.694 3.32154H326.071L338.595 36.3785H334.033ZM329.33 23.1092L324.721 10.2123C324.379 9.28111 324.116 8.44304 323.929 7.69809H323.836C323.65 8.44304 323.386 9.28111 323.045 10.2123L318.435 23.1092H329.33Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M349.909 36.9372C348.047 36.9372 346.401 36.4406 344.974 35.4473C343.546 34.423 342.428 32.9952 341.621 31.1639C340.845 29.3015 340.457 27.1598 340.457 24.7387C340.457 22.3797 340.876 20.2846 341.715 18.4533C342.553 16.5909 343.717 15.1476 345.206 14.1233C346.727 13.0679 348.45 12.5402 350.375 12.5402C353.478 12.5402 355.76 13.8749 357.219 16.5443V2.62315H361.176V36.3785H357.452V32.0485C356.738 33.6315 355.744 34.8421 354.472 35.6801C353.23 36.5182 351.709 36.9372 349.909 36.9372ZM350.98 33.4453C352.904 33.4453 354.441 32.7159 355.589 31.257C356.738 29.7671 357.312 27.7806 357.312 25.2974V24.2266C357.312 21.6814 356.738 19.6793 355.589 18.2205C354.472 16.7616 352.935 16.0322 350.98 16.0322C348.993 16.0322 347.441 16.8082 346.324 18.3601C345.206 19.8811 344.648 22.0073 344.648 24.7387C344.648 27.4702 345.206 29.6119 346.324 31.1639C347.441 32.6848 348.993 33.4453 350.98 33.4453Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M365.132 13.099H369.415L374.63 28.7894C375.034 29.9999 375.359 31.1794 375.608 32.3279H375.747C375.996 31.1794 376.322 29.9999 376.725 28.7894L381.94 13.099H386.223L377.796 36.3785H373.559L365.132 13.099Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M389.932 36.3785V13.099H393.889V36.3785H389.932ZM389.653 8.76895V3.78713H394.169V8.76895H389.653Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M409.051 36.9372C406.258 36.9372 403.976 36.2699 402.207 34.9352C400.469 33.6005 399.398 31.6916 398.995 29.2084L402.999 28.51C403.309 30.2172 403.992 31.5053 405.047 32.3744C406.103 33.2435 407.499 33.6781 409.238 33.6781C410.79 33.6781 411.985 33.3677 412.823 32.7469C413.661 32.1261 414.08 31.2725 414.08 30.1862C414.08 29.0377 413.769 28.1841 413.149 27.6254C412.559 27.0667 411.628 26.7097 410.355 26.5545L406.584 26.1355C404.349 25.8872 402.657 25.1733 401.509 23.9938C400.36 22.8143 399.786 21.2934 399.786 19.431C399.786 17.3203 400.578 15.6442 402.161 14.4026C403.744 13.161 405.901 12.5402 408.632 12.5402C411.271 12.5402 413.428 13.1921 415.104 14.4957C416.811 15.7683 417.789 17.4755 418.037 19.6172L414.126 20.5019C413.847 19.043 413.226 17.8945 412.264 17.0565C411.333 16.1874 410.091 15.7528 408.539 15.7528C406.987 15.7528 405.777 16.0632 404.908 16.684C404.07 17.2738 403.651 18.1273 403.651 19.2448C403.651 21.2934 405.047 22.4729 407.841 22.7833L411.566 23.2023C415.849 23.6679 417.991 25.8717 417.991 29.8137C417.991 32.0485 417.199 33.8022 415.616 35.0749C414.064 36.3164 411.876 36.9372 409.051 36.9372Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M432.151 36.9372C429.979 36.9372 428.07 36.4561 426.424 35.4939C424.779 34.5006 423.507 33.0883 422.607 31.257C421.738 29.4257 421.303 27.2529 421.303 24.7387C421.303 22.2245 421.738 20.0518 422.607 18.2205C423.507 16.3891 424.779 14.9924 426.424 14.0301C428.07 13.0369 429.979 12.5402 432.151 12.5402C434.324 12.5402 436.233 13.0369 437.878 14.0301C439.523 14.9924 440.78 16.3891 441.649 18.2205C442.549 20.0518 443 22.2245 443 24.7387C443 27.2529 442.549 29.4257 441.649 31.257C440.78 33.0883 439.523 34.5006 437.878 35.4939C436.233 36.4561 434.324 36.9372 432.151 36.9372ZM432.151 33.4919C434.262 33.4919 435.892 32.7469 437.04 31.257C438.219 29.7671 438.809 27.5944 438.809 24.7387C438.809 21.8831 438.219 19.7104 437.04 18.2205C435.892 16.7306 434.262 15.9856 432.151 15.9856C430.041 15.9856 428.396 16.7306 427.216 18.2205C426.068 19.7104 425.493 21.8831 425.493 24.7387C425.493 27.5944 426.068 29.7671 427.216 31.257C428.396 32.7469 430.041 33.4919 432.151 33.4919Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M452.016 18.4067C452.606 16.6685 453.506 15.2562 454.717 14.1698C455.958 13.0834 457.417 12.5402 459.093 12.5402C459.466 12.5402 459.745 12.5558 459.931 12.5868V16.4512H459.745C457.541 16.4512 455.834 17.0565 454.624 18.267C453.63 19.2603 452.994 20.4087 452.715 21.7124C452.435 23.0161 452.296 24.5835 452.296 26.4149V36.3785H448.338V13.099H452.016V18.4067Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M485.778 37.17C481.743 37.17 478.593 36.2078 476.327 34.2834C474.061 32.3279 472.788 29.7516 472.509 26.5545L476.979 25.9027C477.32 28.1376 478.205 29.9689 479.632 31.3967C481.091 32.8245 483.186 33.5384 485.918 33.5384C487.967 33.5384 489.705 33.0728 491.133 32.1416C492.56 31.2105 493.274 29.7826 493.274 27.8582C493.274 26.0269 492.762 24.6922 491.738 23.8541C490.714 22.985 489.131 22.3332 486.989 21.8986L482.193 20.9209C476.668 19.7724 473.906 16.7306 473.906 11.7953C473.906 9.96397 474.371 8.34992 475.302 6.95315C476.265 5.55637 477.599 4.46999 479.307 3.69401C481.045 2.91802 483.078 2.53003 485.406 2.53003C488.851 2.53003 491.676 3.32153 493.88 4.90455C496.083 6.48756 497.34 8.83103 497.651 11.935L493.228 12.8662C492.638 8.30336 490 6.02197 485.313 6.02197C483.264 6.02197 481.603 6.50308 480.331 7.4653C479.089 8.42752 478.469 9.73118 478.469 11.3763C478.469 12.9593 478.903 14.2009 479.772 15.101C480.641 16.0011 482.007 16.653 483.869 17.0565L488.712 18.0808C491.598 18.6705 493.833 19.6793 495.416 21.1071C497.03 22.5349 497.837 24.6456 497.837 27.4392C497.837 29.2084 497.387 30.838 496.487 32.3279C495.618 33.7867 494.268 34.9662 492.436 35.8664C490.636 36.7355 488.417 37.17 485.778 37.17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M511.724 36.9372C509.551 36.9372 507.642 36.4561 505.997 35.4939C504.352 34.5006 503.079 33.0883 502.179 31.257C501.31 29.4257 500.875 27.2529 500.875 24.7387C500.875 22.2245 501.31 20.0518 502.179 18.2205C503.079 16.3891 504.352 14.9924 505.997 14.0301C507.642 13.0369 509.551 12.5402 511.724 12.5402C513.896 12.5402 515.805 13.0369 517.451 14.0301C519.096 14.9924 520.353 16.3891 521.222 18.2205C522.122 20.0518 522.572 22.2245 522.572 24.7387C522.572 27.2529 522.122 29.4257 521.222 31.257C520.353 33.0883 519.096 34.5006 517.451 35.4939C515.805 36.4561 513.896 36.9372 511.724 36.9372ZM511.724 33.4919C513.834 33.4919 515.464 32.7469 516.612 31.257C517.792 29.7671 518.382 27.5944 518.382 24.7387C518.382 21.8831 517.792 19.7104 516.612 18.2205C515.464 16.7306 513.834 15.9856 511.724 15.9856C509.613 15.9856 507.968 16.7306 506.788 18.2205C505.64 19.7104 505.066 21.8831 505.066 24.7387C505.066 27.5944 505.64 29.7671 506.788 31.257C507.968 32.7469 509.613 33.4919 511.724 33.4919Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement("path", { d: "M532.101 2.62315V36.3785H528.143V2.62315H532.101Z", fill: "white" }),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M547.065 36.9372C544.271 36.9372 542.238 36.1612 540.965 34.6093C539.724 33.0573 539.103 30.838 539.103 27.9513V13.099H543.061V27.4857C543.061 29.4412 543.464 30.9466 544.271 32.002C545.109 33.0263 546.289 33.5384 547.81 33.5384C549.672 33.5384 551.177 32.809 552.326 31.3501C553.474 29.8913 554.049 27.9824 554.049 25.6234V13.099H558.006V36.3785H554.281V32.002C553.754 33.4298 552.822 34.6093 551.488 35.5405C550.153 36.4716 548.679 36.9372 547.065 36.9372Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M561.977 13.099H566.307V6.99971L570.265 5.32358V13.099H576.084V16.3581H570.265V29.255C570.265 30.5897 570.528 31.5674 571.056 32.1882C571.615 32.778 572.484 33.0728 573.663 33.0728C574.346 33.0728 575.153 32.9642 576.084 32.7469V36.3785C575.06 36.6579 573.912 36.7976 572.639 36.7976C570.28 36.7976 568.635 36.1612 567.704 34.8886C566.773 33.616 566.307 31.7847 566.307 29.3947V16.3581H561.977V13.099Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M580.952 36.3785V13.099H584.909V36.3785H580.952ZM580.672 8.76895V3.78713H585.189V8.76895H580.672Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M601.095 36.9372C598.923 36.9372 597.014 36.4561 595.369 35.4939C593.724 34.5006 592.451 33.0883 591.551 31.257C590.682 29.4257 590.247 27.2529 590.247 24.7387C590.247 22.2245 590.682 20.0518 591.551 18.2205C592.451 16.3891 593.724 14.9924 595.369 14.0301C597.014 13.0369 598.923 12.5402 601.095 12.5402C603.268 12.5402 605.177 13.0369 606.822 14.0301C608.467 14.9924 609.724 16.3891 610.594 18.2205C611.494 20.0518 611.944 22.2245 611.944 24.7387C611.944 27.2529 611.494 29.4257 610.594 31.257C609.724 33.0883 608.467 34.5006 606.822 35.4939C605.177 36.4561 603.268 36.9372 601.095 36.9372ZM601.095 33.4919C603.206 33.4919 604.836 32.7469 605.984 31.257C607.164 29.7671 607.753 27.5944 607.753 24.7387C607.753 21.8831 607.164 19.7104 605.984 18.2205C604.836 16.7306 603.206 15.9856 601.095 15.9856C598.985 15.9856 597.34 16.7306 596.16 18.2205C595.012 19.7104 594.438 21.8831 594.438 24.7387C594.438 27.5944 595.012 29.7671 596.16 31.257C597.34 32.7469 598.985 33.4919 601.095 33.4919Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M617.282 13.099H621.007V17.7083C622.528 14.2009 625.12 12.4471 628.783 12.4471C631.359 12.4471 633.299 13.2542 634.602 14.8682C635.906 16.4512 636.558 18.7947 636.558 21.8986V36.3785H632.6V22.1314C632.6 18.0032 630.893 15.9391 627.479 15.9391C625.554 15.9391 624.033 16.684 622.916 18.1739C621.799 19.6328 621.24 21.6503 621.24 24.2266V36.3785H617.282V13.099Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M651.042 36.9372C648.249 36.9372 645.968 36.2699 644.198 34.9352C642.46 33.6005 641.389 31.6916 640.986 29.2084L644.99 28.51C645.3 30.2172 645.983 31.5053 647.038 32.3744C648.094 33.2435 649.491 33.6781 651.229 33.6781C652.781 33.6781 653.976 33.3677 654.814 32.7469C655.652 32.1261 656.071 31.2725 656.071 30.1862C656.071 29.0377 655.76 28.1841 655.14 27.6254C654.55 27.0667 653.619 26.7097 652.346 26.5545L648.575 26.1355C646.34 25.8872 644.648 25.1733 643.5 23.9938C642.351 22.8143 641.777 21.2934 641.777 19.431C641.777 17.3203 642.569 15.6442 644.152 14.4026C645.735 13.161 647.892 12.5402 650.623 12.5402C653.262 12.5402 655.419 13.1921 657.095 14.4957C658.802 15.7683 659.78 17.4755 660.028 19.6172L656.117 20.5019C655.838 19.043 655.217 17.8945 654.255 17.0565C653.324 16.1874 652.082 15.7528 650.53 15.7528C648.978 15.7528 647.768 16.0632 646.899 16.684C646.061 17.2738 645.642 18.1273 645.642 19.2448C645.642 21.2934 647.038 22.4729 649.832 22.7833L653.557 23.2023C657.84 23.6679 659.982 25.8717 659.982 29.8137C659.982 32.0485 659.19 33.8022 657.607 35.0749C656.055 36.3164 653.867 36.9372 651.042 36.9372Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M270.382 12.5499C268.845 12.5296 267.327 12.9014 265.962 13.6325C264.597 14.3636 263.426 15.4315 262.553 16.7422V13.2626H256.489V36.8628H262.553V25.3118C262.553 20.8728 264.587 18.2243 267.995 18.2243C270.999 18.2243 273.148 20.2859 273.148 23.731V36.8628H279.166V22.4117C279.169 16.2465 275.577 12.5499 270.382 12.5499Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M210.449 36.8456H204.053V23.7151C204.053 20.4725 202.03 18.2089 199.126 18.2089C195.502 18.2089 193.34 20.8572 193.34 25.2957V36.8456H186.893V13.2551H193.34V16.7418C194.267 15.4311 195.511 14.3632 196.961 13.6321C198.412 12.9011 200.025 12.5294 201.658 12.5499C205.355 12.5499 208.145 14.4042 209.513 17.5308C210.483 15.9928 211.845 14.7258 213.466 13.853C215.088 12.9801 216.913 12.5312 218.765 12.5499C224.106 12.5499 227.556 16.4187 227.556 22.4131V36.8628H221.162V23.7323C221.162 20.4898 219.139 18.2262 216.233 18.2262C212.611 18.2262 210.446 20.8745 210.446 25.3129L210.449 36.8456Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M79.0853 20.9563L77.7083 20.4027L79.0245 19.7286C79.1789 19.6498 82.7023 17.7602 82.7023 13.2134C82.7023 9.37521 79.3004 5.49023 72.7979 5.49023H57.0845V36.8628H72.8283C83.1503 36.8628 83.6717 29.7547 83.6717 28.3301C83.6743 22.868 79.1308 20.9784 79.0853 20.9563ZM63.5845 10.6521H71.3526C73.4838 10.6521 75.7796 11.8996 75.7796 14.6429C75.7796 17.3198 73.5522 18.7223 71.3526 18.7223H63.5845V10.6521ZM72.3701 31.7009H63.5845V23.6308H72.3701C75.248 23.6308 76.7516 25.6827 76.7516 27.7125C76.7516 30.0278 74.9089 31.7058 72.3701 31.7058V31.7009Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M110.259 25.1068C110.119 17.7152 105.049 12.5491 97.9242 12.5491C90.6921 12.5491 85.2367 17.9454 85.2367 25.1018C85.1938 28.3771 86.433 31.5419 88.6951 33.934C91.0074 36.3327 94.3232 37.6471 97.9292 37.6471C101.535 37.6471 104.851 36.3277 107.163 33.934C108.406 32.6337 109.346 31.0799 109.916 29.3818H104.073C102.877 31.4883 100.622 32.7656 97.9292 32.7656C94.8287 32.7656 92.3262 30.5848 91.638 27.2108L91.4703 26.394H110.259V25.1068ZM91.8132 22.0893C92.1855 20.7722 92.9856 19.613 94.09 18.7903C95.1944 17.9676 96.5417 17.5272 97.9242 17.537C100.84 17.537 103.019 19.2401 103.78 22.0893H91.8132Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M168.125 25.1068C167.99 17.7152 163.079 12.5491 156.177 12.5491C149.169 12.5491 143.885 17.9454 143.885 25.1018C143.845 28.3768 145.045 31.5412 147.235 33.934C149.475 36.3327 152.687 37.6471 156.182 37.6471C159.678 37.6471 162.887 36.3277 165.127 33.934C166.331 32.6337 167.241 31.0799 167.793 29.3818H162.126C160.967 31.4883 158.781 32.7656 156.175 32.7656C153.171 32.7656 150.747 30.5848 150.081 27.2108L149.918 26.394H168.118L168.125 25.1068ZM150.255 22.0893C150.617 20.772 151.392 19.6127 152.462 18.79C153.532 17.9674 154.838 17.5271 156.177 17.537C159.001 17.537 161.113 19.2401 161.85 22.0893H150.255Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M253.361 25.1068C253.225 17.7152 248.314 12.5491 241.412 12.5491C234.403 12.5491 229.121 17.9454 229.121 25.1018C229.079 28.3765 230.279 31.5409 232.469 33.934C234.711 36.3327 237.923 37.6471 241.417 37.6471C244.91 37.6471 248.122 36.3277 250.362 33.934C251.566 32.6337 252.476 31.0799 253.029 29.3818H247.361C246.202 31.4883 244.018 32.7656 241.409 32.7656C238.406 32.7656 235.981 30.5848 235.315 27.2108L235.152 26.394H253.361V25.1068ZM235.492 22.0893C235.852 20.772 236.627 19.6125 237.697 18.7898C238.767 17.967 240.072 17.5268 241.412 17.537C244.236 17.537 246.348 19.2401 247.085 22.0893H235.492Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M185.329 12.5723C181.351 12.3257 177.969 14.0521 176.257 17.3224V13.2604H169.689V36.8628H176.257V26.6154C176.257 20.3559 180.743 17.1621 185.329 18.9551V12.5723Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M143.14 31.7301C142.216 32.1368 141.217 32.348 140.207 32.3504C137.417 32.3504 135.879 30.6525 135.879 27.568V18.1145H143.417V13.2925H135.874V3.13956L129.582 5.43063V13.2925H118.896V3.13708L112.605 5.42819V28.4133C112.605 34.4537 115.733 37.6469 121.649 37.6469C123.958 37.6469 125.938 37.2737 127.684 36.5051L126.158 31.735C125.233 32.1417 124.235 32.3529 123.225 32.3554C120.434 32.3554 118.896 30.6574 118.896 27.573V18.1219H129.587V28.4133C129.587 34.4537 132.716 37.6469 138.634 37.6469C140.94 37.6469 142.92 37.2737 144.666 36.5051L143.14 31.7301Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M295.648 31.7276C294.738 32.1342 293.755 32.3454 292.76 32.3479C290.009 32.3479 288.496 30.65 288.496 27.5656V18.112H295.921V13.2901H288.493V3.13708L282.294 5.42816V28.4133C282.294 34.4537 285.377 37.6469 291.208 37.6469C293.483 37.6469 295.434 37.2737 297.152 36.5051L295.648 31.7276Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React212.createElement(
      "path",
      {
        d: "M24.7088 32.8718L44.3326 40C47.5464 35.8451 49.4176 30.5549 49.4176 24.6545C49.4176 10.5999 38.7968 0 24.7088 0C10.6208 0 0 10.5999 0 24.6545C0 30.5549 1.87369 35.8378 5.08747 40L24.7088 32.8718Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/b4a-signature-white-stacked.tsx
import React213 from "react";
var B4ASignatureWhiteStacked = (props) => {
  return /* @__PURE__ */ React213.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 386 97",
      "aria-label": "Betterment B4A logo with white, stacked text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M96.766 93.1351L93.7759 84.7383H81.8976L78.9075 93.1351H74.8934L85.9116 64.0536H89.7618L100.78 93.1351H96.766ZM92.629 81.4615L88.574 70.1157C88.2736 69.2965 88.0415 68.5592 87.8777 67.9038H87.7958C87.6319 68.5592 87.3998 69.2965 87.0994 70.1157L83.0444 81.4615H92.629Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M110.733 93.6266C109.095 93.6266 107.647 93.1897 106.391 92.3159C105.135 91.4148 104.152 90.1587 103.442 88.5476C102.759 86.9092 102.418 85.025 102.418 82.8951C102.418 80.8198 102.787 78.9766 103.524 77.3655C104.261 75.7272 105.285 74.4574 106.596 73.5563C107.934 72.6279 109.45 72.1637 111.143 72.1637C113.873 72.1637 115.88 73.3378 117.164 75.6862V63.4392H120.645V93.1351H117.368V89.3258C116.74 90.7184 115.867 91.7834 114.747 92.5207C113.655 93.2579 112.317 93.6266 110.733 93.6266ZM111.675 90.5546C113.368 90.5546 114.72 89.9129 115.73 88.6295C116.74 87.3188 117.246 85.5712 117.246 83.3866V82.4446C117.246 80.2054 116.74 78.4442 115.73 77.1607C114.747 75.8773 113.395 75.2356 111.675 75.2356C109.927 75.2356 108.562 75.9183 107.579 77.2836C106.596 78.6216 106.104 80.4921 106.104 82.8951C106.104 85.2981 106.596 87.1822 107.579 88.5476C108.562 89.8856 109.927 90.5546 111.675 90.5546Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M124.125 72.6552H127.893L132.481 86.4586C132.836 87.5236 133.123 88.5612 133.341 89.5716H133.464C133.682 88.5612 133.969 87.5236 134.324 86.4586L138.912 72.6552H142.68L135.266 93.1351H131.539L124.125 72.6552Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M145.943 93.1351V72.6552H149.424V93.1351H145.943ZM145.697 68.8459V64.4632H149.67V68.8459H145.697Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M162.763 93.6266C160.305 93.6266 158.298 93.0395 156.742 91.8653C155.212 90.6911 154.27 89.0118 153.915 86.8273L157.438 86.2129C157.711 87.7147 158.312 88.8479 159.24 89.6125C160.169 90.3771 161.397 90.7594 162.927 90.7594C164.292 90.7594 165.343 90.4863 166.08 89.9402C166.818 89.3941 167.186 88.6431 167.186 87.6874C167.186 86.6771 166.913 85.9261 166.367 85.4346C165.848 84.9431 165.029 84.6291 163.91 84.4925L160.592 84.1239C158.626 83.9055 157.138 83.2774 156.127 82.2398C155.117 81.2021 154.612 79.8641 154.612 78.2257C154.612 76.3689 155.308 74.8943 156.701 73.802C158.093 72.7098 159.991 72.1637 162.394 72.1637C164.715 72.1637 166.613 72.7371 168.087 73.884C169.589 75.0035 170.45 76.5054 170.668 78.3895L167.227 79.1678C166.982 77.8844 166.435 76.874 165.589 76.1368C164.77 75.3722 163.677 74.9899 162.312 74.9899C160.947 74.9899 159.882 75.2629 159.117 75.8091C158.38 76.3279 158.011 77.0788 158.011 78.0619C158.011 79.8641 159.24 80.9017 161.698 81.1748L164.975 81.5434C168.743 81.953 170.627 83.8918 170.627 87.3597C170.627 89.3258 169.931 90.8686 168.538 91.9882C167.173 93.0805 165.248 93.6266 162.763 93.6266Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M183.085 93.6266C181.173 93.6266 179.494 93.2033 178.046 92.3568C176.599 91.483 175.48 90.2406 174.688 88.6295C173.923 87.0184 173.541 85.1069 173.541 82.8951C173.541 80.6833 173.923 78.7718 174.688 77.1607C175.48 75.5497 176.599 74.3209 178.046 73.4744C179.494 72.6006 181.173 72.1637 183.085 72.1637C184.996 72.1637 186.675 72.6006 188.123 73.4744C189.57 74.3209 190.676 75.5497 191.44 77.1607C192.232 78.7718 192.628 80.6833 192.628 82.8951C192.628 85.1069 192.232 87.0184 191.44 88.6295C190.676 90.2406 189.57 91.483 188.123 92.3568C186.675 93.2033 184.996 93.6266 183.085 93.6266ZM183.085 90.5956C184.941 90.5956 186.375 89.9402 187.385 88.6295C188.423 87.3188 188.942 85.4073 188.942 82.8951C188.942 80.3829 188.423 78.4715 187.385 77.1607C186.375 75.85 184.941 75.1947 183.085 75.1947C181.228 75.1947 179.78 75.85 178.743 77.1607C177.732 78.4715 177.227 80.3829 177.227 82.8951C177.227 85.4073 177.732 87.3188 178.743 88.6295C179.78 89.9402 181.228 90.5956 183.085 90.5956Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M200.561 77.3246C201.079 75.7954 201.871 74.553 202.936 73.5972C204.029 72.6415 205.312 72.1637 206.786 72.1637C207.114 72.1637 207.36 72.1773 207.524 72.2046V75.6043H207.36C205.421 75.6043 203.919 76.1368 202.854 77.2017C201.981 78.0755 201.421 79.0859 201.175 80.2327C200.929 81.3796 200.806 82.7586 200.806 84.3697V93.1351H197.325V72.6552H200.561V77.3246Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M230.262 93.8314C226.712 93.8314 223.941 92.9849 221.947 91.2919C219.954 89.5716 218.834 87.3051 218.589 84.4925L222.521 83.9191C222.821 85.8852 223.599 87.4963 224.856 88.7524C226.139 90.0085 227.982 90.6365 230.385 90.6365C232.187 90.6365 233.716 90.2269 234.973 89.4077C236.229 88.5885 236.857 87.3324 236.857 85.6394C236.857 84.0283 236.406 82.8542 235.505 82.1169C234.604 81.3523 233.211 80.7789 231.327 80.3966L227.108 79.5364C222.248 78.5261 219.817 75.85 219.817 71.5083C219.817 69.8972 220.227 68.4773 221.046 67.2485C221.893 66.0197 223.067 65.064 224.569 64.3813C226.098 63.6986 227.887 63.3573 229.935 63.3573C232.966 63.3573 235.45 64.0536 237.389 65.4462C239.328 66.8389 240.434 68.9005 240.707 71.6312L236.816 72.4504C236.297 68.4363 233.976 66.4293 229.853 66.4293C228.05 66.4293 226.589 66.8525 225.47 67.699C224.378 68.5455 223.832 69.6924 223.832 71.1397C223.832 72.5323 224.214 73.6246 224.978 74.4164C225.743 75.2083 226.944 75.7818 228.583 76.1368L232.843 77.0379C235.382 77.5567 237.348 78.4442 238.741 79.7003C240.161 80.9564 240.871 82.8132 240.871 85.2708C240.871 86.8273 240.475 88.2608 239.683 89.5716C238.918 90.855 237.731 91.8926 236.119 92.6845C234.536 93.4491 232.583 93.8314 230.262 93.8314Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M253.087 93.6266C251.176 93.6266 249.497 93.2033 248.049 92.3568C246.602 91.483 245.483 90.2406 244.691 88.6295C243.926 87.0184 243.544 85.1069 243.544 82.8951C243.544 80.6833 243.926 78.7718 244.691 77.1607C245.483 75.5497 246.602 74.3209 248.049 73.4744C249.497 72.6006 251.176 72.1637 253.087 72.1637C254.999 72.1637 256.678 72.6006 258.125 73.4744C259.573 74.3209 260.679 75.5497 261.443 77.1607C262.235 78.7718 262.631 80.6833 262.631 82.8951C262.631 85.1069 262.235 87.0184 261.443 88.6295C260.679 90.2406 259.573 91.483 258.125 92.3568C256.678 93.2033 254.999 93.6266 253.087 93.6266ZM253.087 90.5956C254.944 90.5956 256.378 89.9402 257.388 88.6295C258.426 87.3188 258.945 85.4073 258.945 82.8951C258.945 80.3829 258.426 78.4715 257.388 77.1607C256.378 75.85 254.944 75.1947 253.087 75.1947C251.231 75.1947 249.783 75.85 248.746 77.1607C247.735 78.4715 247.23 80.3829 247.23 82.8951C247.23 85.4073 247.735 87.3188 248.746 88.6295C249.783 89.9402 251.231 90.5956 253.087 90.5956Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement("path", { d: "M271.014 63.4392V93.1351H267.532V63.4392H271.014Z", fill: "white" }),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M284.178 93.6266C281.721 93.6266 279.932 92.9439 278.812 91.5786C277.72 90.2133 277.174 88.2608 277.174 85.7213V72.6552H280.656V85.3117C280.656 87.0321 281.011 88.3564 281.721 89.2848C282.458 90.186 283.495 90.6365 284.833 90.6365C286.472 90.6365 287.796 89.9948 288.807 88.7114C289.817 87.428 290.322 85.7486 290.322 83.6734V72.6552H293.804V93.1351H290.527V89.2848C290.063 90.5409 289.243 91.5786 288.069 92.3978C286.895 93.217 285.598 93.6266 284.178 93.6266Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M297.297 72.6552H301.106V67.2894L304.588 65.8149V72.6552H309.708V75.5224H304.588V86.8682C304.588 88.0424 304.82 88.9026 305.284 89.4487C305.776 89.9675 306.54 90.2269 307.578 90.2269C308.179 90.2269 308.889 90.1313 309.708 89.9402V93.1351C308.807 93.3808 307.796 93.5037 306.677 93.5037C304.602 93.5037 303.154 92.9439 302.335 91.8243C301.516 90.7048 301.106 89.0937 301.106 86.9911V75.5224H297.297V72.6552Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M313.99 93.1351V72.6552H317.471V93.1351H313.99ZM313.744 68.8459V64.4632H317.717V68.8459H313.744Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M331.711 93.6266C329.799 93.6266 328.12 93.2033 326.673 92.3568C325.226 91.483 324.106 90.2406 323.314 88.6295C322.55 87.0184 322.167 85.1069 322.167 82.8951C322.167 80.6833 322.55 78.7718 323.314 77.1607C324.106 75.5497 325.226 74.3209 326.673 73.4744C328.12 72.6006 329.799 72.1637 331.711 72.1637C333.622 72.1637 335.302 72.6006 336.749 73.4744C338.196 74.3209 339.302 75.5497 340.067 77.1607C340.859 78.7718 341.255 80.6833 341.255 82.8951C341.255 85.1069 340.859 87.0184 340.067 88.6295C339.302 90.2406 338.196 91.483 336.749 92.3568C335.302 93.2033 333.622 93.6266 331.711 93.6266ZM331.711 90.5956C333.568 90.5956 335.001 89.9402 336.012 88.6295C337.049 87.3188 337.568 85.4073 337.568 82.8951C337.568 80.3829 337.049 78.4715 336.012 77.1607C335.001 75.85 333.568 75.1947 331.711 75.1947C329.854 75.1947 328.407 75.85 327.369 77.1607C326.359 78.4715 325.854 80.3829 325.854 82.8951C325.854 85.4073 326.359 87.3188 327.369 88.6295C328.407 89.9402 329.854 90.5956 331.711 90.5956Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M345.951 72.6552H349.228V76.7102C350.566 73.6246 352.846 72.0817 356.068 72.0817C358.335 72.0817 360.041 72.7917 361.188 74.2116C362.335 75.6043 362.909 77.6659 362.909 80.3966V93.1351H359.427V80.6014C359.427 76.9696 357.925 75.1537 354.921 75.1537C353.228 75.1537 351.89 75.8091 350.907 77.1198C349.924 78.4032 349.433 80.1781 349.433 82.4446V93.1351H345.951V72.6552Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M375.651 93.6266C373.194 93.6266 371.187 93.0395 369.63 91.8653C368.101 90.6911 367.159 89.0118 366.804 86.8273L370.326 86.2129C370.599 87.7147 371.2 88.8479 372.129 89.6125C373.057 90.3771 374.286 90.7594 375.815 90.7594C377.18 90.7594 378.232 90.4863 378.969 89.9402C379.706 89.3941 380.075 88.6431 380.075 87.6874C380.075 86.6771 379.802 85.9261 379.256 85.4346C378.737 84.9431 377.918 84.6291 376.798 84.4925L373.48 84.1239C371.514 83.9055 370.026 83.2774 369.016 82.2398C368.005 81.2021 367.5 79.8641 367.5 78.2257C367.5 76.3689 368.197 74.8943 369.589 73.802C370.982 72.7098 372.88 72.1637 375.283 72.1637C377.604 72.1637 379.501 72.7371 380.976 73.884C382.478 75.0035 383.338 76.5054 383.556 78.3895L380.116 79.1678C379.87 77.8844 379.324 76.874 378.477 76.1368C377.658 75.3722 376.566 74.9899 375.201 74.9899C373.835 74.9899 372.77 75.2629 372.006 75.8091C371.268 76.3279 370.9 77.0788 370.9 78.0619C370.9 79.8641 372.129 80.9017 374.586 81.1748L377.863 81.5434C381.631 81.953 383.515 83.8918 383.515 87.3597C383.515 89.3258 382.819 90.8686 381.427 91.9882C380.061 93.0805 378.136 93.6266 375.651 93.6266Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M350.835 16.359C348.845 16.3329 346.88 16.8122 345.112 17.7546C343.344 18.6969 341.828 20.0734 340.697 21.7627V17.2777H332.845V47.6973H340.697V32.8085C340.697 27.087 343.332 23.6731 347.744 23.6731C351.633 23.6731 354.416 26.3304 354.416 30.771V47.6973H362.209V29.0704C362.212 21.1238 357.562 16.359 350.835 16.359Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M273.231 47.6751H264.949V30.7505C264.949 26.571 262.33 23.6533 258.57 23.6533C253.877 23.6533 251.077 27.0668 251.077 32.7878V47.6751H242.73V17.2681H251.077V21.7622C252.278 20.0729 253.889 18.6963 255.767 17.754C257.645 16.8117 259.734 16.3327 261.848 16.3591C266.636 16.3591 270.248 18.7491 272.02 22.7793C273.276 20.7969 275.039 19.1637 277.138 18.0387C279.237 16.9137 281.601 16.335 283.999 16.3591C290.915 16.3591 295.382 21.3459 295.382 29.0723V47.6973H287.103V30.7727C287.103 26.5932 284.483 23.6756 280.721 23.6756C276.031 23.6756 273.228 27.0891 273.228 32.8101L273.231 47.6751Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M103.137 27.1946L101.354 26.481L103.058 25.6121C103.258 25.5106 107.821 23.075 107.821 17.2144C107.821 12.2671 103.416 7.25952 94.996 7.25952H74.6497V47.6973H95.0353C108.401 47.6973 109.076 38.5353 109.076 36.6991C109.079 29.6587 103.196 27.2231 103.137 27.1946ZM83.0661 13.913H93.1246C95.8842 13.913 98.8568 15.5208 98.8568 19.0569C98.8568 22.5073 95.9726 24.315 93.1246 24.315H83.0661V13.913ZM94.4421 41.0438H83.0661V30.6418H94.4421C98.1685 30.6418 100.115 33.2867 100.115 35.903C100.115 38.8873 97.7294 41.0501 94.4421 41.0501V41.0438Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M143.502 32.5443C143.32 23.017 136.756 16.358 127.531 16.358C118.166 16.358 111.102 23.3137 111.102 32.5379C111.047 36.7596 112.651 40.8388 115.58 43.9222C118.574 47.014 122.868 48.7082 127.537 48.7082C132.206 48.7082 136.5 47.0076 139.494 43.9222C141.103 42.2462 142.319 40.2434 143.058 38.0546H135.492C133.943 40.7698 131.024 42.4162 127.537 42.4162C123.522 42.4162 120.282 39.6052 119.391 35.2564L119.174 34.2035H143.502V32.5443ZM119.618 28.6549C120.1 26.9573 121.136 25.4631 122.566 24.4027C123.996 23.3423 125.74 22.7746 127.531 22.7872C131.305 22.7872 134.128 24.9824 135.113 28.6549H119.618Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M218.429 32.5443C218.253 23.017 211.894 16.358 202.959 16.358C193.884 16.358 187.042 23.3137 187.042 32.5379C186.99 36.7593 188.544 40.838 191.38 43.9222C194.28 47.014 198.439 48.7082 202.965 48.7082C207.491 48.7082 211.646 47.0076 214.547 43.9222C216.105 42.2462 217.284 40.2434 217.999 38.0546H210.661C209.161 40.7698 206.33 42.4162 202.955 42.4162C199.066 42.4162 195.928 39.6052 195.065 35.2564L194.854 34.2035H218.42L218.429 32.5443ZM195.291 28.6549C195.758 26.9571 196.762 25.4627 198.148 24.4024C199.534 23.342 201.224 22.7745 202.959 22.7872C206.615 22.7872 209.349 24.9824 210.303 28.6549H195.291Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M328.795 32.5443C328.619 23.017 322.26 16.358 313.323 16.358C304.248 16.358 297.408 23.3137 297.408 32.5379C297.355 36.7589 298.908 40.8376 301.743 43.9222C304.647 47.014 308.806 48.7082 313.329 48.7082C317.853 48.7082 322.012 47.0076 324.912 43.9222C326.471 42.2462 327.65 40.2434 328.365 38.0546H321.026C319.526 40.7698 316.697 42.4162 313.32 42.4162C309.431 42.4162 306.292 39.6052 305.428 35.2564L305.218 34.2035H328.795V32.5443ZM305.657 28.6549C306.124 26.957 307.128 25.4625 308.513 24.402C309.898 23.3415 311.589 22.7741 313.323 22.7872C316.98 22.7872 319.714 24.9824 320.668 28.6549H305.657Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M240.705 16.388C235.555 16.0701 231.175 18.2953 228.959 22.5106V17.2749H220.454V47.6973H228.959V34.4888C228.959 26.4207 234.767 22.304 240.705 24.6151V16.388Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M186.078 41.0816C184.88 41.6058 183.587 41.878 182.279 41.8812C178.667 41.8812 176.675 39.6926 176.675 35.7169V23.5317H186.436V17.3165H176.669V4.22975L168.522 7.18284V17.3165H154.686V4.22656L146.539 7.17969V36.8064C146.539 44.5922 150.59 48.7081 158.25 48.7081C161.24 48.7081 163.804 48.2271 166.064 47.2363L164.088 41.0879C162.891 41.6122 161.598 41.8844 160.29 41.8876C156.677 41.8876 154.686 39.699 154.686 35.7233V23.5413H168.529V36.8064C168.529 44.5922 172.58 48.7081 180.243 48.7081C183.229 48.7081 185.793 48.2271 188.053 47.2363L186.078 41.0816Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M383.55 41.0784C382.372 41.6025 381.099 41.8748 379.811 41.878C376.248 41.878 374.289 39.6894 374.289 35.7137V23.5285H383.903V17.3133H374.286V4.22656L366.259 7.17965V36.8064C366.259 44.5922 370.25 48.7081 377.801 48.7081C380.747 48.7081 383.273 48.2271 385.497 47.2363L383.55 41.0784Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React213.createElement(
      "path",
      {
        d: "M32.7287 42.5531L58.1382 51.741C62.2995 46.3856 64.7225 39.5667 64.7225 31.9613C64.7225 13.8456 50.9703 0.182861 32.7287 0.182861C14.4871 0.182861 0.734863 13.8456 0.734863 31.9613C0.734863 39.5667 3.16098 46.3762 7.32229 51.741L32.7287 42.5531Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/b4b-signature.tsx
import React214 from "react";
var B4BSignature = (props) => {
  return /* @__PURE__ */ React214.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 457 40",
      "aria-label": "Betterment B4B logo",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M271.19 12.5498C269.648 12.5296 268.126 12.9014 266.756 13.6325C265.387 14.3636 264.213 15.4315 263.337 16.7421V13.2625H257.255V36.8628H263.337V25.3117C263.337 20.8728 265.378 18.2242 268.796 18.2242C271.808 18.2242 273.963 20.2859 273.963 23.731V36.8628H280V22.4116C280.002 16.2465 276.4 12.5498 271.19 12.5498Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M211.077 36.8455H204.662V23.7151C204.662 20.4725 202.633 18.2089 199.721 18.2089C196.086 18.2089 193.917 20.8572 193.917 25.2956V36.8455H187.451V13.2551H193.917V16.7417C194.847 15.4311 196.094 14.3632 197.549 13.6321C199.004 12.901 200.622 12.5294 202.26 12.5498C205.969 12.5498 208.766 14.4041 210.139 17.5308C211.112 15.9928 212.478 14.7258 214.104 13.8529C215.73 12.9801 217.56 12.5312 219.418 12.5498C224.775 12.5498 228.235 16.4187 228.235 22.4131V36.8628H221.823V23.7323C221.823 20.4898 219.793 18.2262 216.879 18.2262C213.246 18.2262 211.075 20.8744 211.075 25.3129L211.077 36.8455Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M79.3214 20.9562L77.9403 20.4026L79.2605 19.7285C79.4153 19.6498 82.9492 17.7602 82.9492 13.2134C82.9492 9.37515 79.5372 5.49017 73.0152 5.49017H57.2549V36.8627H73.0457C83.3986 36.8627 83.9215 29.7546 83.9215 28.33C83.9241 22.868 79.3671 20.9784 79.3214 20.9562ZM63.7743 10.6521H71.5656C73.7032 10.6521 76.0058 11.8995 76.0058 14.6428C76.0058 17.3198 73.7718 18.7222 71.5656 18.7222H63.7743V10.6521ZM72.5862 31.7008H63.7743V23.6307H72.5862C75.4727 23.6307 76.9807 25.6827 76.9807 27.7125C76.9807 30.0277 75.1325 31.7057 72.5862 31.7057V31.7008Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M110.588 25.1067C110.448 17.7152 105.362 12.549 98.2166 12.549C90.9629 12.549 85.4912 17.9454 85.4912 25.1018C85.4482 28.377 86.6911 31.5418 88.9599 33.934C91.2791 36.3326 94.6048 37.6471 98.2217 37.6471C101.838 37.6471 105.164 36.3277 107.483 33.934C108.73 32.6337 109.672 31.0798 110.244 29.3817H104.384C103.184 31.4883 100.922 32.7656 98.2217 32.7656C95.1118 32.7656 92.6019 30.5848 91.9116 27.2108L91.7435 26.3939H110.588V25.1067ZM92.0873 22.0892C92.4608 20.7722 93.2633 19.6129 94.371 18.7903C95.4787 17.9676 96.83 17.5272 98.2166 17.537C101.141 17.537 103.327 19.24 104.09 22.0892H92.0873Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M168.628 25.1067C168.491 17.7152 163.566 12.549 156.644 12.549C149.615 12.549 144.315 17.9454 144.315 25.1018C144.274 28.3768 145.478 31.5411 147.675 33.934C149.921 36.3326 153.143 37.6471 156.649 37.6471C160.155 37.6471 163.374 36.3277 165.62 33.934C166.827 32.6337 167.74 31.0798 168.294 29.3817H162.61C161.448 31.4883 159.255 32.7656 156.641 32.7656C153.629 32.7656 151.198 30.5848 150.529 27.2108L150.366 26.3939H168.62L168.628 25.1067ZM150.704 22.0892C151.066 20.772 151.844 19.6127 152.918 18.79C153.991 17.9674 155.3 17.5271 156.644 17.537C159.476 17.537 161.594 19.24 162.333 22.0892H150.704Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M254.118 25.1067C253.982 17.7152 249.055 12.549 242.133 12.549C235.103 12.549 229.805 17.9454 229.805 25.1018C229.764 28.3765 230.967 31.5409 233.163 33.934C235.412 36.3326 238.634 37.6471 242.138 37.6471C245.641 37.6471 248.863 36.3277 251.11 33.934C252.317 32.6337 253.23 31.0798 253.785 29.3817H248.1C246.937 31.4883 244.747 32.7656 242.13 32.7656C239.118 32.7656 236.686 30.5848 236.018 27.2108L235.855 26.3939H254.118V25.1067ZM236.195 22.0892C236.556 20.772 237.334 19.6125 238.407 18.7897C239.48 17.967 240.789 17.5268 242.133 17.537C244.965 17.537 247.083 19.24 247.822 22.0892H236.195Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M185.882 12.5723C181.893 12.3256 178.501 14.052 176.784 17.3223V13.2604H170.196V36.8628H176.784V26.6153C176.784 20.3559 181.283 17.162 185.882 18.955V12.5723Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M143.568 31.7302C142.64 32.137 141.639 32.3482 140.626 32.3506C137.827 32.3506 136.284 30.6527 136.284 27.5682V18.1147H143.845V13.2927H136.279V3.13974L129.969 5.43081V13.2927H119.251V3.13727L112.941 5.42837V28.4135C112.941 34.4539 116.079 37.6471 122.012 37.6471C124.328 37.6471 126.314 37.2739 128.065 36.5052L126.534 31.7352C125.607 32.1419 124.605 32.3531 123.592 32.3555C120.794 32.3555 119.251 30.6576 119.251 27.5732V18.1221H129.974V28.4135C129.974 34.4539 133.112 37.6471 139.048 37.6471C141.361 37.6471 143.347 37.2739 145.098 36.5052L143.568 31.7302Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M296.531 31.7278C295.618 32.1344 294.632 32.3456 293.635 32.3481C290.875 32.3481 289.357 30.6502 289.357 27.5657V18.1122H296.804V13.2903H289.355V3.13727L283.137 5.42834V28.4135C283.137 34.4538 286.229 37.6471 292.078 37.6471C294.359 37.6471 296.316 37.2739 298.039 36.5052L296.531 31.7278Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M24.7826 32.8718L44.465 40C47.6884 35.8451 49.5652 30.5549 49.5652 24.6545C49.5652 10.5999 38.9127 0 24.7826 0C10.6525 0 0 10.5999 0 24.6545C0 30.5549 1.87929 35.8378 5.10266 40L24.7826 32.8718Z",
        fill: "#FFC729"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M316.358 37.2835C313.991 37.2835 312.1 36.6686 310.686 35.4389C309.272 34.2091 308.565 32.5644 308.565 30.5045C308.565 29.3363 308.841 28.291 309.395 27.3687C309.948 26.4157 310.747 25.6471 311.793 25.0629C312.684 24.6325 313.729 24.2636 314.928 23.9562C316.127 23.6487 317.665 23.3874 319.54 23.1722L323.829 22.6649V22.296C323.829 20.1747 323.429 18.6529 322.63 17.7306C321.83 16.8083 320.539 16.3471 318.756 16.3471C317.188 16.3471 315.943 16.7468 315.021 17.5461C314.098 18.3455 313.591 19.4676 313.499 20.9126H309.302C309.456 18.5453 310.378 16.6546 312.069 15.2404C313.791 13.8262 316.005 13.1191 318.71 13.1191C321.877 13.1191 324.182 13.8877 325.627 15.4248C327.072 16.9313 327.795 19.36 327.795 22.7111V28.9366C327.795 32.4414 328.056 35.0392 328.579 36.7301H324.474C324.29 35.4389 324.167 34.0401 324.105 32.5336C323.583 34.0093 322.63 35.1776 321.246 36.0384C319.863 36.8685 318.233 37.2835 316.358 37.2835ZM317.234 34.0554C319.233 34.0554 320.831 33.3944 322.03 32.0725C323.26 30.7198 323.875 28.9213 323.875 26.677V25.5241L317.603 26.4464C315.912 26.6924 314.667 27.1381 313.868 27.7837C313.099 28.3986 312.715 29.2748 312.715 30.4123C312.715 31.5498 313.115 32.4414 313.914 33.087C314.713 33.7326 315.82 34.0554 317.234 34.0554Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M330.217 13.6725H334.506V7.63135L338.426 5.9712V13.6725H344.19V16.9005H338.426V29.6745C338.426 30.9964 338.687 31.9649 339.21 32.5797C339.763 33.1639 340.624 33.4559 341.792 33.4559C342.468 33.4559 343.268 33.3483 344.19 33.1331V36.7301C343.176 37.0068 342.038 37.1451 340.778 37.1451C338.441 37.1451 336.812 36.5149 335.889 35.2544C334.967 33.9939 334.506 32.1801 334.506 29.8128V16.9005H330.217V13.6725Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M353.381 3.98824H357.854L363.526 30.3662C363.649 31.0118 363.742 31.6113 363.803 32.1647H363.942C363.972 31.7958 364.095 31.1963 364.31 30.3662L371.043 3.98824H375.47L382.203 30.3662C382.418 31.1963 382.541 31.7958 382.572 32.1647H382.71C382.772 31.6113 382.864 31.0118 382.987 30.3662L388.659 3.98824H393.132L385.339 36.7301H379.99L373.626 11.1822C373.472 10.5674 373.38 10.0601 373.349 9.66042H373.165C373.134 10.0601 373.042 10.5674 372.888 11.1822L366.524 36.7301H361.175L353.381 3.98824Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M404.792 37.2835C402.64 37.2835 400.749 36.807 399.12 35.8539C397.491 34.8701 396.23 33.4713 395.338 31.6574C394.478 29.8436 394.047 27.6915 394.047 25.2013C394.047 22.7111 394.478 20.559 395.338 18.7451C396.23 16.9313 397.491 15.5478 399.12 14.5948C400.749 13.611 402.64 13.1191 404.792 13.1191C406.944 13.1191 408.835 13.611 410.464 14.5948C412.094 15.5478 413.339 16.9313 414.2 18.7451C415.091 20.559 415.537 22.7111 415.537 25.2013C415.537 27.6915 415.091 29.8436 414.2 31.6574C413.339 33.4713 412.094 34.8701 410.464 35.8539C408.835 36.807 406.944 37.2835 404.792 37.2835ZM404.792 33.871C406.883 33.871 408.497 33.1331 409.634 31.6574C410.802 30.1817 411.387 28.0297 411.387 25.2013C411.387 22.3729 410.802 20.2208 409.634 18.7451C408.497 17.2694 406.883 16.5316 404.792 16.5316C402.702 16.5316 401.072 17.2694 399.904 18.7451C398.766 20.2208 398.198 22.3729 398.198 25.2013C398.198 28.0297 398.766 30.1817 399.904 31.6574C401.072 33.1331 402.702 33.871 404.792 33.871Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M424.468 18.9296C425.052 17.208 425.944 15.8091 427.143 14.7331C428.372 13.6571 429.817 13.1191 431.477 13.1191C431.846 13.1191 432.123 13.1344 432.307 13.1652V16.9928H432.123C429.94 16.9928 428.249 17.5923 427.05 18.7913C426.067 19.775 425.436 20.9126 425.16 22.2038C424.883 23.495 424.745 25.0476 424.745 26.8614V36.7301H420.825V13.6725H424.468V18.9296Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React214.createElement(
      "path",
      {
        d: "M451.431 36.7301L444.467 25.4319L440.271 29.6745V36.7301H436.351V3.29651H440.271V25.0168L450.601 13.6725H455.719L447.28 22.5727L456.273 36.7301H451.431Z",
        fill: "#000B50"
      }
    )
  );
};

// src/components/logo/b4b-signature-stacked.tsx
import React215 from "react";
var B4BSignatureStacked = (props) => {
  return /* @__PURE__ */ React215.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 380 96",
      "aria-label": "Betterment B4B logo with stacked text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M345.763 16.0013C343.8 15.9724 341.861 16.4429 340.115 17.3712C338.37 18.2996 336.872 19.6574 335.753 21.3252V16.8886H328V47H335.753V32.2659C335.753 26.6003 338.357 23.2196 342.717 23.2196C346.557 23.2196 349.307 25.8506 349.307 30.2473V47H357V28.5613C357 20.7129 352.418 16.0013 345.763 16.0013Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M269.112 46.9911H260.951V30.2433C260.951 26.1095 258.36 23.2176 254.647 23.2176C250.012 23.2176 247.248 26.5974 247.248 32.2613V46.9911H239V16.8884H247.248V21.3237C248.436 19.6562 250.028 18.2986 251.883 17.3704C253.738 16.4422 255.8 15.972 257.886 16.0013C262.616 16.0013 266.188 18.3654 267.922 22.3527C269.162 20.3908 270.904 18.7746 272.978 17.6616C275.052 16.5485 277.387 15.9765 279.755 16.0013C286.598 16.0013 291 20.9334 291 28.5667V47H282.821V30.2521C282.821 26.1183 280.23 23.2265 276.516 23.2265C271.881 23.2265 269.112 26.6062 269.112 32.2702V46.9911Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M101.119 26.7191L99.3575 26.0158L101.041 25.1577C102.509 24.2939 103.716 23.0713 104.541 21.6124C105.367 20.1536 105.783 18.5099 105.746 16.8463C105.746 11.9541 101.393 7 93.0784 7H73V47H93.1332C106.33 47 106.996 37.9411 106.996 36.1231C107.049 34.1745 106.523 32.2523 105.481 30.5852C104.439 28.918 102.925 27.5761 101.119 26.7191ZM81.296 13.5819H91.2303C93.9683 13.5819 96.8933 15.1743 96.8933 18.6687C96.8933 22.0835 94.0458 23.8705 91.2303 23.8705H81.296V13.5819ZM92.5308 40.4225H81.296V30.1295H92.5308C96.2088 30.1295 98.1345 32.7481 98.1345 35.3357C98.1528 38.2817 95.7799 40.4225 92.5308 40.4225Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M141 32.0089C140.824 22.5859 134.343 16 125.226 16C115.987 16 109.001 22.8749 109.001 32.0089C108.947 36.181 110.529 40.2123 113.418 43.2596C116.37 46.319 120.607 48 125.213 48C129.819 48 134.055 46.319 137.011 43.2596C138.601 41.6106 139.804 39.6371 140.536 37.4786H133.1C131.572 40.1467 128.687 41.7921 125.249 41.7921C121.292 41.7921 118.096 39.0128 117.213 34.7126L117.001 33.672H141V32.0089ZM117.438 28.1623C117.917 26.4874 118.94 25.0141 120.35 23.9694C121.761 22.9248 123.48 22.3668 125.244 22.3813C128.967 22.3813 131.752 24.547 132.725 28.1623H117.438Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M215 32.0089C214.825 22.5859 208.551 16 199.719 16C190.769 16 184.001 22.8749 184.001 32.0089C183.948 36.181 185.482 40.2123 188.28 43.2596C191.14 46.3191 195.244 48 199.706 48C204.168 48 208.272 46.3191 211.132 43.2596C212.673 41.6104 213.84 39.637 214.55 37.4786H207.346C205.862 40.1467 203.072 41.7921 199.741 41.7921C195.907 41.7921 192.808 39.0128 191.956 34.7126L191.751 33.672H215V32.0089ZM192.17 28.1623C192.634 26.487 193.627 25.0136 194.994 23.969C196.361 22.9244 198.027 22.3666 199.736 22.3813C203.343 22.3813 206.041 24.547 206.98 28.1623H192.17Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M324 32.0089C323.83 22.5859 317.551 16 308.719 16C299.769 16 293.001 22.8749 293.001 32.0089C292.948 36.181 294.482 40.2123 297.28 43.2596C300.144 46.3191 304.266 48 308.71 48C313.155 48 317.272 46.3191 320.136 43.2596C321.676 41.6096 322.843 39.6365 323.555 37.4786H316.346C314.866 40.1467 312.076 41.7921 308.745 41.7921C304.907 41.7921 301.812 39.0128 300.961 34.7126L300.751 33.672H324V32.0089ZM301.175 28.1623C301.638 26.4874 302.629 25.0141 303.996 23.9694C305.362 22.9248 307.028 22.3668 308.736 22.3813C312.343 22.3813 315.045 24.547 315.984 28.1623H301.175Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M237 16.0298C231.916 15.7149 227.594 17.9103 225.394 22.0881V16.899H217V47H225.394V33.9342C225.394 25.9511 231.123 21.8752 237 24.177V16.0298Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M183.037 40.4464C181.855 40.9648 180.578 41.2339 179.286 41.2368C175.726 41.2368 173.754 39.0743 173.754 35.1446V23.098H183.389V16.9436H173.75V4.00444L165.704 6.92618V16.9436H152.046V4L144 6.92174V36.2281C144 43.9277 148.005 47.995 155.571 47.995C158.215 48.0557 160.843 47.5594 163.283 46.5386L161.329 40.4464C160.148 40.9652 158.872 41.2343 157.582 41.2368C154.022 41.2368 152.05 39.0743 152.05 35.1446V23.1024H165.717V36.2148C165.717 43.9143 169.722 47.9817 177.288 47.9817C179.932 48.0423 182.56 47.5461 185 46.5253L183.037 40.4464Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M378.075 40.442C376.91 40.9604 375.651 41.2294 374.378 41.2324C370.871 41.2324 368.928 39.0699 368.928 35.1402V23.0935H378.421V16.9392H368.924V4L361 6.92174V36.2281C361 43.9277 364.946 47.995 372.401 47.995C375.007 48.0557 377.596 47.5594 380 46.5386L378.075 40.442Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M81.1666 95.8134C78.6653 95.8134 76.6674 95.1637 75.1731 93.8642C73.6788 92.5648 72.9316 90.8269 72.9316 88.6504C72.9316 87.4159 73.224 86.3114 73.8087 85.3369C74.3935 84.3298 75.2381 83.5177 76.3426 82.9005C77.2847 82.4457 78.3891 82.0559 79.6561 81.731C80.923 81.4062 82.5473 81.1301 84.5288 80.9027L89.0605 80.3667V79.9768C89.0605 77.7354 88.6382 76.1273 87.7936 75.1528C86.949 74.1782 85.5846 73.691 83.7005 73.691C82.0437 73.691 80.7281 74.1133 79.7535 74.9579C78.779 75.8025 78.243 76.9882 78.1455 78.515H73.7113C73.8737 76.0136 74.8483 74.0158 76.6349 72.5215C78.4541 71.0272 80.7931 70.28 83.6517 70.28C86.9977 70.28 89.4341 71.0921 90.9609 72.7164C92.4877 74.3082 93.2511 76.8745 93.2511 80.4154V86.9936C93.2511 90.6969 93.5272 93.4419 94.0795 95.2286H89.7427C89.5478 93.8642 89.4179 92.3862 89.3529 90.7944C88.8006 92.3537 87.7936 93.5881 86.3318 94.4977C84.8699 95.3748 83.1482 95.8134 81.1666 95.8134ZM82.0925 92.4024C84.204 92.4024 85.8932 91.704 87.1601 90.3071C88.4595 88.8778 89.1093 86.9774 89.1093 84.606V83.3878L82.4823 84.3623C80.6956 84.6222 79.3799 85.0932 78.5353 85.7754C77.7232 86.4251 77.3171 87.351 77.3171 88.5529C77.3171 89.7549 77.7394 90.6969 78.5841 91.3791C79.4287 92.0613 80.5981 92.4024 82.0925 92.4024Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M96.7854 70.8647H101.317V64.4814L105.459 62.7272V70.8647H111.55V74.2757H105.459V87.7733C105.459 89.1701 105.735 90.1934 106.287 90.8431C106.872 91.4603 107.782 91.7689 109.016 91.7689C109.731 91.7689 110.575 91.6553 111.55 91.4279V95.2286C110.478 95.521 109.276 95.6672 107.944 95.6672C105.475 95.6672 103.753 95.0012 102.779 93.6693C101.804 92.3374 101.317 90.4208 101.317 87.9195V74.2757H96.7854V70.8647Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M127.109 60.6319H131.835L137.829 88.5042C137.959 89.1864 138.056 89.8198 138.121 90.4046H138.268C138.3 90.0147 138.43 89.3813 138.657 88.5042L145.772 60.6319H150.449L157.564 88.5042C157.791 89.3813 157.921 90.0147 157.954 90.4046H158.1C158.165 89.8198 158.262 89.1864 158.392 88.5042L164.386 60.6319H169.112L160.877 95.2286H155.225L148.5 68.2334C148.338 67.5837 148.241 67.0477 148.208 66.6254H148.013C147.981 67.0477 147.883 67.5837 147.721 68.2334L140.996 95.2286H135.344L127.109 60.6319Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M181.432 95.8134C179.158 95.8134 177.161 95.3098 175.439 94.3028C173.717 93.2633 172.385 91.7852 171.443 89.8686C170.534 87.9519 170.079 85.678 170.079 83.0467C170.079 80.4154 170.534 78.1414 171.443 76.2248C172.385 74.3082 173.717 72.8463 175.439 71.8393C177.161 70.7998 179.158 70.28 181.432 70.28C183.706 70.28 185.704 70.7998 187.426 71.8393C189.148 72.8463 190.463 74.3082 191.373 76.2248C192.315 78.1414 192.786 80.4154 192.786 83.0467C192.786 85.678 192.315 87.9519 191.373 89.8686C190.463 91.7852 189.148 93.2633 187.426 94.3028C185.704 95.3098 183.706 95.8134 181.432 95.8134ZM181.432 92.2075C183.641 92.2075 185.347 91.4279 186.549 89.8686C187.783 88.3093 188.4 86.0353 188.4 83.0467C188.4 80.058 187.783 77.7841 186.549 76.2248C185.347 74.6655 183.641 73.8859 181.432 73.8859C179.223 73.8859 177.502 74.6655 176.267 76.2248C175.065 77.7841 174.464 80.058 174.464 83.0467C174.464 86.0353 175.065 88.3093 176.267 89.8686C177.502 91.4279 179.223 92.2075 181.432 92.2075Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M202.223 76.4197C202.84 74.6005 203.782 73.1225 205.049 71.9855C206.348 70.8485 207.875 70.28 209.629 70.28C210.019 70.28 210.312 70.2963 210.506 70.3287V74.3731H210.312C208.005 74.3731 206.218 75.0066 204.951 76.2735C203.912 77.313 203.246 78.515 202.954 79.8794C202.661 81.2438 202.515 82.8843 202.515 84.8009V95.2286H198.373V70.8647H202.223V76.4197Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M230.32 95.2286L222.962 83.2903L218.528 87.7733V95.2286H214.386V59.901H218.528V82.8518L229.443 70.8647H234.852L225.935 80.2692L235.437 95.2286H230.32Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React215.createElement(
      "path",
      {
        d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/b4b-signature-white.tsx
import React216 from "react";
var B4BSignatureWhite = (props) => {
  return /* @__PURE__ */ React216.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 457 40",
      "aria-label": "Betterment B4B logo with white text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M271.19 12.5499C269.648 12.5296 268.126 12.9014 266.756 13.6325C265.387 14.3636 264.213 15.4315 263.337 16.7422V13.2626H257.255V36.8628H263.337V25.3118C263.337 20.8728 265.378 18.2243 268.796 18.2243C271.808 18.2243 273.963 20.2859 273.963 23.731V36.8628H280V22.4117C280.002 16.2465 276.4 12.5499 271.19 12.5499Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M211.077 36.8456H204.662V23.7151C204.662 20.4725 202.633 18.2089 199.721 18.2089C196.086 18.2089 193.917 20.8572 193.917 25.2957V36.8456H187.451V13.2551H193.917V16.7418C194.847 15.4311 196.094 14.3632 197.549 13.6321C199.004 12.9011 200.622 12.5294 202.26 12.5499C205.969 12.5499 208.766 14.4042 210.139 17.5308C211.112 15.9928 212.478 14.7258 214.104 13.853C215.73 12.9801 217.56 12.5312 219.418 12.5499C224.775 12.5499 228.235 16.4187 228.235 22.4131V36.8628H221.823V23.7323C221.823 20.4898 219.793 18.2262 216.879 18.2262C213.246 18.2262 211.075 20.8745 211.075 25.3129L211.077 36.8456Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M79.3214 20.9562L77.9403 20.4026L79.2605 19.7285C79.4153 19.6498 82.9492 17.7602 82.9492 13.2134C82.9492 9.37515 79.5372 5.49017 73.0152 5.49017H57.2549V36.8627H73.0457C83.3986 36.8627 83.9215 29.7546 83.9215 28.33C83.9241 22.868 79.3671 20.9784 79.3214 20.9562ZM63.7743 10.6521H71.5656C73.7032 10.6521 76.0058 11.8995 76.0058 14.6428C76.0058 17.3198 73.7718 18.7222 71.5656 18.7222H63.7743V10.6521ZM72.5862 31.7008H63.7743V23.6307H72.5862C75.4727 23.6307 76.9807 25.6827 76.9807 27.7125C76.9807 30.0277 75.1325 31.7057 72.5862 31.7057V31.7008Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M110.588 25.1068C110.448 17.7152 105.362 12.5491 98.2166 12.5491C90.9629 12.5491 85.4912 17.9454 85.4912 25.1018C85.4482 28.3771 86.6911 31.5419 88.9599 33.934C91.2791 36.3327 94.6048 37.6471 98.2217 37.6471C101.838 37.6471 105.164 36.3277 107.483 33.934C108.73 32.6337 109.672 31.0799 110.244 29.3818H104.384C103.184 31.4883 100.922 32.7656 98.2217 32.7656C95.1118 32.7656 92.6019 30.5848 91.9116 27.2108L91.7435 26.394H110.588V25.1068ZM92.0873 22.0893C92.4608 20.7722 93.2633 19.613 94.371 18.7903C95.4787 17.9676 96.83 17.5272 98.2166 17.537C101.141 17.537 103.327 19.2401 104.09 22.0893H92.0873Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M168.628 25.1068C168.491 17.7152 163.566 12.5491 156.644 12.5491C149.615 12.5491 144.315 17.9454 144.315 25.1018C144.274 28.3768 145.478 31.5412 147.675 33.934C149.921 36.3327 153.143 37.6471 156.649 37.6471C160.155 37.6471 163.374 36.3277 165.62 33.934C166.827 32.6337 167.74 31.0799 168.294 29.3818H162.61C161.448 31.4883 159.255 32.7656 156.641 32.7656C153.629 32.7656 151.198 30.5848 150.529 27.2108L150.366 26.394H168.62L168.628 25.1068ZM150.704 22.0893C151.066 20.772 151.844 19.6127 152.918 18.79C153.991 17.9674 155.3 17.5271 156.644 17.537C159.476 17.537 161.594 19.2401 162.333 22.0893H150.704Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M254.118 25.1068C253.982 17.7152 249.055 12.5491 242.133 12.5491C235.103 12.5491 229.805 17.9454 229.805 25.1018C229.764 28.3765 230.967 31.5409 233.163 33.934C235.412 36.3327 238.634 37.6471 242.138 37.6471C245.641 37.6471 248.863 36.3277 251.11 33.934C252.317 32.6337 253.23 31.0799 253.785 29.3818H248.1C246.937 31.4883 244.747 32.7656 242.13 32.7656C239.118 32.7656 236.686 30.5848 236.018 27.2108L235.855 26.394H254.118V25.1068ZM236.195 22.0893C236.556 20.772 237.334 19.6125 238.407 18.7898C239.48 17.967 240.789 17.5268 242.133 17.537C244.965 17.537 247.083 19.2401 247.822 22.0893H236.195Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M185.882 12.5723C181.893 12.3257 178.501 14.0521 176.784 17.3224V13.2604H170.196V36.8628H176.784V26.6154C176.784 20.3559 181.283 17.1621 185.882 18.9551V12.5723Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M143.568 31.7302C142.64 32.137 141.639 32.3482 140.626 32.3506C137.827 32.3506 136.284 30.6527 136.284 27.5682V18.1147H143.845V13.2927H136.279V3.13974L129.969 5.43081V13.2927H119.251V3.13727L112.941 5.42837V28.4135C112.941 34.4539 116.079 37.6471 122.012 37.6471C124.328 37.6471 126.314 37.2739 128.065 36.5052L126.534 31.7352C125.607 32.1419 124.605 32.3531 123.592 32.3555C120.794 32.3555 119.251 30.6576 119.251 27.5732V18.1221H129.974V28.4135C129.974 34.4539 133.112 37.6471 139.048 37.6471C141.361 37.6471 143.347 37.2739 145.098 36.5052L143.568 31.7302Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M296.531 31.7278C295.618 32.1344 294.632 32.3456 293.635 32.3481C290.875 32.3481 289.357 30.6502 289.357 27.5657V18.1122H296.804V13.2903H289.355V3.13727L283.137 5.42834V28.4135C283.137 34.4538 286.229 37.6471 292.078 37.6471C294.359 37.6471 296.316 37.2739 298.039 36.5052L296.531 31.7278Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M24.7826 32.8718L44.465 40C47.6884 35.8451 49.5652 30.5549 49.5652 24.6545C49.5652 10.5999 38.9127 0 24.7826 0C10.6525 0 0 10.5999 0 24.6545C0 30.5549 1.87929 35.8378 5.10266 40L24.7826 32.8718Z",
        fill: "#FFC729"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M316.358 37.2835C313.991 37.2835 312.1 36.6686 310.686 35.4389C309.272 34.2091 308.565 32.5644 308.565 30.5045C308.565 29.3363 308.841 28.291 309.395 27.3687C309.948 26.4157 310.747 25.6471 311.793 25.0629C312.684 24.6325 313.729 24.2636 314.928 23.9562C316.127 23.6487 317.665 23.3874 319.54 23.1722L323.829 22.6649V22.296C323.829 20.1747 323.429 18.6529 322.63 17.7306C321.83 16.8083 320.539 16.3471 318.756 16.3471C317.188 16.3471 315.943 16.7468 315.021 17.5461C314.098 18.3455 313.591 19.4676 313.499 20.9126H309.302C309.456 18.5453 310.378 16.6546 312.069 15.2404C313.791 13.8262 316.005 13.1191 318.71 13.1191C321.877 13.1191 324.182 13.8877 325.627 15.4248C327.072 16.9313 327.795 19.36 327.795 22.7111V28.9366C327.795 32.4414 328.056 35.0392 328.579 36.7301H324.474C324.29 35.4389 324.167 34.0401 324.105 32.5336C323.583 34.0093 322.63 35.1776 321.246 36.0384C319.863 36.8685 318.233 37.2835 316.358 37.2835ZM317.234 34.0554C319.233 34.0554 320.831 33.3944 322.03 32.0725C323.26 30.7198 323.875 28.9213 323.875 26.677V25.5241L317.603 26.4464C315.912 26.6923 314.667 27.1381 313.868 27.7837C313.099 28.3986 312.715 29.2748 312.715 30.4123C312.715 31.5498 313.115 32.4414 313.914 33.087C314.713 33.7326 315.82 34.0554 317.234 34.0554Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M330.217 13.6725H334.506V7.63135L338.426 5.9712V13.6725H344.19V16.9005H338.426V29.6745C338.426 30.9964 338.687 31.9649 339.21 32.5797C339.763 33.1639 340.624 33.4559 341.792 33.4559C342.468 33.4559 343.268 33.3483 344.19 33.1331V36.7301C343.176 37.0068 342.038 37.1451 340.778 37.1451C338.441 37.1451 336.812 36.5149 335.889 35.2544C334.967 33.9939 334.506 32.1801 334.506 29.8128V16.9005H330.217V13.6725Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M353.381 3.98824H357.854L363.526 30.3662C363.649 31.0118 363.742 31.6113 363.803 32.1647H363.942C363.972 31.7958 364.095 31.1963 364.31 30.3662L371.043 3.98824H375.47L382.203 30.3662C382.418 31.1963 382.541 31.7958 382.572 32.1647H382.71C382.772 31.6113 382.864 31.0118 382.987 30.3662L388.659 3.98824H393.132L385.339 36.7301H379.99L373.626 11.1822C373.472 10.5674 373.38 10.0601 373.349 9.66042H373.165C373.134 10.0601 373.042 10.5674 372.888 11.1822L366.524 36.7301H361.175L353.381 3.98824Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M404.792 37.2835C402.64 37.2835 400.749 36.807 399.12 35.8539C397.491 34.8701 396.23 33.4713 395.338 31.6574C394.478 29.8436 394.047 27.6915 394.047 25.2013C394.047 22.7111 394.478 20.559 395.338 18.7451C396.23 16.9313 397.491 15.5478 399.12 14.5948C400.749 13.611 402.64 13.1191 404.792 13.1191C406.944 13.1191 408.835 13.611 410.464 14.5948C412.094 15.5478 413.339 16.9313 414.2 18.7451C415.091 20.559 415.537 22.7111 415.537 25.2013C415.537 27.6915 415.091 29.8436 414.2 31.6574C413.339 33.4713 412.094 34.8701 410.464 35.8539C408.835 36.807 406.944 37.2835 404.792 37.2835ZM404.792 33.871C406.883 33.871 408.497 33.1331 409.634 31.6574C410.802 30.1817 411.387 28.0297 411.387 25.2013C411.387 22.3729 410.802 20.2208 409.634 18.7451C408.497 17.2694 406.883 16.5316 404.792 16.5316C402.702 16.5316 401.072 17.2694 399.904 18.7451C398.766 20.2208 398.198 22.3729 398.198 25.2013C398.198 28.0297 398.766 30.1817 399.904 31.6574C401.072 33.1331 402.702 33.871 404.792 33.871Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M424.468 18.9296C425.052 17.208 425.944 15.8091 427.143 14.7331C428.372 13.6571 429.817 13.1191 431.477 13.1191C431.846 13.1191 432.123 13.1344 432.307 13.1652V16.9928H432.123C429.94 16.9928 428.249 17.5923 427.05 18.7913C426.067 19.775 425.436 20.9126 425.16 22.2038C424.883 23.495 424.745 25.0476 424.745 26.8614V36.7301H420.825V13.6725H424.468V18.9296Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React216.createElement(
      "path",
      {
        d: "M451.431 36.7301L444.467 25.4319L440.271 29.6745V36.7301H436.351V3.29651H440.271V25.0168L450.601 13.6725H455.719L447.28 22.5727L456.273 36.7301H451.431Z",
        fill: "white"
      }
    )
  );
};

// src/components/logo/b4b-signature-white-stacked.tsx
import React217 from "react";
var B4BSignatureWhiteStacked = (props) => {
  return /* @__PURE__ */ React217.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 380 96",
      "aria-label": "Betterment B4B logo with white, stacked text",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M345.763 16.0013C343.8 15.9724 341.861 16.4429 340.115 17.3712C338.37 18.2996 336.872 19.6574 335.753 21.3252V16.8886H328V47H335.753V32.2659C335.753 26.6003 338.357 23.2196 342.717 23.2196C346.557 23.2196 349.307 25.8506 349.307 30.2473V47H357V28.5613C357 20.7129 352.418 16.0013 345.763 16.0013Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M269.112 46.9911H260.951V30.2433C260.951 26.1095 258.36 23.2176 254.647 23.2176C250.012 23.2176 247.248 26.5974 247.248 32.2613V46.9911H239V16.8884H247.248V21.3237C248.436 19.6562 250.028 18.2986 251.883 17.3704C253.738 16.4422 255.8 15.972 257.886 16.0013C262.616 16.0013 266.188 18.3654 267.922 22.3527C269.162 20.3908 270.904 18.7746 272.978 17.6616C275.052 16.5485 277.387 15.9765 279.755 16.0013C286.598 16.0013 291 20.9334 291 28.5667V47H282.821V30.2521C282.821 26.1183 280.23 23.2265 276.516 23.2265C271.881 23.2265 269.112 26.6062 269.112 32.2702V46.9911Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M101.119 26.7191L99.3575 26.0158L101.041 25.1577C102.509 24.2939 103.716 23.0713 104.541 21.6124C105.367 20.1536 105.783 18.5099 105.746 16.8463C105.746 11.9541 101.393 7 93.0784 7H73V47H93.1332C106.33 47 106.996 37.9411 106.996 36.1231C107.049 34.1745 106.523 32.2523 105.481 30.5852C104.439 28.918 102.925 27.5761 101.119 26.7191ZM81.296 13.5819H91.2303C93.9683 13.5819 96.8933 15.1743 96.8933 18.6687C96.8933 22.0835 94.0458 23.8705 91.2303 23.8705H81.296V13.5819ZM92.5308 40.4225H81.296V30.1295H92.5308C96.2088 30.1295 98.1345 32.7481 98.1345 35.3357C98.1528 38.2817 95.7799 40.4225 92.5308 40.4225Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M141 32.0089C140.824 22.5859 134.343 16 125.226 16C115.987 16 109.001 22.8749 109.001 32.0089C108.947 36.181 110.529 40.2123 113.418 43.2596C116.37 46.3191 120.607 48 125.213 48C129.819 48 134.055 46.3191 137.011 43.2596C138.601 41.6106 139.804 39.6371 140.536 37.4786H133.1C131.572 40.1467 128.687 41.7921 125.249 41.7921C121.292 41.7921 118.096 39.0128 117.213 34.7126L117.001 33.672H141V32.0089ZM117.438 28.1623C117.917 26.4874 118.94 25.0141 120.35 23.9694C121.761 22.9248 123.48 22.3668 125.244 22.3813C128.967 22.3813 131.752 24.547 132.725 28.1623H117.438Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M215 32.0089C214.825 22.5859 208.551 16 199.719 16C190.769 16 184.001 22.8749 184.001 32.0089C183.948 36.181 185.482 40.2123 188.28 43.2596C191.14 46.3191 195.244 48 199.706 48C204.168 48 208.272 46.3191 211.132 43.2596C212.673 41.6104 213.84 39.637 214.55 37.4786H207.346C205.862 40.1467 203.072 41.7921 199.741 41.7921C195.907 41.7921 192.808 39.0128 191.956 34.7126L191.751 33.672H215V32.0089ZM192.17 28.1623C192.634 26.487 193.627 25.0136 194.994 23.969C196.361 22.9244 198.027 22.3666 199.736 22.3813C203.343 22.3813 206.041 24.547 206.98 28.1623H192.17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M324 32.0089C323.83 22.5859 317.551 16 308.719 16C299.769 16 293.001 22.8749 293.001 32.0089C292.948 36.181 294.482 40.2123 297.28 43.2596C300.144 46.3191 304.266 48 308.71 48C313.155 48 317.272 46.3191 320.136 43.2596C321.676 41.6096 322.843 39.6365 323.555 37.4786H316.346C314.866 40.1467 312.076 41.7921 308.745 41.7921C304.907 41.7921 301.812 39.0128 300.961 34.7126L300.751 33.672H324V32.0089ZM301.175 28.1623C301.638 26.4874 302.629 25.0141 303.996 23.9694C305.362 22.9248 307.028 22.3668 308.736 22.3813C312.343 22.3813 315.045 24.547 315.984 28.1623H301.175Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M237 16.0298C231.916 15.7149 227.594 17.9103 225.394 22.0881V16.899H217V47H225.394V33.9342C225.394 25.9511 231.123 21.8752 237 24.177V16.0298Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M183.037 40.4464C181.855 40.9648 180.578 41.2339 179.286 41.2368C175.726 41.2368 173.754 39.0743 173.754 35.1446V23.098H183.389V16.9436H173.75V4.00444L165.704 6.92618V16.9436H152.046V4L144 6.92174V36.2281C144 43.9277 148.005 47.995 155.571 47.995C158.215 48.0557 160.843 47.5594 163.283 46.5386L161.329 40.4464C160.148 40.9652 158.872 41.2343 157.582 41.2368C154.022 41.2368 152.05 39.0743 152.05 35.1446V23.1024H165.717V36.2148C165.717 43.9143 169.722 47.9817 177.288 47.9817C179.932 48.0423 182.56 47.5461 185 46.5253L183.037 40.4464Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M378.075 40.442C376.91 40.9604 375.651 41.2294 374.378 41.2324C370.871 41.2324 368.928 39.0699 368.928 35.1402V23.0935H378.421V16.9392H368.924V4L361 6.92174V36.2281C361 43.9277 364.946 47.995 372.401 47.995C375.007 48.0557 377.596 47.5594 380 46.5386L378.075 40.442Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M81.1666 95.8134C78.6653 95.8134 76.6674 95.1637 75.1731 93.8642C73.6788 92.5648 72.9316 90.8269 72.9316 88.6504C72.9316 87.4159 73.224 86.3114 73.8087 85.3369C74.3935 84.3298 75.2381 83.5177 76.3426 82.9005C77.2847 82.4457 78.3891 82.0559 79.6561 81.731C80.923 81.4062 82.5473 81.1301 84.5288 80.9027L89.0605 80.3667V79.9768C89.0605 77.7354 88.6382 76.1273 87.7936 75.1528C86.949 74.1782 85.5846 73.691 83.7005 73.691C82.0437 73.691 80.7281 74.1133 79.7535 74.9579C78.779 75.8025 78.243 76.9882 78.1455 78.515H73.7113C73.8737 76.0136 74.8483 74.0158 76.6349 72.5215C78.4541 71.0272 80.7931 70.28 83.6517 70.28C86.9977 70.28 89.4341 71.0921 90.9609 72.7164C92.4877 74.3082 93.2511 76.8745 93.2511 80.4154V86.9936C93.2511 90.6969 93.5272 93.4419 94.0795 95.2286H89.7427C89.5478 93.8642 89.4179 92.3862 89.3529 90.7944C88.8006 92.3537 87.7936 93.5881 86.3318 94.4977C84.8699 95.3748 83.1482 95.8134 81.1666 95.8134ZM82.0925 92.4024C84.204 92.4024 85.8932 91.704 87.1601 90.3071C88.4595 88.8778 89.1093 86.9774 89.1093 84.606V83.3878L82.4823 84.3623C80.6956 84.6222 79.3799 85.0932 78.5353 85.7754C77.7232 86.4251 77.3171 87.351 77.3171 88.5529C77.3171 89.7549 77.7394 90.6969 78.5841 91.3791C79.4287 92.0613 80.5981 92.4024 82.0925 92.4024Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M96.7854 70.8647H101.317V64.4814L105.459 62.7272V70.8647H111.55V74.2757H105.459V87.7733C105.459 89.1701 105.735 90.1934 106.287 90.8431C106.872 91.4603 107.782 91.7689 109.016 91.7689C109.731 91.7689 110.575 91.6553 111.55 91.4279V95.2286C110.478 95.521 109.276 95.6672 107.944 95.6672C105.475 95.6672 103.753 95.0012 102.779 93.6693C101.804 92.3374 101.317 90.4208 101.317 87.9195V74.2757H96.7854V70.8647Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M127.109 60.6319H131.835L137.829 88.5042C137.959 89.1864 138.056 89.8198 138.121 90.4046H138.268C138.3 90.0147 138.43 89.3813 138.657 88.5042L145.772 60.6319H150.449L157.564 88.5042C157.791 89.3813 157.921 90.0147 157.954 90.4046H158.1C158.165 89.8198 158.262 89.1864 158.392 88.5042L164.386 60.6319H169.112L160.877 95.2286H155.225L148.5 68.2334C148.338 67.5837 148.241 67.0477 148.208 66.6254H148.013C147.981 67.0477 147.883 67.5837 147.721 68.2334L140.996 95.2286H135.344L127.109 60.6319Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M181.432 95.8134C179.158 95.8134 177.161 95.3098 175.439 94.3028C173.717 93.2633 172.385 91.7852 171.443 89.8686C170.534 87.9519 170.079 85.678 170.079 83.0467C170.079 80.4154 170.534 78.1414 171.443 76.2248C172.385 74.3082 173.717 72.8463 175.439 71.8393C177.161 70.7998 179.158 70.28 181.432 70.28C183.706 70.28 185.704 70.7998 187.426 71.8393C189.148 72.8463 190.463 74.3082 191.373 76.2248C192.315 78.1414 192.786 80.4154 192.786 83.0467C192.786 85.678 192.315 87.9519 191.373 89.8686C190.463 91.7852 189.148 93.2633 187.426 94.3028C185.704 95.3098 183.706 95.8134 181.432 95.8134ZM181.432 92.2075C183.641 92.2075 185.347 91.4279 186.549 89.8686C187.783 88.3093 188.4 86.0353 188.4 83.0467C188.4 80.058 187.783 77.7841 186.549 76.2248C185.347 74.6655 183.641 73.8859 181.432 73.8859C179.223 73.8859 177.502 74.6655 176.267 76.2248C175.065 77.7841 174.464 80.058 174.464 83.0467C174.464 86.0353 175.065 88.3093 176.267 89.8686C177.502 91.4279 179.223 92.2075 181.432 92.2075Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M202.223 76.4197C202.84 74.6005 203.782 73.1225 205.049 71.9855C206.348 70.8485 207.875 70.28 209.629 70.28C210.019 70.28 210.312 70.2963 210.506 70.3287V74.3731H210.312C208.005 74.3731 206.218 75.0066 204.951 76.2735C203.912 77.313 203.246 78.515 202.954 79.8794C202.661 81.2438 202.515 82.8843 202.515 84.8009V95.2286H198.373V70.8647H202.223V76.4197Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M230.32 95.2286L222.962 83.2903L218.528 87.7733V95.2286H214.386V59.901H218.528V82.8518L229.443 70.8647H234.852L225.935 80.2692L235.437 95.2286H230.32Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React217.createElement(
      "path",
      {
        d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/signature.tsx
import React218 from "react";
var Signature = (props) => {
  return /* @__PURE__ */ React218.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 380 51",
      "aria-label": "Betterment brand symbol with text",
      role: "img",
      ...props
    },
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M345.767 16.001C343.802 15.9752 341.861 16.4493 340.114 17.3814C338.368 18.3135 336.871 19.6751 335.754 21.3462V16.9097H328V47H335.754V32.2724C335.754 26.6128 338.356 23.2359 342.715 23.2359C346.555 23.2359 349.303 25.8645 349.303 30.2569V47H357V28.5748C357.003 20.7142 352.411 16.001 345.767 16.001Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M269.124 46.978H260.944V30.2367C260.944 26.1024 258.357 23.2163 254.644 23.2163C250.009 23.2163 247.244 26.5928 247.244 32.2519V46.978H239V16.9002H247.244V21.3457C248.43 19.6746 250.02 18.313 251.876 17.3809C253.731 16.4488 255.793 15.9749 257.881 16.001C262.61 16.001 266.177 18.3652 267.927 22.3517C269.168 20.3908 270.909 18.7753 272.982 17.6625C275.056 16.5496 277.39 15.9773 279.758 16.001C286.589 16.001 291 20.9338 291 28.5767V47H282.824V30.2587C282.824 26.1244 280.236 23.2383 276.52 23.2383C271.889 23.2383 269.12 26.6149 269.12 32.2739L269.124 46.978Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M101.135 26.7192L99.374 26.0134L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9533 101.41 7 93.0944 7H73V47H93.1333C106.333 47 107 37.9372 107 36.1208C107.003 29.1567 101.193 26.7475 101.135 26.7192ZM81.3123 13.5814H91.2462C93.9716 13.5814 96.9074 15.1719 96.9074 18.6697C96.9074 22.0827 94.059 23.8708 91.2462 23.8708H81.3123V13.5814ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7454 98.1504 35.3334C98.1504 38.2854 95.794 40.4248 92.5474 40.4248V40.4186Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M141 32.011C140.821 22.5868 134.337 16 125.226 16C115.978 16 109.001 22.8803 109.001 32.0047C108.947 36.1807 110.531 40.2158 113.424 43.2658C116.381 46.3241 120.621 48 125.233 48C129.844 48 134.084 46.3178 137.041 43.2658C138.631 41.6079 139.832 39.6268 140.562 37.4617H133.089C131.559 40.1475 128.676 41.7761 125.233 41.7761C121.268 41.7761 118.067 38.9956 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.888 26.4845 118.911 25.0065 120.323 23.9576C121.735 22.9086 123.458 22.3471 125.226 22.3596C128.955 22.3596 131.742 24.531 132.715 28.1637H117.411Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M215 32.011C214.826 22.5868 208.546 16 199.721 16C190.759 16 184.001 22.8803 184.001 32.0047C183.95 36.1804 185.485 40.2149 188.285 43.2658C191.15 46.3241 195.257 48 199.727 48C204.197 48 208.301 46.3178 211.165 43.2658C212.705 41.6079 213.869 39.6268 214.575 37.4617H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9956 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4843 193.601 25.0061 194.97 23.9572C196.338 22.9084 198.008 22.347 199.721 22.3596C203.332 22.3596 206.032 24.531 206.974 28.1637H192.148Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M324 32.011C323.826 22.5868 317.545 16 308.719 16C299.757 16 293.001 22.8803 293.001 32.0047C292.949 36.18 294.483 40.2146 297.283 43.2658C300.15 46.3241 304.258 48 308.725 48C313.193 48 317.301 46.3178 320.165 43.2658C321.705 41.6079 322.869 39.6268 323.575 37.4617H316.327C314.845 40.1475 312.052 41.7761 308.716 41.7761C304.875 41.7761 301.775 38.9956 300.922 34.6937L300.715 33.6522H324V32.011ZM301.149 28.1637C301.609 26.4843 302.6 25.0059 303.969 23.9569C305.337 22.9079 307.006 22.3466 308.719 22.3596C312.331 22.3596 315.031 24.531 315.974 28.1637H301.149Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M237 16.0296C231.913 15.7152 227.588 17.9163 225.4 22.086V16.9069H217V47H225.4V33.9345C225.4 25.9537 231.135 21.8816 237 24.1676V16.0296Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M183.049 40.456C181.866 40.9746 180.589 41.2439 179.298 41.247C175.73 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.711 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148.001 48 155.566 48C158.518 48 161.05 47.5242 163.283 46.5442L161.331 40.4624C160.149 40.9809 158.872 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.718 48 177.286 48C180.235 48 182.768 47.5242 185 46.5442L183.049 40.456Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M378.077 40.4529C376.913 40.9714 375.656 41.2406 374.384 41.2438C370.866 41.2438 368.93 39.079 368.93 35.1463V23.093H378.426V16.9451H368.927V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.399 48C375.308 48 377.804 47.5242 380 46.5442L378.077 40.4529Z",
        fill: "#000B50"
      }
    ),
    /* @__PURE__ */ React218.createElement(
      "path",
      {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/signature-white.tsx
import React219 from "react";
var SignatureWhite = (props) => {
  return /* @__PURE__ */ React219.createElement(
    "svg",
    {
      height: "100%",
      width: "100%",
      viewBox: "0 0 380 51",
      "aria-label": "Betterment brand symbol with white text",
      role: "img",
      ...props
    },
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M345.767 16.001C343.802 15.9752 341.861 16.4493 340.114 17.3814C338.368 18.3135 336.871 19.6751 335.754 21.3462V16.9097H328V47H335.754V32.2724C335.754 26.6128 338.356 23.2359 342.715 23.2359C346.555 23.2359 349.303 25.8645 349.303 30.2569V47H357V28.5748C357.003 20.7142 352.411 16.001 345.767 16.001Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M269.124 46.978H260.944V30.2367C260.944 26.1024 258.357 23.2163 254.644 23.2163C250.009 23.2163 247.244 26.5928 247.244 32.2519V46.978H239V16.9002H247.244V21.3457C248.43 19.6746 250.02 18.313 251.876 17.3809C253.731 16.4488 255.793 15.9749 257.881 16.001C262.61 16.001 266.177 18.3652 267.927 22.3517C269.168 20.3908 270.909 18.7753 272.982 17.6625C275.056 16.5496 277.39 15.9773 279.758 16.001C286.589 16.001 291 20.9338 291 28.5767V47H282.824V30.2587C282.824 26.1244 280.236 23.2383 276.52 23.2383C271.889 23.2383 269.12 26.6149 269.12 32.2739L269.124 46.978Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M101.135 26.7192L99.374 26.0134L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9533 101.41 7 93.0944 7H73V47H93.1333C106.333 47 107 37.9372 107 36.1208C107.003 29.1567 101.193 26.7475 101.135 26.7192ZM81.3123 13.5814H91.2462C93.9716 13.5814 96.9074 15.1719 96.9074 18.6697C96.9074 22.0827 94.059 23.8708 91.2462 23.8708H81.3123V13.5814ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7454 98.1504 35.3334C98.1504 38.2854 95.794 40.4248 92.5474 40.4248V40.4186Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M141 32.011C140.821 22.5868 134.337 16 125.226 16C115.978 16 109.001 22.8803 109.001 32.0047C108.947 36.1807 110.531 40.2158 113.424 43.2658C116.381 46.3241 120.621 48 125.233 48C129.844 48 134.084 46.3178 137.041 43.2658C138.631 41.6079 139.832 39.6268 140.562 37.4617H133.089C131.559 40.1475 128.676 41.7761 125.233 41.7761C121.268 41.7761 118.067 38.9956 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.888 26.4845 118.911 25.0065 120.323 23.9576C121.735 22.9086 123.458 22.3471 125.226 22.3596C128.955 22.3596 131.742 24.531 132.715 28.1637H117.411Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M215 32.011C214.826 22.5868 208.546 16 199.721 16C190.759 16 184.001 22.8803 184.001 32.0047C183.95 36.1804 185.485 40.2149 188.285 43.2658C191.15 46.3241 195.257 48 199.727 48C204.197 48 208.301 46.3178 211.165 43.2658C212.705 41.6079 213.869 39.6268 214.575 37.4617H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9956 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4843 193.601 25.0061 194.97 23.9572C196.338 22.9084 198.008 22.347 199.721 22.3596C203.332 22.3596 206.032 24.531 206.974 28.1637H192.148Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M324 32.011C323.826 22.5868 317.545 16 308.719 16C299.757 16 293.001 22.8803 293.001 32.0047C292.949 36.18 294.483 40.2146 297.283 43.2658C300.15 46.3241 304.258 48 308.725 48C313.193 48 317.301 46.3178 320.165 43.2658C321.705 41.6079 322.869 39.6268 323.575 37.4617H316.327C314.845 40.1475 312.052 41.7761 308.716 41.7761C304.875 41.7761 301.775 38.9956 300.922 34.6937L300.715 33.6522H324V32.011ZM301.149 28.1637C301.609 26.4843 302.6 25.0059 303.969 23.9569C305.337 22.9079 307.006 22.3466 308.719 22.3596C312.331 22.3596 315.031 24.531 315.974 28.1637H301.149Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M237 16.0296C231.913 15.7152 227.588 17.9163 225.4 22.086V16.9069H217V47H225.4V33.9345C225.4 25.9537 231.135 21.8816 237 24.1676V16.0296Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M183.049 40.456C181.866 40.9746 180.589 41.2439 179.298 41.247C175.73 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.711 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148.001 48 155.566 48C158.518 48 161.05 47.5242 163.283 46.5442L161.331 40.4624C160.149 40.9809 158.872 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.718 48 177.286 48C180.235 48 182.768 47.5242 185 46.5442L183.049 40.456Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M378.077 40.4529C376.913 40.9714 375.656 41.2406 374.384 41.2438C370.866 41.2438 368.93 39.079 368.93 35.1463V23.093H378.426V16.9451H368.927V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.399 48C375.308 48 377.804 47.5242 380 46.5442L378.077 40.4529Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React219.createElement(
      "path",
      {
        d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
        fill: "#FFC729"
      }
    )
  );
};

// src/components/logo/symbol.tsx
import React220 from "react";
var Symbol2 = (props) => {
  return /* @__PURE__ */ React220.createElement("svg", { height: "100%", width: "100%", viewBox: "0 0 83 68", "aria-label": "Betterment brand symbol", role: "img", ...props }, /* @__PURE__ */ React220.createElement(
    "path",
    {
      d: "M41.5 55.8821L74.4594 68C79.8571 60.9367 83 51.9434 83 41.9126C83 18.0198 65.1617 0 41.5 0C17.8383 0 0 18.0198 0 41.9126C0 51.9434 3.14698 60.9243 8.54472 68L41.5 55.8821Z",
      fill: "#FFC729"
    }
  ));
};

// src/components/logo/logo.tsx
var logoRegistry = {
  symbol: Symbol2,
  signature: Signature,
  signatureWhite: SignatureWhite,
  b4aSignature: B4ASignature,
  b4aSignatureStacked: B4ASignatureStacked,
  b4aSignatureWhite: B4ASignatureWhite,
  b4aSignatureWhiteStacked: B4ASignatureWhiteStacked,
  b4bSignature: B4BSignature,
  b4bSignatureStacked: B4BSignatureStacked,
  b4bSignatureWhite: B4BSignatureWhite,
  b4bSignatureWhiteStacked: B4BSignatureWhiteStacked
};
var Logo = (props) => {
  const { type, css: cssProp, ...restProps } = props;
  const RawLogo = logoRegistry[type];
  return /* @__PURE__ */ React221.createElement(Box, { css: { display: "inline-block", ...cssProp } }, /* @__PURE__ */ React221.createElement(RawLogo, { ...restProps }));
};

// src/layouts/pancake-stack/pancake-stack.tsx
import { styled as styled7 } from "@betterment/samba-styled-system/jsx";
var maxWidth = "1200px";
var minWidth = "320px";
var minHeight = "100vh";
var Header6 = styled7("div", { base: { width: "100%", maxWidth } });
var Main = styled7("div");
var Footer2 = styled7("div");
var PancakeStackContainer = styled7("div", {
  base: {
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    mx: "auto",
    minHeight,
    minWidth,
    maxWidth
  }
});
var PancakeStack = PancakeStackContainer;
PancakeStack.Header = Header6;
PancakeStack.Main = Main;
PancakeStack.Footer = Footer2;
PancakeStack.displayName = "PancakeStack";
PancakeStack.Header.displayName = "PancakeStack.Header";
PancakeStack.Main.displayName = "PancakeStack.Main";
PancakeStack.Footer.displayName = "PancakeStack.Footer";

// src/components/progress/progress.tsx
import React222 from "react";
import { css as css27 } from "@betterment/samba-styled-system/css";
import { token as token5 } from "@betterment/samba-styled-system/tokens";
import { Indicator as Indicator2, Root as Root13 } from "@radix-ui/react-progress";
var rootStyles3 = css27({
  position: "relative",
  overflow: "hidden",
  bg: "background",
  borderRadius: "round",
  width: "100%",
  height: "6px"
});
var indicatorStyles2 = css27({
  height: "100%",
  borderRadius: "round",
  transition: "transform 660ms cubic-bezier(0.65, 0, 0.35, 1)"
});
var defaultIndicatorColor = "background.info.strong";
var Progress = React222.forwardRef(
  ({ value, indicatorColor = defaultIndicatorColor, ...rootProps }, forwardedRef) => {
    return /* @__PURE__ */ React222.createElement(Root13, { ref: forwardedRef, className: rootStyles3, value, ...rootProps }, /* @__PURE__ */ React222.createElement(
      Indicator2,
      {
        className: indicatorStyles2,
        style: {
          transform: `translateX(-${100 - (value ?? 0)}%)`,
          backgroundColor: token5.var(`colors.${indicatorColor}`)
        }
      }
    ));
  }
);
Progress.displayName = "Progress";

// src/components/radio-group/radio-group.tsx
import React223 from "react";
import { css as css28, cva as cva16 } from "@betterment/samba-styled-system/css";
import {
  Indicator as Indicator3,
  Item as Item6,
  Root as RadioGroupRootPrimitive
} from "@radix-ui/react-radio-group";
var RadioGroupContext = React223.createContext({
  appearance: "default"
});
var useRadioGroupContext = () => React223.useContext(RadioGroupContext);
var VanillaRoot2 = React223.forwardRef(
  ({ css: cssProp, children, appearance, ...rootProps }, forwardedRef) => {
    const contextValue = React223.useMemo(
      () => ({
        appearance
      }),
      [appearance]
    );
    const className = css28({ display: "flex", flexDirection: "column", gap: "space.150" }, cssProp);
    return /* @__PURE__ */ React223.createElement(RadioGroupContext.Provider, { value: contextValue }, /* @__PURE__ */ React223.createElement(RadioGroupRootPrimitive, { "data-samba-component": true, className, ref: forwardedRef, ...rootProps }, children));
  }
);
var FormikRoot2 = React223.forwardRef((props, forwardedRef) => {
  const { propsOrFieldName, fieldState } = useFormikField();
  const [{ value }, , { setValue }] = fieldState;
  return /* @__PURE__ */ React223.createElement(
    VanillaRoot2,
    {
      ref: forwardedRef,
      name: formikFieldName(propsOrFieldName),
      value,
      onValueChange: (newValue) => void setValue(newValue),
      ...props
    }
  );
});
var Root14 = React223.forwardRef(({ formStrategy = "vanilla", ...props }, forwardedRef) => {
  const Component = formStrategy === "formik" ? FormikRoot2 : VanillaRoot2;
  return /* @__PURE__ */ React223.createElement(FormStrategyProvider, { value: formStrategy }, /* @__PURE__ */ React223.createElement(Component, { ref: forwardedRef, ...props }));
});
var itemStyles3 = cva16({
  base: {
    backgroundColor: "background.input",
    display: "flex",
    borderRadius: "round",
    flexShrink: "0",
    p: "space.0",
    height: "20px",
    width: "20px",
    _hover: {
      backgroundColor: "background.surface.hover",
      cursor: "pointer",
      "& + label": {
        cursor: "pointer"
      }
    },
    _disabled: {
      backgroundColor: "background.input.disabled",
      "& + label": {
        color: "text.weak"
      },
      '& [data-state="checked"]': {
        // this is the indicator circle
        _after: {
          backgroundColor: "icon.disabled"
        }
      },
      _hover: {
        backgroundColor: "background.input.disabled",
        cursor: "default",
        "& + label": {
          cursor: "default"
        }
      }
    },
    _focusVisible: {
      border: "token(borderWidths.thin) solid token(colors.border.selected)",
      backgroundColor: "background.surface.hover",
      '&[data-state="checked"]': {
        backgroundColor: "background.primary"
      }
    },
    '&[data-state="checked"]': {
      border: "token(borderWidths.thin) solid token(colors.border.selected)",
      backgroundColor: "background.primary",
      _hover: {
        backgroundColor: "background.primary"
      },
      _disabled: {
        border: "token(borderWidths.thin) solid token(colors.border.strong)",
        backgroundColor: "background.input.disabled"
      }
    }
  },
  variants: {
    appearance: {
      default: {
        border: "token(borderWidths.thin) solid token(colors.border.strong)"
      },
      critical: {
        border: "token(borderWidths.thin) solid token(colors.border.critical)",
        _disabled: {
          border: "token(borderWidths.thin) solid token(colors.border.strong)"
        }
      }
    }
  },
  defaultVariants: {
    appearance: "default"
  }
});
var indicatorCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  position: "relative",
  borderRadius: "round",
  border: "none",
  _after: {
    content: '""',
    display: "block",
    width: "8px",
    height: "8px",
    borderRadius: "round",
    backgroundColor: "background.input"
  }
};
var VanillaRadioGroupItem = React223.forwardRef(
  ({ css: cssProp, id: idProp, ...props }, forwardedRef) => {
    const { appearance } = useRadioGroupContext();
    const id = idProp || useFieldId();
    const className = css28(itemStyles3.raw({ appearance }), cssProp);
    return /* @__PURE__ */ React223.createElement(Item6, { "data-samba-component": true, className, ref: forwardedRef, id, ...props }, /* @__PURE__ */ React223.createElement(Indicator3, { className: css28(indicatorCss) }));
  }
);
var FormikRadioGroupItem = React223.forwardRef((props, forwardedRef) => {
  const { fieldState } = useFormikField();
  const [field] = fieldState;
  const { value: _omitValue, ...rest } = field;
  return React223.cloneElement(/* @__PURE__ */ React223.createElement(VanillaRadioGroupItem, { ...props }), { ref: forwardedRef, ...rest });
});
var RadioGroupItem = React223.forwardRef((props, forwardedRef) => {
  const formStrategy = useFormStrategy();
  const Component = formStrategy === "formik" ? FormikRadioGroupItem : VanillaRadioGroupItem;
  return React223.cloneElement(/* @__PURE__ */ React223.createElement(Component, { ...props }), { ref: forwardedRef });
});
var ItemLabel = ({ children, ...props }) => {
  const id = useFieldId();
  return /* @__PURE__ */ React223.createElement(Label, { htmlFor: id, ...props }, children);
};
var ItemContainer = ({
  id: idProp,
  css: cssProp,
  children
}) => {
  const id = idProp || React223.useId();
  const itemContainerCss = css28.raw(
    {
      display: "flex",
      gap: "space.100",
      alignItems: "center"
    },
    cssProp
  );
  return /* @__PURE__ */ React223.createElement(FieldIdProvider, { id }, /* @__PURE__ */ React223.createElement(Box, { css: itemContainerCss }, children));
};
var RadioGroup = Object.assign(Root14, {
  Item: RadioGroupItem,
  ItemLabel,
  ItemContainer
});
RadioGroup.displayName = "RadioGroup";
RadioGroup.Item.displayName = "RadioGroup.Item";
RadioGroup.ItemLabel.displayName = "RadioGroup.ItemLabel";
RadioGroup.ItemContainer.displayName = "RadioGroup.ItemContainer";

// src/components/scroll-area/scroll-area.tsx
import React224, { forwardRef as forwardRef17 } from "react";
import { css as css29 } from "@betterment/samba-styled-system/css";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
var rootStyles4 = css29.raw({
  width: "100%",
  height: "100%",
  borderRadius: "medium",
  overflow: "hidden"
});
var viewportStyles = css29({
  width: "100%",
  height: "100%",
  borderRadius: "inherit"
});
var scrollBarStyles = css29.raw({
  display: "flex",
  /* ensures no selection */
  userSelect: "none",
  /* disable browser handling of all panning and zooming gestures on touch devices */
  touchAction: "none",
  p: "space.25",
  transition: "background 160ms ease-out"
});
var thumbStyles = css29({
  flex: 1,
  borderRadius: "round",
  position: "relative",
  _before: {
    content: "",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%"
  }
});
var verticalScrollBarCss = css29.raw({
  width: "10px"
});
var horizontalScrollBarCss = css29.raw({
  height: "10px",
  flexDirection: "column"
});
var ScrollArea = forwardRef17((props, forwardedRef) => {
  const { css: cssProp = {}, children, scrollbars = "vertical", ...componentProps } = props;
  const className = css29(rootStyles4, cssProp);
  const horizontalScrollBarStyles = css29(scrollBarStyles, horizontalScrollBarCss);
  const verticalScrollBarStyles = css29(scrollBarStyles, verticalScrollBarCss);
  const shouldShowHorizontalBar = scrollbars === "horizontal" || scrollbars === "both";
  const shouldShowVerticalBar = scrollbars === "vertical" || scrollbars === "both";
  const shouldShowCorner = scrollbars === "both";
  return /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Root, { "data-samba-component": true, ref: forwardedRef, className, ...componentProps }, /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Viewport, { className: viewportStyles }, children), shouldShowHorizontalBar && /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Scrollbar, { orientation: "horizontal", className: horizontalScrollBarStyles }, /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Thumb, { className: thumbStyles })), shouldShowVerticalBar && /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Scrollbar, { orientation: "vertical", className: verticalScrollBarStyles }, /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Thumb, { className: thumbStyles })), shouldShowCorner && /* @__PURE__ */ React224.createElement(ScrollAreaPrimitive.Corner, null));
});
ScrollArea.displayName = "ScrollArea";

// src/components/select/select.tsx
import React225 from "react";
import { css as css30, cva as cva17 } from "@betterment/samba-styled-system/css";
import * as SelectPrimitive from "@radix-ui/react-select";
var { Root: VanillaRoot3, Value: VanillaValue, Group } = SelectPrimitive;
var FormikRoot3 = (props) => {
  const { propsOrFieldName, fieldState } = useFormikField();
  const [, , { setValue }] = fieldState;
  return /* @__PURE__ */ React225.createElement(VanillaRoot3, { name: formikFieldName(propsOrFieldName), onValueChange: (value) => void setValue(value), ...props });
};
var Root16 = ({ formStrategy = "vanilla", ...props }) => {
  const Component = formStrategy === "formik" ? FormikRoot3 : VanillaRoot3;
  return /* @__PURE__ */ React225.createElement(FormStrategyProvider, { value: formStrategy }, /* @__PURE__ */ React225.createElement(Component, { ...props }));
};
var buttonColorReset2 = css30.raw({
  color: "text"
});
var triggerStyles2 = cva17({
  base: {
    ...buttonColorReset2,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "medium",
    border: "token(borderWidths.thin) solid token(colors.border.input)",
    paddingY: "space.150",
    paddingX: "space.200",
    height: "48px",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "background.surface",
    textStyle: "text100",
    _placeholder: { color: "text.placeholder" },
    _focus: {
      outline: "2px solid token(colors.border.focused)"
    }
  },
  variants: {
    appearance: {
      default: {
        borderColor: "border.input",
        _focus: {
          outlineColor: "border.focused"
        }
      },
      critical: {
        borderColor: "border.critical",
        _focus: {
          outlineColor: "border.critical"
        }
      }
    }
  },
  defaultVariants: {
    appearance: "default"
  }
});
var VanillaTrigger = React225.forwardRef(
  ({ css: cssProp, appearance, children, ...props }, forwardedRef) => {
    const className = css30(triggerStyles2.raw({ appearance }), cssProp);
    return /* @__PURE__ */ React225.createElement(SelectPrimitive.Trigger, { "data-samba-component": true, className, ref: forwardedRef, ...props }, children, /* @__PURE__ */ React225.createElement(SelectPrimitive.Icon, { "data-samba-component": true, asChild: true }, /* @__PURE__ */ React225.createElement(Icon, { name: "CaretDown", size: "small", color: "icon" })));
  }
);
var FormikTrigger = (props) => {
  const { fieldState } = useFormikField();
  const [, { error }] = fieldState;
  const appearance = error ? "critical" : "default";
  return React225.cloneElement(/* @__PURE__ */ React225.createElement(VanillaTrigger, null), { ...props, appearance });
};
var Trigger6 = (props) => {
  const formStrategy = useFormStrategy();
  const Component = formStrategy === "formik" ? FormikTrigger : VanillaTrigger;
  return React225.cloneElement(/* @__PURE__ */ React225.createElement(Component, null), props);
};
var FormikValue = (props) => {
  const { fieldState } = useFormikField();
  const [field] = fieldState;
  return React225.cloneElement(/* @__PURE__ */ React225.createElement(VanillaValue, null), { ...props, ...field });
};
var Value = (props) => {
  const formStrategy = useFormStrategy();
  const Component = formStrategy === "formik" ? FormikValue : VanillaValue;
  return React225.cloneElement(/* @__PURE__ */ React225.createElement(Component, null), props);
};
var contentStyles3 = css30.raw({
  overflow: "hidden",
  minWidth: "var(--radix-select-trigger-width)",
  backgroundColor: "background.surface",
  borderRadius: "medium",
  border: "token(borderWidths.thin) solid token(colors.border.input)",
  maxHeight: "300px",
  "&[data-side = bottom]": { transform: "translate(0, token(spacing.space.50))" },
  "&[data-side = top]": { transform: "translate(0, token(spacing.space.-50))" }
});
var Content12 = React225.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css30(contentStyles3, cssProp);
  return /* @__PURE__ */ React225.createElement(SelectPrimitive.Portal, null, /* @__PURE__ */ React225.createElement(SelectPrimitive.Content, { ref: forwardedRef, className, position: "popper", ...props }, /* @__PURE__ */ React225.createElement(SelectPrimitive.Viewport, { className: css30({ paddingY: "space.100" }) }, children)));
});
var labelStyles2 = css30.raw({
  textStyle: "text50",
  color: "text.weak",
  paddingY: "space.100",
  paddingX: "space.200"
});
var Label3 = React225.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const className = css30(labelStyles2, cssProp);
  return /* @__PURE__ */ React225.createElement(SelectPrimitive.Label, { className, ref: forwardedRef, ...props });
});
var itemStyles4 = css30.raw({
  outline: "none",
  textStyle: "text100",
  display: "flex",
  alignItems: "center",
  paddingY: "space.100",
  paddingX: "space.200",
  position: "relative",
  userSelect: "none",
  cursor: "default",
  _focus: { bg: "background.surface.hover" },
  _hover: { bg: "background.surface.hover" }
});
var Item8 = React225.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css30(itemStyles4, cssProp);
  return /* @__PURE__ */ React225.createElement(SelectPrimitive.Item, { className, ref: forwardedRef, ...props }, /* @__PURE__ */ React225.createElement(SelectPrimitive.ItemText, null, children));
});
var separatorStyles2 = css30.raw({
  height: "1px",
  bg: "border",
  marginX: "space.200"
});
var Separator7 = React225.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const className = css30(separatorStyles2, cssProp);
  return /* @__PURE__ */ React225.createElement(SelectPrimitive.Separator, { ref: forwardedRef, className, ...props });
});
var CompositeComponent5 = Object.assign(Root16, {
  Trigger: Trigger6,
  Value,
  Content: Content12,
  Group,
  Label: Label3,
  Item: Item8,
  Separator: Separator7
});
var Select = CompositeComponent5;
Select.displayName = "Select";
Select.Trigger.displayName = "Select.Trigger";
Select.Value.displayName = "Select.Value";
Select.Content.displayName = "Select.Content";
Select.Group.displayName = "Select.Group";
Select.Label.displayName = "Select.Label";
Select.Item.displayName = "Select.Item";
Select.Separator.displayName = "Separator";

// src/components/sheet/sheet.tsx
import * as React226 from "react";
import { css as css31, cva as cva18 } from "@betterment/samba-styled-system/css";
import * as DialogPrimitive3 from "@radix-ui/react-dialog";
var SheetContext = React226.createContext({
  overlay: "default"
});
var useSheetContext = () => React226.useContext(SheetContext);
var Root18 = ({ overlay, ...props }) => {
  const contextValue = React226.useMemo(() => ({ overlay }), [overlay]);
  return /* @__PURE__ */ React226.createElement(SheetContext.Provider, { value: contextValue }, /* @__PURE__ */ React226.createElement(DialogPrimitive3.Root, { ...props }));
};
var { Trigger: Trigger7, Close: Close4, Portal: Portal4, Title: Title2, Description: Description2 } = DialogPrimitive3;
var sheetStyles = cva18({
  base: {
    background: "background.surface",
    boxShadow: "sm",
    height: "100vh",
    minWidth: "container.small",
    p: "space.0",
    position: "fixed",
    top: "space.0",
    _focus: {
      outline: "none"
    }
  },
  variants: {
    variant: {
      left: {
        left: "space.0",
        _open: {
          animation: "slideRightIn"
        },
        _closed: {
          animation: "slideLeftOut"
        }
      },
      right: {
        right: "space.0",
        _open: {
          animation: "slideLeftIn"
        },
        _closed: {
          animation: "slideRightOut"
        }
      }
    },
    size: {
      medium: {
        width: "min(100vw, token(sizes.container.medium))"
      },
      large: {
        width: "min(100vw, token(sizes.container.large))"
      }
    }
  },
  defaultVariants: {
    variant: "right",
    size: "medium"
  }
});
var sheetCloseStyles = css31.raw({
  position: "absolute",
  right: "space.200",
  top: "space.200"
});
var Content14 = React226.forwardRef(
  ({ variant, size, css: cssProps, children, ...props }, ref) => {
    const { overlay } = useSheetContext();
    return /* @__PURE__ */ React226.createElement(Portal4, null, /* @__PURE__ */ React226.createElement(Overlay2, { variant: overlay }), /* @__PURE__ */ React226.createElement(DialogPrimitive3.Content, { ref, className: css31(sheetStyles.raw({ variant, size }), cssProps), ...props }, children, /* @__PURE__ */ React226.createElement(Close4, { asChild: true }, /* @__PURE__ */ React226.createElement(Box, { className: css31(sheetCloseStyles) }, /* @__PURE__ */ React226.createElement(IconButton, { label: "Close", name: "X", spacing: "compact" })))));
  }
);
var CompositeComponent6 = Object.assign(Root18, {
  Trigger: Trigger7,
  Close: Close4,
  Portal: Portal4,
  Content: Content14,
  Title: Title2,
  Description: Description2
});
var Sheet = CompositeComponent6;
Sheet.displayName = "Sheet";
Sheet.Trigger.displayName = "Sheet.Trigger";
Sheet.Close.displayName = "Sheet.Close";
Sheet.Portal.displayName = "Sheet.Portal";
Sheet.Content.displayName = "Sheet.Content";
Sheet.Title.displayName = "Sheet.Title";
Sheet.Description.displayName = "Sheet.Description";

// src/components/shimmer/shimmer.tsx
import React227 from "react";
var Shimmer = ({ css: cssProp, ...props }) => {
  const { borderRadius = "medium", width = "100%", ...cssProps } = cssProp ?? {};
  return /* @__PURE__ */ React227.createElement(
    Box,
    {
      "aria-hidden": "true",
      css: {
        animation: "shimmerPulse",
        width,
        borderRadius,
        ...cssProps
      },
      ...props
    }
  );
};

// src/components/shimmer-text/shimmer-text.tsx
import React228 from "react";
import { css as css32 } from "@betterment/samba-styled-system/css";
var baseShimmerStyles = css32.raw({
  animation: "shimmerPulse",
  width: "100%",
  borderRadius: "medium"
});
var ShimmerText = ({ css: cssProp, textStyle = "text25", ...props }) => {
  return /* @__PURE__ */ React228.createElement(
    Box,
    {
      "aria-hidden": "true",
      css: {
        ...baseShimmerStyles,
        ...cssProp,
        textStyle
      },
      ...props
    },
    "\u200C"
  );
};

// src/components/slider/slider.tsx
import React229, { forwardRef as forwardRef19 } from "react";
import { css as css33, cva as cva19 } from "@betterment/samba-styled-system/css";
import * as SliderPrimitive from "@radix-ui/react-slider";
var rootStyles5 = cva19({
  base: {
    position: "relative",
    display: "flex",
    userSelect: "none",
    touchAction: "none"
  },
  variants: {
    orientation: {
      horizontal: {
        alignItems: "center",
        width: "100%"
      },
      vertical: {
        justifyContent: "center",
        width: "4px",
        minHeight: "32px"
      }
    }
  }
});
var trackStyles = cva19({
  base: {
    position: "relative",
    bg: "background.neutral",
    borderRadius: "round",
    width: "4px",
    flexGrow: 1
  },
  variants: {
    orientation: {
      horizontal: {
        height: "4px"
      },
      vertical: {
        width: "4px"
      }
    }
  }
});
var rangeStyles = cva19({
  base: {
    position: "absolute",
    bg: "background.primary",
    borderRadius: "round"
  },
  variants: {
    orientation: {
      horizontal: {
        height: "100%"
      },
      vertical: {
        width: "4px"
      }
    }
  }
});
var thumbStyles2 = css33({
  display: "block",
  bg: "background.neutral",
  width: "20px",
  height: "20px",
  borderRadius: "round",
  border: "token(borderWidths.thin) solid token(colors.background.primary)",
  _hover: {
    bg: "background.neutral.hover"
  },
  _active: {
    bg: "background.neutral.active"
  },
  _focus: {
    bg: "background.neutral.active"
  }
});
var Slider = forwardRef19(
  ({ css: cssProp = {}, orientation = "horizontal", ...sliderRootProps }, forwardedRef) => {
    const rootClassName = css33(rootStyles5.raw({ orientation }), cssProp);
    const thumbCount = sliderRootProps.defaultValue?.length || 0;
    return /* @__PURE__ */ React229.createElement(SliderPrimitive.Root, { ref: forwardedRef, className: rootClassName, orientation, ...sliderRootProps }, /* @__PURE__ */ React229.createElement(SliderPrimitive.Track, { className: trackStyles({ orientation }) }, /* @__PURE__ */ React229.createElement(SliderPrimitive.Range, { className: rangeStyles({ orientation }) })), Array.from({ length: thumbCount }, (_defaultValue, index) => /* @__PURE__ */ React229.createElement(SliderPrimitive.Thumb, { key: `thumb-${index}`, className: thumbStyles2 })));
  }
);
Slider.displayName = "Slider";

// src/components/success-fullscreen/success-fullscreen.tsx
import React231 from "react";

// src/components/success-fullscreen/animated-checkmark.tsx
import React230 from "react";
import { css as css34 } from "@betterment/samba-styled-system/css";
var curve = "cubic-bezier(0.65, 0, 0.45, 1)";
var svgStyles = css34({
  strokeWidth: 3,
  width: "10rem",
  fill: "none",
  stroke: "icon.onPrimary"
});
var circleStyles = css34({
  strokeDasharray: 218,
  strokeDashoffset: 218,
  animation: `strokeIn 0.6s ${curve} forwards`,
  fill: "none",
  stroke: "icon.onPrimary"
});
var polylineStyles = css34({
  transformOrigin: "50% 50%",
  strokeDasharray: 48,
  strokeDashoffset: 48,
  animation: `strokeIn 0.3s ${curve} 0.8s forwards;`,
  fill: "none",
  stroke: "icon.onPrimary"
});
function AnimatedCheckmark(props) {
  const { onAnimationEnd, ...svgProps } = props;
  return /* @__PURE__ */ React230.createElement("svg", { className: svgStyles, preserveAspectRatio: "xMidYMid meet", viewBox: "0 0 76 76", ...svgProps }, /* @__PURE__ */ React230.createElement(
    "polyline",
    {
      "data-testid": "checkmark",
      onAnimationEnd,
      className: polylineStyles,
      points: "22.3 39.5 31.8 49.9 54.5 27.1 "
    }
  ), /* @__PURE__ */ React230.createElement("circle", { className: circleStyles, cx: "38", cy: "38", r: "34.5" }));
}
var animated_checkmark_default = AnimatedCheckmark;

// src/components/success-fullscreen/success-fullscreen.tsx
var SuccessFullScreen = ({ message, onCompletion }) => {
  const onAnimationEnd = () => {
    if (onCompletion) {
      setTimeout(onCompletion, 300);
    }
  };
  return /* @__PURE__ */ React231.createElement(
    Box,
    {
      css: {
        bg: "background.abyss",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column"
      }
    },
    /* @__PURE__ */ React231.createElement(Box, { css: { mb: "space.200" } }, /* @__PURE__ */ React231.createElement(animated_checkmark_default, { onAnimationEnd })),
    /* @__PURE__ */ React231.createElement(Text, { variant: "text200", color: "text.onPrimary" }, message)
  );
};

// src/components/switch/switch.tsx
import React232 from "react";
import { css as css35 } from "@betterment/samba-styled-system/css";
import * as SwitchPrimitive from "@radix-ui/react-switch";
var rootStyles6 = css35.raw({
  width: "40px",
  height: "24px",
  backgroundColor: "background.neutral.strong",
  borderRadius: "round",
  border: "none",
  position: "relative",
  padding: "0px",
  transition: "background-color",
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "100ms",
  _checked: { bg: "background.primary" },
  _focusVisible: { outline: "2px solid token(colors.border.focused)", outlineOffset: "1px" }
});
var thumbStyles3 = css35({
  display: "block",
  width: "20px",
  height: "20px",
  backgroundColor: "background.surface",
  borderRadius: "round",
  transition: "transform 140ms cubic-bezier(0.45, 0.05, 0.55, 0.95)",
  transform: "translateX(2px)",
  willChange: "transform",
  _checked: { transform: "translateX(18px)" }
});
var VanillaSwitch = React232.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const className = css35(rootStyles6, cssProp);
  return /* @__PURE__ */ React232.createElement(SwitchPrimitive.Root, { "data-samba-component": true, ref: forwardedRef, className, ...props }, /* @__PURE__ */ React232.createElement(SwitchPrimitive.Thumb, { className: thumbStyles3 }));
});
var FormikSwitch = React232.forwardRef((props, forwardedRef) => {
  const { fieldState } = useFormikField();
  const [field, { value }, { setValue }] = fieldState;
  const { value: _omitValue, ...rest } = field;
  return React232.cloneElement(/* @__PURE__ */ React232.createElement(VanillaSwitch, null), {
    ...props,
    ...rest,
    checked: value,
    onCheckedChange: (newValue) => void setValue(newValue),
    ref: forwardedRef
  });
});
var Switch = React232.forwardRef(({ formStrategy = "vanilla", ...props }, forwardedRef) => {
  const Component = formStrategy === "formik" ? FormikSwitch : VanillaSwitch;
  return React232.cloneElement(/* @__PURE__ */ React232.createElement(Component, null), { ...props, ref: forwardedRef });
});
VanillaSwitch.displayName = "VanillaSwitch";
FormikSwitch.displayName = "FormikSwitch";
Switch.displayName = "Switch";

// src/components/table/table.tsx
import React233, { forwardRef as forwardRef20 } from "react";
import { css as css36, cva as cva20 } from "@betterment/samba-styled-system/css";
var tableStyles = css36.raw({
  width: "100%",
  borderCollapse: "collapse"
});
var headerStyles2 = css36.raw({
  textStyle: "title100",
  borderWidth: "thin",
  borderBottom: "solid token(colors.border)"
});
var footerStyles = css36.raw({
  borderWidth: "thin",
  borderTop: "solid token(colors.border)"
});
var rowStyles = css36.raw({
  borderWidth: "thin",
  borderBottom: "solid token(colors.border)",
  _last: {
    borderBottom: "none"
  }
});
var columnHeaderCellStyles = cva20({
  base: {
    p: "space.200",
    textStyle: "title100"
  },
  variants: {
    alignment: {
      start: {
        textAlign: "start"
      },
      center: {
        textAlign: "center"
      },
      end: {
        textAlign: "end"
      }
    }
  }
});
var cellStyles = cva20({
  base: {
    p: "space.200",
    textStyle: "text100"
  },
  variants: {
    alignment: {
      start: {
        textAlign: "start"
      },
      center: {
        textAlign: "center"
      },
      end: {
        textAlign: "end"
      }
    }
  }
});
var Header7 = React233.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React233.createElement("thead", { "data-samba-component": true, ref: forwardedRef, className: css36(headerStyles2, cssProp), ...props });
});
var Body = React233.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React233.createElement("tbody", { "data-samba-component": true, ref: forwardedRef, className: css36(cssProp), ...props });
});
var Footer3 = React233.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React233.createElement("tfoot", { ref: forwardedRef, className: css36(footerStyles, cssProp), ...props });
});
var ColumnHeaderCell = React233.forwardRef(
  ({ css: cssProp, ...props }, forwardedRef) => {
    const { alignment = "start" } = props;
    const className = css36(columnHeaderCellStyles.raw({ alignment }), cssProp);
    return /* @__PURE__ */ React233.createElement("th", { "data-samba-component": true, scope: "col", ref: forwardedRef, ...props, className });
  }
);
var Row = React233.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React233.createElement("tr", { "data-samba-component": true, ref: forwardedRef, className: css36(rowStyles, cssProp), ...props });
});
var RowHeaderCell = React233.forwardRef(
  ({ css: cssProp, ...props }, forwardedRef) => {
    const { alignment = "start" } = props;
    const className = css36(cellStyles.raw({ alignment }), cssProp);
    return /* @__PURE__ */ React233.createElement("th", { "data-samba-component": true, scope: "row", ref: forwardedRef, className, ...props });
  }
);
var Cell = React233.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  const { alignment = "start" } = props;
  const className = css36(cellStyles.raw({ alignment }), cssProp);
  return /* @__PURE__ */ React233.createElement("td", { "data-samba-component": true, ref: forwardedRef, ...props, className });
});
var Root21 = forwardRef20((props, forwardedRef) => {
  const { css: cssProp = {}, children, ...tableProps } = props;
  const className = css36(tableStyles, cssProp);
  return /* @__PURE__ */ React233.createElement("table", { "data-samba-component": true, ref: forwardedRef, className, ...tableProps }, children);
});
var CompositeComponent7 = Object.assign(Root21, {
  Header: Header7,
  Body,
  Footer: Footer3,
  ColumnHeaderCell,
  RowHeaderCell,
  Row,
  Cell
});
var Table = CompositeComponent7;
Table.displayName = "Table";
Header7.displayName = "Table.Header";
Body.displayName = "Table.Body";
Footer3.displayName = "Table.Footer";
ColumnHeaderCell.displayName = "Table.ColumnHeader";
RowHeaderCell.displayName = "Table.HeaderCell";
Row.displayName = "Table.Row";
Cell.displayName = "Table.Cell";

// src/components/tabs/tabs.tsx
import React234 from "react";
import { css as css37, cva as cva21 } from "@betterment/samba-styled-system/css";
import * as TabsPrimitive from "@radix-ui/react-tabs";
var TabsContext = React234.createContext({
  alignment: "start",
  spacing: "default",
  border: "none"
});
var useTabsContext = () => React234.useContext(TabsContext);
var tabsStyles = css37.raw({
  display: "flex",
  flexDirection: "column",
  flex: "1",
  maxWidth: "100%",
  gap: "space.100"
});
var Root23 = React234.forwardRef(({ css: cssProp, alignment, spacing, border, ...props }, ref) => {
  const contextValue = React234.useMemo(
    () => ({
      alignment,
      spacing,
      border
    }),
    [alignment, spacing, border]
  );
  const className = css37(tabsStyles, cssProp);
  return /* @__PURE__ */ React234.createElement(TabsContext.Provider, { value: contextValue }, /* @__PURE__ */ React234.createElement(
    TabsPrimitive.Root,
    {
      "data-samba-component": true,
      ref,
      className,
      activationMode: "manual",
      ...props
    }
  ));
});
var wrapperListStyles = css37.raw({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  padding: "2px",
  // space for the trigger's outline inside the tabs list
  "&::-webkit-scrollbar": {
    height: "8px"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "background.neutral",
    borderRadius: "medium",
    "&:hover": {
      backgroundColor: "background.neutral.hover"
    }
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "background.transparent"
  }
});
var listStyles = cva21({
  base: {
    display: "flex",
    position: "relative",
    gap: "space.100",
    flex: "1"
  },
  variants: {
    border: {
      none: {
        border: "none"
      },
      bottom: {
        boxShadow: "inset 0 -1px 0 token(colors.border)"
      }
    }
  },
  defaultVariants: {
    border: "none"
  }
});
var List2 = React234.forwardRef(({ css: cssProp, ...props }, ref) => {
  const { border } = useTabsContext();
  const className = css37(listStyles.raw({ border }), cssProp);
  return /* @__PURE__ */ React234.createElement(Box, { css: wrapperListStyles }, /* @__PURE__ */ React234.createElement(TabsPrimitive.List, { "data-samba-component": true, className, ref, ...props }));
});
var triggerStyles3 = cva21({
  base: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    gap: "space.50",
    border: "none",
    borderRadius: "medium",
    backgroundColor: "background.transparent",
    color: "text.weak",
    whiteSpace: "nowrap",
    textStyle: "text100",
    '&[data-state="active"]': {
      color: "text",
      _after: {
        content: '""',
        position: "absolute",
        bottom: "0",
        borderBottom: "token(borderWidths.thick) solid token(colors.border.strongest)",
        borderRadius: "medium"
      }
    },
    _hover: {
      cursor: "pointer",
      _after: {
        content: '""',
        position: "absolute",
        bottom: "0",
        width: "auto",
        borderBottom: "token(borderWidths.thick) solid token(colors.border.strong)",
        borderRadius: "medium"
      },
      '&[data-state="active"]': {
        cursor: "default",
        _after: {
          borderColor: "token(colors.border.strongest)"
        }
      }
    },
    _focusVisible: {
      outline: "token(borderWidths.thick) solid token(colors.border.focused)"
    }
  },
  variants: {
    alignment: {
      start: { flex: "none" },
      stretch: { flex: "1" }
    },
    spacing: {
      default: {
        py: "space.200",
        px: "space.100",
        _after: {
          insetInlineStart: "space.100",
          insetInlineEnd: "space.100"
        }
      },
      compact: {
        py: "space.50",
        px: "space.100",
        _after: {
          insetInlineStart: "space.100",
          insetInlineEnd: "space.100"
        }
      }
    }
  },
  defaultVariants: {
    alignment: "start",
    spacing: "default"
  }
});
var Trigger9 = React234.forwardRef(({ css: cssProp, ...props }, ref) => {
  const { alignment, spacing } = useTabsContext();
  const className = css37(triggerStyles3.raw({ alignment, spacing }), cssProp);
  return /* @__PURE__ */ React234.createElement(TabsPrimitive.Trigger, { "data-samba-component": true, ref, className, ...props });
});
var contentStyles4 = css37.raw({
  _focusVisible: {
    borderRadius: "medium",
    outline: "token(borderWidths.thick) solid token(colors.border.focused)"
  }
});
var Content16 = React234.forwardRef(({ css: cssProp, ...props }, ref) => {
  const className = css37(contentStyles4, cssProp);
  return /* @__PURE__ */ React234.createElement(TabsPrimitive.Content, { "data-samba-component": true, className, ref, ...props });
});
var CompositeComponent8 = Object.assign(Root23, {
  List: List2,
  Trigger: Trigger9,
  Content: Content16
});
var Tabs = CompositeComponent8;
Tabs.displayName = "Tabs";
Tabs.List.displayName = "Tabs.List";
Tabs.Trigger.displayName = "Tabs.Trigger";
Tabs.Content.displayName = "Tabs.Content";

// src/components/tag/tag.tsx
import React235 from "react";
import { css as css38, cva as cva22 } from "@betterment/samba-styled-system/css";
var tagStyles = cva22({
  base: {
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "nowrap",
    borderRadius: "round",
    pr: "space.100",
    pl: "space.50",
    minHeight: "size.300",
    gap: "space.25"
  },
  variants: {
    accent: {
      teal: {
        color: "text.accent.teal",
        backgroundColor: "background.accent.teal"
      },
      blue: {
        color: "text.accent.blue",
        backgroundColor: "background.accent.blue"
      },
      red: {
        color: "text.accent.red",
        backgroundColor: "background.accent.red"
      },
      gold: {
        color: "text.accent.gold",
        backgroundColor: "background.accent.gold"
      },
      grey: {
        color: "text.accent.grey",
        backgroundColor: "background.accent.grey"
      }
    },
    spacing: {
      default: {
        pl: "space.100"
      },
      withIcon: {
        pl: "space.50"
      }
    }
  },
  defaultVariants: {
    accent: "blue",
    spacing: "default"
  }
});
var Tag = ({ accent, children, iconName, css: cssProp }) => {
  const spacing = iconName ? "withIcon" : "default";
  const className = css38.raw(tagStyles.raw({ accent, spacing }), cssProp);
  return /* @__PURE__ */ React235.createElement(Box, { css: className, as: "span" }, iconName && /* @__PURE__ */ React235.createElement(Icon, { name: iconName, size: "xxsmall", css: { textStyle: "text25", flexShrink: 0 } }), /* @__PURE__ */ React235.createElement(Text, { variant: "text25", css: { pb: "1px" } }, children));
};
Tag.displayName = "Tag";

// src/components/form/textarea.tsx
import React236, { forwardRef as forwardRef21 } from "react";
import { css as css39, cva as cva23 } from "@betterment/samba-styled-system/css";
var textareaStyles = cva23({
  base: {
    backgroundColor: "background.input",
    border: "token(borderWidths.thin) solid",
    borderRadius: "medium",
    color: "text",
    textStyle: "text100",
    width: "100%",
    _focus: {
      outline: "token(borderWidths.thick) solid"
    },
    _disabled: {
      backgroundColor: "background.surface.disabled",
      borderColor: "border.input",
      color: "text.disabled",
      cursor: "not-allowed",
      resize: "none"
    }
  },
  variants: {
    appearance: {
      default: {
        borderColor: "border.input",
        _focus: {
          outlineColor: "border.focused"
        }
      },
      critical: {
        borderColor: "border.critical",
        _focus: {
          outlineColor: "border.critical"
        }
      }
    },
    spacing: {
      default: {
        minHeight: "72px",
        px: "space.200",
        py: "space.150"
      },
      compact: {
        minHeight: "64px",
        px: "space.150",
        py: "space.100"
      }
    }
  },
  defaultVariants: {
    appearance: "default",
    spacing: "default"
  }
});
var Textarea = forwardRef21(
  ({ css: cssProp, appearance, spacing, resize, rows, formStrategy: _unusedFormStrategy, ...props }, forwardedRef) => {
    const className = css39(textareaStyles.raw({ appearance, spacing }), css39.raw({ resize }), cssProp);
    return /* @__PURE__ */ React236.createElement("textarea", { ref: forwardedRef, className, rows, ...props, "data-samba-component": true });
  }
);
Textarea.displayName = "Textarea";

// src/components/toggle-group/toggle-group.tsx
import React237 from "react";
import { css as css40, cva as cva24 } from "@betterment/samba-styled-system/css";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
var ToggleGroupContext = React237.createContext({
  spacing: "default"
});
var useToggleGroupContext = () => React237.useContext(ToggleGroupContext);
var toggleGroupStyles = css40.raw({
  display: "flex",
  padding: "space.50",
  gap: "space.50",
  borderRadius: "medium",
  backgroundColor: "background.neutral"
});
var Root25 = React237.forwardRef(({ css: cssProp, spacing, type, ...props }, ref) => {
  const contextValue = React237.useMemo(() => ({ spacing }), [spacing]);
  const className = css40(toggleGroupStyles, cssProp);
  return /* @__PURE__ */ React237.createElement(ToggleGroupContext.Provider, { value: contextValue }, /* @__PURE__ */ React237.createElement(ToggleGroupPrimitive.Root, { "data-samba-component": true, ref, className, type: "single", ...props }));
});
var itemStyles5 = cva24({
  base: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    flex: "1",
    gap: "space.50",
    border: "none",
    borderRadius: "medium",
    backgroundColor: "background.neutral",
    color: "text",
    whiteSpace: "nowrap",
    textStyle: "text100",
    _hover: {
      cursor: "pointer",
      backgroundColor: "background.transparent.hover"
    },
    '&[data-state="on"]': {
      backgroundColor: "background.surface",
      boxShadow: "0 0 0 token(borderWidths.thin) token(colors.border.strongest)",
      _hover: {
        backgroundColor: "background.surface"
      }
    },
    _focusVisible: {
      outline: "token(borderWidths.thick) solid token(colors.border.focused)"
    }
  },
  variants: {
    spacing: {
      default: {
        py: "space.100",
        px: "space.100"
      },
      compact: {
        py: "space.50",
        px: "space.100"
      }
    }
  },
  defaultVariants: {
    spacing: "default"
  }
});
var Item10 = React237.forwardRef(({ css: cssProp, ...props }, ref) => {
  const { spacing } = useToggleGroupContext();
  const className = css40(itemStyles5.raw({ spacing }), cssProp);
  return /* @__PURE__ */ React237.createElement(ToggleGroupPrimitive.Item, { "data-samba-component": true, ref, className, ...props });
});
var CompositeComponent9 = Object.assign(Root25, {
  Item: Item10
});
var ToggleGroup = CompositeComponent9;
ToggleGroup.displayName = "ToggleGroup";
ToggleGroup.Item.displayName = "ToggleGroup.Item";

// src/components/tooltip/tooltip.tsx
import React238 from "react";
import { css as css41 } from "@betterment/samba-styled-system/css";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
var { Trigger: Trigger10 } = TooltipPrimitive;
var Root27 = ({ children, ...props }) => {
  return /* @__PURE__ */ React238.createElement(TooltipPrimitive.Provider, null, /* @__PURE__ */ React238.createElement(TooltipPrimitive.Root, { ...props }, children));
};
var contentStyles5 = css41.raw({
  maxWidth: "300px",
  maxHeight: "240px",
  overflowY: "auto",
  color: "text.inverse",
  backgroundColor: "background.neutral.strong",
  borderRadius: "large",
  padding: "space.150",
  textStyle: "text50",
  willChange: "transform",
  '&[data-state="closed"]': {
    animation: "fadeOut .1s ease"
  },
  '&[data-state="delayed-open"]': {
    '&[data-side="bottom"]': {
      animation: "slideDown .1s ease, fadeIn .1s ease"
    },
    '&[data-side="top"]': {
      animation: "slideUp .1s ease,  fadeIn .1s ease"
    },
    '&[data-side="left"]': {
      animation: "slideLeft .1s ease,  fadeIn .1s ease"
    },
    '&[data-side="right"]': {
      animation: "slideRight .1s ease,  fadeIn .1s ease"
    }
  }
});
var Content18 = React238.forwardRef(({ css: cssProp, children, ...props }, forwardedRef) => {
  const className = css41(contentStyles5, cssProp);
  return /* @__PURE__ */ React238.createElement(TooltipPrimitive.Portal, null, /* @__PURE__ */ React238.createElement(TooltipPrimitive.Content, { sideOffset: 8, ref: forwardedRef, className, ...props }, children));
});
var Text2 = (props) => React238.cloneElement(/* @__PURE__ */ React238.createElement(Text, null), { variant: "text50", ...props });
var buttonMinHeightReset = { minHeight: "unset" };
var IconButton2 = React238.forwardRef(({ css: cssProp, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React238.createElement(
    Button,
    {
      type: "button",
      "aria-label": "Info",
      variant: "ghost-alt",
      ref: forwardedRef,
      css: {
        ...buttonMinHeightReset,
        alignSelf: "center",
        borderRadius: "round",
        padding: "space.0",
        maxHeight: "icon.xsmall",
        ...cssProp
      },
      ...props
    },
    /* @__PURE__ */ React238.createElement(Icon, { name: "InfoCircle", size: "xsmall" })
  );
});
var CompositeComponent10 = Object.assign(Root27, { Trigger: Trigger10, Content: Content18, Text: Text2, IconButton: IconButton2 });
var Tooltip = CompositeComponent10;
Tooltip.displayName = "Tooltip";
Tooltip.Trigger.displayName = "Tooltip.Trigger";
Tooltip.Content.displayName = "Tooltip.Content";
Tooltip.Text.displayName = "Tooltip.Text";
Tooltip.IconButton.displayName = "Tooltip.IconButton";

// src/utilities/visually-hidden/visually-hidden.tsx
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
var VisuallyHidden2 = VisuallyHiddenPrimitive.Root;

// src/components/workflow-header/workflow-header.tsx
import { styled as styled8 } from "@betterment/samba-styled-system/jsx";
var headerMinHeight = "72px";
var Root29 = styled8("div", {
  base: {
    minHeight: headerMinHeight,
    display: "grid",
    gridTemplateColumns: "1fr 2fr 1fr",
    alignItems: "center",
    backgroundColor: "background.surface",
    px: "space.400",
    py: "space.200",
    maxWidth: "container.max"
  }
});
var Leading = styled8("div");
var Trailing = styled8("div", {
  base: { justifySelf: "flex-end" }
});
var Title3 = styled8("div", {
  base: {
    justifySelf: "center",
    textStyle: "text50"
  }
});
var CompositeComponent11 = Object.assign(Root29, {
  Leading,
  Trailing,
  Title: Title3
});
var WorkflowHeader = CompositeComponent11;
WorkflowHeader.displayName = "WorkflowHeader";
WorkflowHeader.Leading.displayName = "WorkflowHeader.Leading";
WorkflowHeader.Trailing.displayName = "WorkflowHeader.Trailing";
WorkflowHeader.Title.displayName = "WorkflowHeader.Title";

// src/index.tsx
import {
  cssDefaultStyles,
  cssReset,
  sambaPreset,
  styleClosetCssReset
} from "@betterment/samba-styled-system/config";
export {
  Accordion,
  Banner,
  Box,
  Button2 as Button,
  Button as ButtonLegacy,
  Card,
  CenteredLayout,
  Checkbox,
  ComboBox2 as ComboBox,
  ContentLayoutF,
  Dialog,
  DropdownMenu,
  FormikField,
  GuidanceBox,
  Heading,
  Icon,
  IconButton,
  IconLink,
  Input3 as Input,
  Label,
  LegacyContentLayoutE,
  LegacySectionLayout,
  Link2 as Link,
  Link as LinkLegacy,
  ListRow,
  Logo,
  PancakeStack,
  Progress,
  RadioGroup,
  ScrollArea,
  Select,
  Separator3 as Separator,
  Sheet,
  Shimmer,
  ShimmerText,
  Slider,
  Spinner,
  SuccessFullScreen,
  Switch,
  Table,
  Tabs,
  Tag,
  Text,
  Textarea,
  ToggleGroup,
  Tooltip,
  VisuallyHidden2 as VisuallyHidden,
  WorkflowHeader,
  cssDefaultStyles,
  cssReset,
  sambaPreset,
  styleClosetCssReset
};
//# sourceMappingURL=index.js.map